
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eqJ66", function(module, exports) {

$parcel$export(module.exports, "register", () => $a81679cc4870fa6f$export$6503ec6e8aabbaf, (v) => $a81679cc4870fa6f$export$6503ec6e8aabbaf = v);
var $a81679cc4870fa6f$export$6503ec6e8aabbaf;
var $a81679cc4870fa6f$export$f7ad0328861e2f03;
"use strict";
var $a81679cc4870fa6f$var$mapping = new Map();
function $a81679cc4870fa6f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$a81679cc4870fa6f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $a81679cc4870fa6f$var$resolve(id) {
    var resolved = $a81679cc4870fa6f$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$a81679cc4870fa6f$export$6503ec6e8aabbaf = $a81679cc4870fa6f$var$register;
$a81679cc4870fa6f$export$f7ad0328861e2f03 = $a81679cc4870fa6f$var$resolve;

});

parcelRegister("ZC3hY", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0b9336f6b7c54517$export$ffb0004e005737fa, (v) => $0b9336f6b7c54517$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0b9336f6b7c54517$export$34b9dba7ce09269b, (v) => $0b9336f6b7c54517$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0b9336f6b7c54517$export$25062201e9e25d76, (v) => $0b9336f6b7c54517$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b9336f6b7c54517$export$ffb0004e005737fa;
var $0b9336f6b7c54517$export$34b9dba7ce09269b;
var $0b9336f6b7c54517$export$25062201e9e25d76;
"use strict";
var $0b9336f6b7c54517$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0b9336f6b7c54517$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $0b9336f6b7c54517$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $0b9336f6b7c54517$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$0b9336f6b7c54517$export$ffb0004e005737fa = $0b9336f6b7c54517$var$REACT_FRAGMENT_TYPE;
$0b9336f6b7c54517$export$34b9dba7ce09269b = $0b9336f6b7c54517$var$jsxProd;
$0b9336f6b7c54517$export$25062201e9e25d76 = $0b9336f6b7c54517$var$jsxProd;

});

parcelRegister("2xyO7", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1d99a9db12f920a7$export$dca3b0875bd9a954, (v) => $1d99a9db12f920a7$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1d99a9db12f920a7$export$16fa2f45be04daa8, (v) => $1d99a9db12f920a7$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1d99a9db12f920a7$export$ffb0004e005737fa, (v) => $1d99a9db12f920a7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1d99a9db12f920a7$export$e2c29f18771995cb, (v) => $1d99a9db12f920a7$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1d99a9db12f920a7$export$221d75b3f55bb0bd, (v) => $1d99a9db12f920a7$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1d99a9db12f920a7$export$5f8d39834fd61797, (v) => $1d99a9db12f920a7$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1d99a9db12f920a7$export$74bf444e3cd11ea5, (v) => $1d99a9db12f920a7$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $1d99a9db12f920a7$export$1ced07cd6b1985ce, (v) => $1d99a9db12f920a7$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $1d99a9db12f920a7$export$3ba232387fd5d6dd, (v) => $1d99a9db12f920a7$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $1d99a9db12f920a7$export$69a3209f1a06c04d, (v) => $1d99a9db12f920a7$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $1d99a9db12f920a7$export$e530037191fcd5d7, (v) => $1d99a9db12f920a7$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1d99a9db12f920a7$export$fd42f52fd3ae1109, (v) => $1d99a9db12f920a7$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1d99a9db12f920a7$export$c8a8987d4410bf2d, (v) => $1d99a9db12f920a7$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $1d99a9db12f920a7$export$7d1e3a5e95ceca43, (v) => $1d99a9db12f920a7$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1d99a9db12f920a7$export$257a8862b851cb5b, (v) => $1d99a9db12f920a7$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1d99a9db12f920a7$export$a8257692ac88316c, (v) => $1d99a9db12f920a7$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1d99a9db12f920a7$export$488013bae63b21da, (v) => $1d99a9db12f920a7$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1d99a9db12f920a7$export$7c73462e0d25e514, (v) => $1d99a9db12f920a7$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1d99a9db12f920a7$export$7568632d0d33d16d, (v) => $1d99a9db12f920a7$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $1d99a9db12f920a7$export$f93f40ac0ca7e3a8, (v) => $1d99a9db12f920a7$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $1d99a9db12f920a7$export$1f96ae73734a86cc, (v) => $1d99a9db12f920a7$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $1d99a9db12f920a7$export$9a47ced3238df325, (v) => $1d99a9db12f920a7$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $1d99a9db12f920a7$export$35808ee640e87ca7, (v) => $1d99a9db12f920a7$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1d99a9db12f920a7$export$fae74005e78b1a27, (v) => $1d99a9db12f920a7$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1d99a9db12f920a7$export$dc8fbce3eb94dc1e, (v) => $1d99a9db12f920a7$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1d99a9db12f920a7$export$6a7bc4e911dc01cf, (v) => $1d99a9db12f920a7$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1d99a9db12f920a7$export$6d9c69b0de29b591, (v) => $1d99a9db12f920a7$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1d99a9db12f920a7$export$f680877a34711e37, (v) => $1d99a9db12f920a7$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1d99a9db12f920a7$export$d5a552a76deda3c2, (v) => $1d99a9db12f920a7$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1d99a9db12f920a7$export$aaabe4eda9ed9969, (v) => $1d99a9db12f920a7$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1d99a9db12f920a7$export$e5c5a5f917a5871c, (v) => $1d99a9db12f920a7$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1d99a9db12f920a7$export$1538c33de8887b59, (v) => $1d99a9db12f920a7$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $1d99a9db12f920a7$export$fca7f784ae7a249a, (v) => $1d99a9db12f920a7$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $1d99a9db12f920a7$export$13e3392192263954, (v) => $1d99a9db12f920a7$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1d99a9db12f920a7$export$b8f5890fc79d6aca, (v) => $1d99a9db12f920a7$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1d99a9db12f920a7$export$60241385465d0a34, (v) => $1d99a9db12f920a7$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1d99a9db12f920a7$export$306c0aa65ff9ec16, (v) => $1d99a9db12f920a7$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1d99a9db12f920a7$export$7b286972b8d8ccbf, (v) => $1d99a9db12f920a7$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1d99a9db12f920a7$export$83d89fbfd8236492, (v) => $1d99a9db12f920a7$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1d99a9db12f920a7$export$dca3b0875bd9a954;
var $1d99a9db12f920a7$export$16fa2f45be04daa8;
var $1d99a9db12f920a7$export$ffb0004e005737fa;
var $1d99a9db12f920a7$export$e2c29f18771995cb;
var $1d99a9db12f920a7$export$221d75b3f55bb0bd;
var $1d99a9db12f920a7$export$5f8d39834fd61797;
var $1d99a9db12f920a7$export$74bf444e3cd11ea5;
var $1d99a9db12f920a7$export$1ced07cd6b1985ce;
var $1d99a9db12f920a7$export$3ba232387fd5d6dd;
var $1d99a9db12f920a7$export$69a3209f1a06c04d;
var $1d99a9db12f920a7$export$e530037191fcd5d7;
var $1d99a9db12f920a7$export$fd42f52fd3ae1109;
var $1d99a9db12f920a7$export$c8a8987d4410bf2d;
var $1d99a9db12f920a7$export$7d1e3a5e95ceca43;
var $1d99a9db12f920a7$export$257a8862b851cb5b;
var $1d99a9db12f920a7$export$a8257692ac88316c;
var $1d99a9db12f920a7$export$488013bae63b21da;
var $1d99a9db12f920a7$export$7c73462e0d25e514;
var $1d99a9db12f920a7$export$7568632d0d33d16d;
var $1d99a9db12f920a7$export$f93f40ac0ca7e3a8;
var $1d99a9db12f920a7$export$1f96ae73734a86cc;
var $1d99a9db12f920a7$export$9a47ced3238df325;
var $1d99a9db12f920a7$export$35808ee640e87ca7;
var $1d99a9db12f920a7$export$fae74005e78b1a27;
var $1d99a9db12f920a7$export$dc8fbce3eb94dc1e;
var $1d99a9db12f920a7$export$6a7bc4e911dc01cf;
var $1d99a9db12f920a7$export$6d9c69b0de29b591;
var $1d99a9db12f920a7$export$f680877a34711e37;
var $1d99a9db12f920a7$export$d5a552a76deda3c2;
var $1d99a9db12f920a7$export$aaabe4eda9ed9969;
var $1d99a9db12f920a7$export$e5c5a5f917a5871c;
var $1d99a9db12f920a7$export$1538c33de8887b59;
var $1d99a9db12f920a7$export$fca7f784ae7a249a;
var $1d99a9db12f920a7$export$13e3392192263954;
var $1d99a9db12f920a7$export$b8f5890fc79d6aca;
var $1d99a9db12f920a7$export$60241385465d0a34;
var $1d99a9db12f920a7$export$306c0aa65ff9ec16;
var $1d99a9db12f920a7$export$7b286972b8d8ccbf;
var $1d99a9db12f920a7$export$83d89fbfd8236492;

var $4kiXg = parcelRequire("4kiXg");
"use strict";
var $1d99a9db12f920a7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1d99a9db12f920a7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $1d99a9db12f920a7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $1d99a9db12f920a7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $1d99a9db12f920a7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $1d99a9db12f920a7$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $1d99a9db12f920a7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $1d99a9db12f920a7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $1d99a9db12f920a7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $1d99a9db12f920a7$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $1d99a9db12f920a7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $1d99a9db12f920a7$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $1d99a9db12f920a7$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $1d99a9db12f920a7$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$1d99a9db12f920a7$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $1d99a9db12f920a7$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1d99a9db12f920a7$var$assign = Object.assign, $1d99a9db12f920a7$var$emptyObject = {};
function $1d99a9db12f920a7$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1d99a9db12f920a7$var$emptyObject;
    this.updater = updater || $1d99a9db12f920a7$var$ReactNoopUpdateQueue;
}
$1d99a9db12f920a7$var$Component.prototype.isReactComponent = {};
$1d99a9db12f920a7$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$1d99a9db12f920a7$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $1d99a9db12f920a7$var$ComponentDummy() {}
$1d99a9db12f920a7$var$ComponentDummy.prototype = $1d99a9db12f920a7$var$Component.prototype;
function $1d99a9db12f920a7$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1d99a9db12f920a7$var$emptyObject;
    this.updater = updater || $1d99a9db12f920a7$var$ReactNoopUpdateQueue;
}
var $1d99a9db12f920a7$var$pureComponentPrototype = $1d99a9db12f920a7$var$PureComponent.prototype = new $1d99a9db12f920a7$var$ComponentDummy();
$1d99a9db12f920a7$var$pureComponentPrototype.constructor = $1d99a9db12f920a7$var$PureComponent;
$1d99a9db12f920a7$var$assign($1d99a9db12f920a7$var$pureComponentPrototype, $1d99a9db12f920a7$var$Component.prototype);
$1d99a9db12f920a7$var$pureComponentPrototype.isPureReactComponent = !0;
var $1d99a9db12f920a7$var$isArrayImpl = Array.isArray, $1d99a9db12f920a7$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $1d99a9db12f920a7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1d99a9db12f920a7$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $1d99a9db12f920a7$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $1d99a9db12f920a7$var$cloneAndReplaceKey(oldElement, newKey) {
    return $1d99a9db12f920a7$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $1d99a9db12f920a7$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $1d99a9db12f920a7$var$REACT_ELEMENT_TYPE;
}
function $1d99a9db12f920a7$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $1d99a9db12f920a7$var$userProvidedKeyEscapeRegex = /\/+/g;
function $1d99a9db12f920a7$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $1d99a9db12f920a7$var$escape("" + element.key) : index.toString(36);
}
function $1d99a9db12f920a7$var$noop$1() {}
function $1d99a9db12f920a7$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($1d99a9db12f920a7$var$noop$1, $1d99a9db12f920a7$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $1d99a9db12f920a7$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $1d99a9db12f920a7$var$REACT_ELEMENT_TYPE:
                case $1d99a9db12f920a7$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $1d99a9db12f920a7$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $1d99a9db12f920a7$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $1d99a9db12f920a7$var$getElementKey(children, 0) : nameSoFar, $1d99a9db12f920a7$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($1d99a9db12f920a7$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $1d99a9db12f920a7$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($1d99a9db12f920a7$var$isValidElement(callback) && (callback = $1d99a9db12f920a7$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($1d99a9db12f920a7$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($1d99a9db12f920a7$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $1d99a9db12f920a7$var$getElementKey(nameSoFar, i), invokeCallback += $1d99a9db12f920a7$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $1d99a9db12f920a7$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $1d99a9db12f920a7$var$getElementKey(nameSoFar, i++), invokeCallback += $1d99a9db12f920a7$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $1d99a9db12f920a7$var$mapIntoArray($1d99a9db12f920a7$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $1d99a9db12f920a7$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $1d99a9db12f920a7$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $1d99a9db12f920a7$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $1d99a9db12f920a7$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4kiXg && "function" === typeof $4kiXg.emit) {
        $4kiXg.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $1d99a9db12f920a7$var$noop() {}
$1d99a9db12f920a7$export$dca3b0875bd9a954 = {
    map: $1d99a9db12f920a7$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $1d99a9db12f920a7$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $1d99a9db12f920a7$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $1d99a9db12f920a7$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$1d99a9db12f920a7$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$1d99a9db12f920a7$export$16fa2f45be04daa8 = $1d99a9db12f920a7$var$Component;
$1d99a9db12f920a7$export$ffb0004e005737fa = $1d99a9db12f920a7$var$REACT_FRAGMENT_TYPE;
$1d99a9db12f920a7$export$e2c29f18771995cb = $1d99a9db12f920a7$var$REACT_PROFILER_TYPE;
$1d99a9db12f920a7$export$221d75b3f55bb0bd = $1d99a9db12f920a7$var$PureComponent;
$1d99a9db12f920a7$export$5f8d39834fd61797 = $1d99a9db12f920a7$var$REACT_STRICT_MODE_TYPE;
$1d99a9db12f920a7$export$74bf444e3cd11ea5 = $1d99a9db12f920a7$var$REACT_SUSPENSE_TYPE;
$1d99a9db12f920a7$export$1ced07cd6b1985ce = $1d99a9db12f920a7$var$ReactSharedInternals;
$1d99a9db12f920a7$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1d99a9db12f920a7$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$1d99a9db12f920a7$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $1d99a9db12f920a7$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$1d99a9db12f920a7$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $1d99a9db12f920a7$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$1d99a9db12f920a7$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $1d99a9db12f920a7$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $1d99a9db12f920a7$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$1d99a9db12f920a7$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$1d99a9db12f920a7$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $1d99a9db12f920a7$var$ReactElement(type, key, void 0, void 0, null, props);
};
$1d99a9db12f920a7$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1d99a9db12f920a7$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $1d99a9db12f920a7$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$1d99a9db12f920a7$export$a8257692ac88316c = $1d99a9db12f920a7$var$isValidElement;
$1d99a9db12f920a7$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $1d99a9db12f920a7$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $1d99a9db12f920a7$var$lazyInitializer
    };
};
$1d99a9db12f920a7$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $1d99a9db12f920a7$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$1d99a9db12f920a7$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $1d99a9db12f920a7$var$ReactSharedInternals.T, currentTransition = {};
    $1d99a9db12f920a7$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $1d99a9db12f920a7$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($1d99a9db12f920a7$var$noop, $1d99a9db12f920a7$var$reportGlobalError);
    } catch (error) {
        $1d99a9db12f920a7$var$reportGlobalError(error);
    } finally{
        $1d99a9db12f920a7$var$ReactSharedInternals.T = prevTransition;
    }
};
$1d99a9db12f920a7$export$f93f40ac0ca7e3a8 = function() {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useCacheRefresh();
};
$1d99a9db12f920a7$export$1f96ae73734a86cc = function(usable) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.use(usable);
};
$1d99a9db12f920a7$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$1d99a9db12f920a7$export$35808ee640e87ca7 = function(callback, deps) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$1d99a9db12f920a7$export$fae74005e78b1a27 = function(Context) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useContext(Context);
};
$1d99a9db12f920a7$export$dc8fbce3eb94dc1e = function() {};
$1d99a9db12f920a7$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$1d99a9db12f920a7$export$6d9c69b0de29b591 = function(create, deps) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useEffect(create, deps);
};
$1d99a9db12f920a7$export$f680877a34711e37 = function() {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useId();
};
$1d99a9db12f920a7$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$1d99a9db12f920a7$export$aaabe4eda9ed9969 = function(create, deps) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$1d99a9db12f920a7$export$e5c5a5f917a5871c = function(create, deps) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$1d99a9db12f920a7$export$1538c33de8887b59 = function(create, deps) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useMemo(create, deps);
};
$1d99a9db12f920a7$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$1d99a9db12f920a7$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$1d99a9db12f920a7$export$b8f5890fc79d6aca = function(initialValue) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useRef(initialValue);
};
$1d99a9db12f920a7$export$60241385465d0a34 = function(initialState) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useState(initialState);
};
$1d99a9db12f920a7$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$1d99a9db12f920a7$export$7b286972b8d8ccbf = function() {
    return $1d99a9db12f920a7$var$ReactSharedInternals.H.useTransition();
};
$1d99a9db12f920a7$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("4kiXg", function(module, exports) {
// shim for using process in browser
var $3267bbb6db0678de$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3267bbb6db0678de$var$cachedSetTimeout;
var $3267bbb6db0678de$var$cachedClearTimeout;
function $3267bbb6db0678de$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3267bbb6db0678de$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3267bbb6db0678de$var$cachedSetTimeout = setTimeout;
        else $3267bbb6db0678de$var$cachedSetTimeout = $3267bbb6db0678de$var$defaultSetTimout;
    } catch (e) {
        $3267bbb6db0678de$var$cachedSetTimeout = $3267bbb6db0678de$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3267bbb6db0678de$var$cachedClearTimeout = clearTimeout;
        else $3267bbb6db0678de$var$cachedClearTimeout = $3267bbb6db0678de$var$defaultClearTimeout;
    } catch (e) {
        $3267bbb6db0678de$var$cachedClearTimeout = $3267bbb6db0678de$var$defaultClearTimeout;
    }
})();
function $3267bbb6db0678de$var$runTimeout(fun) {
    if ($3267bbb6db0678de$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3267bbb6db0678de$var$cachedSetTimeout === $3267bbb6db0678de$var$defaultSetTimout || !$3267bbb6db0678de$var$cachedSetTimeout) && setTimeout) {
        $3267bbb6db0678de$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3267bbb6db0678de$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3267bbb6db0678de$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3267bbb6db0678de$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3267bbb6db0678de$var$runClearTimeout(marker) {
    if ($3267bbb6db0678de$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3267bbb6db0678de$var$cachedClearTimeout === $3267bbb6db0678de$var$defaultClearTimeout || !$3267bbb6db0678de$var$cachedClearTimeout) && clearTimeout) {
        $3267bbb6db0678de$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3267bbb6db0678de$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3267bbb6db0678de$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3267bbb6db0678de$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3267bbb6db0678de$var$queue = [];
var $3267bbb6db0678de$var$draining = false;
var $3267bbb6db0678de$var$currentQueue;
var $3267bbb6db0678de$var$queueIndex = -1;
function $3267bbb6db0678de$var$cleanUpNextTick() {
    if (!$3267bbb6db0678de$var$draining || !$3267bbb6db0678de$var$currentQueue) return;
    $3267bbb6db0678de$var$draining = false;
    if ($3267bbb6db0678de$var$currentQueue.length) $3267bbb6db0678de$var$queue = $3267bbb6db0678de$var$currentQueue.concat($3267bbb6db0678de$var$queue);
    else $3267bbb6db0678de$var$queueIndex = -1;
    if ($3267bbb6db0678de$var$queue.length) $3267bbb6db0678de$var$drainQueue();
}
function $3267bbb6db0678de$var$drainQueue() {
    if ($3267bbb6db0678de$var$draining) return;
    var timeout = $3267bbb6db0678de$var$runTimeout($3267bbb6db0678de$var$cleanUpNextTick);
    $3267bbb6db0678de$var$draining = true;
    var len = $3267bbb6db0678de$var$queue.length;
    while(len){
        $3267bbb6db0678de$var$currentQueue = $3267bbb6db0678de$var$queue;
        $3267bbb6db0678de$var$queue = [];
        while(++$3267bbb6db0678de$var$queueIndex < len)if ($3267bbb6db0678de$var$currentQueue) $3267bbb6db0678de$var$currentQueue[$3267bbb6db0678de$var$queueIndex].run();
        $3267bbb6db0678de$var$queueIndex = -1;
        len = $3267bbb6db0678de$var$queue.length;
    }
    $3267bbb6db0678de$var$currentQueue = null;
    $3267bbb6db0678de$var$draining = false;
    $3267bbb6db0678de$var$runClearTimeout(timeout);
}
$3267bbb6db0678de$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3267bbb6db0678de$var$queue.push(new $3267bbb6db0678de$var$Item(fun, args));
    if ($3267bbb6db0678de$var$queue.length === 1 && !$3267bbb6db0678de$var$draining) $3267bbb6db0678de$var$runTimeout($3267bbb6db0678de$var$drainQueue);
};
// v8 likes predictible objects
function $3267bbb6db0678de$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3267bbb6db0678de$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3267bbb6db0678de$var$process.title = 'browser';
$3267bbb6db0678de$var$process.browser = true;
$3267bbb6db0678de$var$process.env = {};
$3267bbb6db0678de$var$process.argv = [];
$3267bbb6db0678de$var$process.version = ''; // empty string to avoid regexp issues
$3267bbb6db0678de$var$process.versions = {};
function $3267bbb6db0678de$var$noop() {}
$3267bbb6db0678de$var$process.on = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.addListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.once = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.off = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.removeListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.removeAllListeners = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.emit = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.prependListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.prependOnceListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.listeners = function(name) {
    return [];
};
$3267bbb6db0678de$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3267bbb6db0678de$var$process.cwd = function() {
    return '/';
};
$3267bbb6db0678de$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3267bbb6db0678de$var$process.umask = function() {
    return 0;
};

});


parcelRegister("fKCny", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $b778ec20f9ee6541$export$882461b6382ed46c, (v) => $b778ec20f9ee6541$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $b778ec20f9ee6541$export$757ceba2d55c277e, (v) => $b778ec20f9ee6541$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $b778ec20f9ee6541$export$83d89fbfd8236492, (v) => $b778ec20f9ee6541$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b778ec20f9ee6541$export$882461b6382ed46c;
var $b778ec20f9ee6541$export$757ceba2d55c277e;
var $b778ec20f9ee6541$export$83d89fbfd8236492;

var $4kiXg = parcelRequire("4kiXg");
"use strict";

var $7DCtq = parcelRequire("7DCtq");

var $8tsvq = parcelRequire("8tsvq");

var $dYG4P = parcelRequire("dYG4P");
function $b778ec20f9ee6541$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b778ec20f9ee6541$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $b778ec20f9ee6541$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b778ec20f9ee6541$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b778ec20f9ee6541$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b778ec20f9ee6541$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b778ec20f9ee6541$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b778ec20f9ee6541$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b778ec20f9ee6541$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $b778ec20f9ee6541$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b778ec20f9ee6541$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b778ec20f9ee6541$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b778ec20f9ee6541$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b778ec20f9ee6541$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b778ec20f9ee6541$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b778ec20f9ee6541$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b778ec20f9ee6541$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $b778ec20f9ee6541$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b778ec20f9ee6541$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b778ec20f9ee6541$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b778ec20f9ee6541$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b778ec20f9ee6541$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b778ec20f9ee6541$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b778ec20f9ee6541$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b778ec20f9ee6541$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b778ec20f9ee6541$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b778ec20f9ee6541$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b778ec20f9ee6541$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b778ec20f9ee6541$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b778ec20f9ee6541$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $b778ec20f9ee6541$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b778ec20f9ee6541$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b778ec20f9ee6541$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b778ec20f9ee6541$var$getComponentNameFromType(type.type) || "Memo";
        case $b778ec20f9ee6541$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b778ec20f9ee6541$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b778ec20f9ee6541$var$ReactSharedInternals = $8tsvq.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b778ec20f9ee6541$var$assign = Object.assign, $b778ec20f9ee6541$var$prefix, $b778ec20f9ee6541$var$suffix;
function $b778ec20f9ee6541$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b778ec20f9ee6541$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b778ec20f9ee6541$var$prefix = match && match[1] || "";
        $b778ec20f9ee6541$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b778ec20f9ee6541$var$prefix + name + $b778ec20f9ee6541$var$suffix;
}
var $b778ec20f9ee6541$var$reentry = !1;
function $b778ec20f9ee6541$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b778ec20f9ee6541$var$reentry) return "";
    $b778ec20f9ee6541$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b778ec20f9ee6541$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b778ec20f9ee6541$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b778ec20f9ee6541$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b778ec20f9ee6541$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b778ec20f9ee6541$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $b778ec20f9ee6541$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b778ec20f9ee6541$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $b778ec20f9ee6541$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $b778ec20f9ee6541$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $b778ec20f9ee6541$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $b778ec20f9ee6541$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $b778ec20f9ee6541$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $b778ec20f9ee6541$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b778ec20f9ee6541$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b778ec20f9ee6541$var$assertIsMounted(fiber) {
    if ($b778ec20f9ee6541$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(188));
}
function $b778ec20f9ee6541$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b778ec20f9ee6541$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b778ec20f9ee6541$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b778ec20f9ee6541$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b778ec20f9ee6541$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b778ec20f9ee6541$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b778ec20f9ee6541$var$isArrayImpl = Array.isArray, $b778ec20f9ee6541$var$ReactDOMSharedInternals = $dYG4P.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b778ec20f9ee6541$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b778ec20f9ee6541$var$valueStack = [], $b778ec20f9ee6541$var$index = -1;
function $b778ec20f9ee6541$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b778ec20f9ee6541$var$pop(cursor) {
    0 > $b778ec20f9ee6541$var$index || (cursor.current = $b778ec20f9ee6541$var$valueStack[$b778ec20f9ee6541$var$index], $b778ec20f9ee6541$var$valueStack[$b778ec20f9ee6541$var$index] = null, $b778ec20f9ee6541$var$index--);
}
function $b778ec20f9ee6541$var$push(cursor, value) {
    $b778ec20f9ee6541$var$index++;
    $b778ec20f9ee6541$var$valueStack[$b778ec20f9ee6541$var$index] = cursor.current;
    cursor.current = value;
}
var $b778ec20f9ee6541$var$contextStackCursor = $b778ec20f9ee6541$var$createCursor(null), $b778ec20f9ee6541$var$contextFiberStackCursor = $b778ec20f9ee6541$var$createCursor(null), $b778ec20f9ee6541$var$rootInstanceStackCursor = $b778ec20f9ee6541$var$createCursor(null), $b778ec20f9ee6541$var$hostTransitionProviderCursor = $b778ec20f9ee6541$var$createCursor(null);
function $b778ec20f9ee6541$var$pushHostContainer(fiber, nextRootInstance) {
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$rootInstanceStackCursor, nextRootInstance);
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$contextFiberStackCursor, fiber);
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $b778ec20f9ee6541$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $b778ec20f9ee6541$var$getOwnHostContext(fiber), nextRootInstance = $b778ec20f9ee6541$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$contextStackCursor);
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$contextStackCursor, nextRootInstance);
}
function $b778ec20f9ee6541$var$popHostContainer() {
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$contextStackCursor);
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$contextFiberStackCursor);
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$rootInstanceStackCursor);
}
function $b778ec20f9ee6541$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$hostTransitionProviderCursor, fiber);
    var context = $b778ec20f9ee6541$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b778ec20f9ee6541$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$contextFiberStackCursor, fiber), $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$contextStackCursor, JSCompiler_inline_result));
}
function $b778ec20f9ee6541$var$popHostContext(fiber) {
    $b778ec20f9ee6541$var$contextFiberStackCursor.current === fiber && ($b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$contextStackCursor), $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$contextFiberStackCursor));
    $b778ec20f9ee6541$var$hostTransitionProviderCursor.current === fiber && ($b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$hostTransitionProviderCursor), $b778ec20f9ee6541$var$HostTransitionContext._currentValue = $b778ec20f9ee6541$var$sharedNotPendingObject);
}
var $b778ec20f9ee6541$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b778ec20f9ee6541$var$scheduleCallback$3 = $7DCtq.unstable_scheduleCallback, $b778ec20f9ee6541$var$cancelCallback$1 = $7DCtq.unstable_cancelCallback, $b778ec20f9ee6541$var$shouldYield = $7DCtq.unstable_shouldYield, $b778ec20f9ee6541$var$requestPaint = $7DCtq.unstable_requestPaint, $b778ec20f9ee6541$var$now = $7DCtq.unstable_now, $b778ec20f9ee6541$var$getCurrentPriorityLevel = $7DCtq.unstable_getCurrentPriorityLevel, $b778ec20f9ee6541$var$ImmediatePriority = $7DCtq.unstable_ImmediatePriority, $b778ec20f9ee6541$var$UserBlockingPriority = $7DCtq.unstable_UserBlockingPriority, $b778ec20f9ee6541$var$NormalPriority$1 = $7DCtq.unstable_NormalPriority, $b778ec20f9ee6541$var$LowPriority = $7DCtq.unstable_LowPriority, $b778ec20f9ee6541$var$IdlePriority = $7DCtq.unstable_IdlePriority, $b778ec20f9ee6541$var$log$1 = $7DCtq.log, $b778ec20f9ee6541$var$unstable_setDisableYieldValue = $7DCtq.unstable_setDisableYieldValue, $b778ec20f9ee6541$var$rendererID = null, $b778ec20f9ee6541$var$injectedHook = null;
function $b778ec20f9ee6541$var$onCommitRoot(root) {
    if ($b778ec20f9ee6541$var$injectedHook && "function" === typeof $b778ec20f9ee6541$var$injectedHook.onCommitFiberRoot) try {
        $b778ec20f9ee6541$var$injectedHook.onCommitFiberRoot($b778ec20f9ee6541$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $b778ec20f9ee6541$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b778ec20f9ee6541$var$log$1 && $b778ec20f9ee6541$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b778ec20f9ee6541$var$injectedHook && "function" === typeof $b778ec20f9ee6541$var$injectedHook.setStrictMode) try {
        $b778ec20f9ee6541$var$injectedHook.setStrictMode($b778ec20f9ee6541$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b778ec20f9ee6541$var$clz32 = Math.clz32 ? Math.clz32 : $b778ec20f9ee6541$var$clz32Fallback, $b778ec20f9ee6541$var$log = Math.log, $b778ec20f9ee6541$var$LN2 = Math.LN2;
function $b778ec20f9ee6541$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b778ec20f9ee6541$var$log(x) / $b778ec20f9ee6541$var$LN2 | 0) | 0;
}
var $b778ec20f9ee6541$var$nextTransitionLane = 128, $b778ec20f9ee6541$var$nextRetryLane = 4194304;
function $b778ec20f9ee6541$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b778ec20f9ee6541$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b778ec20f9ee6541$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b778ec20f9ee6541$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $b778ec20f9ee6541$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b778ec20f9ee6541$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b778ec20f9ee6541$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $b778ec20f9ee6541$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $b778ec20f9ee6541$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b778ec20f9ee6541$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b778ec20f9ee6541$var$claimNextTransitionLane() {
    var lane = $b778ec20f9ee6541$var$nextTransitionLane;
    $b778ec20f9ee6541$var$nextTransitionLane <<= 1;
    0 === ($b778ec20f9ee6541$var$nextTransitionLane & 4194176) && ($b778ec20f9ee6541$var$nextTransitionLane = 128);
    return lane;
}
function $b778ec20f9ee6541$var$claimNextRetryLane() {
    var lane = $b778ec20f9ee6541$var$nextRetryLane;
    $b778ec20f9ee6541$var$nextRetryLane <<= 1;
    0 === ($b778ec20f9ee6541$var$nextRetryLane & 62914560) && ($b778ec20f9ee6541$var$nextRetryLane = 4194304);
    return lane;
}
function $b778ec20f9ee6541$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b778ec20f9ee6541$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b778ec20f9ee6541$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $b778ec20f9ee6541$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b778ec20f9ee6541$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b778ec20f9ee6541$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b778ec20f9ee6541$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $b778ec20f9ee6541$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $b778ec20f9ee6541$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b778ec20f9ee6541$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b778ec20f9ee6541$var$resolveUpdatePriority() {
    var updatePriority = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b778ec20f9ee6541$var$getEventPriority(updatePriority.type);
}
function $b778ec20f9ee6541$var$runWithPriority(priority, fn) {
    var previousPriority = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p;
    try {
        return $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b778ec20f9ee6541$var$randomKey = Math.random().toString(36).slice(2), $b778ec20f9ee6541$var$internalInstanceKey = "__reactFiber$" + $b778ec20f9ee6541$var$randomKey, $b778ec20f9ee6541$var$internalPropsKey = "__reactProps$" + $b778ec20f9ee6541$var$randomKey, $b778ec20f9ee6541$var$internalContainerInstanceKey = "__reactContainer$" + $b778ec20f9ee6541$var$randomKey, $b778ec20f9ee6541$var$internalEventHandlersKey = "__reactEvents$" + $b778ec20f9ee6541$var$randomKey, $b778ec20f9ee6541$var$internalEventHandlerListenersKey = "__reactListeners$" + $b778ec20f9ee6541$var$randomKey, $b778ec20f9ee6541$var$internalEventHandlesSetKey = "__reactHandles$" + $b778ec20f9ee6541$var$randomKey, $b778ec20f9ee6541$var$internalRootNodeResourcesKey = "__reactResources$" + $b778ec20f9ee6541$var$randomKey, $b778ec20f9ee6541$var$internalHoistableMarker = "__reactMarker$" + $b778ec20f9ee6541$var$randomKey;
function $b778ec20f9ee6541$var$detachDeletedInstance(node) {
    delete node[$b778ec20f9ee6541$var$internalInstanceKey];
    delete node[$b778ec20f9ee6541$var$internalPropsKey];
    delete node[$b778ec20f9ee6541$var$internalEventHandlersKey];
    delete node[$b778ec20f9ee6541$var$internalEventHandlerListenersKey];
    delete node[$b778ec20f9ee6541$var$internalEventHandlesSetKey];
}
function $b778ec20f9ee6541$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b778ec20f9ee6541$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b778ec20f9ee6541$var$internalContainerInstanceKey] || parentNode[$b778ec20f9ee6541$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b778ec20f9ee6541$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b778ec20f9ee6541$var$internalInstanceKey]) return parentNode;
                targetNode = $b778ec20f9ee6541$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b778ec20f9ee6541$var$getInstanceFromNode(node) {
    if (node = node[$b778ec20f9ee6541$var$internalInstanceKey] || node[$b778ec20f9ee6541$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b778ec20f9ee6541$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(33));
}
function $b778ec20f9ee6541$var$getResourcesFromRoot(root) {
    var resources = root[$b778ec20f9ee6541$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b778ec20f9ee6541$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b778ec20f9ee6541$var$markNodeAsHoistable(node) {
    node[$b778ec20f9ee6541$var$internalHoistableMarker] = !0;
}
var $b778ec20f9ee6541$var$allNativeEvents = new Set(), $b778ec20f9ee6541$var$registrationNameDependencies = {};
function $b778ec20f9ee6541$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b778ec20f9ee6541$var$registerDirectEvent(registrationName, dependencies);
    $b778ec20f9ee6541$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b778ec20f9ee6541$var$registerDirectEvent(registrationName, dependencies) {
    $b778ec20f9ee6541$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b778ec20f9ee6541$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b778ec20f9ee6541$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b778ec20f9ee6541$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b778ec20f9ee6541$var$illegalAttributeNameCache = {}, $b778ec20f9ee6541$var$validatedAttributeNameCache = {};
function $b778ec20f9ee6541$var$isAttributeNameSafe(attributeName) {
    if ($b778ec20f9ee6541$var$hasOwnProperty.call($b778ec20f9ee6541$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b778ec20f9ee6541$var$hasOwnProperty.call($b778ec20f9ee6541$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b778ec20f9ee6541$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b778ec20f9ee6541$var$validatedAttributeNameCache[attributeName] = !0;
    $b778ec20f9ee6541$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b778ec20f9ee6541$var$setValueForAttribute(node, name, value) {
    if ($b778ec20f9ee6541$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b778ec20f9ee6541$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b778ec20f9ee6541$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $b778ec20f9ee6541$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b778ec20f9ee6541$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b778ec20f9ee6541$var$trackValueOnNode(node) {
    var valueField = $b778ec20f9ee6541$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b778ec20f9ee6541$var$track(node) {
    node._valueTracker || (node._valueTracker = $b778ec20f9ee6541$var$trackValueOnNode(node));
}
function $b778ec20f9ee6541$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b778ec20f9ee6541$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b778ec20f9ee6541$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b778ec20f9ee6541$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b778ec20f9ee6541$var$getToStringValue(value);
        } else element.value !== "" + $b778ec20f9ee6541$var$getToStringValue(value) && (element.value = "" + $b778ec20f9ee6541$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b778ec20f9ee6541$var$setDefaultValue(element, type, $b778ec20f9ee6541$var$getToStringValue(value)) : null != defaultValue ? $b778ec20f9ee6541$var$setDefaultValue(element, type, $b778ec20f9ee6541$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b778ec20f9ee6541$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b778ec20f9ee6541$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $b778ec20f9ee6541$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b778ec20f9ee6541$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $b778ec20f9ee6541$var$setDefaultValue(node, type, value) {
    "number" === type && $b778ec20f9ee6541$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b778ec20f9ee6541$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b778ec20f9ee6541$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b778ec20f9ee6541$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b778ec20f9ee6541$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b778ec20f9ee6541$var$getToStringValue(defaultValue) : "";
}
function $b778ec20f9ee6541$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(92));
            if ($b778ec20f9ee6541$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b778ec20f9ee6541$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $b778ec20f9ee6541$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b778ec20f9ee6541$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b778ec20f9ee6541$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b778ec20f9ee6541$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b778ec20f9ee6541$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b778ec20f9ee6541$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b778ec20f9ee6541$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b778ec20f9ee6541$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b778ec20f9ee6541$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b778ec20f9ee6541$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b778ec20f9ee6541$var$sanitizeURL(url) {
    return $b778ec20f9ee6541$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $b778ec20f9ee6541$var$currentReplayingEvent = null;
function $b778ec20f9ee6541$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b778ec20f9ee6541$var$restoreTarget = null, $b778ec20f9ee6541$var$restoreQueue = null;
function $b778ec20f9ee6541$var$restoreStateOfTarget(target) {
    var internalInstance = $b778ec20f9ee6541$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b778ec20f9ee6541$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b778ec20f9ee6541$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b778ec20f9ee6541$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(90));
                            $b778ec20f9ee6541$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b778ec20f9ee6541$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b778ec20f9ee6541$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b778ec20f9ee6541$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b778ec20f9ee6541$var$isInsideEventHandler = !1;
function $b778ec20f9ee6541$var$batchedUpdates$1(fn, a, b) {
    if ($b778ec20f9ee6541$var$isInsideEventHandler) return fn(a, b);
    $b778ec20f9ee6541$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b778ec20f9ee6541$var$isInsideEventHandler = !1, null !== $b778ec20f9ee6541$var$restoreTarget || null !== $b778ec20f9ee6541$var$restoreQueue) {
            if ($b778ec20f9ee6541$var$flushSyncWork$1(), $b778ec20f9ee6541$var$restoreTarget && (a = $b778ec20f9ee6541$var$restoreTarget, fn = $b778ec20f9ee6541$var$restoreQueue, $b778ec20f9ee6541$var$restoreQueue = $b778ec20f9ee6541$var$restoreTarget = null, $b778ec20f9ee6541$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b778ec20f9ee6541$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b778ec20f9ee6541$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b778ec20f9ee6541$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b778ec20f9ee6541$var$passiveBrowserEventsSupported = !1;
if ($b778ec20f9ee6541$var$canUseDOM) try {
    var $b778ec20f9ee6541$var$options = {};
    Object.defineProperty($b778ec20f9ee6541$var$options, "passive", {
        get: function() {
            $b778ec20f9ee6541$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b778ec20f9ee6541$var$options, $b778ec20f9ee6541$var$options);
    window.removeEventListener("test", $b778ec20f9ee6541$var$options, $b778ec20f9ee6541$var$options);
} catch (e) {
    $b778ec20f9ee6541$var$passiveBrowserEventsSupported = !1;
}
var $b778ec20f9ee6541$var$root = null, $b778ec20f9ee6541$var$startText = null, $b778ec20f9ee6541$var$fallbackText = null;
function $b778ec20f9ee6541$var$getData() {
    if ($b778ec20f9ee6541$var$fallbackText) return $b778ec20f9ee6541$var$fallbackText;
    var start, startValue = $b778ec20f9ee6541$var$startText, startLength = startValue.length, end, endValue = "value" in $b778ec20f9ee6541$var$root ? $b778ec20f9ee6541$var$root.value : $b778ec20f9ee6541$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b778ec20f9ee6541$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b778ec20f9ee6541$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b778ec20f9ee6541$var$functionThatReturnsTrue() {
    return !0;
}
function $b778ec20f9ee6541$var$functionThatReturnsFalse() {
    return !1;
}
function $b778ec20f9ee6541$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b778ec20f9ee6541$var$functionThatReturnsTrue : $b778ec20f9ee6541$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b778ec20f9ee6541$var$functionThatReturnsFalse;
        return this;
    }
    $b778ec20f9ee6541$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b778ec20f9ee6541$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b778ec20f9ee6541$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b778ec20f9ee6541$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b778ec20f9ee6541$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b778ec20f9ee6541$var$SyntheticEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$EventInterface), $b778ec20f9ee6541$var$UIEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$EventInterface, {
    view: 0,
    detail: 0
}), $b778ec20f9ee6541$var$SyntheticUIEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$UIEventInterface), $b778ec20f9ee6541$var$lastMovementX, $b778ec20f9ee6541$var$lastMovementY, $b778ec20f9ee6541$var$lastMouseEvent, $b778ec20f9ee6541$var$MouseEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b778ec20f9ee6541$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b778ec20f9ee6541$var$lastMouseEvent && ($b778ec20f9ee6541$var$lastMouseEvent && "mousemove" === event.type ? ($b778ec20f9ee6541$var$lastMovementX = event.screenX - $b778ec20f9ee6541$var$lastMouseEvent.screenX, $b778ec20f9ee6541$var$lastMovementY = event.screenY - $b778ec20f9ee6541$var$lastMouseEvent.screenY) : $b778ec20f9ee6541$var$lastMovementY = $b778ec20f9ee6541$var$lastMovementX = 0, $b778ec20f9ee6541$var$lastMouseEvent = event);
        return $b778ec20f9ee6541$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b778ec20f9ee6541$var$lastMovementY;
    }
}), $b778ec20f9ee6541$var$SyntheticMouseEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$MouseEventInterface), $b778ec20f9ee6541$var$DragEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$MouseEventInterface, {
    dataTransfer: 0
}), $b778ec20f9ee6541$var$SyntheticDragEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$DragEventInterface), $b778ec20f9ee6541$var$FocusEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$UIEventInterface, {
    relatedTarget: 0
}), $b778ec20f9ee6541$var$SyntheticFocusEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$FocusEventInterface), $b778ec20f9ee6541$var$AnimationEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b778ec20f9ee6541$var$SyntheticAnimationEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$AnimationEventInterface), $b778ec20f9ee6541$var$ClipboardEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b778ec20f9ee6541$var$SyntheticClipboardEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$ClipboardEventInterface), $b778ec20f9ee6541$var$CompositionEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$EventInterface, {
    data: 0
}), $b778ec20f9ee6541$var$SyntheticCompositionEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$CompositionEventInterface), $b778ec20f9ee6541$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b778ec20f9ee6541$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b778ec20f9ee6541$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b778ec20f9ee6541$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b778ec20f9ee6541$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b778ec20f9ee6541$var$getEventModifierState() {
    return $b778ec20f9ee6541$var$modifierStateGetter;
}
var $b778ec20f9ee6541$var$KeyboardEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b778ec20f9ee6541$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b778ec20f9ee6541$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b778ec20f9ee6541$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b778ec20f9ee6541$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b778ec20f9ee6541$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b778ec20f9ee6541$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b778ec20f9ee6541$var$SyntheticKeyboardEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$KeyboardEventInterface), $b778ec20f9ee6541$var$PointerEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b778ec20f9ee6541$var$SyntheticPointerEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$PointerEventInterface), $b778ec20f9ee6541$var$TouchEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b778ec20f9ee6541$var$getEventModifierState
}), $b778ec20f9ee6541$var$SyntheticTouchEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$TouchEventInterface), $b778ec20f9ee6541$var$TransitionEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b778ec20f9ee6541$var$SyntheticTransitionEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$TransitionEventInterface), $b778ec20f9ee6541$var$WheelEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b778ec20f9ee6541$var$SyntheticWheelEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$WheelEventInterface), $b778ec20f9ee6541$var$ToggleEventInterface = $b778ec20f9ee6541$var$assign({}, $b778ec20f9ee6541$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b778ec20f9ee6541$var$SyntheticToggleEvent = $b778ec20f9ee6541$var$createSyntheticEvent($b778ec20f9ee6541$var$ToggleEventInterface), $b778ec20f9ee6541$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b778ec20f9ee6541$var$canUseCompositionEvent = $b778ec20f9ee6541$var$canUseDOM && "CompositionEvent" in window, $b778ec20f9ee6541$var$documentMode = null;
$b778ec20f9ee6541$var$canUseDOM && "documentMode" in document && ($b778ec20f9ee6541$var$documentMode = document.documentMode);
var $b778ec20f9ee6541$var$canUseTextInputEvent = $b778ec20f9ee6541$var$canUseDOM && "TextEvent" in window && !$b778ec20f9ee6541$var$documentMode, $b778ec20f9ee6541$var$useFallbackCompositionData = $b778ec20f9ee6541$var$canUseDOM && (!$b778ec20f9ee6541$var$canUseCompositionEvent || $b778ec20f9ee6541$var$documentMode && 8 < $b778ec20f9ee6541$var$documentMode && 11 >= $b778ec20f9ee6541$var$documentMode), $b778ec20f9ee6541$var$SPACEBAR_CHAR = String.fromCharCode(32), $b778ec20f9ee6541$var$hasSpaceKeypress = !1;
function $b778ec20f9ee6541$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b778ec20f9ee6541$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b778ec20f9ee6541$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b778ec20f9ee6541$var$isComposing = !1;
function $b778ec20f9ee6541$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b778ec20f9ee6541$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b778ec20f9ee6541$var$hasSpaceKeypress = !0;
            return $b778ec20f9ee6541$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b778ec20f9ee6541$var$SPACEBAR_CHAR && $b778ec20f9ee6541$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b778ec20f9ee6541$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b778ec20f9ee6541$var$isComposing) return "compositionend" === domEventName || !$b778ec20f9ee6541$var$canUseCompositionEvent && $b778ec20f9ee6541$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b778ec20f9ee6541$var$getData(), $b778ec20f9ee6541$var$fallbackText = $b778ec20f9ee6541$var$startText = $b778ec20f9ee6541$var$root = null, $b778ec20f9ee6541$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b778ec20f9ee6541$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b778ec20f9ee6541$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b778ec20f9ee6541$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b778ec20f9ee6541$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b778ec20f9ee6541$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b778ec20f9ee6541$var$restoreTarget ? $b778ec20f9ee6541$var$restoreQueue ? $b778ec20f9ee6541$var$restoreQueue.push(target) : $b778ec20f9ee6541$var$restoreQueue = [
        target
    ] : $b778ec20f9ee6541$var$restoreTarget = target;
    inst = $b778ec20f9ee6541$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b778ec20f9ee6541$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b778ec20f9ee6541$var$activeElement$1 = null, $b778ec20f9ee6541$var$activeElementInst$1 = null;
function $b778ec20f9ee6541$var$runEventInBatch(dispatchQueue) {
    $b778ec20f9ee6541$var$processDispatchQueue(dispatchQueue, 0);
}
function $b778ec20f9ee6541$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b778ec20f9ee6541$var$getNodeFromInstance(targetInst);
    if ($b778ec20f9ee6541$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b778ec20f9ee6541$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b778ec20f9ee6541$var$isInputEventSupported = !1;
if ($b778ec20f9ee6541$var$canUseDOM) {
    var $b778ec20f9ee6541$var$JSCompiler_inline_result$jscomp$283;
    if ($b778ec20f9ee6541$var$canUseDOM) {
        var $b778ec20f9ee6541$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$b778ec20f9ee6541$var$isSupported$jscomp$inline_418) {
            var $b778ec20f9ee6541$var$element$jscomp$inline_419 = document.createElement("div");
            $b778ec20f9ee6541$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $b778ec20f9ee6541$var$isSupported$jscomp$inline_418 = "function" === typeof $b778ec20f9ee6541$var$element$jscomp$inline_419.oninput;
        }
        $b778ec20f9ee6541$var$JSCompiler_inline_result$jscomp$283 = $b778ec20f9ee6541$var$isSupported$jscomp$inline_418;
    } else $b778ec20f9ee6541$var$JSCompiler_inline_result$jscomp$283 = !1;
    $b778ec20f9ee6541$var$isInputEventSupported = $b778ec20f9ee6541$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $b778ec20f9ee6541$var$stopWatchingForValueChange() {
    $b778ec20f9ee6541$var$activeElement$1 && ($b778ec20f9ee6541$var$activeElement$1.detachEvent("onpropertychange", $b778ec20f9ee6541$var$handlePropertyChange), $b778ec20f9ee6541$var$activeElementInst$1 = $b778ec20f9ee6541$var$activeElement$1 = null);
}
function $b778ec20f9ee6541$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b778ec20f9ee6541$var$getInstIfValueChanged($b778ec20f9ee6541$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b778ec20f9ee6541$var$createAndAccumulateChangeEvent(dispatchQueue, $b778ec20f9ee6541$var$activeElementInst$1, nativeEvent, $b778ec20f9ee6541$var$getEventTarget(nativeEvent));
        $b778ec20f9ee6541$var$batchedUpdates$1($b778ec20f9ee6541$var$runEventInBatch, dispatchQueue);
    }
}
function $b778ec20f9ee6541$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b778ec20f9ee6541$var$stopWatchingForValueChange(), $b778ec20f9ee6541$var$activeElement$1 = target, $b778ec20f9ee6541$var$activeElementInst$1 = targetInst, $b778ec20f9ee6541$var$activeElement$1.attachEvent("onpropertychange", $b778ec20f9ee6541$var$handlePropertyChange)) : "focusout" === domEventName && $b778ec20f9ee6541$var$stopWatchingForValueChange();
}
function $b778ec20f9ee6541$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b778ec20f9ee6541$var$getInstIfValueChanged($b778ec20f9ee6541$var$activeElementInst$1);
}
function $b778ec20f9ee6541$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b778ec20f9ee6541$var$getInstIfValueChanged(targetInst);
}
function $b778ec20f9ee6541$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b778ec20f9ee6541$var$getInstIfValueChanged(targetInst);
}
function $b778ec20f9ee6541$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b778ec20f9ee6541$var$objectIs = "function" === typeof Object.is ? Object.is : $b778ec20f9ee6541$var$is;
function $b778ec20f9ee6541$var$shallowEqual(objA, objB) {
    if ($b778ec20f9ee6541$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b778ec20f9ee6541$var$hasOwnProperty.call(objB, currentKey) || !$b778ec20f9ee6541$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b778ec20f9ee6541$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b778ec20f9ee6541$var$getNodeForCharacterOffset(root, offset) {
    var node = $b778ec20f9ee6541$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b778ec20f9ee6541$var$getLeafNode(node);
    }
}
function $b778ec20f9ee6541$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b778ec20f9ee6541$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b778ec20f9ee6541$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b778ec20f9ee6541$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b778ec20f9ee6541$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b778ec20f9ee6541$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $b778ec20f9ee6541$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $b778ec20f9ee6541$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $b778ec20f9ee6541$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $b778ec20f9ee6541$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $b778ec20f9ee6541$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $b778ec20f9ee6541$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $b778ec20f9ee6541$var$skipSelectionChangeEvent = $b778ec20f9ee6541$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b778ec20f9ee6541$var$activeElement = null, $b778ec20f9ee6541$var$activeElementInst = null, $b778ec20f9ee6541$var$lastSelection = null, $b778ec20f9ee6541$var$mouseDown = !1;
function $b778ec20f9ee6541$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b778ec20f9ee6541$var$mouseDown || null == $b778ec20f9ee6541$var$activeElement || $b778ec20f9ee6541$var$activeElement !== $b778ec20f9ee6541$var$getActiveElement(doc) || (doc = $b778ec20f9ee6541$var$activeElement, "selectionStart" in doc && $b778ec20f9ee6541$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b778ec20f9ee6541$var$lastSelection && $b778ec20f9ee6541$var$shallowEqual($b778ec20f9ee6541$var$lastSelection, doc) || ($b778ec20f9ee6541$var$lastSelection = doc, doc = $b778ec20f9ee6541$var$accumulateTwoPhaseListeners($b778ec20f9ee6541$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b778ec20f9ee6541$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b778ec20f9ee6541$var$activeElement)));
}
function $b778ec20f9ee6541$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b778ec20f9ee6541$var$vendorPrefixes = {
    animationend: $b778ec20f9ee6541$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b778ec20f9ee6541$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b778ec20f9ee6541$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b778ec20f9ee6541$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b778ec20f9ee6541$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b778ec20f9ee6541$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b778ec20f9ee6541$var$makePrefixMap("Transition", "TransitionEnd")
}, $b778ec20f9ee6541$var$prefixedEventNames = {}, $b778ec20f9ee6541$var$style = {};
$b778ec20f9ee6541$var$canUseDOM && ($b778ec20f9ee6541$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b778ec20f9ee6541$var$vendorPrefixes.animationend.animation, delete $b778ec20f9ee6541$var$vendorPrefixes.animationiteration.animation, delete $b778ec20f9ee6541$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b778ec20f9ee6541$var$vendorPrefixes.transitionend.transition);
function $b778ec20f9ee6541$var$getVendorPrefixedEventName(eventName) {
    if ($b778ec20f9ee6541$var$prefixedEventNames[eventName]) return $b778ec20f9ee6541$var$prefixedEventNames[eventName];
    if (!$b778ec20f9ee6541$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b778ec20f9ee6541$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b778ec20f9ee6541$var$style) return $b778ec20f9ee6541$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b778ec20f9ee6541$var$ANIMATION_END = $b778ec20f9ee6541$var$getVendorPrefixedEventName("animationend"), $b778ec20f9ee6541$var$ANIMATION_ITERATION = $b778ec20f9ee6541$var$getVendorPrefixedEventName("animationiteration"), $b778ec20f9ee6541$var$ANIMATION_START = $b778ec20f9ee6541$var$getVendorPrefixedEventName("animationstart"), $b778ec20f9ee6541$var$TRANSITION_RUN = $b778ec20f9ee6541$var$getVendorPrefixedEventName("transitionrun"), $b778ec20f9ee6541$var$TRANSITION_START = $b778ec20f9ee6541$var$getVendorPrefixedEventName("transitionstart"), $b778ec20f9ee6541$var$TRANSITION_CANCEL = $b778ec20f9ee6541$var$getVendorPrefixedEventName("transitioncancel"), $b778ec20f9ee6541$var$TRANSITION_END = $b778ec20f9ee6541$var$getVendorPrefixedEventName("transitionend"), $b778ec20f9ee6541$var$topLevelEventsToReactNames = new Map(), $b778ec20f9ee6541$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $b778ec20f9ee6541$var$registerSimpleEvent(domEventName, reactName) {
    $b778ec20f9ee6541$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b778ec20f9ee6541$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b778ec20f9ee6541$var$concurrentQueues = [], $b778ec20f9ee6541$var$concurrentQueuesIndex = 0, $b778ec20f9ee6541$var$concurrentlyUpdatedLanes = 0;
function $b778ec20f9ee6541$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b778ec20f9ee6541$var$concurrentQueuesIndex, i = $b778ec20f9ee6541$var$concurrentlyUpdatedLanes = $b778ec20f9ee6541$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b778ec20f9ee6541$var$concurrentQueues[i];
        $b778ec20f9ee6541$var$concurrentQueues[i++] = null;
        var queue = $b778ec20f9ee6541$var$concurrentQueues[i];
        $b778ec20f9ee6541$var$concurrentQueues[i++] = null;
        var update = $b778ec20f9ee6541$var$concurrentQueues[i];
        $b778ec20f9ee6541$var$concurrentQueues[i++] = null;
        var lane = $b778ec20f9ee6541$var$concurrentQueues[i];
        $b778ec20f9ee6541$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b778ec20f9ee6541$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b778ec20f9ee6541$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b778ec20f9ee6541$var$concurrentQueues[$b778ec20f9ee6541$var$concurrentQueuesIndex++] = fiber;
    $b778ec20f9ee6541$var$concurrentQueues[$b778ec20f9ee6541$var$concurrentQueuesIndex++] = queue;
    $b778ec20f9ee6541$var$concurrentQueues[$b778ec20f9ee6541$var$concurrentQueuesIndex++] = update;
    $b778ec20f9ee6541$var$concurrentQueues[$b778ec20f9ee6541$var$concurrentQueuesIndex++] = lane;
    $b778ec20f9ee6541$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b778ec20f9ee6541$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b778ec20f9ee6541$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b778ec20f9ee6541$var$getRootForUpdatedFiber(fiber);
}
function $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b778ec20f9ee6541$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b778ec20f9ee6541$var$getRootForUpdatedFiber(fiber);
}
function $b778ec20f9ee6541$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $b778ec20f9ee6541$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $b778ec20f9ee6541$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b778ec20f9ee6541$var$nestedUpdateCount) throw $b778ec20f9ee6541$var$nestedUpdateCount = 0, $b778ec20f9ee6541$var$rootWithNestedUpdates = null, Error($b778ec20f9ee6541$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b778ec20f9ee6541$var$emptyContextObject = {}, $b778ec20f9ee6541$var$CapturedStacks = new WeakMap();
function $b778ec20f9ee6541$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b778ec20f9ee6541$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b778ec20f9ee6541$var$getStackByFiberInDevAndProd(source)
        };
        $b778ec20f9ee6541$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b778ec20f9ee6541$var$getStackByFiberInDevAndProd(source)
    };
}
var $b778ec20f9ee6541$var$forkStack = [], $b778ec20f9ee6541$var$forkStackIndex = 0, $b778ec20f9ee6541$var$treeForkProvider = null, $b778ec20f9ee6541$var$treeForkCount = 0, $b778ec20f9ee6541$var$idStack = [], $b778ec20f9ee6541$var$idStackIndex = 0, $b778ec20f9ee6541$var$treeContextProvider = null, $b778ec20f9ee6541$var$treeContextId = 1, $b778ec20f9ee6541$var$treeContextOverflow = "";
function $b778ec20f9ee6541$var$pushTreeFork(workInProgress, totalChildren) {
    $b778ec20f9ee6541$var$forkStack[$b778ec20f9ee6541$var$forkStackIndex++] = $b778ec20f9ee6541$var$treeForkCount;
    $b778ec20f9ee6541$var$forkStack[$b778ec20f9ee6541$var$forkStackIndex++] = $b778ec20f9ee6541$var$treeForkProvider;
    $b778ec20f9ee6541$var$treeForkProvider = workInProgress;
    $b778ec20f9ee6541$var$treeForkCount = totalChildren;
}
function $b778ec20f9ee6541$var$pushTreeId(workInProgress, totalChildren, index) {
    $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex++] = $b778ec20f9ee6541$var$treeContextId;
    $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex++] = $b778ec20f9ee6541$var$treeContextOverflow;
    $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex++] = $b778ec20f9ee6541$var$treeContextProvider;
    $b778ec20f9ee6541$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b778ec20f9ee6541$var$treeContextId;
    workInProgress = $b778ec20f9ee6541$var$treeContextOverflow;
    var baseLength = 32 - $b778ec20f9ee6541$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b778ec20f9ee6541$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b778ec20f9ee6541$var$treeContextId = 1 << 32 - $b778ec20f9ee6541$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b778ec20f9ee6541$var$treeContextOverflow = length + workInProgress;
    } else $b778ec20f9ee6541$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b778ec20f9ee6541$var$treeContextOverflow = workInProgress;
}
function $b778ec20f9ee6541$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b778ec20f9ee6541$var$pushTreeFork(workInProgress, 1), $b778ec20f9ee6541$var$pushTreeId(workInProgress, 1, 0));
}
function $b778ec20f9ee6541$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b778ec20f9ee6541$var$treeForkProvider;)$b778ec20f9ee6541$var$treeForkProvider = $b778ec20f9ee6541$var$forkStack[--$b778ec20f9ee6541$var$forkStackIndex], $b778ec20f9ee6541$var$forkStack[$b778ec20f9ee6541$var$forkStackIndex] = null, $b778ec20f9ee6541$var$treeForkCount = $b778ec20f9ee6541$var$forkStack[--$b778ec20f9ee6541$var$forkStackIndex], $b778ec20f9ee6541$var$forkStack[$b778ec20f9ee6541$var$forkStackIndex] = null;
    for(; workInProgress === $b778ec20f9ee6541$var$treeContextProvider;)$b778ec20f9ee6541$var$treeContextProvider = $b778ec20f9ee6541$var$idStack[--$b778ec20f9ee6541$var$idStackIndex], $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex] = null, $b778ec20f9ee6541$var$treeContextOverflow = $b778ec20f9ee6541$var$idStack[--$b778ec20f9ee6541$var$idStackIndex], $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex] = null, $b778ec20f9ee6541$var$treeContextId = $b778ec20f9ee6541$var$idStack[--$b778ec20f9ee6541$var$idStackIndex], $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex] = null;
}
var $b778ec20f9ee6541$var$hydrationParentFiber = null, $b778ec20f9ee6541$var$nextHydratableInstance = null, $b778ec20f9ee6541$var$isHydrating = !1, $b778ec20f9ee6541$var$hydrationErrors = null, $b778ec20f9ee6541$var$rootOrSingletonContext = !1, $b778ec20f9ee6541$var$HydrationMismatchException = Error($b778ec20f9ee6541$var$formatProdErrorMessage(519));
function $b778ec20f9ee6541$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b778ec20f9ee6541$var$formatProdErrorMessage(418, ""));
    $b778ec20f9ee6541$var$queueHydrationError($b778ec20f9ee6541$var$createCapturedValueAtFiber(error, fiber));
    throw $b778ec20f9ee6541$var$HydrationMismatchException;
}
function $b778ec20f9ee6541$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b778ec20f9ee6541$var$internalInstanceKey] = fiber;
    instance[$b778ec20f9ee6541$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("cancel", instance);
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b778ec20f9ee6541$var$mediaEventTypes.length; type++)$b778ec20f9ee6541$var$listenToNonDelegatedEvent($b778ec20f9ee6541$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("error", instance);
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("invalid", instance);
            $b778ec20f9ee6541$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $b778ec20f9ee6541$var$track(instance);
            break;
        case "select":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("invalid", instance), $b778ec20f9ee6541$var$initTextarea(instance, props.value, props.defaultValue, props.children), $b778ec20f9ee6541$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b778ec20f9ee6541$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b778ec20f9ee6541$var$listenToNonDelegatedEvent("beforetoggle", instance), $b778ec20f9ee6541$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b778ec20f9ee6541$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b778ec20f9ee6541$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b778ec20f9ee6541$var$noop$1), instance = !0) : instance = !1;
    instance || $b778ec20f9ee6541$var$throwOnHydrationMismatch(fiber);
}
function $b778ec20f9ee6541$var$popToNextHostParent(fiber) {
    for($b778ec20f9ee6541$var$hydrationParentFiber = fiber.return; $b778ec20f9ee6541$var$hydrationParentFiber;)switch($b778ec20f9ee6541$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $b778ec20f9ee6541$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $b778ec20f9ee6541$var$rootOrSingletonContext = !1;
            return;
        default:
            $b778ec20f9ee6541$var$hydrationParentFiber = $b778ec20f9ee6541$var$hydrationParentFiber.return;
    }
}
function $b778ec20f9ee6541$var$popHydrationState(fiber) {
    if (fiber !== $b778ec20f9ee6541$var$hydrationParentFiber) return !1;
    if (!$b778ec20f9ee6541$var$isHydrating) return $b778ec20f9ee6541$var$popToNextHostParent(fiber), $b778ec20f9ee6541$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b778ec20f9ee6541$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $b778ec20f9ee6541$var$nextHydratableInstance && $b778ec20f9ee6541$var$throwOnHydrationMismatch(fiber);
    $b778ec20f9ee6541$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $b778ec20f9ee6541$var$nextHydratableInstance = null;
        }
    } else $b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$hydrationParentFiber ? $b778ec20f9ee6541$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b778ec20f9ee6541$var$resetHydrationState() {
    $b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$hydrationParentFiber = null;
    $b778ec20f9ee6541$var$isHydrating = !1;
}
function $b778ec20f9ee6541$var$queueHydrationError(error) {
    null === $b778ec20f9ee6541$var$hydrationErrors ? $b778ec20f9ee6541$var$hydrationErrors = [
        error
    ] : $b778ec20f9ee6541$var$hydrationErrors.push(error);
}
var $b778ec20f9ee6541$var$SuspenseException = Error($b778ec20f9ee6541$var$formatProdErrorMessage(460)), $b778ec20f9ee6541$var$SuspenseyCommitException = Error($b778ec20f9ee6541$var$formatProdErrorMessage(474)), $b778ec20f9ee6541$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b778ec20f9ee6541$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b778ec20f9ee6541$var$noop$3() {}
function $b778ec20f9ee6541$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b778ec20f9ee6541$var$noop$3, $b778ec20f9ee6541$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $b778ec20f9ee6541$var$SuspenseException) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b778ec20f9ee6541$var$noop$3, $b778ec20f9ee6541$var$noop$3);
            else {
                thenableState = $b778ec20f9ee6541$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $b778ec20f9ee6541$var$SuspenseException) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $b778ec20f9ee6541$var$suspendedThenable = thenable;
            throw $b778ec20f9ee6541$var$SuspenseException;
    }
}
var $b778ec20f9ee6541$var$suspendedThenable = null;
function $b778ec20f9ee6541$var$getSuspendedThenable() {
    if (null === $b778ec20f9ee6541$var$suspendedThenable) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(459));
    var thenable = $b778ec20f9ee6541$var$suspendedThenable;
    $b778ec20f9ee6541$var$suspendedThenable = null;
    return thenable;
}
var $b778ec20f9ee6541$var$thenableState$1 = null, $b778ec20f9ee6541$var$thenableIndexCounter$1 = 0;
function $b778ec20f9ee6541$var$unwrapThenable(thenable) {
    var index = $b778ec20f9ee6541$var$thenableIndexCounter$1;
    $b778ec20f9ee6541$var$thenableIndexCounter$1 += 1;
    null === $b778ec20f9ee6541$var$thenableState$1 && ($b778ec20f9ee6541$var$thenableState$1 = []);
    return $b778ec20f9ee6541$var$trackUsedThenable($b778ec20f9ee6541$var$thenableState$1, thenable, index);
}
function $b778ec20f9ee6541$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b778ec20f9ee6541$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $b778ec20f9ee6541$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b778ec20f9ee6541$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $b778ec20f9ee6541$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b778ec20f9ee6541$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b778ec20f9ee6541$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b778ec20f9ee6541$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b778ec20f9ee6541$var$REACT_LAZY_TYPE && $b778ec20f9ee6541$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b778ec20f9ee6541$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b778ec20f9ee6541$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b778ec20f9ee6541$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b778ec20f9ee6541$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b778ec20f9ee6541$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b778ec20f9ee6541$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b778ec20f9ee6541$var$REACT_ELEMENT_TYPE:
                    return lanes = $b778ec20f9ee6541$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b778ec20f9ee6541$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b778ec20f9ee6541$var$REACT_PORTAL_TYPE:
                    return newChild = $b778ec20f9ee6541$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b778ec20f9ee6541$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($b778ec20f9ee6541$var$isArrayImpl(newChild) || $b778ec20f9ee6541$var$getIteratorFn(newChild)) return newChild = $b778ec20f9ee6541$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b778ec20f9ee6541$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b778ec20f9ee6541$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b778ec20f9ee6541$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b778ec20f9ee6541$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b778ec20f9ee6541$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b778ec20f9ee6541$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b778ec20f9ee6541$var$isArrayImpl(newChild) || $b778ec20f9ee6541$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b778ec20f9ee6541$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b778ec20f9ee6541$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b778ec20f9ee6541$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b778ec20f9ee6541$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b778ec20f9ee6541$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b778ec20f9ee6541$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b778ec20f9ee6541$var$isArrayImpl(newChild) || $b778ec20f9ee6541$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b778ec20f9ee6541$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b778ec20f9ee6541$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b778ec20f9ee6541$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b778ec20f9ee6541$var$isHydrating && $b778ec20f9ee6541$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b778ec20f9ee6541$var$isHydrating && $b778ec20f9ee6541$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b778ec20f9ee6541$var$isHydrating && $b778ec20f9ee6541$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b778ec20f9ee6541$var$isHydrating && $b778ec20f9ee6541$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b778ec20f9ee6541$var$isHydrating && $b778ec20f9ee6541$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b778ec20f9ee6541$var$isHydrating && $b778ec20f9ee6541$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b778ec20f9ee6541$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b778ec20f9ee6541$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b778ec20f9ee6541$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b778ec20f9ee6541$var$REACT_LAZY_TYPE && $b778ec20f9ee6541$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b778ec20f9ee6541$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b778ec20f9ee6541$var$REACT_FRAGMENT_TYPE ? (lanes = $b778ec20f9ee6541$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b778ec20f9ee6541$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b778ec20f9ee6541$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b778ec20f9ee6541$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b778ec20f9ee6541$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b778ec20f9ee6541$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b778ec20f9ee6541$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b778ec20f9ee6541$var$getIteratorFn(newChild)) {
                key = $b778ec20f9ee6541$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b778ec20f9ee6541$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b778ec20f9ee6541$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b778ec20f9ee6541$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b778ec20f9ee6541$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b778ec20f9ee6541$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b778ec20f9ee6541$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b778ec20f9ee6541$var$SuspenseException) throw x;
            var fiber = $b778ec20f9ee6541$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b778ec20f9ee6541$var$reconcileChildFibers = $b778ec20f9ee6541$var$createChildReconciler(!0), $b778ec20f9ee6541$var$mountChildFibers = $b778ec20f9ee6541$var$createChildReconciler(!1), $b778ec20f9ee6541$var$currentTreeHiddenStackCursor = $b778ec20f9ee6541$var$createCursor(null), $b778ec20f9ee6541$var$prevEntangledRenderLanesCursor = $b778ec20f9ee6541$var$createCursor(0);
function $b778ec20f9ee6541$var$pushHiddenContext(fiber, context) {
    fiber = $b778ec20f9ee6541$var$entangledRenderLanes;
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$prevEntangledRenderLanesCursor, fiber);
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$currentTreeHiddenStackCursor, context);
    $b778ec20f9ee6541$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b778ec20f9ee6541$var$reuseHiddenContextOnStack() {
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$prevEntangledRenderLanesCursor, $b778ec20f9ee6541$var$entangledRenderLanes);
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$currentTreeHiddenStackCursor, $b778ec20f9ee6541$var$currentTreeHiddenStackCursor.current);
}
function $b778ec20f9ee6541$var$popHiddenContext() {
    $b778ec20f9ee6541$var$entangledRenderLanes = $b778ec20f9ee6541$var$prevEntangledRenderLanesCursor.current;
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$currentTreeHiddenStackCursor);
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$prevEntangledRenderLanesCursor);
}
var $b778ec20f9ee6541$var$suspenseHandlerStackCursor = $b778ec20f9ee6541$var$createCursor(null), $b778ec20f9ee6541$var$shellBoundary = null;
function $b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseStackCursor, $b778ec20f9ee6541$var$suspenseStackCursor.current & 1);
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseHandlerStackCursor, handler);
    null === $b778ec20f9ee6541$var$shellBoundary && (null === current || null !== $b778ec20f9ee6541$var$currentTreeHiddenStackCursor.current ? $b778ec20f9ee6541$var$shellBoundary = handler : null !== current.memoizedState && ($b778ec20f9ee6541$var$shellBoundary = handler));
}
function $b778ec20f9ee6541$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseStackCursor, $b778ec20f9ee6541$var$suspenseStackCursor.current), $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseHandlerStackCursor, fiber), null === $b778ec20f9ee6541$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($b778ec20f9ee6541$var$shellBoundary = fiber);
        }
    } else $b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack() {
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseStackCursor, $b778ec20f9ee6541$var$suspenseStackCursor.current);
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseHandlerStackCursor, $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current);
}
function $b778ec20f9ee6541$var$popSuspenseHandler(fiber) {
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$suspenseHandlerStackCursor);
    $b778ec20f9ee6541$var$shellBoundary === fiber && ($b778ec20f9ee6541$var$shellBoundary = null);
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$suspenseStackCursor);
}
var $b778ec20f9ee6541$var$suspenseStackCursor = $b778ec20f9ee6541$var$createCursor(0);
function $b778ec20f9ee6541$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $b778ec20f9ee6541$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b778ec20f9ee6541$var$scheduleCallback$2 = $7DCtq.unstable_scheduleCallback, $b778ec20f9ee6541$var$NormalPriority = $7DCtq.unstable_NormalPriority, $b778ec20f9ee6541$var$CacheContext = {
    $$typeof: $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b778ec20f9ee6541$var$createCache() {
    return {
        controller: new $b778ec20f9ee6541$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b778ec20f9ee6541$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b778ec20f9ee6541$var$scheduleCallback$2($b778ec20f9ee6541$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b778ec20f9ee6541$var$currentEntangledListeners = null, $b778ec20f9ee6541$var$currentEntangledPendingCount = 0, $b778ec20f9ee6541$var$currentEntangledLane = 0, $b778ec20f9ee6541$var$currentEntangledActionThenable = null;
function $b778ec20f9ee6541$var$entangleAsyncAction(transition, thenable) {
    if (null === $b778ec20f9ee6541$var$currentEntangledListeners) {
        var entangledListeners = $b778ec20f9ee6541$var$currentEntangledListeners = [];
        $b778ec20f9ee6541$var$currentEntangledPendingCount = 0;
        $b778ec20f9ee6541$var$currentEntangledLane = $b778ec20f9ee6541$var$requestTransitionLane();
        $b778ec20f9ee6541$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b778ec20f9ee6541$var$currentEntangledPendingCount++;
    thenable.then($b778ec20f9ee6541$var$pingEngtangledActionScope, $b778ec20f9ee6541$var$pingEngtangledActionScope);
    return thenable;
}
function $b778ec20f9ee6541$var$pingEngtangledActionScope() {
    if (0 === --$b778ec20f9ee6541$var$currentEntangledPendingCount && null !== $b778ec20f9ee6541$var$currentEntangledListeners) {
        null !== $b778ec20f9ee6541$var$currentEntangledActionThenable && ($b778ec20f9ee6541$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b778ec20f9ee6541$var$currentEntangledListeners;
        $b778ec20f9ee6541$var$currentEntangledListeners = null;
        $b778ec20f9ee6541$var$currentEntangledLane = 0;
        $b778ec20f9ee6541$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b778ec20f9ee6541$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b778ec20f9ee6541$var$prevOnStartTransitionFinish = $b778ec20f9ee6541$var$ReactSharedInternals.S;
$b778ec20f9ee6541$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b778ec20f9ee6541$var$entangleAsyncAction(transition, returnValue);
    null !== $b778ec20f9ee6541$var$prevOnStartTransitionFinish && $b778ec20f9ee6541$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b778ec20f9ee6541$var$resumedCache = $b778ec20f9ee6541$var$createCursor(null);
function $b778ec20f9ee6541$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b778ec20f9ee6541$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b778ec20f9ee6541$var$workInProgressRoot.pooledCache;
}
function $b778ec20f9ee6541$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$resumedCache, $b778ec20f9ee6541$var$resumedCache.current) : $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$resumedCache, prevCachePool.pool);
}
function $b778ec20f9ee6541$var$getSuspendedCache() {
    var cacheFromPool = $b778ec20f9ee6541$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b778ec20f9ee6541$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b778ec20f9ee6541$var$renderLanes = 0, $b778ec20f9ee6541$var$currentlyRenderingFiber$1 = null, $b778ec20f9ee6541$var$currentHook = null, $b778ec20f9ee6541$var$workInProgressHook = null, $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdate = !1, $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b778ec20f9ee6541$var$localIdCounter = 0, $b778ec20f9ee6541$var$thenableIndexCounter = 0, $b778ec20f9ee6541$var$thenableState = null, $b778ec20f9ee6541$var$globalClientIdCounter = 0;
function $b778ec20f9ee6541$var$throwInvalidHookError() {
    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(321));
}
function $b778ec20f9ee6541$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b778ec20f9ee6541$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b778ec20f9ee6541$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b778ec20f9ee6541$var$renderLanes = nextRenderLanes;
    $b778ec20f9ee6541$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b778ec20f9ee6541$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b778ec20f9ee6541$var$HooksDispatcherOnMount : $b778ec20f9ee6541$var$HooksDispatcherOnUpdate;
    $b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b778ec20f9ee6541$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b778ec20f9ee6541$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b778ec20f9ee6541$var$finishRenderingHooks(current) {
    $b778ec20f9ee6541$var$ReactSharedInternals.H = $b778ec20f9ee6541$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b778ec20f9ee6541$var$currentHook && null !== $b778ec20f9ee6541$var$currentHook.next;
    $b778ec20f9ee6541$var$renderLanes = 0;
    $b778ec20f9ee6541$var$workInProgressHook = $b778ec20f9ee6541$var$currentHook = $b778ec20f9ee6541$var$currentlyRenderingFiber$1 = null;
    $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdate = !1;
    $b778ec20f9ee6541$var$thenableIndexCounter = 0;
    $b778ec20f9ee6541$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(300));
    null === current || $b778ec20f9ee6541$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b778ec20f9ee6541$var$checkIfContextChanged(current) && ($b778ec20f9ee6541$var$didReceiveUpdate = !0));
}
function $b778ec20f9ee6541$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b778ec20f9ee6541$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b778ec20f9ee6541$var$thenableState = null);
        $b778ec20f9ee6541$var$thenableIndexCounter = 0;
        $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b778ec20f9ee6541$var$workInProgressHook = $b778ec20f9ee6541$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b778ec20f9ee6541$var$ReactSharedInternals.H = $b778ec20f9ee6541$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b778ec20f9ee6541$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b778ec20f9ee6541$var$TransitionAwareHostComponent() {
    var dispatcher = $b778ec20f9ee6541$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b778ec20f9ee6541$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b778ec20f9ee6541$var$currentHook ? $b778ec20f9ee6541$var$currentHook.memoizedState : null) !== dispatcher && ($b778ec20f9ee6541$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $b778ec20f9ee6541$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b778ec20f9ee6541$var$localIdCounter;
    $b778ec20f9ee6541$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b778ec20f9ee6541$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b778ec20f9ee6541$var$resetHooksOnUnwind(workInProgress) {
    if ($b778ec20f9ee6541$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b778ec20f9ee6541$var$renderLanes = 0;
    $b778ec20f9ee6541$var$workInProgressHook = $b778ec20f9ee6541$var$currentHook = $b778ec20f9ee6541$var$currentlyRenderingFiber$1 = null;
    $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b778ec20f9ee6541$var$thenableIndexCounter = $b778ec20f9ee6541$var$localIdCounter = 0;
    $b778ec20f9ee6541$var$thenableState = null;
}
function $b778ec20f9ee6541$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b778ec20f9ee6541$var$workInProgressHook ? $b778ec20f9ee6541$var$currentlyRenderingFiber$1.memoizedState = $b778ec20f9ee6541$var$workInProgressHook = hook : $b778ec20f9ee6541$var$workInProgressHook = $b778ec20f9ee6541$var$workInProgressHook.next = hook;
    return $b778ec20f9ee6541$var$workInProgressHook;
}
function $b778ec20f9ee6541$var$updateWorkInProgressHook() {
    if (null === $b778ec20f9ee6541$var$currentHook) {
        var nextCurrentHook = $b778ec20f9ee6541$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b778ec20f9ee6541$var$currentHook.next;
    var nextWorkInProgressHook = null === $b778ec20f9ee6541$var$workInProgressHook ? $b778ec20f9ee6541$var$currentlyRenderingFiber$1.memoizedState : $b778ec20f9ee6541$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b778ec20f9ee6541$var$workInProgressHook = nextWorkInProgressHook, $b778ec20f9ee6541$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b778ec20f9ee6541$var$currentlyRenderingFiber$1.alternate) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(467));
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(310));
        }
        $b778ec20f9ee6541$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b778ec20f9ee6541$var$currentHook.memoizedState,
            baseState: $b778ec20f9ee6541$var$currentHook.baseState,
            baseQueue: $b778ec20f9ee6541$var$currentHook.baseQueue,
            queue: $b778ec20f9ee6541$var$currentHook.queue,
            next: null
        };
        null === $b778ec20f9ee6541$var$workInProgressHook ? $b778ec20f9ee6541$var$currentlyRenderingFiber$1.memoizedState = $b778ec20f9ee6541$var$workInProgressHook = nextCurrentHook : $b778ec20f9ee6541$var$workInProgressHook = $b778ec20f9ee6541$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b778ec20f9ee6541$var$workInProgressHook;
}
var $b778ec20f9ee6541$var$createFunctionComponentUpdateQueue;
$b778ec20f9ee6541$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $b778ec20f9ee6541$var$useThenable(thenable) {
    var index = $b778ec20f9ee6541$var$thenableIndexCounter;
    $b778ec20f9ee6541$var$thenableIndexCounter += 1;
    null === $b778ec20f9ee6541$var$thenableState && ($b778ec20f9ee6541$var$thenableState = []);
    thenable = $b778ec20f9ee6541$var$trackUsedThenable($b778ec20f9ee6541$var$thenableState, thenable, index);
    index = $b778ec20f9ee6541$var$currentlyRenderingFiber$1;
    null === (null === $b778ec20f9ee6541$var$workInProgressHook ? index.memoizedState : $b778ec20f9ee6541$var$workInProgressHook.next) && (index = index.alternate, $b778ec20f9ee6541$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b778ec20f9ee6541$var$HooksDispatcherOnMount : $b778ec20f9ee6541$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b778ec20f9ee6541$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b778ec20f9ee6541$var$useThenable(usable);
        if (usable.$$typeof === $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE) return $b778ec20f9ee6541$var$readContext(usable);
    }
    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(438, String(usable)));
}
function $b778ec20f9ee6541$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b778ec20f9ee6541$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b778ec20f9ee6541$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b778ec20f9ee6541$var$createFunctionComponentUpdateQueue(), $b778ec20f9ee6541$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b778ec20f9ee6541$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b778ec20f9ee6541$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b778ec20f9ee6541$var$updateReducer(reducer) {
    var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    return $b778ec20f9ee6541$var$updateReducerImpl(hook, $b778ec20f9ee6541$var$currentHook, reducer);
}
function $b778ec20f9ee6541$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b778ec20f9ee6541$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b778ec20f9ee6541$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($b778ec20f9ee6541$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b778ec20f9ee6541$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b778ec20f9ee6541$var$currentlyRenderingFiber$1.lanes |= revertLane, $b778ec20f9ee6541$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b778ec20f9ee6541$var$currentlyRenderingFiber$1.lanes |= updateLane, $b778ec20f9ee6541$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b778ec20f9ee6541$var$objectIs(pendingQueue, hook.memoizedState) && ($b778ec20f9ee6541$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $b778ec20f9ee6541$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b778ec20f9ee6541$var$rerenderReducer(reducer) {
    var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b778ec20f9ee6541$var$objectIs(newState, hook.memoizedState) || ($b778ec20f9ee6541$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b778ec20f9ee6541$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b778ec20f9ee6541$var$currentlyRenderingFiber$1, hook = $b778ec20f9ee6541$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b778ec20f9ee6541$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b778ec20f9ee6541$var$objectIs(($b778ec20f9ee6541$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b778ec20f9ee6541$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $b778ec20f9ee6541$var$updateEffect($b778ec20f9ee6541$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b778ec20f9ee6541$var$workInProgressHook && $b778ec20f9ee6541$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b778ec20f9ee6541$var$pushEffect(9, $b778ec20f9ee6541$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $b778ec20f9ee6541$var$workInProgressRoot) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b778ec20f9ee6541$var$renderLanes & 60) || $b778ec20f9ee6541$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b778ec20f9ee6541$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b778ec20f9ee6541$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $b778ec20f9ee6541$var$createFunctionComponentUpdateQueue(), $b778ec20f9ee6541$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b778ec20f9ee6541$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b778ec20f9ee6541$var$checkIfSnapshotChanged(inst) && $b778ec20f9ee6541$var$forceStoreRerender(fiber);
}
function $b778ec20f9ee6541$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b778ec20f9ee6541$var$checkIfSnapshotChanged(inst) && $b778ec20f9ee6541$var$forceStoreRerender(fiber);
    });
}
function $b778ec20f9ee6541$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b778ec20f9ee6541$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b778ec20f9ee6541$var$forceStoreRerender(fiber) {
    var root = $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b778ec20f9ee6541$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b778ec20f9ee6541$var$mountStateImpl(initialState) {
    var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b778ec20f9ee6541$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b778ec20f9ee6541$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b778ec20f9ee6541$var$updateReducerImpl(hook, $b778ec20f9ee6541$var$currentHook, "function" === typeof reducer ? reducer : $b778ec20f9ee6541$var$basicStateReducer);
}
function $b778ec20f9ee6541$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b778ec20f9ee6541$var$isRenderPhaseUpdate(fiber)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b778ec20f9ee6541$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b778ec20f9ee6541$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b778ec20f9ee6541$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b778ec20f9ee6541$var$ReactSharedInternals.T, currentTransition = {};
        $b778ec20f9ee6541$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b778ec20f9ee6541$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b778ec20f9ee6541$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b778ec20f9ee6541$var$onActionError(actionQueue, node, error);
        } finally{
            $b778ec20f9ee6541$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b778ec20f9ee6541$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $b778ec20f9ee6541$var$onActionError(actionQueue, node, error$60);
    }
}
function $b778ec20f9ee6541$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b778ec20f9ee6541$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b778ec20f9ee6541$var$onActionError(actionQueue, node, error);
    }) : $b778ec20f9ee6541$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b778ec20f9ee6541$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b778ec20f9ee6541$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b778ec20f9ee6541$var$runActionStateAction(actionQueue, nextState)));
}
function $b778ec20f9ee6541$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b778ec20f9ee6541$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b778ec20f9ee6541$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b778ec20f9ee6541$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b778ec20f9ee6541$var$mountActionState(action, initialStateProp) {
    if ($b778ec20f9ee6541$var$isHydrating) {
        var ssrFormState = $b778ec20f9ee6541$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b778ec20f9ee6541$var$currentlyRenderingFiber$1;
                if ($b778ec20f9ee6541$var$isHydrating) {
                    if ($b778ec20f9ee6541$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b778ec20f9ee6541$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b778ec20f9ee6541$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b778ec20f9ee6541$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b778ec20f9ee6541$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b778ec20f9ee6541$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b778ec20f9ee6541$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b778ec20f9ee6541$var$dispatchSetState.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b778ec20f9ee6541$var$mountStateImpl(!1);
    inRootOrSingleton = $b778ec20f9ee6541$var$dispatchOptimisticSetState.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b778ec20f9ee6541$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b778ec20f9ee6541$var$dispatchActionState.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b778ec20f9ee6541$var$updateActionState(action) {
    var stateHook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    return $b778ec20f9ee6541$var$updateActionStateImpl(stateHook, $b778ec20f9ee6541$var$currentHook, action);
}
function $b778ec20f9ee6541$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b778ec20f9ee6541$var$updateReducerImpl(stateHook, currentStateHook, $b778ec20f9ee6541$var$actionStateReducer)[0];
    stateHook = $b778ec20f9ee6541$var$updateReducer($b778ec20f9ee6541$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $b778ec20f9ee6541$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $b778ec20f9ee6541$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($b778ec20f9ee6541$var$currentlyRenderingFiber$1.flags |= 2048, $b778ec20f9ee6541$var$pushEffect(9, $b778ec20f9ee6541$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $b778ec20f9ee6541$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b778ec20f9ee6541$var$rerenderActionState(action) {
    var stateHook = $b778ec20f9ee6541$var$updateWorkInProgressHook(), currentStateHook = $b778ec20f9ee6541$var$currentHook;
    if (null !== currentStateHook) return $b778ec20f9ee6541$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b778ec20f9ee6541$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b778ec20f9ee6541$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $b778ec20f9ee6541$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $b778ec20f9ee6541$var$createFunctionComponentUpdateQueue(), $b778ec20f9ee6541$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $b778ec20f9ee6541$var$updateRef() {
    return $b778ec20f9ee6541$var$updateWorkInProgressHook().memoizedState;
}
function $b778ec20f9ee6541$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
    $b778ec20f9ee6541$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $b778ec20f9ee6541$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $b778ec20f9ee6541$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b778ec20f9ee6541$var$currentHook && null !== deps && $b778ec20f9ee6541$var$areHookInputsEqual(deps, $b778ec20f9ee6541$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b778ec20f9ee6541$var$pushEffect(hookFlags, create, inst, deps) : ($b778ec20f9ee6541$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $b778ec20f9ee6541$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $b778ec20f9ee6541$var$mountEffect(create, deps) {
    $b778ec20f9ee6541$var$mountEffectImpl(8390656, 8, create, deps);
}
function $b778ec20f9ee6541$var$updateEffect(create, deps) {
    $b778ec20f9ee6541$var$updateEffectImpl(2048, 8, create, deps);
}
function $b778ec20f9ee6541$var$updateInsertionEffect(create, deps) {
    return $b778ec20f9ee6541$var$updateEffectImpl(4, 2, create, deps);
}
function $b778ec20f9ee6541$var$updateLayoutEffect(create, deps) {
    return $b778ec20f9ee6541$var$updateEffectImpl(4, 4, create, deps);
}
function $b778ec20f9ee6541$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b778ec20f9ee6541$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b778ec20f9ee6541$var$updateEffectImpl(4, 4, $b778ec20f9ee6541$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b778ec20f9ee6541$var$mountDebugValue() {}
function $b778ec20f9ee6541$var$updateCallback(callback, deps) {
    var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b778ec20f9ee6541$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b778ec20f9ee6541$var$updateMemo(nextCreate, deps) {
    var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b778ec20f9ee6541$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b778ec20f9ee6541$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b778ec20f9ee6541$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b778ec20f9ee6541$var$requestDeferredLane();
    $b778ec20f9ee6541$var$currentlyRenderingFiber$1.lanes |= hook;
    $b778ec20f9ee6541$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b778ec20f9ee6541$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b778ec20f9ee6541$var$objectIs(value, prevValue)) return value;
    if (null !== $b778ec20f9ee6541$var$currentTreeHiddenStackCursor.current) return hook = $b778ec20f9ee6541$var$mountDeferredValueImpl(hook, value, initialValue), $b778ec20f9ee6541$var$objectIs(hook, prevValue) || ($b778ec20f9ee6541$var$didReceiveUpdate = !0), hook;
    if (0 === ($b778ec20f9ee6541$var$renderLanes & 42)) return $b778ec20f9ee6541$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b778ec20f9ee6541$var$requestDeferredLane();
    $b778ec20f9ee6541$var$currentlyRenderingFiber$1.lanes |= hook;
    $b778ec20f9ee6541$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b778ec20f9ee6541$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p;
    $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b778ec20f9ee6541$var$ReactSharedInternals.T, currentTransition = {};
    $b778ec20f9ee6541$var$ReactSharedInternals.T = currentTransition;
    $b778ec20f9ee6541$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b778ec20f9ee6541$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b778ec20f9ee6541$var$chainThenableValue(returnValue, finishedState);
            $b778ec20f9ee6541$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b778ec20f9ee6541$var$requestUpdateLane(fiber));
        } else $b778ec20f9ee6541$var$dispatchSetStateInternal(fiber, queue, finishedState, $b778ec20f9ee6541$var$requestUpdateLane(fiber));
    } catch (error) {
        $b778ec20f9ee6541$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b778ec20f9ee6541$var$requestUpdateLane());
    } finally{
        $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = previousPriority, $b778ec20f9ee6541$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b778ec20f9ee6541$var$noop$2() {}
function $b778ec20f9ee6541$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(476));
    var queue = $b778ec20f9ee6541$var$ensureFormComponentIsStateful(formFiber).queue;
    $b778ec20f9ee6541$var$startTransition(formFiber, queue, pendingState, $b778ec20f9ee6541$var$sharedNotPendingObject, null === action ? $b778ec20f9ee6541$var$noop$2 : function() {
        $b778ec20f9ee6541$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b778ec20f9ee6541$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b778ec20f9ee6541$var$sharedNotPendingObject,
        baseState: $b778ec20f9ee6541$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b778ec20f9ee6541$var$basicStateReducer,
            lastRenderedState: $b778ec20f9ee6541$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b778ec20f9ee6541$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b778ec20f9ee6541$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $b778ec20f9ee6541$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $b778ec20f9ee6541$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $b778ec20f9ee6541$var$requestUpdateLane());
}
function $b778ec20f9ee6541$var$useHostTransitionStatus() {
    return $b778ec20f9ee6541$var$readContext($b778ec20f9ee6541$var$HostTransitionContext);
}
function $b778ec20f9ee6541$var$updateId() {
    return $b778ec20f9ee6541$var$updateWorkInProgressHook().memoizedState;
}
function $b778ec20f9ee6541$var$updateRefresh() {
    return $b778ec20f9ee6541$var$updateWorkInProgressHook().memoizedState;
}
function $b778ec20f9ee6541$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b778ec20f9ee6541$var$requestUpdateLane();
                fiber = $b778ec20f9ee6541$var$createUpdate(lane);
                var root$63 = $b778ec20f9ee6541$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($b778ec20f9ee6541$var$scheduleUpdateOnFiber(root$63, provider, lane), $b778ec20f9ee6541$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $b778ec20f9ee6541$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b778ec20f9ee6541$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b778ec20f9ee6541$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b778ec20f9ee6541$var$isRenderPhaseUpdate(fiber) ? $b778ec20f9ee6541$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b778ec20f9ee6541$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b778ec20f9ee6541$var$scheduleUpdateOnFiber(action, fiber, lane), $b778ec20f9ee6541$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b778ec20f9ee6541$var$dispatchSetState(fiber, queue, action) {
    var lane = $b778ec20f9ee6541$var$requestUpdateLane();
    $b778ec20f9ee6541$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b778ec20f9ee6541$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b778ec20f9ee6541$var$isRenderPhaseUpdate(fiber)) $b778ec20f9ee6541$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b778ec20f9ee6541$var$objectIs(eagerState, currentState)) return $b778ec20f9ee6541$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b778ec20f9ee6541$var$workInProgressRoot && $b778ec20f9ee6541$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b778ec20f9ee6541$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b778ec20f9ee6541$var$scheduleUpdateOnFiber(action, fiber, lane), $b778ec20f9ee6541$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b778ec20f9ee6541$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b778ec20f9ee6541$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b778ec20f9ee6541$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b778ec20f9ee6541$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b778ec20f9ee6541$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b778ec20f9ee6541$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b778ec20f9ee6541$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $b778ec20f9ee6541$var$currentlyRenderingFiber$1;
}
function $b778ec20f9ee6541$var$enqueueRenderPhaseUpdate(queue, update) {
    $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdateDuringThisPass = $b778ec20f9ee6541$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b778ec20f9ee6541$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b778ec20f9ee6541$var$markRootEntangled(root, lane);
    }
}
var $b778ec20f9ee6541$var$ContextOnlyDispatcher = {
    readContext: $b778ec20f9ee6541$var$readContext,
    use: $b778ec20f9ee6541$var$use,
    useCallback: $b778ec20f9ee6541$var$throwInvalidHookError,
    useContext: $b778ec20f9ee6541$var$throwInvalidHookError,
    useEffect: $b778ec20f9ee6541$var$throwInvalidHookError,
    useImperativeHandle: $b778ec20f9ee6541$var$throwInvalidHookError,
    useLayoutEffect: $b778ec20f9ee6541$var$throwInvalidHookError,
    useInsertionEffect: $b778ec20f9ee6541$var$throwInvalidHookError,
    useMemo: $b778ec20f9ee6541$var$throwInvalidHookError,
    useReducer: $b778ec20f9ee6541$var$throwInvalidHookError,
    useRef: $b778ec20f9ee6541$var$throwInvalidHookError,
    useState: $b778ec20f9ee6541$var$throwInvalidHookError,
    useDebugValue: $b778ec20f9ee6541$var$throwInvalidHookError,
    useDeferredValue: $b778ec20f9ee6541$var$throwInvalidHookError,
    useTransition: $b778ec20f9ee6541$var$throwInvalidHookError,
    useSyncExternalStore: $b778ec20f9ee6541$var$throwInvalidHookError,
    useId: $b778ec20f9ee6541$var$throwInvalidHookError
};
$b778ec20f9ee6541$var$ContextOnlyDispatcher.useCacheRefresh = $b778ec20f9ee6541$var$throwInvalidHookError;
$b778ec20f9ee6541$var$ContextOnlyDispatcher.useMemoCache = $b778ec20f9ee6541$var$throwInvalidHookError;
$b778ec20f9ee6541$var$ContextOnlyDispatcher.useHostTransitionStatus = $b778ec20f9ee6541$var$throwInvalidHookError;
$b778ec20f9ee6541$var$ContextOnlyDispatcher.useFormState = $b778ec20f9ee6541$var$throwInvalidHookError;
$b778ec20f9ee6541$var$ContextOnlyDispatcher.useActionState = $b778ec20f9ee6541$var$throwInvalidHookError;
$b778ec20f9ee6541$var$ContextOnlyDispatcher.useOptimistic = $b778ec20f9ee6541$var$throwInvalidHookError;
var $b778ec20f9ee6541$var$HooksDispatcherOnMount = {
    readContext: $b778ec20f9ee6541$var$readContext,
    use: $b778ec20f9ee6541$var$use,
    useCallback: function(callback, deps) {
        $b778ec20f9ee6541$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b778ec20f9ee6541$var$readContext,
    useEffect: $b778ec20f9ee6541$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b778ec20f9ee6541$var$mountEffectImpl(4194308, 4, $b778ec20f9ee6541$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b778ec20f9ee6541$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b778ec20f9ee6541$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b778ec20f9ee6541$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b778ec20f9ee6541$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b778ec20f9ee6541$var$dispatchReducerAction.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b778ec20f9ee6541$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b778ec20f9ee6541$var$dispatchSetState.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b778ec20f9ee6541$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
        return $b778ec20f9ee6541$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b778ec20f9ee6541$var$mountStateImpl(!1);
        stateHook = $b778ec20f9ee6541$var$startTransition.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $b778ec20f9ee6541$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b778ec20f9ee6541$var$currentlyRenderingFiber$1, hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
        if ($b778ec20f9ee6541$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b778ec20f9ee6541$var$workInProgressRoot) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(349));
            0 !== ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 60) || $b778ec20f9ee6541$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b778ec20f9ee6541$var$mountEffect($b778ec20f9ee6541$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b778ec20f9ee6541$var$pushEffect(9, $b778ec20f9ee6541$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook(), identifierPrefix = $b778ec20f9ee6541$var$workInProgressRoot.identifierPrefix;
        if ($b778ec20f9ee6541$var$isHydrating) {
            var JSCompiler_inline_result = $b778ec20f9ee6541$var$treeContextOverflow;
            var idWithLeadingBit = $b778ec20f9ee6541$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b778ec20f9ee6541$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b778ec20f9ee6541$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $b778ec20f9ee6541$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $b778ec20f9ee6541$var$mountWorkInProgressHook().memoizedState = $b778ec20f9ee6541$var$refreshCache.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1);
    }
};
$b778ec20f9ee6541$var$HooksDispatcherOnMount.useMemoCache = $b778ec20f9ee6541$var$useMemoCache;
$b778ec20f9ee6541$var$HooksDispatcherOnMount.useHostTransitionStatus = $b778ec20f9ee6541$var$useHostTransitionStatus;
$b778ec20f9ee6541$var$HooksDispatcherOnMount.useFormState = $b778ec20f9ee6541$var$mountActionState;
$b778ec20f9ee6541$var$HooksDispatcherOnMount.useActionState = $b778ec20f9ee6541$var$mountActionState;
$b778ec20f9ee6541$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $b778ec20f9ee6541$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $b778ec20f9ee6541$var$dispatchOptimisticSetState.bind(null, $b778ec20f9ee6541$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $b778ec20f9ee6541$var$HooksDispatcherOnUpdate = {
    readContext: $b778ec20f9ee6541$var$readContext,
    use: $b778ec20f9ee6541$var$use,
    useCallback: $b778ec20f9ee6541$var$updateCallback,
    useContext: $b778ec20f9ee6541$var$readContext,
    useEffect: $b778ec20f9ee6541$var$updateEffect,
    useImperativeHandle: $b778ec20f9ee6541$var$updateImperativeHandle,
    useInsertionEffect: $b778ec20f9ee6541$var$updateInsertionEffect,
    useLayoutEffect: $b778ec20f9ee6541$var$updateLayoutEffect,
    useMemo: $b778ec20f9ee6541$var$updateMemo,
    useReducer: $b778ec20f9ee6541$var$updateReducer,
    useRef: $b778ec20f9ee6541$var$updateRef,
    useState: function() {
        return $b778ec20f9ee6541$var$updateReducer($b778ec20f9ee6541$var$basicStateReducer);
    },
    useDebugValue: $b778ec20f9ee6541$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
        return $b778ec20f9ee6541$var$updateDeferredValueImpl(hook, $b778ec20f9ee6541$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b778ec20f9ee6541$var$updateReducer($b778ec20f9ee6541$var$basicStateReducer)[0], start = $b778ec20f9ee6541$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b778ec20f9ee6541$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b778ec20f9ee6541$var$updateSyncExternalStore,
    useId: $b778ec20f9ee6541$var$updateId
};
$b778ec20f9ee6541$var$HooksDispatcherOnUpdate.useCacheRefresh = $b778ec20f9ee6541$var$updateRefresh;
$b778ec20f9ee6541$var$HooksDispatcherOnUpdate.useMemoCache = $b778ec20f9ee6541$var$useMemoCache;
$b778ec20f9ee6541$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $b778ec20f9ee6541$var$useHostTransitionStatus;
$b778ec20f9ee6541$var$HooksDispatcherOnUpdate.useFormState = $b778ec20f9ee6541$var$updateActionState;
$b778ec20f9ee6541$var$HooksDispatcherOnUpdate.useActionState = $b778ec20f9ee6541$var$updateActionState;
$b778ec20f9ee6541$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    return $b778ec20f9ee6541$var$updateOptimisticImpl(hook, $b778ec20f9ee6541$var$currentHook, passthrough, reducer);
};
var $b778ec20f9ee6541$var$HooksDispatcherOnRerender = {
    readContext: $b778ec20f9ee6541$var$readContext,
    use: $b778ec20f9ee6541$var$use,
    useCallback: $b778ec20f9ee6541$var$updateCallback,
    useContext: $b778ec20f9ee6541$var$readContext,
    useEffect: $b778ec20f9ee6541$var$updateEffect,
    useImperativeHandle: $b778ec20f9ee6541$var$updateImperativeHandle,
    useInsertionEffect: $b778ec20f9ee6541$var$updateInsertionEffect,
    useLayoutEffect: $b778ec20f9ee6541$var$updateLayoutEffect,
    useMemo: $b778ec20f9ee6541$var$updateMemo,
    useReducer: $b778ec20f9ee6541$var$rerenderReducer,
    useRef: $b778ec20f9ee6541$var$updateRef,
    useState: function() {
        return $b778ec20f9ee6541$var$rerenderReducer($b778ec20f9ee6541$var$basicStateReducer);
    },
    useDebugValue: $b778ec20f9ee6541$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
        return null === $b778ec20f9ee6541$var$currentHook ? $b778ec20f9ee6541$var$mountDeferredValueImpl(hook, value, initialValue) : $b778ec20f9ee6541$var$updateDeferredValueImpl(hook, $b778ec20f9ee6541$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b778ec20f9ee6541$var$rerenderReducer($b778ec20f9ee6541$var$basicStateReducer)[0], start = $b778ec20f9ee6541$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b778ec20f9ee6541$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b778ec20f9ee6541$var$updateSyncExternalStore,
    useId: $b778ec20f9ee6541$var$updateId
};
$b778ec20f9ee6541$var$HooksDispatcherOnRerender.useCacheRefresh = $b778ec20f9ee6541$var$updateRefresh;
$b778ec20f9ee6541$var$HooksDispatcherOnRerender.useMemoCache = $b778ec20f9ee6541$var$useMemoCache;
$b778ec20f9ee6541$var$HooksDispatcherOnRerender.useHostTransitionStatus = $b778ec20f9ee6541$var$useHostTransitionStatus;
$b778ec20f9ee6541$var$HooksDispatcherOnRerender.useFormState = $b778ec20f9ee6541$var$rerenderActionState;
$b778ec20f9ee6541$var$HooksDispatcherOnRerender.useActionState = $b778ec20f9ee6541$var$rerenderActionState;
$b778ec20f9ee6541$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $b778ec20f9ee6541$var$updateWorkInProgressHook();
    if (null !== $b778ec20f9ee6541$var$currentHook) return $b778ec20f9ee6541$var$updateOptimisticImpl(hook, $b778ec20f9ee6541$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $b778ec20f9ee6541$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b778ec20f9ee6541$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b778ec20f9ee6541$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $b778ec20f9ee6541$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b778ec20f9ee6541$var$requestUpdateLane(), update = $b778ec20f9ee6541$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b778ec20f9ee6541$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b778ec20f9ee6541$var$scheduleUpdateOnFiber(payload, inst, lane), $b778ec20f9ee6541$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b778ec20f9ee6541$var$requestUpdateLane(), update = $b778ec20f9ee6541$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b778ec20f9ee6541$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b778ec20f9ee6541$var$scheduleUpdateOnFiber(payload, inst, lane), $b778ec20f9ee6541$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b778ec20f9ee6541$var$requestUpdateLane(), update = $b778ec20f9ee6541$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b778ec20f9ee6541$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b778ec20f9ee6541$var$scheduleUpdateOnFiber(callback, inst, lane), $b778ec20f9ee6541$var$entangleTransitions(callback, inst, lane));
    }
};
function $b778ec20f9ee6541$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b778ec20f9ee6541$var$shallowEqual(oldProps, newProps) || !$b778ec20f9ee6541$var$shallowEqual(oldState, newState) : !0;
}
function $b778ec20f9ee6541$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b778ec20f9ee6541$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b778ec20f9ee6541$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b778ec20f9ee6541$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $b778ec20f9ee6541$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4kiXg && "function" === typeof $4kiXg.emit) {
        $4kiXg.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $b778ec20f9ee6541$var$defaultOnUncaughtError(error) {
    $b778ec20f9ee6541$var$reportGlobalError(error);
}
function $b778ec20f9ee6541$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b778ec20f9ee6541$var$defaultOnRecoverableError(error) {
    $b778ec20f9ee6541$var$reportGlobalError(error);
}
function $b778ec20f9ee6541$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $b778ec20f9ee6541$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $b778ec20f9ee6541$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b778ec20f9ee6541$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b778ec20f9ee6541$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b778ec20f9ee6541$var$createClassErrorUpdate(lane) {
    lane = $b778ec20f9ee6541$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b778ec20f9ee6541$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b778ec20f9ee6541$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b778ec20f9ee6541$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed ? $b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b778ec20f9ee6541$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b778ec20f9ee6541$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $b778ec20f9ee6541$var$shellBoundary ? $b778ec20f9ee6541$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b778ec20f9ee6541$var$workInProgressRootExitStatus && ($b778ec20f9ee6541$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b778ec20f9ee6541$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b778ec20f9ee6541$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b778ec20f9ee6541$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b778ec20f9ee6541$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b778ec20f9ee6541$var$attachPingListener(root, value, rootRenderLanes);
        $b778ec20f9ee6541$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b778ec20f9ee6541$var$isHydrating) return returnFiber = $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b778ec20f9ee6541$var$HydrationMismatchException && (root = Error($b778ec20f9ee6541$var$formatProdErrorMessage(422), {
        cause: value
    }), $b778ec20f9ee6541$var$queueHydrationError($b778ec20f9ee6541$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b778ec20f9ee6541$var$HydrationMismatchException && (returnFiber = Error($b778ec20f9ee6541$var$formatProdErrorMessage(423), {
        cause: value
    }), $b778ec20f9ee6541$var$queueHydrationError($b778ec20f9ee6541$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b778ec20f9ee6541$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b778ec20f9ee6541$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b778ec20f9ee6541$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b778ec20f9ee6541$var$workInProgressRootExitStatus && ($b778ec20f9ee6541$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b778ec20f9ee6541$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b778ec20f9ee6541$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b778ec20f9ee6541$var$workInProgressRootConcurrentErrors ? $b778ec20f9ee6541$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b778ec20f9ee6541$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b778ec20f9ee6541$var$workInProgressRootExitStatus && ($b778ec20f9ee6541$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b778ec20f9ee6541$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b778ec20f9ee6541$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b778ec20f9ee6541$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed || !$b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b778ec20f9ee6541$var$createClassErrorUpdate(rootRenderLanes), $b778ec20f9ee6541$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b778ec20f9ee6541$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b778ec20f9ee6541$var$SelectiveHydrationException = Error($b778ec20f9ee6541$var$formatProdErrorMessage(461)), $b778ec20f9ee6541$var$didReceiveUpdate = !1;
function $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b778ec20f9ee6541$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b778ec20f9ee6541$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b778ec20f9ee6541$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b778ec20f9ee6541$var$prepareToReadContext(workInProgress);
    nextProps = $b778ec20f9ee6541$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b778ec20f9ee6541$var$checkDidRenderIdHook();
    if (null !== current && !$b778ec20f9ee6541$var$didReceiveUpdate) return $b778ec20f9ee6541$var$bailoutHooks(current, workInProgress, renderLanes), $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b778ec20f9ee6541$var$isHydrating && key && $b778ec20f9ee6541$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b778ec20f9ee6541$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b778ec20f9ee6541$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b778ec20f9ee6541$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b778ec20f9ee6541$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b778ec20f9ee6541$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b778ec20f9ee6541$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b778ec20f9ee6541$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b778ec20f9ee6541$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b778ec20f9ee6541$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b778ec20f9ee6541$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b778ec20f9ee6541$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b778ec20f9ee6541$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b778ec20f9ee6541$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b778ec20f9ee6541$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $b778ec20f9ee6541$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $b778ec20f9ee6541$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b778ec20f9ee6541$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b778ec20f9ee6541$var$pushHiddenContext(workInProgress, prevState) : $b778ec20f9ee6541$var$reuseHiddenContextOnStack(), $b778ec20f9ee6541$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $b778ec20f9ee6541$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($b778ec20f9ee6541$var$pushTransition(workInProgress, prevState.cachePool), $b778ec20f9ee6541$var$pushHiddenContext(workInProgress, prevState), $b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b778ec20f9ee6541$var$pushTransition(workInProgress, null), $b778ec20f9ee6541$var$reuseHiddenContextOnStack(), $b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b778ec20f9ee6541$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $b778ec20f9ee6541$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b778ec20f9ee6541$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b778ec20f9ee6541$var$pushTransition(workInProgress, null);
    $b778ec20f9ee6541$var$reuseHiddenContextOnStack();
    $b778ec20f9ee6541$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b778ec20f9ee6541$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $b778ec20f9ee6541$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $b778ec20f9ee6541$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b778ec20f9ee6541$var$prepareToReadContext(workInProgress);
    Component = $b778ec20f9ee6541$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b778ec20f9ee6541$var$checkDidRenderIdHook();
    if (null !== current && !$b778ec20f9ee6541$var$didReceiveUpdate) return $b778ec20f9ee6541$var$bailoutHooks(current, workInProgress, renderLanes), $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b778ec20f9ee6541$var$isHydrating && nextProps && $b778ec20f9ee6541$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b778ec20f9ee6541$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b778ec20f9ee6541$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b778ec20f9ee6541$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b778ec20f9ee6541$var$finishRenderingHooks(current);
    Component = $b778ec20f9ee6541$var$checkDidRenderIdHook();
    if (null !== current && !$b778ec20f9ee6541$var$didReceiveUpdate) return $b778ec20f9ee6541$var$bailoutHooks(current, workInProgress, renderLanes), $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b778ec20f9ee6541$var$isHydrating && Component && $b778ec20f9ee6541$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b778ec20f9ee6541$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b778ec20f9ee6541$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b778ec20f9ee6541$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b778ec20f9ee6541$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b778ec20f9ee6541$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b778ec20f9ee6541$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b778ec20f9ee6541$var$readContext(contextType) : $b778ec20f9ee6541$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b778ec20f9ee6541$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b778ec20f9ee6541$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b778ec20f9ee6541$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b778ec20f9ee6541$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b778ec20f9ee6541$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b778ec20f9ee6541$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b778ec20f9ee6541$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b778ec20f9ee6541$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b778ec20f9ee6541$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b778ec20f9ee6541$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b778ec20f9ee6541$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b778ec20f9ee6541$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b778ec20f9ee6541$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b778ec20f9ee6541$var$hasForceUpdate || $b778ec20f9ee6541$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b778ec20f9ee6541$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b778ec20f9ee6541$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b778ec20f9ee6541$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b778ec20f9ee6541$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b778ec20f9ee6541$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b778ec20f9ee6541$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b778ec20f9ee6541$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b778ec20f9ee6541$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b778ec20f9ee6541$var$hasForceUpdate || null !== current && null !== current.dependencies && $b778ec20f9ee6541$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b778ec20f9ee6541$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b778ec20f9ee6541$var$hasForceUpdate || $b778ec20f9ee6541$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b778ec20f9ee6541$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b778ec20f9ee6541$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b778ec20f9ee6541$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b778ec20f9ee6541$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b778ec20f9ee6541$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b778ec20f9ee6541$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b778ec20f9ee6541$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b778ec20f9ee6541$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b778ec20f9ee6541$var$getSuspendedCache()
    };
}
function $b778ec20f9ee6541$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b778ec20f9ee6541$var$workInProgressDeferredLane);
    return current;
}
function $b778ec20f9ee6541$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b778ec20f9ee6541$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b778ec20f9ee6541$var$isHydrating) {
            showFallback ? $b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($b778ec20f9ee6541$var$isHydrating) {
                var nextInstance = $b778ec20f9ee6541$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $b778ec20f9ee6541$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $b778ec20f9ee6541$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $b778ec20f9ee6541$var$treeContextProvider ? {
                            id: $b778ec20f9ee6541$var$treeContextId,
                            overflow: $b778ec20f9ee6541$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $b778ec20f9ee6541$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $b778ec20f9ee6541$var$hydrationParentFiber = workInProgress, $b778ec20f9ee6541$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $b778ec20f9ee6541$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $b778ec20f9ee6541$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $b778ec20f9ee6541$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $b778ec20f9ee6541$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $b778ec20f9ee6541$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $b778ec20f9ee6541$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b778ec20f9ee6541$var$SUSPENDED_MARKER, nextProps;
        $b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b778ec20f9ee6541$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b778ec20f9ee6541$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $b778ec20f9ee6541$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $b778ec20f9ee6541$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $b778ec20f9ee6541$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b778ec20f9ee6541$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b778ec20f9ee6541$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b778ec20f9ee6541$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b778ec20f9ee6541$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b778ec20f9ee6541$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b778ec20f9ee6541$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b778ec20f9ee6541$var$didReceiveUpdate || $b778ec20f9ee6541$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b778ec20f9ee6541$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b778ec20f9ee6541$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(current, nextProps), $b778ec20f9ee6541$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b778ec20f9ee6541$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $b778ec20f9ee6541$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b778ec20f9ee6541$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $b778ec20f9ee6541$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$getNextHydratable(nextInstance.nextSibling), $b778ec20f9ee6541$var$hydrationParentFiber = workInProgress, $b778ec20f9ee6541$var$isHydrating = !0, $b778ec20f9ee6541$var$hydrationErrors = null, $b778ec20f9ee6541$var$rootOrSingletonContext = !1, null !== current && ($b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex++] = $b778ec20f9ee6541$var$treeContextId, $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex++] = $b778ec20f9ee6541$var$treeContextOverflow, $b778ec20f9ee6541$var$idStack[$b778ec20f9ee6541$var$idStackIndex++] = $b778ec20f9ee6541$var$treeContextProvider, $b778ec20f9ee6541$var$treeContextId = current.id, $b778ec20f9ee6541$var$treeContextOverflow = current.overflow, $b778ec20f9ee6541$var$treeContextProvider = workInProgress), workInProgress = $b778ec20f9ee6541$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b778ec20f9ee6541$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $b778ec20f9ee6541$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $b778ec20f9ee6541$var$createWorkInProgress(digest, showFallback) : (showFallback = $b778ec20f9ee6541$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $b778ec20f9ee6541$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $b778ec20f9ee6541$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $b778ec20f9ee6541$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $b778ec20f9ee6541$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b778ec20f9ee6541$var$SUSPENDED_MARKER, nextProps;
    $b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b778ec20f9ee6541$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b778ec20f9ee6541$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b778ec20f9ee6541$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b778ec20f9ee6541$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $b778ec20f9ee6541$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $b778ec20f9ee6541$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b778ec20f9ee6541$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b778ec20f9ee6541$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b778ec20f9ee6541$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b778ec20f9ee6541$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b778ec20f9ee6541$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $b778ec20f9ee6541$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $b778ec20f9ee6541$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $b778ec20f9ee6541$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $b778ec20f9ee6541$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b778ec20f9ee6541$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b778ec20f9ee6541$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b778ec20f9ee6541$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b778ec20f9ee6541$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $b778ec20f9ee6541$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b778ec20f9ee6541$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b778ec20f9ee6541$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b778ec20f9ee6541$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b778ec20f9ee6541$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b778ec20f9ee6541$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b778ec20f9ee6541$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b778ec20f9ee6541$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b778ec20f9ee6541$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b778ec20f9ee6541$var$pushProvider(workInProgress, $b778ec20f9ee6541$var$CacheContext, current.memoizedState.cache);
            $b778ec20f9ee6541$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b778ec20f9ee6541$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b778ec20f9ee6541$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b778ec20f9ee6541$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b778ec20f9ee6541$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b778ec20f9ee6541$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($b778ec20f9ee6541$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $b778ec20f9ee6541$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseStackCursor, $b778ec20f9ee6541$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $b778ec20f9ee6541$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $b778ec20f9ee6541$var$pushProvider(workInProgress, $b778ec20f9ee6541$var$CacheContext, current.memoizedState.cache);
    }
    return $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b778ec20f9ee6541$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b778ec20f9ee6541$var$didReceiveUpdate = !0;
        else {
            if (!$b778ec20f9ee6541$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b778ec20f9ee6541$var$didReceiveUpdate = !1, $b778ec20f9ee6541$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b778ec20f9ee6541$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b778ec20f9ee6541$var$didReceiveUpdate = !1, $b778ec20f9ee6541$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b778ec20f9ee6541$var$pushTreeId(workInProgress, $b778ec20f9ee6541$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $b778ec20f9ee6541$var$shouldConstruct(lazyComponent) ? (current = $b778ec20f9ee6541$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $b778ec20f9ee6541$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b778ec20f9ee6541$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $b778ec20f9ee6541$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b778ec20f9ee6541$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $b778ec20f9ee6541$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b778ec20f9ee6541$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b778ec20f9ee6541$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b778ec20f9ee6541$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $b778ec20f9ee6541$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $b778ec20f9ee6541$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $b778ec20f9ee6541$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $b778ec20f9ee6541$var$cloneUpdateQueue(current, workInProgress);
                $b778ec20f9ee6541$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $b778ec20f9ee6541$var$pushProvider(workInProgress, $b778ec20f9ee6541$var$CacheContext, nextProps);
                nextProps !== init.cache && $b778ec20f9ee6541$var$propagateContextChanges(workInProgress, [
                    $b778ec20f9ee6541$var$CacheContext
                ], renderLanes, !0);
                $b778ec20f9ee6541$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $b778ec20f9ee6541$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $b778ec20f9ee6541$var$createCapturedValueAtFiber(Error($b778ec20f9ee6541$var$formatProdErrorMessage(424)), workInProgress);
                        $b778ec20f9ee6541$var$queueHydrationError(lazyComponent);
                        workInProgress = $b778ec20f9ee6541$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $b778ec20f9ee6541$var$hydrationParentFiber = workInProgress, $b778ec20f9ee6541$var$isHydrating = !0, $b778ec20f9ee6541$var$hydrationErrors = null, $b778ec20f9ee6541$var$rootOrSingletonContext = !0, renderLanes = $b778ec20f9ee6541$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $b778ec20f9ee6541$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $b778ec20f9ee6541$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b778ec20f9ee6541$var$markRef(current, workInProgress), null === current ? (renderLanes = $b778ec20f9ee6541$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b778ec20f9ee6541$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $b778ec20f9ee6541$var$getOwnerDocumentFromRootContainer($b778ec20f9ee6541$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$b778ec20f9ee6541$var$internalInstanceKey] = workInProgress, lazyComponent[$b778ec20f9ee6541$var$internalPropsKey] = current, $b778ec20f9ee6541$var$setInitialProperties(lazyComponent, renderLanes, current), $b778ec20f9ee6541$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $b778ec20f9ee6541$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b778ec20f9ee6541$var$pushHostContext(workInProgress), null === current && $b778ec20f9ee6541$var$isHydrating && (lazyComponent = workInProgress.stateNode = $b778ec20f9ee6541$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b778ec20f9ee6541$var$rootInstanceStackCursor.current), $b778ec20f9ee6541$var$hydrationParentFiber = workInProgress, $b778ec20f9ee6541$var$rootOrSingletonContext = !0, $b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $b778ec20f9ee6541$var$isHydrating ? $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $b778ec20f9ee6541$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $b778ec20f9ee6541$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $b778ec20f9ee6541$var$isHydrating) {
                if (init = lazyComponent = $b778ec20f9ee6541$var$nextHydratableInstance) lazyComponent = $b778ec20f9ee6541$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $b778ec20f9ee6541$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $b778ec20f9ee6541$var$hydrationParentFiber = workInProgress, $b778ec20f9ee6541$var$nextHydratableInstance = $b778ec20f9ee6541$var$getNextHydratable(lazyComponent.firstChild), $b778ec20f9ee6541$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $b778ec20f9ee6541$var$throwOnHydrationMismatch(workInProgress);
            }
            $b778ec20f9ee6541$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $b778ec20f9ee6541$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $b778ec20f9ee6541$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $b778ec20f9ee6541$var$renderWithHooks(current, workInProgress, $b778ec20f9ee6541$var$TransitionAwareHostComponent, null, null, renderLanes), $b778ec20f9ee6541$var$HostTransitionContext._currentValue = init);
            $b778ec20f9ee6541$var$markRef(current, workInProgress);
            $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b778ec20f9ee6541$var$isHydrating) {
                if (current = renderLanes = $b778ec20f9ee6541$var$nextHydratableInstance) renderLanes = $b778ec20f9ee6541$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b778ec20f9ee6541$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b778ec20f9ee6541$var$hydrationParentFiber = workInProgress, $b778ec20f9ee6541$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b778ec20f9ee6541$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b778ec20f9ee6541$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b778ec20f9ee6541$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $b778ec20f9ee6541$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $b778ec20f9ee6541$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $b778ec20f9ee6541$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $b778ec20f9ee6541$var$prepareToReadContext(workInProgress), init = $b778ec20f9ee6541$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $b778ec20f9ee6541$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b778ec20f9ee6541$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b778ec20f9ee6541$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $b778ec20f9ee6541$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $b778ec20f9ee6541$var$prepareToReadContext(workInProgress), lazyComponent = $b778ec20f9ee6541$var$readContext($b778ec20f9ee6541$var$CacheContext), null === current ? (init = $b778ec20f9ee6541$var$peekCacheFromPool(), null === init && (init = $b778ec20f9ee6541$var$workInProgressRoot, nextProps = $b778ec20f9ee6541$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $b778ec20f9ee6541$var$initializeUpdateQueue(workInProgress), $b778ec20f9ee6541$var$pushProvider(workInProgress, $b778ec20f9ee6541$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($b778ec20f9ee6541$var$cloneUpdateQueue(current, workInProgress), $b778ec20f9ee6541$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b778ec20f9ee6541$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $b778ec20f9ee6541$var$pushProvider(workInProgress, $b778ec20f9ee6541$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $b778ec20f9ee6541$var$pushProvider(workInProgress, $b778ec20f9ee6541$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $b778ec20f9ee6541$var$propagateContextChanges(workInProgress, [
                $b778ec20f9ee6541$var$CacheContext
            ], renderLanes, !0))), $b778ec20f9ee6541$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $b778ec20f9ee6541$var$valueCursor = $b778ec20f9ee6541$var$createCursor(null), $b778ec20f9ee6541$var$currentlyRenderingFiber = null, $b778ec20f9ee6541$var$lastContextDependency = null;
function $b778ec20f9ee6541$var$pushProvider(providerFiber, context, nextValue) {
    $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b778ec20f9ee6541$var$popProvider(context) {
    context._currentValue = $b778ec20f9ee6541$var$valueCursor.current;
    $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$valueCursor);
}
function $b778ec20f9ee6541$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b778ec20f9ee6541$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b778ec20f9ee6541$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b778ec20f9ee6541$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b778ec20f9ee6541$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b778ec20f9ee6541$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b778ec20f9ee6541$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b778ec20f9ee6541$var$HostTransitionContext) : current = [
                $b778ec20f9ee6541$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b778ec20f9ee6541$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b778ec20f9ee6541$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b778ec20f9ee6541$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b778ec20f9ee6541$var$prepareToReadContext(workInProgress) {
    $b778ec20f9ee6541$var$currentlyRenderingFiber = workInProgress;
    $b778ec20f9ee6541$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b778ec20f9ee6541$var$readContext(context) {
    return $b778ec20f9ee6541$var$readContextForConsumer($b778ec20f9ee6541$var$currentlyRenderingFiber, context);
}
function $b778ec20f9ee6541$var$readContextDuringReconciliation(consumer, context) {
    null === $b778ec20f9ee6541$var$currentlyRenderingFiber && $b778ec20f9ee6541$var$prepareToReadContext(consumer);
    return $b778ec20f9ee6541$var$readContextForConsumer(consumer, context);
}
function $b778ec20f9ee6541$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b778ec20f9ee6541$var$lastContextDependency) {
        if (null === consumer) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(308));
        $b778ec20f9ee6541$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b778ec20f9ee6541$var$lastContextDependency = $b778ec20f9ee6541$var$lastContextDependency.next = context;
    return value;
}
var $b778ec20f9ee6541$var$hasForceUpdate = !1;
function $b778ec20f9ee6541$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b778ec20f9ee6541$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b778ec20f9ee6541$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b778ec20f9ee6541$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b778ec20f9ee6541$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b778ec20f9ee6541$var$getRootForUpdatedFiber(fiber);
        $b778ec20f9ee6541$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b778ec20f9ee6541$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b778ec20f9ee6541$var$getRootForUpdatedFiber(fiber);
}
function $b778ec20f9ee6541$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b778ec20f9ee6541$var$markRootEntangled(root, lane);
    }
}
function $b778ec20f9ee6541$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b778ec20f9ee6541$var$didReadFromEntangledAsyncAction = !1;
function $b778ec20f9ee6541$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b778ec20f9ee6541$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b778ec20f9ee6541$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b778ec20f9ee6541$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b778ec20f9ee6541$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b778ec20f9ee6541$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b778ec20f9ee6541$var$currentEntangledLane && ($b778ec20f9ee6541$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b778ec20f9ee6541$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b778ec20f9ee6541$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b778ec20f9ee6541$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b778ec20f9ee6541$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b778ec20f9ee6541$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b778ec20f9ee6541$var$callCallback(callbacks[updateQueue], context);
}
function $b778ec20f9ee6541$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b778ec20f9ee6541$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $b778ec20f9ee6541$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b778ec20f9ee6541$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b778ec20f9ee6541$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b778ec20f9ee6541$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b778ec20f9ee6541$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b778ec20f9ee6541$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b778ec20f9ee6541$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b778ec20f9ee6541$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b778ec20f9ee6541$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b778ec20f9ee6541$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $b778ec20f9ee6541$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $b778ec20f9ee6541$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b778ec20f9ee6541$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b778ec20f9ee6541$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b778ec20f9ee6541$var$internalPropsKey] = newProps;
    } catch (error) {
        $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b778ec20f9ee6541$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $b778ec20f9ee6541$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b778ec20f9ee6541$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b778ec20f9ee6541$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b778ec20f9ee6541$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($b778ec20f9ee6541$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b778ec20f9ee6541$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b778ec20f9ee6541$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($b778ec20f9ee6541$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b778ec20f9ee6541$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $b778ec20f9ee6541$var$offscreenSubtreeIsHidden = !1, $b778ec20f9ee6541$var$offscreenSubtreeWasHidden = !1, $b778ec20f9ee6541$var$needsFormReset = !1, $b778ec20f9ee6541$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b778ec20f9ee6541$var$nextEffect = null, $b778ec20f9ee6541$var$shouldFireAfterActiveInstanceBlur = !1;
function $b778ec20f9ee6541$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b778ec20f9ee6541$var$eventsEnabled = $b778ec20f9ee6541$var$_enabled;
    root = $b778ec20f9ee6541$var$getActiveElementDeep(root);
    if ($b778ec20f9ee6541$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b778ec20f9ee6541$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b778ec20f9ee6541$var$_enabled = !1;
    for($b778ec20f9ee6541$var$nextEffect = firstChild; null !== $b778ec20f9ee6541$var$nextEffect;)if (firstChild = $b778ec20f9ee6541$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $b778ec20f9ee6541$var$nextEffect = root;
    else for(; null !== $b778ec20f9ee6541$var$nextEffect;){
        firstChild = $b778ec20f9ee6541$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b778ec20f9ee6541$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b778ec20f9ee6541$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b778ec20f9ee6541$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b778ec20f9ee6541$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b778ec20f9ee6541$var$nextEffect = root;
            break;
        }
        $b778ec20f9ee6541$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $b778ec20f9ee6541$var$shouldFireAfterActiveInstanceBlur;
    $b778ec20f9ee6541$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $b778ec20f9ee6541$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b778ec20f9ee6541$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b778ec20f9ee6541$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $b778ec20f9ee6541$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b778ec20f9ee6541$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $b778ec20f9ee6541$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $b778ec20f9ee6541$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b778ec20f9ee6541$var$commitHostMount(finishedWork);
            flags & 512 && $b778ec20f9ee6541$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b778ec20f9ee6541$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $b778ec20f9ee6541$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $b778ec20f9ee6541$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $b778ec20f9ee6541$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b778ec20f9ee6541$var$offscreenSubtreeWasHidden;
                $b778ec20f9ee6541$var$offscreenSubtreeIsHidden = prevProps;
                ($b778ec20f9ee6541$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b778ec20f9ee6541$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $b778ec20f9ee6541$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $b778ec20f9ee6541$var$safelyAttachRef(finishedWork, finishedWork.return) : $b778ec20f9ee6541$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b778ec20f9ee6541$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b778ec20f9ee6541$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b778ec20f9ee6541$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b778ec20f9ee6541$var$hostParent = null, $b778ec20f9ee6541$var$hostParentIsContainer = !1;
function $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b778ec20f9ee6541$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b778ec20f9ee6541$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b778ec20f9ee6541$var$injectedHook && "function" === typeof $b778ec20f9ee6541$var$injectedHook.onCommitFiberUnmount) try {
        $b778ec20f9ee6541$var$injectedHook.onCommitFiberUnmount($b778ec20f9ee6541$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden || $b778ec20f9ee6541$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden || $b778ec20f9ee6541$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b778ec20f9ee6541$var$hostParent, prevHostParentIsContainer = $b778ec20f9ee6541$var$hostParentIsContainer;
            $b778ec20f9ee6541$var$hostParent = deletedFiber.stateNode;
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $b778ec20f9ee6541$var$detachDeletedInstance(deletedFiber);
            $b778ec20f9ee6541$var$hostParent = prevHostParent;
            $b778ec20f9ee6541$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden || $b778ec20f9ee6541$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $b778ec20f9ee6541$var$hostParent;
            var prevHostParentIsContainer$119 = $b778ec20f9ee6541$var$hostParentIsContainer;
            $b778ec20f9ee6541$var$hostParent = null;
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b778ec20f9ee6541$var$hostParent = prevHostParentIsContainer;
            $b778ec20f9ee6541$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $b778ec20f9ee6541$var$hostParent) {
                if ($b778ec20f9ee6541$var$hostParentIsContainer) try {
                    finishedRoot = $b778ec20f9ee6541$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b778ec20f9ee6541$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b778ec20f9ee6541$var$hostParent && ($b778ec20f9ee6541$var$hostParentIsContainer ? (nearestMountedAncestor = $b778ec20f9ee6541$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $b778ec20f9ee6541$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $b778ec20f9ee6541$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $b778ec20f9ee6541$var$retryIfBlockedOn(nearestMountedAncestor)) : $b778ec20f9ee6541$var$clearSuspenseBoundary($b778ec20f9ee6541$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b778ec20f9ee6541$var$hostParent;
            prevHostParentIsContainer = $b778ec20f9ee6541$var$hostParentIsContainer;
            $b778ec20f9ee6541$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b778ec20f9ee6541$var$hostParentIsContainer = !0;
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b778ec20f9ee6541$var$hostParent = prevHostParent;
            $b778ec20f9ee6541$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden || $b778ec20f9ee6541$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden || $b778ec20f9ee6541$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden || ($b778ec20f9ee6541$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b778ec20f9ee6541$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden || $b778ec20f9ee6541$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden = (prevHostParent = $b778ec20f9ee6541$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b778ec20f9ee6541$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b778ec20f9ee6541$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b778ec20f9ee6541$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b778ec20f9ee6541$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b778ec20f9ee6541$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b778ec20f9ee6541$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b778ec20f9ee6541$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b778ec20f9ee6541$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $b778ec20f9ee6541$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $b778ec20f9ee6541$var$hostParent = parent.stateNode;
                    $b778ec20f9ee6541$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $b778ec20f9ee6541$var$hostParent = parent.stateNode.containerInfo;
                    $b778ec20f9ee6541$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $b778ec20f9ee6541$var$hostParent = parent.stateNode.containerInfo;
                    $b778ec20f9ee6541$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b778ec20f9ee6541$var$hostParent) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(160));
        $b778ec20f9ee6541$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b778ec20f9ee6541$var$hostParent = null;
        $b778ec20f9ee6541$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$b778ec20f9ee6541$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b778ec20f9ee6541$var$currentHoistableRoot = null;
function $b778ec20f9ee6541$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b778ec20f9ee6541$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b778ec20f9ee6541$var$commitHookEffectListMount(3, finishedWork), $b778ec20f9ee6541$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b778ec20f9ee6541$var$offscreenSubtreeWasHidden || null === current || $b778ec20f9ee6541$var$safelyDetachRef(current, current.return));
            flags & 64 && $b778ec20f9ee6541$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b778ec20f9ee6541$var$currentHoistableRoot;
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b778ec20f9ee6541$var$offscreenSubtreeWasHidden || null === current || $b778ec20f9ee6541$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b778ec20f9ee6541$var$internalHoistableMarker] || currentResource[$b778ec20f9ee6541$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b778ec20f9ee6541$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b778ec20f9ee6541$var$internalInstanceKey] = finishedWork;
                                        $b778ec20f9ee6541$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b778ec20f9ee6541$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b778ec20f9ee6541$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b778ec20f9ee6541$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b778ec20f9ee6541$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b778ec20f9ee6541$var$internalInstanceKey] = finishedWork;
                                $b778ec20f9ee6541$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b778ec20f9ee6541$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b778ec20f9ee6541$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b778ec20f9ee6541$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b778ec20f9ee6541$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b778ec20f9ee6541$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$b778ec20f9ee6541$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $b778ec20f9ee6541$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$b778ec20f9ee6541$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$b778ec20f9ee6541$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b778ec20f9ee6541$var$offscreenSubtreeWasHidden || null === current || $b778ec20f9ee6541$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b778ec20f9ee6541$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b778ec20f9ee6541$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b778ec20f9ee6541$var$needsFormReset = !0);
            break;
        case 6:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b778ec20f9ee6541$var$tagCaches = null;
            hoistableRoot = $b778ec20f9ee6541$var$currentHoistableRoot;
            $b778ec20f9ee6541$var$currentHoistableRoot = $b778ec20f9ee6541$var$getHoistableRoot(root.containerInfo);
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$currentHoistableRoot = hoistableRoot;
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b778ec20f9ee6541$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b778ec20f9ee6541$var$needsFormReset && ($b778ec20f9ee6541$var$needsFormReset = !1, $b778ec20f9ee6541$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b778ec20f9ee6541$var$currentHoistableRoot;
            $b778ec20f9ee6541$var$currentHoistableRoot = $b778ec20f9ee6541$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            $b778ec20f9ee6541$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b778ec20f9ee6541$var$globalMostRecentFallbackTime = $b778ec20f9ee6541$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b778ec20f9ee6541$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($b778ec20f9ee6541$var$offscreenSubtreeWasHidden || null === current || $b778ec20f9ee6541$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $b778ec20f9ee6541$var$offscreenSubtreeIsHidden;
            type = $b778ec20f9ee6541$var$offscreenSubtreeWasHidden;
            $b778ec20f9ee6541$var$offscreenSubtreeIsHidden = nodeName || node;
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden = type || nextNode;
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$offscreenSubtreeWasHidden = type;
            $b778ec20f9ee6541$var$offscreenSubtreeIsHidden = nodeName;
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $b778ec20f9ee6541$var$offscreenSubtreeIsHidden || $b778ec20f9ee6541$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $b778ec20f9ee6541$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b778ec20f9ee6541$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $b778ec20f9ee6541$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b778ec20f9ee6541$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b778ec20f9ee6541$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $b778ec20f9ee6541$var$recursivelyTraverseMutationEffects(root, finishedWork), $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork);
    }
}
function $b778ec20f9ee6541$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($b778ec20f9ee6541$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $b778ec20f9ee6541$var$getHostSibling(finishedWork);
                        $b778ec20f9ee6541$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($b778ec20f9ee6541$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $b778ec20f9ee6541$var$getHostSibling(finishedWork);
                        $b778ec20f9ee6541$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $b778ec20f9ee6541$var$getHostSibling(finishedWork);
                        $b778ec20f9ee6541$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b778ec20f9ee6541$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b778ec20f9ee6541$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b778ec20f9ee6541$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b778ec20f9ee6541$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b778ec20f9ee6541$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b778ec20f9ee6541$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b778ec20f9ee6541$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b778ec20f9ee6541$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b778ec20f9ee6541$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b778ec20f9ee6541$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $b778ec20f9ee6541$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b778ec20f9ee6541$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $b778ec20f9ee6541$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $b778ec20f9ee6541$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b778ec20f9ee6541$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b778ec20f9ee6541$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b778ec20f9ee6541$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b778ec20f9ee6541$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b778ec20f9ee6541$var$commitClassCallbacks(finishedWork);
                $b778ec20f9ee6541$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b778ec20f9ee6541$var$commitHostMount(finishedWork);
                $b778ec20f9ee6541$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b778ec20f9ee6541$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b778ec20f9ee6541$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $b778ec20f9ee6541$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b778ec20f9ee6541$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b778ec20f9ee6541$var$releaseCache(previousCache));
}
function $b778ec20f9ee6541$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b778ec20f9ee6541$var$releaseCache(current));
}
function $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b778ec20f9ee6541$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b778ec20f9ee6541$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b778ec20f9ee6541$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b778ec20f9ee6541$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b778ec20f9ee6541$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b778ec20f9ee6541$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $b778ec20f9ee6541$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $b778ec20f9ee6541$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b778ec20f9ee6541$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b778ec20f9ee6541$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b778ec20f9ee6541$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b778ec20f9ee6541$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $b778ec20f9ee6541$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b778ec20f9ee6541$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $b778ec20f9ee6541$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b778ec20f9ee6541$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b778ec20f9ee6541$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b778ec20f9ee6541$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b778ec20f9ee6541$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b778ec20f9ee6541$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b778ec20f9ee6541$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b778ec20f9ee6541$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b778ec20f9ee6541$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b778ec20f9ee6541$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b778ec20f9ee6541$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b778ec20f9ee6541$var$suspenseyCommitFlag = 8192;
function $b778ec20f9ee6541$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $b778ec20f9ee6541$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b778ec20f9ee6541$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b778ec20f9ee6541$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $b778ec20f9ee6541$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $b778ec20f9ee6541$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b778ec20f9ee6541$var$suspendResource($b778ec20f9ee6541$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b778ec20f9ee6541$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b778ec20f9ee6541$var$currentHoistableRoot;
            $b778ec20f9ee6541$var$currentHoistableRoot = $b778ec20f9ee6541$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b778ec20f9ee6541$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $b778ec20f9ee6541$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b778ec20f9ee6541$var$suspenseyCommitFlag, $b778ec20f9ee6541$var$suspenseyCommitFlag = 16777216, $b778ec20f9ee6541$var$recursivelyAccumulateSuspenseyCommit(fiber), $b778ec20f9ee6541$var$suspenseyCommitFlag = previousHoistableRoot) : $b778ec20f9ee6541$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $b778ec20f9ee6541$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $b778ec20f9ee6541$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b778ec20f9ee6541$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b778ec20f9ee6541$var$nextEffect = childToDelete;
            $b778ec20f9ee6541$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b778ec20f9ee6541$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b778ec20f9ee6541$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b778ec20f9ee6541$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b778ec20f9ee6541$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $b778ec20f9ee6541$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b778ec20f9ee6541$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b778ec20f9ee6541$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b778ec20f9ee6541$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b778ec20f9ee6541$var$nextEffect = childToDelete;
            $b778ec20f9ee6541$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b778ec20f9ee6541$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b778ec20f9ee6541$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b778ec20f9ee6541$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $b778ec20f9ee6541$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b778ec20f9ee6541$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b778ec20f9ee6541$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b778ec20f9ee6541$var$nextEffect;){
        var fiber = $b778ec20f9ee6541$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b778ec20f9ee6541$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b778ec20f9ee6541$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b778ec20f9ee6541$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b778ec20f9ee6541$var$nextEffect;){
            cache = $b778ec20f9ee6541$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b778ec20f9ee6541$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b778ec20f9ee6541$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b778ec20f9ee6541$var$nextEffect = sibling;
                break a;
            }
            $b778ec20f9ee6541$var$nextEffect = returnFiber;
        }
    }
}
function $b778ec20f9ee6541$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b778ec20f9ee6541$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b778ec20f9ee6541$var$FiberNode(tag, pendingProps, key, mode);
}
function $b778ec20f9ee6541$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b778ec20f9ee6541$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b778ec20f9ee6541$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b778ec20f9ee6541$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b778ec20f9ee6541$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b778ec20f9ee6541$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b778ec20f9ee6541$var$isHostHoistableType(type, pendingProps, $b778ec20f9ee6541$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b778ec20f9ee6541$var$REACT_FRAGMENT_TYPE:
            return $b778ec20f9ee6541$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b778ec20f9ee6541$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b778ec20f9ee6541$var$REACT_PROFILER_TYPE:
            return type = $b778ec20f9ee6541$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b778ec20f9ee6541$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b778ec20f9ee6541$var$REACT_SUSPENSE_TYPE:
            return type = $b778ec20f9ee6541$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b778ec20f9ee6541$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b778ec20f9ee6541$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b778ec20f9ee6541$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b778ec20f9ee6541$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $b778ec20f9ee6541$var$REACT_OFFSCREEN_TYPE:
            return $b778ec20f9ee6541$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b778ec20f9ee6541$var$REACT_PROVIDER_TYPE:
                case $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b778ec20f9ee6541$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b778ec20f9ee6541$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b778ec20f9ee6541$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b778ec20f9ee6541$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b778ec20f9ee6541$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b778ec20f9ee6541$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b778ec20f9ee6541$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b778ec20f9ee6541$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b778ec20f9ee6541$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $b778ec20f9ee6541$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $b778ec20f9ee6541$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $b778ec20f9ee6541$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $b778ec20f9ee6541$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $b778ec20f9ee6541$var$createFiberFromText(content, mode, lanes) {
    content = $b778ec20f9ee6541$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b778ec20f9ee6541$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b778ec20f9ee6541$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $b778ec20f9ee6541$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b778ec20f9ee6541$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b778ec20f9ee6541$var$preloadResource(resource)) {
        resource = $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 4194176) === $b778ec20f9ee6541$var$workInProgressRootRenderLanes ? null !== $b778ec20f9ee6541$var$shellBoundary : ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 62914560) !== $b778ec20f9ee6541$var$workInProgressRootRenderLanes && 0 === ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 536870912) || resource !== $b778ec20f9ee6541$var$shellBoundary)) throw $b778ec20f9ee6541$var$suspendedThenable = $b778ec20f9ee6541$var$noopSuspenseyCommitThenable, $b778ec20f9ee6541$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $b778ec20f9ee6541$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b778ec20f9ee6541$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b778ec20f9ee6541$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b778ec20f9ee6541$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b778ec20f9ee6541$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $b778ec20f9ee6541$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b778ec20f9ee6541$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b778ec20f9ee6541$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b778ec20f9ee6541$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b778ec20f9ee6541$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b778ec20f9ee6541$var$popProvider($b778ec20f9ee6541$var$CacheContext);
            $b778ec20f9ee6541$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b778ec20f9ee6541$var$popHydrationState(workInProgress) ? $b778ec20f9ee6541$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $b778ec20f9ee6541$var$hydrationErrors && ($b778ec20f9ee6541$var$queueRecoverableErrors($b778ec20f9ee6541$var$hydrationErrors), $b778ec20f9ee6541$var$hydrationErrors = null));
            $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($b778ec20f9ee6541$var$markUpdate(workInProgress), null !== renderLanes ? ($b778ec20f9ee6541$var$bubbleProperties(workInProgress), $b778ec20f9ee6541$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($b778ec20f9ee6541$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($b778ec20f9ee6541$var$markUpdate(workInProgress), $b778ec20f9ee6541$var$bubbleProperties(workInProgress), $b778ec20f9ee6541$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($b778ec20f9ee6541$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $b778ec20f9ee6541$var$markUpdate(workInProgress), $b778ec20f9ee6541$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $b778ec20f9ee6541$var$popHostContext(workInProgress);
            renderLanes = $b778ec20f9ee6541$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b778ec20f9ee6541$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(166));
                    $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b778ec20f9ee6541$var$contextStackCursor.current;
                $b778ec20f9ee6541$var$popHydrationState(workInProgress) ? $b778ec20f9ee6541$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b778ec20f9ee6541$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b778ec20f9ee6541$var$markUpdate(workInProgress));
            }
            $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b778ec20f9ee6541$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b778ec20f9ee6541$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(166));
                    $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b778ec20f9ee6541$var$contextStackCursor.current;
                if ($b778ec20f9ee6541$var$popHydrationState(workInProgress)) $b778ec20f9ee6541$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $b778ec20f9ee6541$var$getOwnerDocumentFromRootContainer($b778ec20f9ee6541$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$b778ec20f9ee6541$var$internalInstanceKey] = workInProgress;
                    current[$b778ec20f9ee6541$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($b778ec20f9ee6541$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $b778ec20f9ee6541$var$markUpdate(workInProgress);
                }
            }
            $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b778ec20f9ee6541$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(166));
                current = $b778ec20f9ee6541$var$rootInstanceStackCursor.current;
                if ($b778ec20f9ee6541$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b778ec20f9ee6541$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b778ec20f9ee6541$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b778ec20f9ee6541$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b778ec20f9ee6541$var$throwOnHydrationMismatch(workInProgress);
                } else current = $b778ec20f9ee6541$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b778ec20f9ee6541$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b778ec20f9ee6541$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(317));
                        type[$b778ec20f9ee6541$var$internalInstanceKey] = workInProgress;
                    } else $b778ec20f9ee6541$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $b778ec20f9ee6541$var$hydrationErrors && ($b778ec20f9ee6541$var$queueRecoverableErrors($b778ec20f9ee6541$var$hydrationErrors), $b778ec20f9ee6541$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b778ec20f9ee6541$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b778ec20f9ee6541$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b778ec20f9ee6541$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b778ec20f9ee6541$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b778ec20f9ee6541$var$popHostContainer(), null === current && $b778ec20f9ee6541$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b778ec20f9ee6541$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b778ec20f9ee6541$var$popProvider(workInProgress.type), $b778ec20f9ee6541$var$bubbleProperties(workInProgress), null;
        case 19:
            $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $b778ec20f9ee6541$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $b778ec20f9ee6541$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $b778ec20f9ee6541$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $b778ec20f9ee6541$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $b778ec20f9ee6541$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $b778ec20f9ee6541$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b778ec20f9ee6541$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseStackCursor, $b778ec20f9ee6541$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $b778ec20f9ee6541$var$now() > $b778ec20f9ee6541$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $b778ec20f9ee6541$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $b778ec20f9ee6541$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b778ec20f9ee6541$var$scheduleRetryEffect(workInProgress, current), $b778ec20f9ee6541$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$b778ec20f9ee6541$var$isHydrating) return $b778ec20f9ee6541$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b778ec20f9ee6541$var$now() - type.renderingStartTime > $b778ec20f9ee6541$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $b778ec20f9ee6541$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $b778ec20f9ee6541$var$now(), workInProgress.sibling = null, current = $b778ec20f9ee6541$var$suspenseStackCursor.current, $b778ec20f9ee6541$var$push($b778ec20f9ee6541$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $b778ec20f9ee6541$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b778ec20f9ee6541$var$popSuspenseHandler(workInProgress), $b778ec20f9ee6541$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b778ec20f9ee6541$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b778ec20f9ee6541$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b778ec20f9ee6541$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b778ec20f9ee6541$var$popProvider($b778ec20f9ee6541$var$CacheContext), $b778ec20f9ee6541$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b778ec20f9ee6541$var$unwindWork(current, workInProgress) {
    $b778ec20f9ee6541$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b778ec20f9ee6541$var$popProvider($b778ec20f9ee6541$var$CacheContext), $b778ec20f9ee6541$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b778ec20f9ee6541$var$popHostContext(workInProgress), null;
        case 13:
            $b778ec20f9ee6541$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(340));
                $b778ec20f9ee6541$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$suspenseStackCursor), null;
        case 4:
            return $b778ec20f9ee6541$var$popHostContainer(), null;
        case 10:
            return $b778ec20f9ee6541$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b778ec20f9ee6541$var$popSuspenseHandler(workInProgress), $b778ec20f9ee6541$var$popHiddenContext(), null !== current && $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b778ec20f9ee6541$var$popProvider($b778ec20f9ee6541$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b778ec20f9ee6541$var$unwindInterruptedWork(current, interruptedWork) {
    $b778ec20f9ee6541$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b778ec20f9ee6541$var$popProvider($b778ec20f9ee6541$var$CacheContext);
            $b778ec20f9ee6541$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b778ec20f9ee6541$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b778ec20f9ee6541$var$popHostContainer();
            break;
        case 13:
            $b778ec20f9ee6541$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$suspenseStackCursor);
            break;
        case 10:
            $b778ec20f9ee6541$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b778ec20f9ee6541$var$popSuspenseHandler(interruptedWork);
            $b778ec20f9ee6541$var$popHiddenContext();
            null !== current && $b778ec20f9ee6541$var$pop($b778ec20f9ee6541$var$resumedCache);
            break;
        case 24:
            $b778ec20f9ee6541$var$popProvider($b778ec20f9ee6541$var$CacheContext);
    }
}
var $b778ec20f9ee6541$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b778ec20f9ee6541$var$readContext($b778ec20f9ee6541$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $b778ec20f9ee6541$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b778ec20f9ee6541$var$executionContext = 0, $b778ec20f9ee6541$var$workInProgressRoot = null, $b778ec20f9ee6541$var$workInProgress = null, $b778ec20f9ee6541$var$workInProgressRootRenderLanes = 0, $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0, $b778ec20f9ee6541$var$workInProgressThrownValue = null, $b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b778ec20f9ee6541$var$workInProgressRootIsPrerendering = !1, $b778ec20f9ee6541$var$workInProgressRootDidAttachPingListener = !1, $b778ec20f9ee6541$var$entangledRenderLanes = 0, $b778ec20f9ee6541$var$workInProgressRootExitStatus = 0, $b778ec20f9ee6541$var$workInProgressRootSkippedLanes = 0, $b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes = 0, $b778ec20f9ee6541$var$workInProgressRootPingedLanes = 0, $b778ec20f9ee6541$var$workInProgressDeferredLane = 0, $b778ec20f9ee6541$var$workInProgressSuspendedRetryLanes = 0, $b778ec20f9ee6541$var$workInProgressRootConcurrentErrors = null, $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors = null, $b778ec20f9ee6541$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b778ec20f9ee6541$var$globalMostRecentFallbackTime = 0, $b778ec20f9ee6541$var$workInProgressRootRenderTargetTime = Infinity, $b778ec20f9ee6541$var$workInProgressTransitions = null, $b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed = null, $b778ec20f9ee6541$var$rootDoesHavePassiveEffects = !1, $b778ec20f9ee6541$var$rootWithPendingPassiveEffects = null, $b778ec20f9ee6541$var$pendingPassiveEffectsLanes = 0, $b778ec20f9ee6541$var$pendingPassiveEffectsRemainingLanes = 0, $b778ec20f9ee6541$var$pendingPassiveTransitions = null, $b778ec20f9ee6541$var$nestedUpdateCount = 0, $b778ec20f9ee6541$var$rootWithNestedUpdates = null;
function $b778ec20f9ee6541$var$requestUpdateLane() {
    if (0 !== ($b778ec20f9ee6541$var$executionContext & 2) && 0 !== $b778ec20f9ee6541$var$workInProgressRootRenderLanes) return $b778ec20f9ee6541$var$workInProgressRootRenderLanes & -$b778ec20f9ee6541$var$workInProgressRootRenderLanes;
    if (null !== $b778ec20f9ee6541$var$ReactSharedInternals.T) {
        var actionScopeLane = $b778ec20f9ee6541$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $b778ec20f9ee6541$var$requestTransitionLane();
    }
    return $b778ec20f9ee6541$var$resolveUpdatePriority();
}
function $b778ec20f9ee6541$var$requestDeferredLane() {
    0 === $b778ec20f9ee6541$var$workInProgressDeferredLane && ($b778ec20f9ee6541$var$workInProgressDeferredLane = 0 === ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 536870912) || $b778ec20f9ee6541$var$isHydrating ? $b778ec20f9ee6541$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $b778ec20f9ee6541$var$workInProgressDeferredLane;
}
function $b778ec20f9ee6541$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b778ec20f9ee6541$var$workInProgressRoot && 2 === $b778ec20f9ee6541$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $b778ec20f9ee6541$var$prepareFreshStack(root, 0), $b778ec20f9ee6541$var$markRootSuspended(root, $b778ec20f9ee6541$var$workInProgressRootRenderLanes, $b778ec20f9ee6541$var$workInProgressDeferredLane, !1);
    $b778ec20f9ee6541$var$markRootUpdated$1(root, lane);
    if (0 === ($b778ec20f9ee6541$var$executionContext & 2) || root !== $b778ec20f9ee6541$var$workInProgressRoot) root === $b778ec20f9ee6541$var$workInProgressRoot && (0 === ($b778ec20f9ee6541$var$executionContext & 2) && ($b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b778ec20f9ee6541$var$workInProgressRootExitStatus && $b778ec20f9ee6541$var$markRootSuspended(root, $b778ec20f9ee6541$var$workInProgressRootRenderLanes, $b778ec20f9ee6541$var$workInProgressDeferredLane, !1)), $b778ec20f9ee6541$var$ensureRootIsScheduled(root);
}
function $b778ec20f9ee6541$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b778ec20f9ee6541$var$executionContext & 6)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b778ec20f9ee6541$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b778ec20f9ee6541$var$renderRootConcurrent(root$jscomp$0, lanes) : $b778ec20f9ee6541$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b778ec20f9ee6541$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b778ec20f9ee6541$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $b778ec20f9ee6541$var$markRootSuspended(root$jscomp$0, lanes, 0, !$b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b778ec20f9ee6541$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b778ec20f9ee6541$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b778ec20f9ee6541$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b778ec20f9ee6541$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b778ec20f9ee6541$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b778ec20f9ee6541$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors;
                            $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $b778ec20f9ee6541$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b778ec20f9ee6541$var$prepareFreshStack(root$jscomp$0, 0);
                $b778ec20f9ee6541$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $b778ec20f9ee6541$var$markRootSuspended(shouldTimeSlice, lanes, $b778ec20f9ee6541$var$workInProgressDeferredLane, !$b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $b778ec20f9ee6541$var$globalMostRecentFallbackTime + 300 - $b778ec20f9ee6541$var$now(), 10 < renderWasConcurrent)) {
                    $b778ec20f9ee6541$var$markRootSuspended(shouldTimeSlice, lanes, $b778ec20f9ee6541$var$workInProgressDeferredLane, !$b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b778ec20f9ee6541$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $b778ec20f9ee6541$var$scheduleTimeout($b778ec20f9ee6541$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors, $b778ec20f9ee6541$var$workInProgressTransitions, $b778ec20f9ee6541$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b778ec20f9ee6541$var$workInProgressDeferredLane, $b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes, $b778ec20f9ee6541$var$workInProgressSuspendedRetryLanes, $b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $b778ec20f9ee6541$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors, $b778ec20f9ee6541$var$workInProgressTransitions, $b778ec20f9ee6541$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b778ec20f9ee6541$var$workInProgressDeferredLane, $b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes, $b778ec20f9ee6541$var$workInProgressSuspendedRetryLanes, $b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $b778ec20f9ee6541$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b778ec20f9ee6541$var$queueRecoverableErrors(errors) {
    null === $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors ? $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors = errors : $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors.push.apply($b778ec20f9ee6541$var$workInProgressRootRecoverableErrors, errors);
}
function $b778ec20f9ee6541$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($b778ec20f9ee6541$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $b778ec20f9ee6541$var$noop
        }, $b778ec20f9ee6541$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $b778ec20f9ee6541$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($b778ec20f9ee6541$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $b778ec20f9ee6541$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b778ec20f9ee6541$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $b778ec20f9ee6541$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b778ec20f9ee6541$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b778ec20f9ee6541$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b778ec20f9ee6541$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $b778ec20f9ee6541$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b778ec20f9ee6541$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b778ec20f9ee6541$var$flushSyncWork$1() {
    return 0 === ($b778ec20f9ee6541$var$executionContext & 6) ? ($b778ec20f9ee6541$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b778ec20f9ee6541$var$resetWorkInProgressStack() {
    if (null !== $b778ec20f9ee6541$var$workInProgress) {
        if (0 === $b778ec20f9ee6541$var$workInProgressSuspendedReason) var interruptedWork = $b778ec20f9ee6541$var$workInProgress.return;
        else interruptedWork = $b778ec20f9ee6541$var$workInProgress, $b778ec20f9ee6541$var$lastContextDependency = $b778ec20f9ee6541$var$currentlyRenderingFiber = null, $b778ec20f9ee6541$var$resetHooksOnUnwind(interruptedWork), $b778ec20f9ee6541$var$thenableState$1 = null, $b778ec20f9ee6541$var$thenableIndexCounter$1 = 0, interruptedWork = $b778ec20f9ee6541$var$workInProgress;
        for(; null !== interruptedWork;)$b778ec20f9ee6541$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b778ec20f9ee6541$var$workInProgress = null;
    }
}
function $b778ec20f9ee6541$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b778ec20f9ee6541$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b778ec20f9ee6541$var$resetWorkInProgressStack();
    $b778ec20f9ee6541$var$workInProgressRoot = root;
    $b778ec20f9ee6541$var$workInProgress = timeoutHandle = $b778ec20f9ee6541$var$createWorkInProgress(root.current, null);
    $b778ec20f9ee6541$var$workInProgressRootRenderLanes = lanes;
    $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0;
    $b778ec20f9ee6541$var$workInProgressThrownValue = null;
    $b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b778ec20f9ee6541$var$workInProgressRootIsPrerendering = $b778ec20f9ee6541$var$checkIfRootIsPrerendering(root, lanes);
    $b778ec20f9ee6541$var$workInProgressRootDidAttachPingListener = !1;
    $b778ec20f9ee6541$var$workInProgressSuspendedRetryLanes = $b778ec20f9ee6541$var$workInProgressDeferredLane = $b778ec20f9ee6541$var$workInProgressRootPingedLanes = $b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes = $b778ec20f9ee6541$var$workInProgressRootSkippedLanes = $b778ec20f9ee6541$var$workInProgressRootExitStatus = 0;
    $b778ec20f9ee6541$var$workInProgressRootRecoverableErrors = $b778ec20f9ee6541$var$workInProgressRootConcurrentErrors = null;
    $b778ec20f9ee6541$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $b778ec20f9ee6541$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $b778ec20f9ee6541$var$entangledRenderLanes = lanes;
    $b778ec20f9ee6541$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b778ec20f9ee6541$var$handleThrow(root, thrownValue) {
    $b778ec20f9ee6541$var$currentlyRenderingFiber$1 = null;
    $b778ec20f9ee6541$var$ReactSharedInternals.H = $b778ec20f9ee6541$var$ContextOnlyDispatcher;
    thrownValue === $b778ec20f9ee6541$var$SuspenseException ? (thrownValue = $b778ec20f9ee6541$var$getSuspendedThenable(), $b778ec20f9ee6541$var$workInProgressSuspendedReason = 3) : thrownValue === $b778ec20f9ee6541$var$SuspenseyCommitException ? (thrownValue = $b778ec20f9ee6541$var$getSuspendedThenable(), $b778ec20f9ee6541$var$workInProgressSuspendedReason = 4) : $b778ec20f9ee6541$var$workInProgressSuspendedReason = thrownValue === $b778ec20f9ee6541$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b778ec20f9ee6541$var$workInProgressThrownValue = thrownValue;
    null === $b778ec20f9ee6541$var$workInProgress && ($b778ec20f9ee6541$var$workInProgressRootExitStatus = 1, $b778ec20f9ee6541$var$logUncaughtError(root, $b778ec20f9ee6541$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b778ec20f9ee6541$var$pushDispatcher() {
    var prevDispatcher = $b778ec20f9ee6541$var$ReactSharedInternals.H;
    $b778ec20f9ee6541$var$ReactSharedInternals.H = $b778ec20f9ee6541$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b778ec20f9ee6541$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b778ec20f9ee6541$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b778ec20f9ee6541$var$ReactSharedInternals.A;
    $b778ec20f9ee6541$var$ReactSharedInternals.A = $b778ec20f9ee6541$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b778ec20f9ee6541$var$renderDidSuspendDelayIfPossible() {
    $b778ec20f9ee6541$var$workInProgressRootExitStatus = 4;
    $b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings || ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 4194176) !== $b778ec20f9ee6541$var$workInProgressRootRenderLanes && null !== $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current || ($b778ec20f9ee6541$var$workInProgressRootIsPrerendering = !0);
    0 === ($b778ec20f9ee6541$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b778ec20f9ee6541$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b778ec20f9ee6541$var$workInProgressRoot || $b778ec20f9ee6541$var$markRootSuspended($b778ec20f9ee6541$var$workInProgressRoot, $b778ec20f9ee6541$var$workInProgressRootRenderLanes, $b778ec20f9ee6541$var$workInProgressDeferredLane, !1);
}
function $b778ec20f9ee6541$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b778ec20f9ee6541$var$executionContext;
    $b778ec20f9ee6541$var$executionContext |= 2;
    var prevDispatcher = $b778ec20f9ee6541$var$pushDispatcher(), prevAsyncDispatcher = $b778ec20f9ee6541$var$pushAsyncDispatcher();
    if ($b778ec20f9ee6541$var$workInProgressRoot !== root || $b778ec20f9ee6541$var$workInProgressRootRenderLanes !== lanes) $b778ec20f9ee6541$var$workInProgressTransitions = null, $b778ec20f9ee6541$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b778ec20f9ee6541$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b778ec20f9ee6541$var$workInProgressSuspendedReason && null !== $b778ec20f9ee6541$var$workInProgress) {
            var unitOfWork = $b778ec20f9ee6541$var$workInProgress, thrownValue = $b778ec20f9ee6541$var$workInProgressThrownValue;
            switch($b778ec20f9ee6541$var$workInProgressSuspendedReason){
                case 8:
                    $b778ec20f9ee6541$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b778ec20f9ee6541$var$workInProgressSuspendedReason;
                    $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0;
                    $b778ec20f9ee6541$var$workInProgressThrownValue = null;
                    $b778ec20f9ee6541$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b778ec20f9ee6541$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b778ec20f9ee6541$var$workInProgressSuspendedReason, $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0, $b778ec20f9ee6541$var$workInProgressThrownValue = null, $b778ec20f9ee6541$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b778ec20f9ee6541$var$workLoopSync();
        exitStatus = $b778ec20f9ee6541$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $b778ec20f9ee6541$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b778ec20f9ee6541$var$lastContextDependency = $b778ec20f9ee6541$var$currentlyRenderingFiber = null;
    $b778ec20f9ee6541$var$executionContext = prevExecutionContext;
    $b778ec20f9ee6541$var$ReactSharedInternals.H = prevDispatcher;
    $b778ec20f9ee6541$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b778ec20f9ee6541$var$workInProgress && ($b778ec20f9ee6541$var$workInProgressRoot = null, $b778ec20f9ee6541$var$workInProgressRootRenderLanes = 0, $b778ec20f9ee6541$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b778ec20f9ee6541$var$workLoopSync() {
    for(; null !== $b778ec20f9ee6541$var$workInProgress;)$b778ec20f9ee6541$var$performUnitOfWork($b778ec20f9ee6541$var$workInProgress);
}
function $b778ec20f9ee6541$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b778ec20f9ee6541$var$executionContext;
    $b778ec20f9ee6541$var$executionContext |= 2;
    var prevDispatcher = $b778ec20f9ee6541$var$pushDispatcher(), prevAsyncDispatcher = $b778ec20f9ee6541$var$pushAsyncDispatcher();
    $b778ec20f9ee6541$var$workInProgressRoot !== root || $b778ec20f9ee6541$var$workInProgressRootRenderLanes !== lanes ? ($b778ec20f9ee6541$var$workInProgressTransitions = null, $b778ec20f9ee6541$var$workInProgressRootRenderTargetTime = $b778ec20f9ee6541$var$now() + 500, $b778ec20f9ee6541$var$prepareFreshStack(root, lanes)) : $b778ec20f9ee6541$var$workInProgressRootIsPrerendering = $b778ec20f9ee6541$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b778ec20f9ee6541$var$workInProgressSuspendedReason && null !== $b778ec20f9ee6541$var$workInProgress) {
            lanes = $b778ec20f9ee6541$var$workInProgress;
            var thrownValue = $b778ec20f9ee6541$var$workInProgressThrownValue;
            b: switch($b778ec20f9ee6541$var$workInProgressSuspendedReason){
                case 1:
                    $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0;
                    $b778ec20f9ee6541$var$workInProgressThrownValue = null;
                    $b778ec20f9ee6541$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($b778ec20f9ee6541$var$isThenableResolved(thrownValue)) {
                        $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0;
                        $b778ec20f9ee6541$var$workInProgressThrownValue = null;
                        $b778ec20f9ee6541$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $b778ec20f9ee6541$var$workInProgressSuspendedReason && $b778ec20f9ee6541$var$workInProgressRoot === root && ($b778ec20f9ee6541$var$workInProgressSuspendedReason = 7);
                        $b778ec20f9ee6541$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b778ec20f9ee6541$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b778ec20f9ee6541$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b778ec20f9ee6541$var$isThenableResolved(thrownValue) ? ($b778ec20f9ee6541$var$workInProgressSuspendedReason = 0, $b778ec20f9ee6541$var$workInProgressThrownValue = null, $b778ec20f9ee6541$var$replaySuspendedUnitOfWork(lanes)) : ($b778ec20f9ee6541$var$workInProgressSuspendedReason = 0, $b778ec20f9ee6541$var$workInProgressThrownValue = null, $b778ec20f9ee6541$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b778ec20f9ee6541$var$workInProgress.tag){
                        case 26:
                            resource = $b778ec20f9ee6541$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b778ec20f9ee6541$var$workInProgress;
                            if (resource ? $b778ec20f9ee6541$var$preloadResource(resource) : 1) {
                                $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0;
                                $b778ec20f9ee6541$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b778ec20f9ee6541$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b778ec20f9ee6541$var$workInProgress = returnFiber, $b778ec20f9ee6541$var$completeUnitOfWork(returnFiber)) : $b778ec20f9ee6541$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0;
                    $b778ec20f9ee6541$var$workInProgressThrownValue = null;
                    $b778ec20f9ee6541$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b778ec20f9ee6541$var$workInProgressSuspendedReason = 0;
                    $b778ec20f9ee6541$var$workInProgressThrownValue = null;
                    $b778ec20f9ee6541$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b778ec20f9ee6541$var$resetWorkInProgressStack();
                    $b778ec20f9ee6541$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(462));
            }
        }
        $b778ec20f9ee6541$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $b778ec20f9ee6541$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $b778ec20f9ee6541$var$lastContextDependency = $b778ec20f9ee6541$var$currentlyRenderingFiber = null;
    $b778ec20f9ee6541$var$ReactSharedInternals.H = prevDispatcher;
    $b778ec20f9ee6541$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b778ec20f9ee6541$var$executionContext = prevExecutionContext;
    if (null !== $b778ec20f9ee6541$var$workInProgress) return 0;
    $b778ec20f9ee6541$var$workInProgressRoot = null;
    $b778ec20f9ee6541$var$workInProgressRootRenderLanes = 0;
    $b778ec20f9ee6541$var$finishQueueingConcurrentUpdates();
    return $b778ec20f9ee6541$var$workInProgressRootExitStatus;
}
function $b778ec20f9ee6541$var$workLoopConcurrent() {
    for(; null !== $b778ec20f9ee6541$var$workInProgress && !$b778ec20f9ee6541$var$shouldYield();)$b778ec20f9ee6541$var$performUnitOfWork($b778ec20f9ee6541$var$workInProgress);
}
function $b778ec20f9ee6541$var$performUnitOfWork(unitOfWork) {
    var next = $b778ec20f9ee6541$var$beginWork(unitOfWork.alternate, unitOfWork, $b778ec20f9ee6541$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b778ec20f9ee6541$var$completeUnitOfWork(unitOfWork) : $b778ec20f9ee6541$var$workInProgress = next;
}
function $b778ec20f9ee6541$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b778ec20f9ee6541$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b778ec20f9ee6541$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b778ec20f9ee6541$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b778ec20f9ee6541$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b778ec20f9ee6541$var$resetHooksOnUnwind(next);
        default:
            $b778ec20f9ee6541$var$unwindInterruptedWork(current, next), next = $b778ec20f9ee6541$var$workInProgress = $b778ec20f9ee6541$var$resetWorkInProgress(next, $b778ec20f9ee6541$var$entangledRenderLanes), next = $b778ec20f9ee6541$var$beginWork(current, next, $b778ec20f9ee6541$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b778ec20f9ee6541$var$completeUnitOfWork(unitOfWork) : $b778ec20f9ee6541$var$workInProgress = next;
}
function $b778ec20f9ee6541$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b778ec20f9ee6541$var$lastContextDependency = $b778ec20f9ee6541$var$currentlyRenderingFiber = null;
    $b778ec20f9ee6541$var$resetHooksOnUnwind(unitOfWork);
    $b778ec20f9ee6541$var$thenableState$1 = null;
    $b778ec20f9ee6541$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b778ec20f9ee6541$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b778ec20f9ee6541$var$workInProgressRootRenderLanes)) {
            $b778ec20f9ee6541$var$workInProgressRootExitStatus = 1;
            $b778ec20f9ee6541$var$logUncaughtError(root, $b778ec20f9ee6541$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b778ec20f9ee6541$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b778ec20f9ee6541$var$workInProgress = returnFiber, error;
        $b778ec20f9ee6541$var$workInProgressRootExitStatus = 1;
        $b778ec20f9ee6541$var$logUncaughtError(root, $b778ec20f9ee6541$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b778ec20f9ee6541$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b778ec20f9ee6541$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b778ec20f9ee6541$var$workInProgressRootIsPrerendering || 0 !== ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b778ec20f9ee6541$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b778ec20f9ee6541$var$unwindUnitOfWork(unitOfWork, root);
    } else $b778ec20f9ee6541$var$completeUnitOfWork(unitOfWork);
}
function $b778ec20f9ee6541$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b778ec20f9ee6541$var$unwindUnitOfWork(completedWork, $b778ec20f9ee6541$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b778ec20f9ee6541$var$completeWork(completedWork.alternate, completedWork, $b778ec20f9ee6541$var$entangledRenderLanes);
        if (null !== next) {
            $b778ec20f9ee6541$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b778ec20f9ee6541$var$workInProgress = completedWork;
            return;
        }
        $b778ec20f9ee6541$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b778ec20f9ee6541$var$workInProgressRootExitStatus && ($b778ec20f9ee6541$var$workInProgressRootExitStatus = 5);
}
function $b778ec20f9ee6541$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b778ec20f9ee6541$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b778ec20f9ee6541$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b778ec20f9ee6541$var$workInProgress = unitOfWork;
            return;
        }
        $b778ec20f9ee6541$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b778ec20f9ee6541$var$workInProgressRootExitStatus = 6;
    $b778ec20f9ee6541$var$workInProgress = null;
}
function $b778ec20f9ee6541$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $b778ec20f9ee6541$var$ReactSharedInternals.T, previousUpdateLanePriority = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p;
    try {
        $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = 2, $b778ec20f9ee6541$var$ReactSharedInternals.T = null, $b778ec20f9ee6541$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $b778ec20f9ee6541$var$ReactSharedInternals.T = prevTransition, $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $b778ec20f9ee6541$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $b778ec20f9ee6541$var$flushPassiveEffects();
    while (null !== $b778ec20f9ee6541$var$rootWithPendingPassiveEffects);
    if (0 !== ($b778ec20f9ee6541$var$executionContext & 6)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $b778ec20f9ee6541$var$concurrentlyUpdatedLanes;
    $b778ec20f9ee6541$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $b778ec20f9ee6541$var$workInProgressRoot && ($b778ec20f9ee6541$var$workInProgress = $b778ec20f9ee6541$var$workInProgressRoot = null, $b778ec20f9ee6541$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $b778ec20f9ee6541$var$rootDoesHavePassiveEffects || ($b778ec20f9ee6541$var$rootDoesHavePassiveEffects = !0, $b778ec20f9ee6541$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $b778ec20f9ee6541$var$pendingPassiveTransitions = transitions, $b778ec20f9ee6541$var$scheduleCallback$1($b778ec20f9ee6541$var$NormalPriority$1, function() {
        $b778ec20f9ee6541$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $b778ec20f9ee6541$var$ReactSharedInternals.T, $b778ec20f9ee6541$var$ReactSharedInternals.T = null, spawnedLane = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p, $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = 2, updatedLanes = $b778ec20f9ee6541$var$executionContext, $b778ec20f9ee6541$var$executionContext |= 4, $b778ec20f9ee6541$var$commitBeforeMutationEffects(root, finishedWork), $b778ec20f9ee6541$var$commitMutationEffectsOnFiber(finishedWork, root), $b778ec20f9ee6541$var$restoreSelection($b778ec20f9ee6541$var$selectionInformation, root.containerInfo), $b778ec20f9ee6541$var$_enabled = !!$b778ec20f9ee6541$var$eventsEnabled, $b778ec20f9ee6541$var$selectionInformation = $b778ec20f9ee6541$var$eventsEnabled = null, root.current = finishedWork, $b778ec20f9ee6541$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $b778ec20f9ee6541$var$requestPaint(), $b778ec20f9ee6541$var$executionContext = updatedLanes, $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = spawnedLane, $b778ec20f9ee6541$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $b778ec20f9ee6541$var$rootDoesHavePassiveEffects ? ($b778ec20f9ee6541$var$rootDoesHavePassiveEffects = !1, $b778ec20f9ee6541$var$rootWithPendingPassiveEffects = root, $b778ec20f9ee6541$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $b778ec20f9ee6541$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $b778ec20f9ee6541$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $b778ec20f9ee6541$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($b778ec20f9ee6541$var$pendingPassiveEffectsLanes & 3) && $b778ec20f9ee6541$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $b778ec20f9ee6541$var$rootWithNestedUpdates ? $b778ec20f9ee6541$var$nestedUpdateCount++ : ($b778ec20f9ee6541$var$nestedUpdateCount = 0, $b778ec20f9ee6541$var$rootWithNestedUpdates = root) : $b778ec20f9ee6541$var$nestedUpdateCount = 0;
    $b778ec20f9ee6541$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $b778ec20f9ee6541$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b778ec20f9ee6541$var$releaseCache(remainingLanes)));
}
function $b778ec20f9ee6541$var$flushPassiveEffects() {
    if (null !== $b778ec20f9ee6541$var$rootWithPendingPassiveEffects) {
        var root$170 = $b778ec20f9ee6541$var$rootWithPendingPassiveEffects, remainingLanes = $b778ec20f9ee6541$var$pendingPassiveEffectsRemainingLanes;
        $b778ec20f9ee6541$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $b778ec20f9ee6541$var$lanesToEventPriority($b778ec20f9ee6541$var$pendingPassiveEffectsLanes), prevTransition = $b778ec20f9ee6541$var$ReactSharedInternals.T, previousPriority = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p;
        try {
            $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $b778ec20f9ee6541$var$ReactSharedInternals.T = null;
            if (null === $b778ec20f9ee6541$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $b778ec20f9ee6541$var$pendingPassiveTransitions;
                $b778ec20f9ee6541$var$pendingPassiveTransitions = null;
                var root = $b778ec20f9ee6541$var$rootWithPendingPassiveEffects, lanes = $b778ec20f9ee6541$var$pendingPassiveEffectsLanes;
                $b778ec20f9ee6541$var$rootWithPendingPassiveEffects = null;
                $b778ec20f9ee6541$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($b778ec20f9ee6541$var$executionContext & 6)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(331));
                var prevExecutionContext = $b778ec20f9ee6541$var$executionContext;
                $b778ec20f9ee6541$var$executionContext |= 4;
                $b778ec20f9ee6541$var$commitPassiveUnmountOnFiber(root.current);
                $b778ec20f9ee6541$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $b778ec20f9ee6541$var$executionContext = prevExecutionContext;
                $b778ec20f9ee6541$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($b778ec20f9ee6541$var$injectedHook && "function" === typeof $b778ec20f9ee6541$var$injectedHook.onPostCommitFiberRoot) try {
                    $b778ec20f9ee6541$var$injectedHook.onPostCommitFiberRoot($b778ec20f9ee6541$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = previousPriority, $b778ec20f9ee6541$var$ReactSharedInternals.T = prevTransition, $b778ec20f9ee6541$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $b778ec20f9ee6541$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b778ec20f9ee6541$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b778ec20f9ee6541$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b778ec20f9ee6541$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b778ec20f9ee6541$var$markRootUpdated$1(rootFiber, 2), $b778ec20f9ee6541$var$ensureRootIsScheduled(rootFiber));
}
function $b778ec20f9ee6541$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b778ec20f9ee6541$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b778ec20f9ee6541$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed || !$b778ec20f9ee6541$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b778ec20f9ee6541$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b778ec20f9ee6541$var$createClassErrorUpdate(2);
                instance = $b778ec20f9ee6541$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b778ec20f9ee6541$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b778ec20f9ee6541$var$markRootUpdated$1(instance, 2), $b778ec20f9ee6541$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b778ec20f9ee6541$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b778ec20f9ee6541$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b778ec20f9ee6541$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b778ec20f9ee6541$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b778ec20f9ee6541$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b778ec20f9ee6541$var$workInProgressRoot === root && ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b778ec20f9ee6541$var$workInProgressRootExitStatus || 3 === $b778ec20f9ee6541$var$workInProgressRootExitStatus && ($b778ec20f9ee6541$var$workInProgressRootRenderLanes & 62914560) === $b778ec20f9ee6541$var$workInProgressRootRenderLanes && 300 > $b778ec20f9ee6541$var$now() - $b778ec20f9ee6541$var$globalMostRecentFallbackTime ? 0 === ($b778ec20f9ee6541$var$executionContext & 2) && $b778ec20f9ee6541$var$prepareFreshStack(root, 0) : $b778ec20f9ee6541$var$workInProgressRootPingedLanes |= pingedLanes, $b778ec20f9ee6541$var$workInProgressSuspendedRetryLanes === $b778ec20f9ee6541$var$workInProgressRootRenderLanes && ($b778ec20f9ee6541$var$workInProgressSuspendedRetryLanes = 0));
    $b778ec20f9ee6541$var$ensureRootIsScheduled(root);
}
function $b778ec20f9ee6541$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b778ec20f9ee6541$var$claimNextRetryLane());
    boundaryFiber = $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b778ec20f9ee6541$var$markRootUpdated$1(boundaryFiber, retryLane), $b778ec20f9ee6541$var$ensureRootIsScheduled(boundaryFiber));
}
function $b778ec20f9ee6541$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b778ec20f9ee6541$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b778ec20f9ee6541$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b778ec20f9ee6541$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b778ec20f9ee6541$var$scheduleCallback$1(priorityLevel, callback) {
    return $b778ec20f9ee6541$var$scheduleCallback$3(priorityLevel, callback);
}
var $b778ec20f9ee6541$var$firstScheduledRoot = null, $b778ec20f9ee6541$var$lastScheduledRoot = null, $b778ec20f9ee6541$var$didScheduleMicrotask = !1, $b778ec20f9ee6541$var$mightHavePendingSyncWork = !1, $b778ec20f9ee6541$var$isFlushingWork = !1, $b778ec20f9ee6541$var$currentEventTransitionLane = 0;
function $b778ec20f9ee6541$var$ensureRootIsScheduled(root) {
    root !== $b778ec20f9ee6541$var$lastScheduledRoot && null === root.next && (null === $b778ec20f9ee6541$var$lastScheduledRoot ? $b778ec20f9ee6541$var$firstScheduledRoot = $b778ec20f9ee6541$var$lastScheduledRoot = root : $b778ec20f9ee6541$var$lastScheduledRoot = $b778ec20f9ee6541$var$lastScheduledRoot.next = root);
    $b778ec20f9ee6541$var$mightHavePendingSyncWork = !0;
    $b778ec20f9ee6541$var$didScheduleMicrotask || ($b778ec20f9ee6541$var$didScheduleMicrotask = !0, $b778ec20f9ee6541$var$scheduleImmediateTask($b778ec20f9ee6541$var$processRootScheduleInMicrotask));
}
function $b778ec20f9ee6541$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b778ec20f9ee6541$var$isFlushingWork && $b778ec20f9ee6541$var$mightHavePendingSyncWork) {
        $b778ec20f9ee6541$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $b778ec20f9ee6541$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b778ec20f9ee6541$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b778ec20f9ee6541$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b778ec20f9ee6541$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b778ec20f9ee6541$var$getNextLanes(root$172, root$172 === $b778ec20f9ee6541$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $b778ec20f9ee6541$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b778ec20f9ee6541$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $b778ec20f9ee6541$var$isFlushingWork = !1;
    }
}
function $b778ec20f9ee6541$var$processRootScheduleInMicrotask() {
    $b778ec20f9ee6541$var$mightHavePendingSyncWork = $b778ec20f9ee6541$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b778ec20f9ee6541$var$currentEventTransitionLane && ($b778ec20f9ee6541$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b778ec20f9ee6541$var$currentEventTransitionLane), $b778ec20f9ee6541$var$currentEventTransitionLane = 0);
    for(var currentTime = $b778ec20f9ee6541$var$now(), prev = null, root = $b778ec20f9ee6541$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b778ec20f9ee6541$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b778ec20f9ee6541$var$firstScheduledRoot = next : prev.next = next, null === next && ($b778ec20f9ee6541$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b778ec20f9ee6541$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $b778ec20f9ee6541$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $b778ec20f9ee6541$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $b778ec20f9ee6541$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $b778ec20f9ee6541$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b778ec20f9ee6541$var$workInProgressRoot;
    suspendedLanes = $b778ec20f9ee6541$var$workInProgressRootRenderLanes;
    suspendedLanes = $b778ec20f9ee6541$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $b778ec20f9ee6541$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b778ec20f9ee6541$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b778ec20f9ee6541$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b778ec20f9ee6541$var$cancelCallback$1(pingedLanes);
        switch($b778ec20f9ee6541$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b778ec20f9ee6541$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b778ec20f9ee6541$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b778ec20f9ee6541$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b778ec20f9ee6541$var$NormalPriority$1;
        }
        pingedLanes = $b778ec20f9ee6541$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b778ec20f9ee6541$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b778ec20f9ee6541$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b778ec20f9ee6541$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($b778ec20f9ee6541$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b778ec20f9ee6541$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b778ec20f9ee6541$var$getNextLanes(root, root === $b778ec20f9ee6541$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b778ec20f9ee6541$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b778ec20f9ee6541$var$scheduleTaskForRootDuringMicrotask(root, $b778ec20f9ee6541$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b778ec20f9ee6541$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b778ec20f9ee6541$var$performSyncWorkOnRoot(root, lanes) {
    if ($b778ec20f9ee6541$var$flushPassiveEffects()) return null;
    $b778ec20f9ee6541$var$performWorkOnRoot(root, lanes, !0);
}
function $b778ec20f9ee6541$var$scheduleImmediateTask(cb) {
    $b778ec20f9ee6541$var$scheduleMicrotask(function() {
        0 !== ($b778ec20f9ee6541$var$executionContext & 6) ? $b778ec20f9ee6541$var$scheduleCallback$3($b778ec20f9ee6541$var$ImmediatePriority, cb) : cb();
    });
}
function $b778ec20f9ee6541$var$requestTransitionLane() {
    0 === $b778ec20f9ee6541$var$currentEventTransitionLane && ($b778ec20f9ee6541$var$currentEventTransitionLane = $b778ec20f9ee6541$var$claimNextTransitionLane());
    return $b778ec20f9ee6541$var$currentEventTransitionLane;
}
function $b778ec20f9ee6541$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b778ec20f9ee6541$var$sanitizeURL("" + actionProp);
}
function $b778ec20f9ee6541$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b778ec20f9ee6541$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b778ec20f9ee6541$var$coerceFormActionProp((nativeEventTarget[$b778ec20f9ee6541$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b778ec20f9ee6541$var$internalPropsKey] || null) ? $b778ec20f9ee6541$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b778ec20f9ee6541$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b778ec20f9ee6541$var$currentEventTransitionLane) {
                                var formData = submitter ? $b778ec20f9ee6541$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b778ec20f9ee6541$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b778ec20f9ee6541$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b778ec20f9ee6541$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b778ec20f9ee6541$var$i$jscomp$inline_1439 = 0; $b778ec20f9ee6541$var$i$jscomp$inline_1439 < $b778ec20f9ee6541$var$simpleEventPluginEvents.length; $b778ec20f9ee6541$var$i$jscomp$inline_1439++){
    var $b778ec20f9ee6541$var$eventName$jscomp$inline_1440 = $b778ec20f9ee6541$var$simpleEventPluginEvents[$b778ec20f9ee6541$var$i$jscomp$inline_1439], $b778ec20f9ee6541$var$domEventName$jscomp$inline_1441 = $b778ec20f9ee6541$var$eventName$jscomp$inline_1440.toLowerCase(), $b778ec20f9ee6541$var$capitalizedEvent$jscomp$inline_1442 = $b778ec20f9ee6541$var$eventName$jscomp$inline_1440[0].toUpperCase() + $b778ec20f9ee6541$var$eventName$jscomp$inline_1440.slice(1);
    $b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$domEventName$jscomp$inline_1441, "on" + $b778ec20f9ee6541$var$capitalizedEvent$jscomp$inline_1442);
}
$b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$ANIMATION_END, "onAnimationEnd");
$b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$ANIMATION_ITERATION, "onAnimationIteration");
$b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$ANIMATION_START, "onAnimationStart");
$b778ec20f9ee6541$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b778ec20f9ee6541$var$registerSimpleEvent("focusin", "onFocus");
$b778ec20f9ee6541$var$registerSimpleEvent("focusout", "onBlur");
$b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$TRANSITION_RUN, "onTransitionRun");
$b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$TRANSITION_START, "onTransitionStart");
$b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$TRANSITION_CANCEL, "onTransitionCancel");
$b778ec20f9ee6541$var$registerSimpleEvent($b778ec20f9ee6541$var$TRANSITION_END, "onTransitionEnd");
$b778ec20f9ee6541$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b778ec20f9ee6541$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b778ec20f9ee6541$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b778ec20f9ee6541$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b778ec20f9ee6541$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b778ec20f9ee6541$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b778ec20f9ee6541$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b778ec20f9ee6541$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b778ec20f9ee6541$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b778ec20f9ee6541$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b778ec20f9ee6541$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b778ec20f9ee6541$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b778ec20f9ee6541$var$mediaEventTypes));
function $b778ec20f9ee6541$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b778ec20f9ee6541$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b778ec20f9ee6541$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b778ec20f9ee6541$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b778ec20f9ee6541$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b778ec20f9ee6541$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b778ec20f9ee6541$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b778ec20f9ee6541$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b778ec20f9ee6541$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b778ec20f9ee6541$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b778ec20f9ee6541$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b778ec20f9ee6541$var$listeningMarker]) {
        rootContainerElement[$b778ec20f9ee6541$var$listeningMarker] = !0;
        $b778ec20f9ee6541$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b778ec20f9ee6541$var$nonDelegatedEvents.has(domEventName) || $b778ec20f9ee6541$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b778ec20f9ee6541$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b778ec20f9ee6541$var$listeningMarker] || (ownerDocument[$b778ec20f9ee6541$var$listeningMarker] = !0, $b778ec20f9ee6541$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b778ec20f9ee6541$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b778ec20f9ee6541$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b778ec20f9ee6541$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b778ec20f9ee6541$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b778ec20f9ee6541$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b778ec20f9ee6541$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b778ec20f9ee6541$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b778ec20f9ee6541$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b778ec20f9ee6541$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b778ec20f9ee6541$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b778ec20f9ee6541$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b778ec20f9ee6541$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticTouchEvent;
                        break;
                    case $b778ec20f9ee6541$var$ANIMATION_END:
                    case $b778ec20f9ee6541$var$ANIMATION_ITERATION:
                    case $b778ec20f9ee6541$var$ANIMATION_START:
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticAnimationEvent;
                        break;
                    case $b778ec20f9ee6541$var$TRANSITION_END:
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b778ec20f9ee6541$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b778ec20f9ee6541$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b778ec20f9ee6541$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b778ec20f9ee6541$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b778ec20f9ee6541$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b778ec20f9ee6541$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b778ec20f9ee6541$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b778ec20f9ee6541$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b778ec20f9ee6541$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b778ec20f9ee6541$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b778ec20f9ee6541$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b778ec20f9ee6541$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b778ec20f9ee6541$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $b778ec20f9ee6541$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $b778ec20f9ee6541$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $b778ec20f9ee6541$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $b778ec20f9ee6541$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $b778ec20f9ee6541$var$getParent(inCapturePhase);
                                reactEventName = $b778ec20f9ee6541$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b778ec20f9ee6541$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b778ec20f9ee6541$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b778ec20f9ee6541$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b778ec20f9ee6541$var$getTargetInstForChangeEvent;
                else if ($b778ec20f9ee6541$var$isTextInputElement(reactName)) {
                    if ($b778ec20f9ee6541$var$isInputEventSupported) getTargetInstFunc = $b778ec20f9ee6541$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b778ec20f9ee6541$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b778ec20f9ee6541$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b778ec20f9ee6541$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b778ec20f9ee6541$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b778ec20f9ee6541$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b778ec20f9ee6541$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b778ec20f9ee6541$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b778ec20f9ee6541$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b778ec20f9ee6541$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b778ec20f9ee6541$var$activeElement = handleEventFunc, $b778ec20f9ee6541$var$activeElementInst = targetInst, $b778ec20f9ee6541$var$lastSelection = null;
                    break;
                case "focusout":
                    $b778ec20f9ee6541$var$lastSelection = $b778ec20f9ee6541$var$activeElementInst = $b778ec20f9ee6541$var$activeElement = null;
                    break;
                case "mousedown":
                    $b778ec20f9ee6541$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b778ec20f9ee6541$var$mouseDown = !1;
                    $b778ec20f9ee6541$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b778ec20f9ee6541$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b778ec20f9ee6541$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b778ec20f9ee6541$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b778ec20f9ee6541$var$isComposing ? $b778ec20f9ee6541$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b778ec20f9ee6541$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b778ec20f9ee6541$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b778ec20f9ee6541$var$isComposing && (fallbackData = $b778ec20f9ee6541$var$getData()) : ($b778ec20f9ee6541$var$root = nativeEventTarget, $b778ec20f9ee6541$var$startText = "value" in $b778ec20f9ee6541$var$root ? $b778ec20f9ee6541$var$root.value : $b778ec20f9ee6541$var$root.textContent, $b778ec20f9ee6541$var$isComposing = !0)), handleEventFunc = $b778ec20f9ee6541$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b778ec20f9ee6541$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b778ec20f9ee6541$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b778ec20f9ee6541$var$canUseTextInputEvent ? $b778ec20f9ee6541$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b778ec20f9ee6541$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b778ec20f9ee6541$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b778ec20f9ee6541$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b778ec20f9ee6541$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b778ec20f9ee6541$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b778ec20f9ee6541$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b778ec20f9ee6541$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b778ec20f9ee6541$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b778ec20f9ee6541$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b778ec20f9ee6541$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b778ec20f9ee6541$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $b778ec20f9ee6541$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b778ec20f9ee6541$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b778ec20f9ee6541$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b778ec20f9ee6541$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b778ec20f9ee6541$var$getListener(target, registrationName), null != stateNode && listeners.push($b778ec20f9ee6541$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b778ec20f9ee6541$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b778ec20f9ee6541$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b778ec20f9ee6541$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b778ec20f9ee6541$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b778ec20f9ee6541$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b778ec20f9ee6541$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b778ec20f9ee6541$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b778ec20f9ee6541$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b778ec20f9ee6541$var$noop$1() {}
function $b778ec20f9ee6541$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b778ec20f9ee6541$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b778ec20f9ee6541$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b778ec20f9ee6541$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b778ec20f9ee6541$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b778ec20f9ee6541$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b778ec20f9ee6541$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b778ec20f9ee6541$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b778ec20f9ee6541$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b778ec20f9ee6541$var$setProp(domElement, tag, "name", props.name, props, null), $b778ec20f9ee6541$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b778ec20f9ee6541$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b778ec20f9ee6541$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b778ec20f9ee6541$var$setProp(domElement, tag, "encType", props.encType, props, null), $b778ec20f9ee6541$var$setProp(domElement, tag, "method", props.method, props, null), $b778ec20f9ee6541$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b778ec20f9ee6541$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b778ec20f9ee6541$var$noop$1);
            break;
        case "onScroll":
            null != value && $b778ec20f9ee6541$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b778ec20f9ee6541$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b778ec20f9ee6541$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("toggle", domElement);
            $b778ec20f9ee6541$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b778ec20f9ee6541$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b778ec20f9ee6541$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b778ec20f9ee6541$var$aliases.get(key) || key, $b778ec20f9ee6541$var$setValueForAttribute(domElement, key, value);
    }
}
function $b778ec20f9ee6541$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b778ec20f9ee6541$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b778ec20f9ee6541$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b778ec20f9ee6541$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b778ec20f9ee6541$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b778ec20f9ee6541$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b778ec20f9ee6541$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b778ec20f9ee6541$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b778ec20f9ee6541$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b778ec20f9ee6541$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b778ec20f9ee6541$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("error", domElement);
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(137, tag));
                    default:
                        $b778ec20f9ee6541$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b778ec20f9ee6541$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b778ec20f9ee6541$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b778ec20f9ee6541$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $b778ec20f9ee6541$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $b778ec20f9ee6541$var$track(domElement);
            return;
        case "select":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b778ec20f9ee6541$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b778ec20f9ee6541$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b778ec20f9ee6541$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $b778ec20f9ee6541$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("cancel", domElement);
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b778ec20f9ee6541$var$mediaEventTypes.length; hasSrc++)$b778ec20f9ee6541$var$listenToNonDelegatedEvent($b778ec20f9ee6541$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("error", domElement);
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b778ec20f9ee6541$var$listenToNonDelegatedEvent("error", domElement), $b778ec20f9ee6541$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(137, tag));
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b778ec20f9ee6541$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $b778ec20f9ee6541$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b778ec20f9ee6541$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b778ec20f9ee6541$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b778ec20f9ee6541$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b778ec20f9ee6541$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $b778ec20f9ee6541$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b778ec20f9ee6541$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b778ec20f9ee6541$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $b778ec20f9ee6541$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $b778ec20f9ee6541$var$updateOptions(domElement, !!lastProps, tag, !0) : $b778ec20f9ee6541$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b778ec20f9ee6541$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b778ec20f9ee6541$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $b778ec20f9ee6541$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b778ec20f9ee6541$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($b778ec20f9ee6541$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $b778ec20f9ee6541$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $b778ec20f9ee6541$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $b778ec20f9ee6541$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $b778ec20f9ee6541$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $b778ec20f9ee6541$var$eventsEnabled = null, $b778ec20f9ee6541$var$selectionInformation = null;
function $b778ec20f9ee6541$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b778ec20f9ee6541$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b778ec20f9ee6541$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b778ec20f9ee6541$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b778ec20f9ee6541$var$currentPopstateTransitionEvent = null;
function $b778ec20f9ee6541$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b778ec20f9ee6541$var$currentPopstateTransitionEvent) return !1;
        $b778ec20f9ee6541$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b778ec20f9ee6541$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b778ec20f9ee6541$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b778ec20f9ee6541$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b778ec20f9ee6541$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b778ec20f9ee6541$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b778ec20f9ee6541$var$localPromise ? function(callback) {
    return $b778ec20f9ee6541$var$localPromise.resolve(null).then(callback).catch($b778ec20f9ee6541$var$handleErrorInNextTick);
} : $b778ec20f9ee6541$var$scheduleTimeout;
function $b778ec20f9ee6541$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b778ec20f9ee6541$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b778ec20f9ee6541$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $b778ec20f9ee6541$var$retryIfBlockedOn(suspenseInstance);
}
function $b778ec20f9ee6541$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b778ec20f9ee6541$var$clearContainerSparingly(node);
                $b778ec20f9ee6541$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b778ec20f9ee6541$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b778ec20f9ee6541$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b778ec20f9ee6541$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b778ec20f9ee6541$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b778ec20f9ee6541$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b778ec20f9ee6541$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $b778ec20f9ee6541$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b778ec20f9ee6541$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b778ec20f9ee6541$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(451));
    }
}
var $b778ec20f9ee6541$var$preloadPropsMap = new Map(), $b778ec20f9ee6541$var$preconnectsSet = new Set();
function $b778ec20f9ee6541$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $b778ec20f9ee6541$var$previousDispatcher = $b778ec20f9ee6541$var$ReactDOMSharedInternals.d;
$b778ec20f9ee6541$var$ReactDOMSharedInternals.d = {
    f: $b778ec20f9ee6541$var$flushSyncWork,
    r: $b778ec20f9ee6541$var$requestFormReset,
    D: $b778ec20f9ee6541$var$prefetchDNS,
    C: $b778ec20f9ee6541$var$preconnect,
    L: $b778ec20f9ee6541$var$preload,
    m: $b778ec20f9ee6541$var$preloadModule,
    X: $b778ec20f9ee6541$var$preinitScript,
    S: $b778ec20f9ee6541$var$preinitStyle,
    M: $b778ec20f9ee6541$var$preinitModuleScript
};
function $b778ec20f9ee6541$var$flushSyncWork() {
    var previousWasRendering = $b778ec20f9ee6541$var$previousDispatcher.f(), wasRendering = $b778ec20f9ee6541$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b778ec20f9ee6541$var$requestFormReset(form) {
    var formInst = $b778ec20f9ee6541$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b778ec20f9ee6541$var$requestFormReset$1(formInst) : $b778ec20f9ee6541$var$previousDispatcher.r(form);
}
var $b778ec20f9ee6541$var$globalDocument = "undefined" === typeof document ? null : document;
function $b778ec20f9ee6541$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b778ec20f9ee6541$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b778ec20f9ee6541$var$preconnectsSet.has(limitedEscapedHref) || ($b778ec20f9ee6541$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b778ec20f9ee6541$var$setInitialProperties(href, "link", rel), $b778ec20f9ee6541$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b778ec20f9ee6541$var$prefetchDNS(href) {
    $b778ec20f9ee6541$var$previousDispatcher.D(href);
    $b778ec20f9ee6541$var$preconnectAs("dns-prefetch", href, null);
}
function $b778ec20f9ee6541$var$preconnect(href, crossOrigin) {
    $b778ec20f9ee6541$var$previousDispatcher.C(href, crossOrigin);
    $b778ec20f9ee6541$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b778ec20f9ee6541$var$preload(href, as, options) {
    $b778ec20f9ee6541$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b778ec20f9ee6541$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b778ec20f9ee6541$var$getStyleKey(href);
                break;
            case "script":
                key = $b778ec20f9ee6541$var$getScriptKey(href);
        }
        $b778ec20f9ee6541$var$preloadPropsMap.has(key) || (href = $b778ec20f9ee6541$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b778ec20f9ee6541$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b778ec20f9ee6541$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b778ec20f9ee6541$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b778ec20f9ee6541$var$setInitialProperties(as, "link", href), $b778ec20f9ee6541$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b778ec20f9ee6541$var$preloadModule(href, options) {
    $b778ec20f9ee6541$var$previousDispatcher.m(href, options);
    var ownerDocument = $b778ec20f9ee6541$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b778ec20f9ee6541$var$getScriptKey(href);
        }
        if (!$b778ec20f9ee6541$var$preloadPropsMap.has(key) && (href = $b778ec20f9ee6541$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b778ec20f9ee6541$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b778ec20f9ee6541$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b778ec20f9ee6541$var$setInitialProperties(as, "link", href);
            $b778ec20f9ee6541$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b778ec20f9ee6541$var$preinitStyle(href, precedence, options) {
    $b778ec20f9ee6541$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b778ec20f9ee6541$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b778ec20f9ee6541$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b778ec20f9ee6541$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b778ec20f9ee6541$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b778ec20f9ee6541$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b778ec20f9ee6541$var$preloadPropsMap.get(key)) && $b778ec20f9ee6541$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b778ec20f9ee6541$var$markNodeAsHoistable(link);
                $b778ec20f9ee6541$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b778ec20f9ee6541$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b778ec20f9ee6541$var$preinitScript(src, options) {
    $b778ec20f9ee6541$var$previousDispatcher.X(src, options);
    var ownerDocument = $b778ec20f9ee6541$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b778ec20f9ee6541$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b778ec20f9ee6541$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b778ec20f9ee6541$var$getScriptSelectorFromKey(key)), resource || (src = $b778ec20f9ee6541$var$assign({
            src: src,
            async: !0
        }, options), (options = $b778ec20f9ee6541$var$preloadPropsMap.get(key)) && $b778ec20f9ee6541$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b778ec20f9ee6541$var$markNodeAsHoistable(resource), $b778ec20f9ee6541$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b778ec20f9ee6541$var$preinitModuleScript(src, options) {
    $b778ec20f9ee6541$var$previousDispatcher.M(src, options);
    var ownerDocument = $b778ec20f9ee6541$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b778ec20f9ee6541$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b778ec20f9ee6541$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b778ec20f9ee6541$var$getScriptSelectorFromKey(key)), resource || (src = $b778ec20f9ee6541$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b778ec20f9ee6541$var$preloadPropsMap.get(key)) && $b778ec20f9ee6541$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b778ec20f9ee6541$var$markNodeAsHoistable(resource), $b778ec20f9ee6541$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b778ec20f9ee6541$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b778ec20f9ee6541$var$rootInstanceStackCursor.current) ? $b778ec20f9ee6541$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b778ec20f9ee6541$var$getStyleKey(pendingProps.href), pendingProps = $b778ec20f9ee6541$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b778ec20f9ee6541$var$getStyleKey(pendingProps.href);
                var styles$242 = $b778ec20f9ee6541$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($b778ec20f9ee6541$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $b778ec20f9ee6541$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b778ec20f9ee6541$var$preloadPropsMap.set(type, pendingProps), styles$242 || $b778ec20f9ee6541$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b778ec20f9ee6541$var$getScriptKey(pendingProps), pendingProps = $b778ec20f9ee6541$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(444, type));
    }
}
function $b778ec20f9ee6541$var$getStyleKey(href) {
    return 'href="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b778ec20f9ee6541$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b778ec20f9ee6541$var$stylesheetPropsFromRawProps(rawProps) {
    return $b778ec20f9ee6541$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b778ec20f9ee6541$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b778ec20f9ee6541$var$setInitialProperties(key, "link", preloadProps), $b778ec20f9ee6541$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b778ec20f9ee6541$var$getScriptKey(src) {
    return '[src="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b778ec20f9ee6541$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b778ec20f9ee6541$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b778ec20f9ee6541$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b778ec20f9ee6541$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b778ec20f9ee6541$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b778ec20f9ee6541$var$markNodeAsHoistable(instance);
            $b778ec20f9ee6541$var$setInitialProperties(instance, "style", styleProps);
            $b778ec20f9ee6541$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b778ec20f9ee6541$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($b778ec20f9ee6541$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $b778ec20f9ee6541$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $b778ec20f9ee6541$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b778ec20f9ee6541$var$preloadPropsMap.get(styleProps)) && $b778ec20f9ee6541$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b778ec20f9ee6541$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b778ec20f9ee6541$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $b778ec20f9ee6541$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $b778ec20f9ee6541$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b778ec20f9ee6541$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $b778ec20f9ee6541$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b778ec20f9ee6541$var$preloadPropsMap.get(instance$248)) instance = $b778ec20f9ee6541$var$assign({}, props), $b778ec20f9ee6541$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b778ec20f9ee6541$var$markNodeAsHoistable(styleProps);
            $b778ec20f9ee6541$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b778ec20f9ee6541$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b778ec20f9ee6541$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b778ec20f9ee6541$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b778ec20f9ee6541$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b778ec20f9ee6541$var$tagCaches = null;
function $b778ec20f9ee6541$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b778ec20f9ee6541$var$tagCaches) {
        var cache = new Map();
        var caches = $b778ec20f9ee6541$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b778ec20f9ee6541$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b778ec20f9ee6541$var$internalHoistableMarker] || node[$b778ec20f9ee6541$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b778ec20f9ee6541$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b778ec20f9ee6541$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b778ec20f9ee6541$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $b778ec20f9ee6541$var$suspendedState = null;
function $b778ec20f9ee6541$var$noop() {}
function $b778ec20f9ee6541$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $b778ec20f9ee6541$var$suspendedState) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(475));
    var state = $b778ec20f9ee6541$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b778ec20f9ee6541$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b778ec20f9ee6541$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b778ec20f9ee6541$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b778ec20f9ee6541$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b778ec20f9ee6541$var$stylesheetPropsFromRawProps(props);
            (key = $b778ec20f9ee6541$var$preloadPropsMap.get(key)) && $b778ec20f9ee6541$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b778ec20f9ee6541$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b778ec20f9ee6541$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b778ec20f9ee6541$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $b778ec20f9ee6541$var$waitForCommitToBeReady() {
    if (null === $b778ec20f9ee6541$var$suspendedState) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(475));
    var state = $b778ec20f9ee6541$var$suspendedState;
    state.stylesheets && 0 === state.count && $b778ec20f9ee6541$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b778ec20f9ee6541$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $b778ec20f9ee6541$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $b778ec20f9ee6541$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b778ec20f9ee6541$var$precedencesByRoot = null;
function $b778ec20f9ee6541$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b778ec20f9ee6541$var$precedencesByRoot = new Map(), resources.forEach($b778ec20f9ee6541$var$insertStylesheetIntoRoot, state), $b778ec20f9ee6541$var$precedencesByRoot = null, $b778ec20f9ee6541$var$onUnsuspend.call(state));
}
function $b778ec20f9ee6541$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b778ec20f9ee6541$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b778ec20f9ee6541$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b778ec20f9ee6541$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b778ec20f9ee6541$var$HostTransitionContext = {
    $$typeof: $b778ec20f9ee6541$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b778ec20f9ee6541$var$sharedNotPendingObject,
    _currentValue2: $b778ec20f9ee6541$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b778ec20f9ee6541$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b778ec20f9ee6541$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b778ec20f9ee6541$var$createLaneMap(0);
    this.hiddenUpdates = $b778ec20f9ee6541$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b778ec20f9ee6541$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $b778ec20f9ee6541$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b778ec20f9ee6541$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b778ec20f9ee6541$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b778ec20f9ee6541$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b778ec20f9ee6541$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b778ec20f9ee6541$var$emptyContextObject;
    parentComponent = $b778ec20f9ee6541$var$emptyContextObject;
    return parentComponent;
}
function $b778ec20f9ee6541$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b778ec20f9ee6541$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b778ec20f9ee6541$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b778ec20f9ee6541$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b778ec20f9ee6541$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b778ec20f9ee6541$var$entangleTransitions(element, rootFiber, lane));
}
function $b778ec20f9ee6541$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b778ec20f9ee6541$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b778ec20f9ee6541$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b778ec20f9ee6541$var$markRetryLaneImpl(fiber, retryLane);
}
function $b778ec20f9ee6541$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b778ec20f9ee6541$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b778ec20f9ee6541$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $b778ec20f9ee6541$var$_enabled = !0;
function $b778ec20f9ee6541$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b778ec20f9ee6541$var$ReactSharedInternals.T;
    $b778ec20f9ee6541$var$ReactSharedInternals.T = null;
    var previousPriority = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p;
    try {
        $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = 2, $b778ec20f9ee6541$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = previousPriority, $b778ec20f9ee6541$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b778ec20f9ee6541$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b778ec20f9ee6541$var$ReactSharedInternals.T;
    $b778ec20f9ee6541$var$ReactSharedInternals.T = null;
    var previousPriority = $b778ec20f9ee6541$var$ReactDOMSharedInternals.p;
    try {
        $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = 8, $b778ec20f9ee6541$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b778ec20f9ee6541$var$ReactDOMSharedInternals.p = previousPriority, $b778ec20f9ee6541$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b778ec20f9ee6541$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b778ec20f9ee6541$var$_enabled) {
        var blockedOn = $b778ec20f9ee6541$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b778ec20f9ee6541$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b778ec20f9ee6541$var$return_targetInst, targetContainer), $b778ec20f9ee6541$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b778ec20f9ee6541$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b778ec20f9ee6541$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b778ec20f9ee6541$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b778ec20f9ee6541$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b778ec20f9ee6541$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b778ec20f9ee6541$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b778ec20f9ee6541$var$ensureRootIsScheduled(fiber);
                                0 === ($b778ec20f9ee6541$var$executionContext & 6) && ($b778ec20f9ee6541$var$workInProgressRootRenderTargetTime = $b778ec20f9ee6541$var$now() + 500, $b778ec20f9ee6541$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b778ec20f9ee6541$var$scheduleUpdateOnFiber(root, fiber, 2), $b778ec20f9ee6541$var$flushSyncWork$1(), $b778ec20f9ee6541$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b778ec20f9ee6541$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b778ec20f9ee6541$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b778ec20f9ee6541$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b778ec20f9ee6541$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b778ec20f9ee6541$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b778ec20f9ee6541$var$getEventTarget(nativeEvent);
    return $b778ec20f9ee6541$var$findInstanceBlockingTarget(nativeEvent);
}
var $b778ec20f9ee6541$var$return_targetInst = null;
function $b778ec20f9ee6541$var$findInstanceBlockingTarget(targetNode) {
    $b778ec20f9ee6541$var$return_targetInst = null;
    targetNode = $b778ec20f9ee6541$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b778ec20f9ee6541$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b778ec20f9ee6541$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b778ec20f9ee6541$var$return_targetInst = targetNode;
    return null;
}
function $b778ec20f9ee6541$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b778ec20f9ee6541$var$getCurrentPriorityLevel()){
                case $b778ec20f9ee6541$var$ImmediatePriority:
                    return 2;
                case $b778ec20f9ee6541$var$UserBlockingPriority:
                    return 8;
                case $b778ec20f9ee6541$var$NormalPriority$1:
                case $b778ec20f9ee6541$var$LowPriority:
                    return 32;
                case $b778ec20f9ee6541$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b778ec20f9ee6541$var$hasScheduledReplayAttempt = !1, $b778ec20f9ee6541$var$queuedFocus = null, $b778ec20f9ee6541$var$queuedDrag = null, $b778ec20f9ee6541$var$queuedMouse = null, $b778ec20f9ee6541$var$queuedPointers = new Map(), $b778ec20f9ee6541$var$queuedPointerCaptures = new Map(), $b778ec20f9ee6541$var$queuedExplicitHydrationTargets = [], $b778ec20f9ee6541$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b778ec20f9ee6541$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b778ec20f9ee6541$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b778ec20f9ee6541$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b778ec20f9ee6541$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b778ec20f9ee6541$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b778ec20f9ee6541$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b778ec20f9ee6541$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b778ec20f9ee6541$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b778ec20f9ee6541$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b778ec20f9ee6541$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b778ec20f9ee6541$var$queuedFocus = $b778ec20f9ee6541$var$accumulateOrCreateContinuousQueuedReplayableEvent($b778ec20f9ee6541$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b778ec20f9ee6541$var$queuedDrag = $b778ec20f9ee6541$var$accumulateOrCreateContinuousQueuedReplayableEvent($b778ec20f9ee6541$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b778ec20f9ee6541$var$queuedMouse = $b778ec20f9ee6541$var$accumulateOrCreateContinuousQueuedReplayableEvent($b778ec20f9ee6541$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b778ec20f9ee6541$var$queuedPointers.set(pointerId, $b778ec20f9ee6541$var$accumulateOrCreateContinuousQueuedReplayableEvent($b778ec20f9ee6541$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b778ec20f9ee6541$var$queuedPointerCaptures.set(pointerId, $b778ec20f9ee6541$var$accumulateOrCreateContinuousQueuedReplayableEvent($b778ec20f9ee6541$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b778ec20f9ee6541$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b778ec20f9ee6541$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b778ec20f9ee6541$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b778ec20f9ee6541$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b778ec20f9ee6541$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $b778ec20f9ee6541$var$requestUpdateLane(), root = $b778ec20f9ee6541$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $b778ec20f9ee6541$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $b778ec20f9ee6541$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b778ec20f9ee6541$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b778ec20f9ee6541$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b778ec20f9ee6541$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b778ec20f9ee6541$var$currentReplayingEvent = null;
        } else return targetContainers = $b778ec20f9ee6541$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b778ec20f9ee6541$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b778ec20f9ee6541$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b778ec20f9ee6541$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b778ec20f9ee6541$var$replayUnblockedEvents() {
    $b778ec20f9ee6541$var$hasScheduledReplayAttempt = !1;
    null !== $b778ec20f9ee6541$var$queuedFocus && $b778ec20f9ee6541$var$attemptReplayContinuousQueuedEvent($b778ec20f9ee6541$var$queuedFocus) && ($b778ec20f9ee6541$var$queuedFocus = null);
    null !== $b778ec20f9ee6541$var$queuedDrag && $b778ec20f9ee6541$var$attemptReplayContinuousQueuedEvent($b778ec20f9ee6541$var$queuedDrag) && ($b778ec20f9ee6541$var$queuedDrag = null);
    null !== $b778ec20f9ee6541$var$queuedMouse && $b778ec20f9ee6541$var$attemptReplayContinuousQueuedEvent($b778ec20f9ee6541$var$queuedMouse) && ($b778ec20f9ee6541$var$queuedMouse = null);
    $b778ec20f9ee6541$var$queuedPointers.forEach($b778ec20f9ee6541$var$attemptReplayContinuousQueuedEventInMap);
    $b778ec20f9ee6541$var$queuedPointerCaptures.forEach($b778ec20f9ee6541$var$attemptReplayContinuousQueuedEventInMap);
}
function $b778ec20f9ee6541$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b778ec20f9ee6541$var$hasScheduledReplayAttempt || ($b778ec20f9ee6541$var$hasScheduledReplayAttempt = !0, $7DCtq.unstable_scheduleCallback($7DCtq.unstable_NormalPriority, $b778ec20f9ee6541$var$replayUnblockedEvents)));
}
var $b778ec20f9ee6541$var$lastScheduledReplayQueue = null;
function $b778ec20f9ee6541$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b778ec20f9ee6541$var$lastScheduledReplayQueue !== formReplayingQueue && ($b778ec20f9ee6541$var$lastScheduledReplayQueue = formReplayingQueue, $7DCtq.unstable_scheduleCallback($7DCtq.unstable_NormalPriority, function() {
        $b778ec20f9ee6541$var$lastScheduledReplayQueue === formReplayingQueue && ($b778ec20f9ee6541$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b778ec20f9ee6541$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b778ec20f9ee6541$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b778ec20f9ee6541$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b778ec20f9ee6541$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b778ec20f9ee6541$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b778ec20f9ee6541$var$queuedFocus && $b778ec20f9ee6541$var$scheduleCallbackIfUnblocked($b778ec20f9ee6541$var$queuedFocus, unblocked);
    null !== $b778ec20f9ee6541$var$queuedDrag && $b778ec20f9ee6541$var$scheduleCallbackIfUnblocked($b778ec20f9ee6541$var$queuedDrag, unblocked);
    null !== $b778ec20f9ee6541$var$queuedMouse && $b778ec20f9ee6541$var$scheduleCallbackIfUnblocked($b778ec20f9ee6541$var$queuedMouse, unblocked);
    $b778ec20f9ee6541$var$queuedPointers.forEach(unblock);
    $b778ec20f9ee6541$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b778ec20f9ee6541$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b778ec20f9ee6541$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b778ec20f9ee6541$var$queuedExplicitHydrationTargets.length && (i = $b778ec20f9ee6541$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b778ec20f9ee6541$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b778ec20f9ee6541$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b778ec20f9ee6541$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b778ec20f9ee6541$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b778ec20f9ee6541$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b778ec20f9ee6541$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b778ec20f9ee6541$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b778ec20f9ee6541$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b778ec20f9ee6541$var$ReactDOMHydrationRoot.prototype.render = $b778ec20f9ee6541$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b778ec20f9ee6541$var$requestUpdateLane();
    $b778ec20f9ee6541$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b778ec20f9ee6541$var$ReactDOMHydrationRoot.prototype.unmount = $b778ec20f9ee6541$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $b778ec20f9ee6541$var$flushPassiveEffects();
        $b778ec20f9ee6541$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b778ec20f9ee6541$var$flushSyncWork$1();
        container[$b778ec20f9ee6541$var$internalContainerInstanceKey] = null;
    }
};
function $b778ec20f9ee6541$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b778ec20f9ee6541$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b778ec20f9ee6541$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b778ec20f9ee6541$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b778ec20f9ee6541$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b778ec20f9ee6541$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b778ec20f9ee6541$var$attemptExplicitHydrationTarget(target);
    }
};
var $b778ec20f9ee6541$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $8tsvq.version;
if ("19.0.0" !== $b778ec20f9ee6541$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(527, $b778ec20f9ee6541$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$b778ec20f9ee6541$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b778ec20f9ee6541$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b778ec20f9ee6541$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b778ec20f9ee6541$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b778ec20f9ee6541$var$ReactSharedInternals,
    findFiberByHostInstance: $b778ec20f9ee6541$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b778ec20f9ee6541$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b778ec20f9ee6541$var$hook$jscomp$inline_2166.isDisabled && $b778ec20f9ee6541$var$hook$jscomp$inline_2166.supportsFiber) try {
        $b778ec20f9ee6541$var$rendererID = $b778ec20f9ee6541$var$hook$jscomp$inline_2166.inject($b778ec20f9ee6541$var$internals$jscomp$inline_2165), $b778ec20f9ee6541$var$injectedHook = $b778ec20f9ee6541$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$b778ec20f9ee6541$export$882461b6382ed46c = function(container, options) {
    if (!$b778ec20f9ee6541$var$isValidContainer(container)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b778ec20f9ee6541$var$defaultOnUncaughtError, onCaughtError = $b778ec20f9ee6541$var$defaultOnCaughtError, onRecoverableError = $b778ec20f9ee6541$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $b778ec20f9ee6541$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$b778ec20f9ee6541$var$internalContainerInstanceKey] = options.current;
    $b778ec20f9ee6541$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $b778ec20f9ee6541$var$ReactDOMRoot(options);
};
$b778ec20f9ee6541$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b778ec20f9ee6541$var$isValidContainer(container)) throw Error($b778ec20f9ee6541$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b778ec20f9ee6541$var$defaultOnUncaughtError, onCaughtError = $b778ec20f9ee6541$var$defaultOnCaughtError, onRecoverableError = $b778ec20f9ee6541$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b778ec20f9ee6541$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $b778ec20f9ee6541$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b778ec20f9ee6541$var$requestUpdateLane();
    identifierPrefix = $b778ec20f9ee6541$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b778ec20f9ee6541$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $b778ec20f9ee6541$var$markRootUpdated$1(initialChildren, isStrictMode);
    $b778ec20f9ee6541$var$ensureRootIsScheduled(initialChildren);
    container[$b778ec20f9ee6541$var$internalContainerInstanceKey] = initialChildren.current;
    $b778ec20f9ee6541$var$listenToAllSupportedEvents(container);
    return new $b778ec20f9ee6541$var$ReactDOMHydrationRoot(initialChildren);
};
$b778ec20f9ee6541$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("7DCtq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iED4A"));

});
parcelRegister("iED4A", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $d94a458073c6476a$export$c4744153514ff05d, (v) => $d94a458073c6476a$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $d94a458073c6476a$export$3e506c1ccc9cc1a7, (v) => $d94a458073c6476a$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $d94a458073c6476a$export$e26fe2ed2fa76875, (v) => $d94a458073c6476a$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $d94a458073c6476a$export$502329bbf4b505b1, (v) => $d94a458073c6476a$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $d94a458073c6476a$export$6e3807111c4874c4, (v) => $d94a458073c6476a$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $d94a458073c6476a$export$c27134553091fb3a, (v) => $d94a458073c6476a$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $d94a458073c6476a$export$33ee1acdc04fd2a2, (v) => $d94a458073c6476a$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $d94a458073c6476a$export$b00a404bbd5edef2, (v) => $d94a458073c6476a$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $d94a458073c6476a$export$8352ce38b91d0c62, (v) => $d94a458073c6476a$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $d94a458073c6476a$export$d66a1c1c77bd778b, (v) => $d94a458073c6476a$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $d94a458073c6476a$export$d3dfb8e4810cb555, (v) => $d94a458073c6476a$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $d94a458073c6476a$export$839f9183b0465a69, (v) => $d94a458073c6476a$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $d94a458073c6476a$export$72fdf0e06517287b, (v) => $d94a458073c6476a$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $d94a458073c6476a$export$4b844e58a3e414b4, (v) => $d94a458073c6476a$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $d94a458073c6476a$export$816d2913ae6b83b1, (v) => $d94a458073c6476a$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $d94a458073c6476a$export$61bcfe829111a1d0, (v) => $d94a458073c6476a$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $d94a458073c6476a$export$7ee8c9beb337bc3f, (v) => $d94a458073c6476a$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $d94a458073c6476a$export$b5836b71941fa3ed, (v) => $d94a458073c6476a$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $d94a458073c6476a$export$cf845f2c119da08a, (v) => $d94a458073c6476a$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d94a458073c6476a$export$c4744153514ff05d;
var $d94a458073c6476a$export$3e506c1ccc9cc1a7;
var $d94a458073c6476a$export$e26fe2ed2fa76875;
var $d94a458073c6476a$export$502329bbf4b505b1;
var $d94a458073c6476a$export$6e3807111c4874c4;
var $d94a458073c6476a$export$c27134553091fb3a;
var $d94a458073c6476a$export$33ee1acdc04fd2a2;
var $d94a458073c6476a$export$b00a404bbd5edef2;
var $d94a458073c6476a$export$8352ce38b91d0c62;
var $d94a458073c6476a$export$d66a1c1c77bd778b;
var $d94a458073c6476a$export$d3dfb8e4810cb555;
var $d94a458073c6476a$export$839f9183b0465a69;
var $d94a458073c6476a$export$72fdf0e06517287b;
var $d94a458073c6476a$export$4b844e58a3e414b4;
var $d94a458073c6476a$export$816d2913ae6b83b1;
var $d94a458073c6476a$export$61bcfe829111a1d0;
var $d94a458073c6476a$export$7ee8c9beb337bc3f;
var $d94a458073c6476a$export$b5836b71941fa3ed;
var $d94a458073c6476a$export$cf845f2c119da08a;
"use strict";
function $d94a458073c6476a$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $d94a458073c6476a$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $d94a458073c6476a$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $d94a458073c6476a$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $d94a458073c6476a$var$compare(left, last)) rightIndex < length && 0 > $d94a458073c6476a$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $d94a458073c6476a$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $d94a458073c6476a$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$d94a458073c6476a$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d94a458073c6476a$var$localPerformance = performance;
    $d94a458073c6476a$export$c4744153514ff05d = function() {
        return $d94a458073c6476a$var$localPerformance.now();
    };
} else {
    var $d94a458073c6476a$var$localDate = Date, $d94a458073c6476a$var$initialTime = $d94a458073c6476a$var$localDate.now();
    $d94a458073c6476a$export$c4744153514ff05d = function() {
        return $d94a458073c6476a$var$localDate.now() - $d94a458073c6476a$var$initialTime;
    };
}
var $d94a458073c6476a$var$taskQueue = [], $d94a458073c6476a$var$timerQueue = [], $d94a458073c6476a$var$taskIdCounter = 1, $d94a458073c6476a$var$currentTask = null, $d94a458073c6476a$var$currentPriorityLevel = 3, $d94a458073c6476a$var$isPerformingWork = !1, $d94a458073c6476a$var$isHostCallbackScheduled = !1, $d94a458073c6476a$var$isHostTimeoutScheduled = !1, $d94a458073c6476a$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $d94a458073c6476a$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $d94a458073c6476a$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $d94a458073c6476a$var$advanceTimers(currentTime) {
    for(var timer = $d94a458073c6476a$var$peek($d94a458073c6476a$var$timerQueue); null !== timer;){
        if (null === timer.callback) $d94a458073c6476a$var$pop($d94a458073c6476a$var$timerQueue);
        else if (timer.startTime <= currentTime) $d94a458073c6476a$var$pop($d94a458073c6476a$var$timerQueue), timer.sortIndex = timer.expirationTime, $d94a458073c6476a$var$push($d94a458073c6476a$var$taskQueue, timer);
        else break;
        timer = $d94a458073c6476a$var$peek($d94a458073c6476a$var$timerQueue);
    }
}
function $d94a458073c6476a$var$handleTimeout(currentTime) {
    $d94a458073c6476a$var$isHostTimeoutScheduled = !1;
    $d94a458073c6476a$var$advanceTimers(currentTime);
    if (!$d94a458073c6476a$var$isHostCallbackScheduled) {
        if (null !== $d94a458073c6476a$var$peek($d94a458073c6476a$var$taskQueue)) $d94a458073c6476a$var$isHostCallbackScheduled = !0, $d94a458073c6476a$var$requestHostCallback();
        else {
            var firstTimer = $d94a458073c6476a$var$peek($d94a458073c6476a$var$timerQueue);
            null !== firstTimer && $d94a458073c6476a$var$requestHostTimeout($d94a458073c6476a$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $d94a458073c6476a$var$isMessageLoopRunning = !1, $d94a458073c6476a$var$taskTimeoutID = -1, $d94a458073c6476a$var$frameInterval = 5, $d94a458073c6476a$var$startTime = -1;
function $d94a458073c6476a$var$shouldYieldToHost() {
    return $d94a458073c6476a$export$c4744153514ff05d() - $d94a458073c6476a$var$startTime < $d94a458073c6476a$var$frameInterval ? !1 : !0;
}
function $d94a458073c6476a$var$performWorkUntilDeadline() {
    if ($d94a458073c6476a$var$isMessageLoopRunning) {
        var currentTime = $d94a458073c6476a$export$c4744153514ff05d();
        $d94a458073c6476a$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $d94a458073c6476a$var$isHostCallbackScheduled = !1;
                $d94a458073c6476a$var$isHostTimeoutScheduled && ($d94a458073c6476a$var$isHostTimeoutScheduled = !1, $d94a458073c6476a$var$localClearTimeout($d94a458073c6476a$var$taskTimeoutID), $d94a458073c6476a$var$taskTimeoutID = -1);
                $d94a458073c6476a$var$isPerformingWork = !0;
                var previousPriorityLevel = $d94a458073c6476a$var$currentPriorityLevel;
                try {
                    b: {
                        $d94a458073c6476a$var$advanceTimers(currentTime);
                        for($d94a458073c6476a$var$currentTask = $d94a458073c6476a$var$peek($d94a458073c6476a$var$taskQueue); null !== $d94a458073c6476a$var$currentTask && !($d94a458073c6476a$var$currentTask.expirationTime > currentTime && $d94a458073c6476a$var$shouldYieldToHost());){
                            var callback = $d94a458073c6476a$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $d94a458073c6476a$var$currentTask.callback = null;
                                $d94a458073c6476a$var$currentPriorityLevel = $d94a458073c6476a$var$currentTask.priorityLevel;
                                var continuationCallback = callback($d94a458073c6476a$var$currentTask.expirationTime <= currentTime);
                                currentTime = $d94a458073c6476a$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $d94a458073c6476a$var$currentTask.callback = continuationCallback;
                                    $d94a458073c6476a$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $d94a458073c6476a$var$currentTask === $d94a458073c6476a$var$peek($d94a458073c6476a$var$taskQueue) && $d94a458073c6476a$var$pop($d94a458073c6476a$var$taskQueue);
                                $d94a458073c6476a$var$advanceTimers(currentTime);
                            } else $d94a458073c6476a$var$pop($d94a458073c6476a$var$taskQueue);
                            $d94a458073c6476a$var$currentTask = $d94a458073c6476a$var$peek($d94a458073c6476a$var$taskQueue);
                        }
                        if (null !== $d94a458073c6476a$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $d94a458073c6476a$var$peek($d94a458073c6476a$var$timerQueue);
                            null !== firstTimer && $d94a458073c6476a$var$requestHostTimeout($d94a458073c6476a$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $d94a458073c6476a$var$currentTask = null, $d94a458073c6476a$var$currentPriorityLevel = previousPriorityLevel, $d94a458073c6476a$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $d94a458073c6476a$var$schedulePerformWorkUntilDeadline() : $d94a458073c6476a$var$isMessageLoopRunning = !1;
        }
    }
}
var $d94a458073c6476a$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $d94a458073c6476a$var$localSetImmediate) $d94a458073c6476a$var$schedulePerformWorkUntilDeadline = function() {
    $d94a458073c6476a$var$localSetImmediate($d94a458073c6476a$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d94a458073c6476a$var$channel = new MessageChannel(), $d94a458073c6476a$var$port = $d94a458073c6476a$var$channel.port2;
    $d94a458073c6476a$var$channel.port1.onmessage = $d94a458073c6476a$var$performWorkUntilDeadline;
    $d94a458073c6476a$var$schedulePerformWorkUntilDeadline = function() {
        $d94a458073c6476a$var$port.postMessage(null);
    };
} else $d94a458073c6476a$var$schedulePerformWorkUntilDeadline = function() {
    $d94a458073c6476a$var$localSetTimeout($d94a458073c6476a$var$performWorkUntilDeadline, 0);
};
function $d94a458073c6476a$var$requestHostCallback() {
    $d94a458073c6476a$var$isMessageLoopRunning || ($d94a458073c6476a$var$isMessageLoopRunning = !0, $d94a458073c6476a$var$schedulePerformWorkUntilDeadline());
}
function $d94a458073c6476a$var$requestHostTimeout(callback, ms) {
    $d94a458073c6476a$var$taskTimeoutID = $d94a458073c6476a$var$localSetTimeout(function() {
        callback($d94a458073c6476a$export$c4744153514ff05d());
    }, ms);
}
$d94a458073c6476a$export$3e506c1ccc9cc1a7 = 5;
$d94a458073c6476a$export$e26fe2ed2fa76875 = 1;
$d94a458073c6476a$export$502329bbf4b505b1 = 4;
$d94a458073c6476a$export$6e3807111c4874c4 = 3;
$d94a458073c6476a$export$c27134553091fb3a = null;
$d94a458073c6476a$export$33ee1acdc04fd2a2 = 2;
$d94a458073c6476a$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$d94a458073c6476a$export$8352ce38b91d0c62 = function() {
    $d94a458073c6476a$var$isHostCallbackScheduled || $d94a458073c6476a$var$isPerformingWork || ($d94a458073c6476a$var$isHostCallbackScheduled = !0, $d94a458073c6476a$var$requestHostCallback());
};
$d94a458073c6476a$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d94a458073c6476a$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$d94a458073c6476a$export$d3dfb8e4810cb555 = function() {
    return $d94a458073c6476a$var$currentPriorityLevel;
};
$d94a458073c6476a$export$839f9183b0465a69 = function() {
    return $d94a458073c6476a$var$peek($d94a458073c6476a$var$taskQueue);
};
$d94a458073c6476a$export$72fdf0e06517287b = function(eventHandler) {
    switch($d94a458073c6476a$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $d94a458073c6476a$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $d94a458073c6476a$var$currentPriorityLevel;
    $d94a458073c6476a$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d94a458073c6476a$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d94a458073c6476a$export$4b844e58a3e414b4 = function() {};
$d94a458073c6476a$export$816d2913ae6b83b1 = function() {};
$d94a458073c6476a$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $d94a458073c6476a$var$currentPriorityLevel;
    $d94a458073c6476a$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d94a458073c6476a$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d94a458073c6476a$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $d94a458073c6476a$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $d94a458073c6476a$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $d94a458073c6476a$var$push($d94a458073c6476a$var$timerQueue, priorityLevel), null === $d94a458073c6476a$var$peek($d94a458073c6476a$var$taskQueue) && priorityLevel === $d94a458073c6476a$var$peek($d94a458073c6476a$var$timerQueue) && ($d94a458073c6476a$var$isHostTimeoutScheduled ? ($d94a458073c6476a$var$localClearTimeout($d94a458073c6476a$var$taskTimeoutID), $d94a458073c6476a$var$taskTimeoutID = -1) : $d94a458073c6476a$var$isHostTimeoutScheduled = !0, $d94a458073c6476a$var$requestHostTimeout($d94a458073c6476a$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $d94a458073c6476a$var$push($d94a458073c6476a$var$taskQueue, priorityLevel), $d94a458073c6476a$var$isHostCallbackScheduled || $d94a458073c6476a$var$isPerformingWork || ($d94a458073c6476a$var$isHostCallbackScheduled = !0, $d94a458073c6476a$var$requestHostCallback()));
    return priorityLevel;
};
$d94a458073c6476a$export$b5836b71941fa3ed = $d94a458073c6476a$var$shouldYieldToHost;
$d94a458073c6476a$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $d94a458073c6476a$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $d94a458073c6476a$var$currentPriorityLevel;
        $d94a458073c6476a$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $d94a458073c6476a$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8tsvq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2xyO7"));

});

parcelRegister("dYG4P", function(module, exports) {
'use strict';
function $a2d184922ae7f92f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a2d184922ae7f92f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a2d184922ae7f92f$var$checkDCE();

module.exports = (parcelRequire("3dkV1"));

});
parcelRegister("3dkV1", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $2572d008e676adbf$export$69ce8ef3fe5cead0, (v) => $2572d008e676adbf$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $2572d008e676adbf$export$d39a5bbd09211389, (v) => $2572d008e676adbf$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $2572d008e676adbf$export$cd75ccfd720a3cd4, (v) => $2572d008e676adbf$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $2572d008e676adbf$export$a0816fa17a9e79be, (v) => $2572d008e676adbf$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $2572d008e676adbf$export$7292efcadded39f3, (v) => $2572d008e676adbf$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $2572d008e676adbf$export$da407abadb9b8f86, (v) => $2572d008e676adbf$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $2572d008e676adbf$export$314cfea32580671c, (v) => $2572d008e676adbf$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $2572d008e676adbf$export$513ccb98c53b8039, (v) => $2572d008e676adbf$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $2572d008e676adbf$export$dbca993bc2d264a, (v) => $2572d008e676adbf$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $2572d008e676adbf$export$4797a8006f0655d0, (v) => $2572d008e676adbf$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2572d008e676adbf$export$c78a37762a8d58e1, (v) => $2572d008e676adbf$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $2572d008e676adbf$export$606f11b2eb45ecc6, (v) => $2572d008e676adbf$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $2572d008e676adbf$export$f7e8a0bf92324b1e, (v) => $2572d008e676adbf$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $2572d008e676adbf$export$83d89fbfd8236492, (v) => $2572d008e676adbf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2572d008e676adbf$export$69ce8ef3fe5cead0;
var $2572d008e676adbf$export$d39a5bbd09211389;
var $2572d008e676adbf$export$cd75ccfd720a3cd4;
var $2572d008e676adbf$export$a0816fa17a9e79be;
var $2572d008e676adbf$export$7292efcadded39f3;
var $2572d008e676adbf$export$da407abadb9b8f86;
var $2572d008e676adbf$export$314cfea32580671c;
var $2572d008e676adbf$export$513ccb98c53b8039;
var $2572d008e676adbf$export$dbca993bc2d264a;
var $2572d008e676adbf$export$4797a8006f0655d0;
var $2572d008e676adbf$export$c78a37762a8d58e1;
var $2572d008e676adbf$export$606f11b2eb45ecc6;
var $2572d008e676adbf$export$f7e8a0bf92324b1e;
var $2572d008e676adbf$export$83d89fbfd8236492;
"use strict";

var $8tsvq = parcelRequire("8tsvq");
function $2572d008e676adbf$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2572d008e676adbf$var$noop() {}
var $2572d008e676adbf$var$Internals = {
    d: {
        f: $2572d008e676adbf$var$noop,
        r: function() {
            throw Error($2572d008e676adbf$var$formatProdErrorMessage(522));
        },
        D: $2572d008e676adbf$var$noop,
        C: $2572d008e676adbf$var$noop,
        L: $2572d008e676adbf$var$noop,
        m: $2572d008e676adbf$var$noop,
        X: $2572d008e676adbf$var$noop,
        S: $2572d008e676adbf$var$noop,
        M: $2572d008e676adbf$var$noop
    },
    p: 0,
    findDOMNode: null
}, $2572d008e676adbf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $2572d008e676adbf$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2572d008e676adbf$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $2572d008e676adbf$var$ReactSharedInternals = $8tsvq.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $2572d008e676adbf$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$2572d008e676adbf$export$69ce8ef3fe5cead0 = $2572d008e676adbf$var$Internals;
$2572d008e676adbf$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($2572d008e676adbf$var$formatProdErrorMessage(299));
    return $2572d008e676adbf$var$createPortal$1(children, container, null, key);
};
$2572d008e676adbf$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $2572d008e676adbf$var$ReactSharedInternals.T, previousUpdatePriority = $2572d008e676adbf$var$Internals.p;
    try {
        if ($2572d008e676adbf$var$ReactSharedInternals.T = null, $2572d008e676adbf$var$Internals.p = 2, fn) return fn();
    } finally{
        $2572d008e676adbf$var$ReactSharedInternals.T = previousTransition, $2572d008e676adbf$var$Internals.p = previousUpdatePriority, $2572d008e676adbf$var$Internals.d.f();
    }
};
$2572d008e676adbf$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $2572d008e676adbf$var$Internals.d.C(href, options));
};
$2572d008e676adbf$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $2572d008e676adbf$var$Internals.d.D(href);
};
$2572d008e676adbf$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2572d008e676adbf$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $2572d008e676adbf$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $2572d008e676adbf$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$2572d008e676adbf$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $2572d008e676adbf$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $2572d008e676adbf$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $2572d008e676adbf$var$Internals.d.M(href);
    }
};
$2572d008e676adbf$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2572d008e676adbf$var$getCrossOriginStringAs(as, options.crossOrigin);
        $2572d008e676adbf$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$2572d008e676adbf$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $2572d008e676adbf$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $2572d008e676adbf$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $2572d008e676adbf$var$Internals.d.m(href);
    }
};
$2572d008e676adbf$export$4797a8006f0655d0 = function(form) {
    $2572d008e676adbf$var$Internals.d.r(form);
};
$2572d008e676adbf$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$2572d008e676adbf$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $2572d008e676adbf$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$2572d008e676adbf$export$f7e8a0bf92324b1e = function() {
    return $2572d008e676adbf$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$2572d008e676adbf$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("fAPKK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $b5a25ce5296607d6$export$306c0aa65ff9ec16, (v) => $b5a25ce5296607d6$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b5a25ce5296607d6$export$306c0aa65ff9ec16;
"use strict";

var $8tsvq = parcelRequire("8tsvq");
function $b5a25ce5296607d6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b5a25ce5296607d6$var$objectIs = "function" === typeof Object.is ? Object.is : $b5a25ce5296607d6$var$is, $b5a25ce5296607d6$var$useState = $8tsvq.useState, $b5a25ce5296607d6$var$useEffect = $8tsvq.useEffect, $b5a25ce5296607d6$var$useLayoutEffect = $8tsvq.useLayoutEffect, $b5a25ce5296607d6$var$useDebugValue = $8tsvq.useDebugValue;
function $b5a25ce5296607d6$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $b5a25ce5296607d6$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $b5a25ce5296607d6$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $b5a25ce5296607d6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $b5a25ce5296607d6$var$useEffect(function() {
        $b5a25ce5296607d6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $b5a25ce5296607d6$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $b5a25ce5296607d6$var$useDebugValue(value);
    return value;
}
function $b5a25ce5296607d6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b5a25ce5296607d6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b5a25ce5296607d6$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $b5a25ce5296607d6$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $b5a25ce5296607d6$var$useSyncExternalStore$1 : $b5a25ce5296607d6$var$useSyncExternalStore$2;
$b5a25ce5296607d6$export$306c0aa65ff9ec16 = void 0 !== $8tsvq.useSyncExternalStore ? $8tsvq.useSyncExternalStore : $b5a25ce5296607d6$var$shim;

});

parcelRegister("734S0", function(module, exports) {
'use strict';
var $521c974cc6262250$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $eA2K9 = parcelRequire("eA2K9");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $521c974cc6262250$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $521c974cc6262250$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $eA2K9();
};

});
parcelRegister("eA2K9", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("kR54n", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});

var $1fc6c12af291ab7a$exports = {};

(parcelRequire("eqJ66")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"96aeh\",\"index.9b49b141.js\",\"2QKZ9\",\"lang-icon.b99fc6cd.svg\",\"c3FYM\",\"phone-icon.95df6bb3.svg\",\"f4V4b\",\"email-icon.c914d7fc.svg\",\"4cP4L\",\"lwn-en.02c82178.svg\",\"6ipCe\",\"lwn-fr.0fef77da.svg\",\"hrylt\",\"index.f8e90b39.css\"]"));

var $d00e5d22a0b5e103$exports = {};
'use strict';

$d00e5d22a0b5e103$exports = (parcelRequire("ZC3hY"));



var $8tsvq = parcelRequire("8tsvq");
var $416246511aeb39de$exports = {};
'use strict';
function $416246511aeb39de$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($416246511aeb39de$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$416246511aeb39de$var$checkDCE();

$416246511aeb39de$exports = (parcelRequire("fKCny"));





var $8tsvq = parcelRequire("8tsvq");
var $12eb31a89aea031d$exports = {};
'use strict';

$12eb31a89aea031d$exports = (parcelRequire("fAPKK"));



var $8tsvq = parcelRequire("8tsvq");
var $876cb8737d2c91b9$exports = {};

$parcel$export($876cb8737d2c91b9$exports, "FOCUS_EVENT", () => $876cb8737d2c91b9$export$831c820ad60f9d12);
$parcel$export($876cb8737d2c91b9$exports, "RECONNECT_EVENT", () => $876cb8737d2c91b9$export$24e9454cb99a11dc);
$parcel$export($876cb8737d2c91b9$exports, "MUTATE_EVENT", () => $876cb8737d2c91b9$export$75ea288459391154);
$parcel$export($876cb8737d2c91b9$exports, "ERROR_REVALIDATE_EVENT", () => $876cb8737d2c91b9$export$b019c3839228f243);
const $876cb8737d2c91b9$export$831c820ad60f9d12 = 0;
const $876cb8737d2c91b9$export$24e9454cb99a11dc = 1;
const $876cb8737d2c91b9$export$75ea288459391154 = 2;
const $876cb8737d2c91b9$export$b019c3839228f243 = 3;


var $7b99c11f338b30af$var$has = Object.prototype.hasOwnProperty;
function $7b99c11f338b30af$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $7b99c11f338b30af$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($7b99c11f338b30af$var$has.call(foo, ctor) && ++len && !$7b99c11f338b30af$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$7b99c11f338b30af$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


'use client';
// Global state used to deduplicate requests and store listeners
const $ed5f927cc35a93d9$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $ed5f927cc35a93d9$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $ed5f927cc35a93d9$export$ebd11618f299a286();
const $ed5f927cc35a93d9$export$c4ce752e73470fba = Object;
const $ed5f927cc35a93d9$export$f1e1789686576879 = (v)=>v === $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08;
const $ed5f927cc35a93d9$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $ed5f927cc35a93d9$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $ed5f927cc35a93d9$export$ef35774e6d314e91 = (x)=>$ed5f927cc35a93d9$export$407448d2b89b1813(x.then);
const $ed5f927cc35a93d9$var$EMPTY_CACHE = {};
const $ed5f927cc35a93d9$var$INITIAL_CACHE = {};
const $ed5f927cc35a93d9$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $ed5f927cc35a93d9$export$23f2a1d2818174ef = typeof window != $ed5f927cc35a93d9$var$STR_UNDEFINED;
const $ed5f927cc35a93d9$export$efccba1c4a2ef57b = typeof document != $ed5f927cc35a93d9$var$STR_UNDEFINED;
const $ed5f927cc35a93d9$export$d141bba7fdc215a3 = $ed5f927cc35a93d9$export$23f2a1d2818174ef && 'Deno' in window;
const $ed5f927cc35a93d9$export$4a5767248b18ef41 = ()=>$ed5f927cc35a93d9$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $ed5f927cc35a93d9$var$STR_UNDEFINED;
const $ed5f927cc35a93d9$export$df995fae86a55f06 = (cache, key)=>{
    const state = $ed5f927cc35a93d9$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$ed5f927cc35a93d9$export$f1e1789686576879(key) && cache.get(key) || $ed5f927cc35a93d9$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$ed5f927cc35a93d9$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $ed5f927cc35a93d9$var$INITIAL_CACHE)) $ed5f927cc35a93d9$var$INITIAL_CACHE[key] = prev;
                state[5](key, $ed5f927cc35a93d9$export$953cecd6e717a553(prev, info), prev || $ed5f927cc35a93d9$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$ed5f927cc35a93d9$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $ed5f927cc35a93d9$var$INITIAL_CACHE) return $ed5f927cc35a93d9$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$ed5f927cc35a93d9$export$f1e1789686576879(key) && cache.get(key) || $ed5f927cc35a93d9$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $ed5f927cc35a93d9$var$online = true;
const $ed5f927cc35a93d9$var$isOnline = ()=>$ed5f927cc35a93d9$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$ed5f927cc35a93d9$var$onWindowEvent, $ed5f927cc35a93d9$var$offWindowEvent] = $ed5f927cc35a93d9$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $ed5f927cc35a93d9$export$ebd11618f299a286,
    $ed5f927cc35a93d9$export$ebd11618f299a286
];
const $ed5f927cc35a93d9$var$isVisible = ()=>{
    const visibilityState = $ed5f927cc35a93d9$export$efccba1c4a2ef57b && document.visibilityState;
    return $ed5f927cc35a93d9$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $ed5f927cc35a93d9$var$initFocus = (callback)=>{
    // focus revalidate
    if ($ed5f927cc35a93d9$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $ed5f927cc35a93d9$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($ed5f927cc35a93d9$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $ed5f927cc35a93d9$var$offWindowEvent('focus', callback);
    };
};
const $ed5f927cc35a93d9$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $ed5f927cc35a93d9$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $ed5f927cc35a93d9$var$online = false;
    };
    $ed5f927cc35a93d9$var$onWindowEvent('online', onOnline);
    $ed5f927cc35a93d9$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $ed5f927cc35a93d9$var$offWindowEvent('online', onOnline);
        $ed5f927cc35a93d9$var$offWindowEvent('offline', onOffline);
    };
};
const $ed5f927cc35a93d9$export$ffb5f4729a158638 = {
    isOnline: $ed5f927cc35a93d9$var$isOnline,
    isVisible: $ed5f927cc35a93d9$var$isVisible
};
const $ed5f927cc35a93d9$export$9e5f44173e64f162 = {
    initFocus: $ed5f927cc35a93d9$var$initFocus,
    initReconnect: $ed5f927cc35a93d9$var$initReconnect
};
const $ed5f927cc35a93d9$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).useId;
const $ed5f927cc35a93d9$export$43caf9889c228507 = !$ed5f927cc35a93d9$export$23f2a1d2818174ef || $ed5f927cc35a93d9$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $ed5f927cc35a93d9$export$625550452a3fa3ec = (f)=>$ed5f927cc35a93d9$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $ed5f927cc35a93d9$export$3b14a55fb2447963 = $ed5f927cc35a93d9$export$43caf9889c228507 ? (0, $8tsvq.useEffect) : (0, $8tsvq.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $ed5f927cc35a93d9$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $ed5f927cc35a93d9$export$90a7f3efeed30595 = !$ed5f927cc35a93d9$export$43caf9889c228507 && $ed5f927cc35a93d9$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($ed5f927cc35a93d9$var$navigatorConnection.effectiveType) || $ed5f927cc35a93d9$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $ed5f927cc35a93d9$var$table = new WeakMap();
const $ed5f927cc35a93d9$var$isObjectType = (value, type)=>$ed5f927cc35a93d9$export$c4ce752e73470fba.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $ed5f927cc35a93d9$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $ed5f927cc35a93d9$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const isDate = $ed5f927cc35a93d9$var$isObjectType(arg, 'Date');
    const isRegex = $ed5f927cc35a93d9$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $ed5f927cc35a93d9$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($ed5f927cc35a93d9$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $ed5f927cc35a93d9$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$ed5f927cc35a93d9$var$counter + '~';
        $ed5f927cc35a93d9$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $ed5f927cc35a93d9$export$882b5998b3b9117c(arg[index]) + ',';
            $ed5f927cc35a93d9$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $ed5f927cc35a93d9$export$c4ce752e73470fba.keys(arg).sort();
            while(!$ed5f927cc35a93d9$export$f1e1789686576879(index = keys.pop()))if (!$ed5f927cc35a93d9$export$f1e1789686576879(arg[index])) result += index + ':' + $ed5f927cc35a93d9$export$882b5998b3b9117c(arg[index]) + ',';
            $ed5f927cc35a93d9$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $ed5f927cc35a93d9$export$2408f22a0fab9ae5 = (key)=>{
    if ($ed5f927cc35a93d9$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $ed5f927cc35a93d9$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $ed5f927cc35a93d9$var$__timestamp = 0;
const $ed5f927cc35a93d9$export$ae1af26003f05816 = ()=>++$ed5f927cc35a93d9$var$__timestamp;
async function $ed5f927cc35a93d9$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $ed5f927cc35a93d9$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($ed5f927cc35a93d9$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $ed5f927cc35a93d9$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $ed5f927cc35a93d9$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $ed5f927cc35a93d9$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $ed5f927cc35a93d9$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($876cb8737d2c91b9$export$75ea288459391154).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $ed5f927cc35a93d9$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$ed5f927cc35a93d9$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $ed5f927cc35a93d9$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $ed5f927cc35a93d9$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($ed5f927cc35a93d9$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $ed5f927cc35a93d9$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($ed5f927cc35a93d9$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08,
                        _c: $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08,
                    _c: $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $ed5f927cc35a93d9$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $ed5f927cc35a93d9$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $ed5f927cc35a93d9$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$ed5f927cc35a93d9$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $ed5f927cc35a93d9$export$953cecd6e717a553($ed5f927cc35a93d9$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $ed5f927cc35a93d9$export$7ccc53e8f1e7dfc5.bind($ed5f927cc35a93d9$export$3a6d5c9ae78a2c08, provider);
        let unmount = $ed5f927cc35a93d9$export$ebd11618f299a286;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$ed5f927cc35a93d9$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $ed5f927cc35a93d9$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$ed5f927cc35a93d9$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($ed5f927cc35a93d9$export$3a6d5c9ae78a2c08, $ed5f927cc35a93d9$var$revalidateAllKeys.bind($ed5f927cc35a93d9$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $876cb8737d2c91b9$export$831c820ad60f9d12)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($ed5f927cc35a93d9$export$3a6d5c9ae78a2c08, $ed5f927cc35a93d9$var$revalidateAllKeys.bind($ed5f927cc35a93d9$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $876cb8737d2c91b9$export$24e9454cb99a11dc)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $ed5f927cc35a93d9$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $ed5f927cc35a93d9$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $ed5f927cc35a93d9$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$ed5f927cc35a93d9$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $ed5f927cc35a93d9$export$342063e11d6c3cad = (0, $7b99c11f338b30af$export$de8294bb3be0322f);
// Default cache provider
const [$ed5f927cc35a93d9$export$db3b6bfb95261072, $ed5f927cc35a93d9$export$35e795649ee09318] = $ed5f927cc35a93d9$export$dda1d9f60106f0e9(new Map());
// Default config
const $ed5f927cc35a93d9$export$4368d992c4eafac0 = $ed5f927cc35a93d9$export$953cecd6e717a553({
    // events
    onLoadingSlow: $ed5f927cc35a93d9$export$ebd11618f299a286,
    onSuccess: $ed5f927cc35a93d9$export$ebd11618f299a286,
    onError: $ed5f927cc35a93d9$export$ebd11618f299a286,
    onErrorRetry: $ed5f927cc35a93d9$var$onErrorRetry,
    onDiscarded: $ed5f927cc35a93d9$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $ed5f927cc35a93d9$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $ed5f927cc35a93d9$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $ed5f927cc35a93d9$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $ed5f927cc35a93d9$export$db3b6bfb95261072,
    mutate: $ed5f927cc35a93d9$export$35e795649ee09318,
    fallback: {}
}, $ed5f927cc35a93d9$export$ffb5f4729a158638);
const $ed5f927cc35a93d9$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $ed5f927cc35a93d9$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $ed5f927cc35a93d9$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $ed5f927cc35a93d9$export$25ce5a424b770e84 = (0, $8tsvq.createContext)({});
const $ed5f927cc35a93d9$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $8tsvq.useContext)($ed5f927cc35a93d9$export$25ce5a424b770e84);
    const isFunctionalConfig = $ed5f927cc35a93d9$export$407448d2b89b1813(value);
    const config = (0, $8tsvq.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $8tsvq.useMemo)(()=>isFunctionalConfig ? config : $ed5f927cc35a93d9$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $8tsvq.useRef)($ed5f927cc35a93d9$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $ed5f927cc35a93d9$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $ed5f927cc35a93d9$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $ed5f927cc35a93d9$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $8tsvq.createElement)($ed5f927cc35a93d9$export$25ce5a424b770e84.Provider, $ed5f927cc35a93d9$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};



const $cebe89d61f64485b$export$8667f065faedc62c = '$inf$';



var $8tsvq = parcelRequire("8tsvq");

// @ts-expect-error
const $50abbeee09a660f4$var$enableDevtools = (0, $ed5f927cc35a93d9$export$23f2a1d2818174ef) && window.__SWR_DEVTOOLS_USE__;
const $50abbeee09a660f4$var$use = $50abbeee09a660f4$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $50abbeee09a660f4$var$setupDevTools = ()=>{
    if ($50abbeee09a660f4$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq)));
};
const $50abbeee09a660f4$export$a3295358bff77e = (args)=>{
    return (0, $ed5f927cc35a93d9$export$407448d2b89b1813)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $50abbeee09a660f4$export$f1dc0e282d4c1c0 = ()=>{
    return (0, $ed5f927cc35a93d9$export$953cecd6e717a553)((0, $ed5f927cc35a93d9$export$4368d992c4eafac0), (0, $8tsvq.useContext)((0, $ed5f927cc35a93d9$export$25ce5a424b770e84)));
};
const $50abbeee09a660f4$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $ed5f927cc35a93d9$export$2408f22a0fab9ae5)(key_);
    const [, , , PRELOAD] = (0, $ed5f927cc35a93d9$export$8b22cf2602fb60ce).get((0, $ed5f927cc35a93d9$export$db3b6bfb95261072));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $50abbeee09a660f4$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $ed5f927cc35a93d9$export$2408f22a0fab9ae5)(key_);
            const [, , , PRELOAD] = (0, $ed5f927cc35a93d9$export$8b22cf2602fb60ce).get((0, $ed5f927cc35a93d9$export$db3b6bfb95261072));
            if (key.startsWith((0, $cebe89d61f64485b$export$8667f065faedc62c))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $ed5f927cc35a93d9$export$f1e1789686576879)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $50abbeee09a660f4$var$BUILT_IN_MIDDLEWARE = $50abbeee09a660f4$var$use.concat($50abbeee09a660f4$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $50abbeee09a660f4$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $50abbeee09a660f4$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $50abbeee09a660f4$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $ed5f927cc35a93d9$export$2d1720544b23b823)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($50abbeee09a660f4$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $50abbeee09a660f4$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $50abbeee09a660f4$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $50abbeee09a660f4$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$50abbeee09a660f4$var$setupDevTools();


// Shared state between server components and client components
const $97e4acba0fbbeffb$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $97e4acba0fbbeffb$var$UNDEFINED = /*#__NOINLINE__*/ $97e4acba0fbbeffb$var$noop();
const $97e4acba0fbbeffb$var$OBJECT = Object;
const $97e4acba0fbbeffb$var$isUndefined = (v)=>v === $97e4acba0fbbeffb$var$UNDEFINED;
const $97e4acba0fbbeffb$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $97e4acba0fbbeffb$var$table = new WeakMap();
const $97e4acba0fbbeffb$var$isObjectType = (value, type)=>$97e4acba0fbbeffb$var$OBJECT.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $97e4acba0fbbeffb$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $97e4acba0fbbeffb$var$stableHash = (arg)=>{
    const type = typeof arg;
    const isDate = $97e4acba0fbbeffb$var$isObjectType(arg, 'Date');
    const isRegex = $97e4acba0fbbeffb$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $97e4acba0fbbeffb$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($97e4acba0fbbeffb$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $97e4acba0fbbeffb$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$97e4acba0fbbeffb$var$counter + '~';
        $97e4acba0fbbeffb$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $97e4acba0fbbeffb$var$stableHash(arg[index]) + ',';
            $97e4acba0fbbeffb$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $97e4acba0fbbeffb$var$OBJECT.keys(arg).sort();
            while(!$97e4acba0fbbeffb$var$isUndefined(index = keys.pop()))if (!$97e4acba0fbbeffb$var$isUndefined(arg[index])) result += index + ':' + $97e4acba0fbbeffb$var$stableHash(arg[index]) + ',';
            $97e4acba0fbbeffb$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $97e4acba0fbbeffb$var$serialize = (key)=>{
    if ($97e4acba0fbbeffb$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $97e4acba0fbbeffb$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $97e4acba0fbbeffb$export$dbab534a48e651ef = (key)=>$97e4acba0fbbeffb$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $97e4acba0fbbeffb$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $97e4acba0fbbeffb$var$WITH_DEDUPE = {
    dedupe: true
};
const $97e4acba0fbbeffb$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $ed5f927cc35a93d9$export$8b22cf2602fb60ce).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $ed5f927cc35a93d9$export$2408f22a0fab9ae5)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $8tsvq.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $8tsvq.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $8tsvq.useRef)(key);
    const fetcherRef = (0, $8tsvq.useRef)(fetcher);
    const configRef = (0, $8tsvq.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $ed5f927cc35a93d9$export$df995fae86a55f06)(cache, key);
    const stateDependencies = (0, $8tsvq.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $ed5f927cc35a93d9$export$f1e1789686576879)(fallbackData) ? (0, $ed5f927cc35a93d9$export$f1e1789686576879)(config.fallback) ? (0, $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $ed5f927cc35a93d9$export$f1e1789686576879)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $8tsvq.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $ed5f927cc35a93d9$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $ed5f927cc35a93d9$export$953cecd6e717a553)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $12eb31a89aea031d$exports.useSyncExternalStore)((0, $8tsvq.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $ed5f927cc35a93d9$export$f1e1789686576879)(cachedData) ? fallback && (0, $ed5f927cc35a93d9$export$ef35774e6d314e91)(fallback) ? $97e4acba0fbbeffb$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $8tsvq.useRef)(data);
    const returnedData = keepPreviousData ? (0, $ed5f927cc35a93d9$export$f1e1789686576879)(cachedData) ? (0, $ed5f927cc35a93d9$export$f1e1789686576879)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $ed5f927cc35a93d9$export$f1e1789686576879)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $ed5f927cc35a93d9$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $ed5f927cc35a93d9$export$f1e1789686576879)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $ed5f927cc35a93d9$export$f1e1789686576879)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $ed5f927cc35a93d9$export$f1e1789686576879)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $ed5f927cc35a93d9$export$f1e1789686576879)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $8tsvq.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $ed5f927cc35a93d9$export$9bb611d729802a56) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $ed5f927cc35a93d9$export$f1e1789686576879)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $ed5f927cc35a93d9$export$f1e1789686576879)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $ed5f927cc35a93d9$export$ae1af26003f05816)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $ed5f927cc35a93d9$export$f1e1789686576879)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $ed5f927cc35a93d9$export$407448d2b89b1813)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $876cb8737d2c91b9$exports).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $8tsvq.useCallback)((...args)=>{
        return (0, $ed5f927cc35a93d9$export$7ccc53e8f1e7dfc5)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $ed5f927cc35a93d9$export$3b14a55fb2447963)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $ed5f927cc35a93d9$export$f1e1789686576879)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $ed5f927cc35a93d9$export$3b14a55fb2447963)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $ed5f927cc35a93d9$export$3a6d5c9ae78a2c08), $97e4acba0fbbeffb$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $876cb8737d2c91b9$exports).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $876cb8737d2c91b9$exports).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $876cb8737d2c91b9$exports).MUTATE_EVENT) return revalidate();
            else if (type == (0, $876cb8737d2c91b9$exports).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $50abbeee09a660f4$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $ed5f927cc35a93d9$export$f1e1789686576879)(data) || (0, $ed5f927cc35a93d9$export$43caf9889c228507)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $ed5f927cc35a93d9$export$625550452a3fa3ec)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $ed5f927cc35a93d9$export$3b14a55fb2447963)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $ed5f927cc35a93d9$export$407448d2b89b1813)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($97e4acba0fbbeffb$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $8tsvq.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $ed5f927cc35a93d9$export$f1e1789686576879)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $ed5f927cc35a93d9$export$9bb611d729802a56) && (0, $ed5f927cc35a93d9$export$43caf9889c228507)) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $ed5f927cc35a93d9$export$f1e1789686576879)(req)) {
            const promise = boundMutate(req);
            $97e4acba0fbbeffb$var$use(promise);
        }
        if ((0, $ed5f927cc35a93d9$export$f1e1789686576879)(error)) {
            const promise = revalidate($97e4acba0fbbeffb$var$WITH_DEDUPE);
            if (!(0, $ed5f927cc35a93d9$export$f1e1789686576879)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            $97e4acba0fbbeffb$var$use(promise);
        } else throw error;
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $97e4acba0fbbeffb$export$4c7bbecdacc3ca2c = (0, $ed5f927cc35a93d9$export$c4ce752e73470fba).defineProperty((0, $ed5f927cc35a93d9$export$39b482c5e57630a8), 'defaultValue', {
    value: (0, $ed5f927cc35a93d9$export$4368d992c4eafac0)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $97e4acba0fbbeffb$export$2e2bcd8739ae039 = (0, $50abbeee09a660f4$export$84d44e54e14b0133)($97e4acba0fbbeffb$var$useSWRHandler);


/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $f018542cedf583c1$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $f018542cedf583c1$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $f018542cedf583c1$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $f018542cedf583c1$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $f018542cedf583c1$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


function $289faae71d0b9c7d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $289faae71d0b9c7d$export$2e2bcd8739ae039 = $289faae71d0b9c7d$var$stylis_min;


var $1e1e1b885f6c348f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $1e1e1b885f6c348f$export$2e2bcd8739ae039 = $1e1e1b885f6c348f$var$weakMemoize;


// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $a276211492fd575f$var$delimiter = '/*|*/';
var $a276211492fd575f$var$needle = $a276211492fd575f$var$delimiter + '}';
function $a276211492fd575f$var$toSheet(block) {
    if (block) $a276211492fd575f$var$Sheet.current.insert(block + '}');
}
var $a276211492fd575f$var$Sheet = {
    current: null
};
var $a276211492fd575f$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $a276211492fd575f$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $a276211492fd575f$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $a276211492fd575f$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $a276211492fd575f$var$delimiter : '');
            }
        case -2:
            content.split($a276211492fd575f$var$needle).forEach($a276211492fd575f$var$toSheet);
    }
};
var $a276211492fd575f$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $289faae71d0b9c7d$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($a276211492fd575f$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $a276211492fd575f$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $f018542cedf583c1$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $a276211492fd575f$export$2e2bcd8739ae039 = $a276211492fd575f$var$createCache;


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $fd60843e7f34d2f0$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $fd60843e7f34d2f0$export$2e2bcd8739ae039 = $fd60843e7f34d2f0$var$murmur2;


var $42b8ea70a8bab97a$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $42b8ea70a8bab97a$export$2e2bcd8739ae039 = $42b8ea70a8bab97a$var$unitlessKeys;


function $66d48fa5c2e2674f$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $66d48fa5c2e2674f$export$2e2bcd8739ae039 = $66d48fa5c2e2674f$var$memoize;


var $f967aabe7c900f32$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $f967aabe7c900f32$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $f967aabe7c900f32$var$hyphenateRegex = /[A-Z]|^ms/g;
var $f967aabe7c900f32$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $f967aabe7c900f32$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $f967aabe7c900f32$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $f967aabe7c900f32$var$processStyleName = (0, $66d48fa5c2e2674f$export$2e2bcd8739ae039)(function(styleName) {
    return $f967aabe7c900f32$var$isCustomProperty(styleName) ? styleName : styleName.replace($f967aabe7c900f32$var$hyphenateRegex, '-$&').toLowerCase();
});
var $f967aabe7c900f32$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($f967aabe7c900f32$var$animationRegex, function(match, p1, p2) {
                $f967aabe7c900f32$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $f967aabe7c900f32$var$cursor
                };
                return p1;
            });
    }
    if ((0, $42b8ea70a8bab97a$export$2e2bcd8739ae039)[key] !== 1 && !$f967aabe7c900f32$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $f967aabe7c900f32$var$contentValuePattern, $f967aabe7c900f32$var$contentValues, $f967aabe7c900f32$var$oldProcessStyleValue, $f967aabe7c900f32$var$msPattern, $f967aabe7c900f32$var$hyphenPattern, $f967aabe7c900f32$var$hyphenatedCache;
var $f967aabe7c900f32$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $f967aabe7c900f32$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $f967aabe7c900f32$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $f967aabe7c900f32$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $f967aabe7c900f32$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $f967aabe7c900f32$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $f967aabe7c900f32$var$cursor;
                var result = interpolation(mergedProps);
                $f967aabe7c900f32$var$cursor = previousCursor;
                return $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $f967aabe7c900f32$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($f967aabe7c900f32$var$isProcessableValue(value)) string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + $f967aabe7c900f32$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($f967aabe7c900f32$var$isProcessableValue(value[_i])) string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + $f967aabe7c900f32$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case 'animation':
                case 'animationName':
                    string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $f967aabe7c900f32$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $f967aabe7c900f32$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $f967aabe7c900f32$var$cursor;
var $f967aabe7c900f32$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $f967aabe7c900f32$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $f967aabe7c900f32$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $f967aabe7c900f32$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $fd60843e7f34d2f0$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $f967aabe7c900f32$var$cursor
    };
};


var $f97744e9554218f8$var$isBrowser = true;
function $f97744e9554218f8$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $f97744e9554218f8$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $f97744e9554218f8$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $3502267f5140feae$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $3502267f5140feae$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $f97744e9554218f8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3502267f5140feae$var$createEmotion = function createEmotion(options) {
    var cache = (0, $a276211492fd575f$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $f97744e9554218f8$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $3502267f5140feae$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered);
        $3502267f5140feae$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $3502267f5140feae$var$merge(cache.registered, css, $3502267f5140feae$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $f97744e9554218f8$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $3502267f5140feae$var$merge.bind(null, cache.registered, css)
    };
};
var $3502267f5140feae$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
var $3502267f5140feae$export$2e2bcd8739ae039 = $3502267f5140feae$var$createEmotion;


var $ee90a39a48e5fa92$var$_createEmotion = (0, $3502267f5140feae$export$2e2bcd8739ae039)(), $ee90a39a48e5fa92$export$4909b86c8034bf73 = $ee90a39a48e5fa92$var$_createEmotion.flush, $ee90a39a48e5fa92$export$fa8d919ba61d84db = $ee90a39a48e5fa92$var$_createEmotion.hydrate, $ee90a39a48e5fa92$export$a274e22fb40f762e = $ee90a39a48e5fa92$var$_createEmotion.cx, $ee90a39a48e5fa92$export$4950aa0f605343fb = $ee90a39a48e5fa92$var$_createEmotion.merge, $ee90a39a48e5fa92$export$95d99596f328fd52 = $ee90a39a48e5fa92$var$_createEmotion.getRegisteredStyles, $ee90a39a48e5fa92$export$efb9f5caaa2ca0c7 = $ee90a39a48e5fa92$var$_createEmotion.injectGlobal, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e = $ee90a39a48e5fa92$var$_createEmotion.keyframes, $ee90a39a48e5fa92$export$dbf350e5966cf602 = $ee90a39a48e5fa92$var$_createEmotion.css, $ee90a39a48e5fa92$export$995990c5c04c46f0 = $ee90a39a48e5fa92$var$_createEmotion.sheet, $ee90a39a48e5fa92$export$69a3209f1a06c04d = $ee90a39a48e5fa92$var$_createEmotion.cache;



var $8tsvq = parcelRequire("8tsvq");
var $3a460728537dec08$exports = {};
Object.defineProperty($3a460728537dec08$exports, "__esModule", {
    value: true
});
$3a460728537dec08$exports = {
    "contentWidthDefault": "1280px",
    "contentWidthText": "768px",
    "contentWidthFull": "100%",
    "spacing2Xs": "0.25rem",
    "spacingXs": "0.5rem",
    "spacingS": "0.75rem",
    "spacingM": "1rem",
    "spacingL": "1.5rem",
    "spacingXl": "2rem",
    "spacing2Xl": "3rem",
    "spacing3Xl": "4rem",
    "spacing4Xl": "5rem",
    "zIndexNegative": -1,
    "zIndexWorkbench": 0,
    "zIndexDefault": 1,
    "zIndexWorkbenchHeader": 10,
    "zIndexModal": 100,
    "zIndexModalContent": 101,
    "zIndexDropdown": 1000,
    "zIndexTooltip": 10000,
    "zIndexNotification": 100000,
    "borderRadiusSmall": "4px",
    "borderRadiusMedium": "6px",
    "boxShadowPositive": "0px 1px 0px rgb(25, 37, 50, 0.1)",
    "boxShadowDefault": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px 3px 7px -3px rgba(25, 37, 50, 0.1), 0px 6px 12px -2px rgba(25, 37, 50, 0.1);",
    "boxShadowHeavy": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px -6px 16px -6px rgba(25, 37, 50, 0.03), 0px 8px 16px -8px rgba(25, 37, 50, 0.2), 0px 13px 27px -5px rgba(25, 37, 50, 0.15);",
    "insetBoxShadowDefault": "inset 0px 2px 0px rgba(225, 228, 232, 0.2);",
    "glowPrimary": "0px 0px 0px 3px #98CBFF",
    "glowNegative": "0px 0px 0px 3px #FFB1B2",
    "glowPositive": "0px 0px 0px 3px #9ED696",
    "glowWarning": "0px 0px 0px 3px #FDE5C0",
    "glowMuted": "0px 0px 0px 3px #E7EBEE",
    "colorBlack": "#0C141C",
    "colorBlueLightest": "#E8F5FF",
    "colorBlueLight": "#98CBFF",
    "colorBlueMid": "#036FE3",
    "colorBlueBase": "#0059C8",
    "colorBlueDark": "#0041AB",
    "blue100": "#E8F5FF",
    "blue200": "#CEECFF",
    "blue300": "#98CBFF",
    "blue400": "#40A0FF",
    "blue500": "#036FE3",
    "blue600": "#0059C8",
    "blue700": "#0041AB",
    "blue800": "#003298",
    "blue900": "#002A8E",
    "colorContrastDark": "#0C141C",
    "colorContrastMid": "#111B2B",
    "colorContrastLight": "#1B273A",
    "colorCoralDark": "#FFE0E0",
    "colorCoralMid": "#FFF2F2",
    "colorElementDarkest": "#67728A",
    "colorElementDark": "#AEC1CC",
    "colorElementMid": "#CFD9E0",
    "colorElementLight": "#E7EBEE",
    "colorElementLightest": "#F7F9FA",
    "gray100": "#F7F9FA",
    "gray200": "#E7EBEE",
    "gray300": "#CFD9E0",
    "gray400": "#AEC1CC",
    "gray500": "#67728A",
    "gray600": "#5A657C",
    "gray700": "#414D63",
    "gray800": "#1B273A",
    "gray900": "#111B2B",
    "colorGreenDark": "#00550C",
    "colorGreenBase": "#006D23",
    "colorGreenMid": "#008539",
    "colorGreenLight": "#9ED696",
    "colorGreenLightest": "#EAF9E8",
    "green100": "#EAF9E8",
    "green200": "#CDF3C6",
    "green300": "#9ED696",
    "green400": "#5DB057",
    "green500": "#008539",
    "green600": "#006D23",
    "green700": "#00550C",
    "green800": "#004700",
    "green900": "#003F00",
    "colorIceDark": "#CEECFF",
    "colorIceMid": "#E8F5FF",
    "colorMintDark": "#CDF3C6",
    "colorMintMid": "#EAF9E8",
    "colorOrangeDark": "#B12D00",
    "colorOrangeBase": "#CC4500",
    "colorOrangeMid": "#F07F23",
    "colorOrangeLight": "#FDE5C0",
    "colorOrangeLightest": "#FFF2E4",
    "orange100": "#FFF2E4",
    "orange200": "#FDE5C0",
    "orange300": "#FDB882",
    "orange400": "#F07F23",
    "orange500": "#CC4500",
    "orange600": "#B12D00",
    "orange700": "#892300",
    "orange800": "#731A00",
    "orange900": "#631C00",
    "colorPeachDark": "#FDE5C0",
    "colorPeachMid": "#FFF2E4",
    "colorPurpleDark": "#5127B5",
    "colorPurpleBase": "#6C3ECF",
    "colorPurpleMid": "#8553E7",
    "colorPurpleLight": "#D1BBFF",
    "colorPurpleLightest": "#F7F2FF",
    "purple100": "#F7F2FF",
    "purple200": "#EDE3FF",
    "purple300": "#D1BBFF",
    "purple400": "#AE89FF",
    "purple500": "#8553E7",
    "purple600": "#6C3ECF",
    "purple700": "#5127B5",
    "purple800": "#3E16A4",
    "purple900": "#340E9C",
    "colorRedDark": "#990017",
    "colorRedBase": "#BD002A",
    "colorRedMid": "#DA294A",
    "colorRedLight": "#FFB1B2",
    "colorRedLightest": "#FFF2F2",
    "red100": "#FFF2F2",
    "red200": "#FFE0E0",
    "red300": "#FFB1B2",
    "red400": "#FF707D",
    "red500": "#DA294A",
    "red600": "#BD002A",
    "red700": "#990017",
    "red800": "#7F0010",
    "red900": "#72000E",
    "colorPrimary": "#0059C8",
    "colorPositive": "#006D23",
    "colorNegative": "#BD002A",
    "colorWarning": "#CC4500",
    "colorTextDark": "#111B2B",
    "colorTextBase": "#1B273A",
    "colorTextMid": "#414D63",
    "colorTextLight": "#5A657C",
    "colorTextLightest": "#67728A",
    "colorWhite": "#ffffff",
    "colorYellowDark": "#956300",
    "colorYellowBase": "#EAAF09",
    "colorYellowMid": "#FFC835",
    "colorYellowLight": "#FFD960",
    "colorYellowLightest": "#FFF6CC",
    "yellow100": "#FEF9DF",
    "yellow200": "#FFF6CC",
    "yellow300": "#FFE993",
    "yellow400": "#FFD960",
    "yellow500": "#FFC835",
    "yellow600": "#EAAF09",
    "yellow700": "#B78300",
    "yellow800": "#956300",
    "yellow900": "#7F5200",
    "transitionDurationShort": "0.1s",
    "transitionDurationDefault": "0.2s",
    "transitionDurationLong": "0.3s",
    "transitionEasingDefault": "ease-in-out",
    "transitionEasingCubicBezier": "cubic-bezier(0.13, 0.62, 0.11, 0.99)",
    "fontBaseDefault": "16",
    "fontSize4Xl": "3rem",
    "fontSize3Xl": "2.25rem",
    "fontSize2Xl": "1.5rem",
    "fontSizeXl": "1.25rem",
    "fontSizeXlHigh": "1.125rem",
    "fontSizeL": "1rem",
    "fontSizeLHigh": "0.875rem",
    "fontSizeM": "0.875rem",
    "fontSizeMHigh": "0.75rem",
    "fontSizeS": "0.75rem",
    "fontSizeSHigh": "0.625rem",
    "fontStackPrimary": "Geist Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "fontStackMonospace": "Geist Mono, SFMono-Regular, Consolas, Liberation Mono, Menlo,monospace",
    "fontWeightNormal": 400,
    "fontWeightMedium": 500,
    "fontWeightDemiBold": 600,
    "letterSpacingDefault": "0rem",
    "letterSpacingWide": "0.1rem",
    "lineHeightDefault": "1.5",
    "lineHeightCondensed": "1.25",
    "lineHeight4Xl": "3.5rem",
    "lineHeight3Xl": "3rem",
    "lineHeight2Xl": "2.25rem",
    "lineHeightXl": "2rem",
    "lineHeightXlHigh": "1.5rem",
    "lineHeightL": "1.5rem",
    "lineHeightLHigh": "1.25rem",
    "lineHeightM": "1.25rem",
    "lineHeightMHigh": "1rem",
    "lineHeightS": "1rem",
    "lineHeightSHigh": "0.75rem"
};



var $8tsvq = parcelRequire("8tsvq");
function $0a621ebff2a8df04$export$2e2bcd8739ae039(t, e) {
    return $0a621ebff2a8df04$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0a621ebff2a8df04$export$2e2bcd8739ae039(t, e);
}


function $c96d5d7e938979f8$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0a621ebff2a8df04$export$2e2bcd8739ae039)(t, o);
}



var $8tsvq = parcelRequire("8tsvq");

var $ab21cee4932cfbed$exports = {};
var $100fb742cc9e90fa$exports = {};
function $100fb742cc9e90fa$var$_setPrototypeOf(t, e) {
    return $100fb742cc9e90fa$exports = $100fb742cc9e90fa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $100fb742cc9e90fa$exports.__esModule = true, $100fb742cc9e90fa$exports["default"] = $100fb742cc9e90fa$exports, $100fb742cc9e90fa$var$_setPrototypeOf(t, e);
}
$100fb742cc9e90fa$exports = $100fb742cc9e90fa$var$_setPrototypeOf, $100fb742cc9e90fa$exports.__esModule = true, $100fb742cc9e90fa$exports["default"] = $100fb742cc9e90fa$exports;


function $ab21cee4932cfbed$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $100fb742cc9e90fa$exports(t, o);
}
$ab21cee4932cfbed$exports = $ab21cee4932cfbed$var$_inheritsLoose, $ab21cee4932cfbed$exports.__esModule = true, $ab21cee4932cfbed$exports["default"] = $ab21cee4932cfbed$exports;



var $8tsvq = parcelRequire("8tsvq");



var $4e21f7e4fe8f58d3$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $4e21f7e4fe8f58d3$var$EmotionCacheContext = /*#__PURE__*/ (0, $8tsvq.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $a276211492fd575f$export$2e2bcd8739ae039)() : null);
var $4e21f7e4fe8f58d3$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $8tsvq.createContext)({});
var $4e21f7e4fe8f58d3$export$e7094788287c5e9b = $4e21f7e4fe8f58d3$var$EmotionCacheContext.Provider;
var $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $8tsvq.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $4e21f7e4fe8f58d3$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $4e21f7e4fe8f58d3$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4e21f7e4fe8f58d3$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $4e21f7e4fe8f58d3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4e21f7e4fe8f58d3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4e21f7e4fe8f58d3$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $4e21f7e4fe8f58d3$var$Noop = function Noop() {
    return null;
};
var $4e21f7e4fe8f58d3$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$4e21f7e4fe8f58d3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $f97744e9554218f8$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(registeredStyles);
    var labelFromStack;
    var rules = (0, $f97744e9554218f8$export$6f077d94b33a01aa)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4e21f7e4fe8f58d3$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $4e21f7e4fe8f58d3$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $8tsvq.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$var$Noop, null);
    return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $8tsvq.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $4e21f7e4fe8f58d3$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $4e21f7e4fe8f58d3$var$render(cache, props, theme, ref);
    });
    return $4e21f7e4fe8f58d3$var$render(cache, props, null, ref);
});






function $7c908f8c65e1ea2a$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $f967aabe7c900f32$export$6321afa313b251b5)(args);
}
var $7c908f8c65e1ea2a$export$2e2bcd8739ae039 = $7c908f8c65e1ea2a$var$css;


var $b7d8f67c6c41081e$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $4e21f7e4fe8f58d3$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return (0, $8tsvq.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4e21f7e4fe8f58d3$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4e21f7e4fe8f58d3$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $8tsvq.createElement).apply(null, createElementArgArray);
};
var $b7d8f67c6c41081e$var$warnedAboutCssPropForGlobal = false;
var $b7d8f67c6c41081e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $4e21f7e4fe8f58d3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)([
        styles
    ]);
    return /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b7d8f67c6c41081e$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $c96d5d7e938979f8$export$2e2bcd8739ae039)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $f018542cedf583c1$export$9d753cd7ae895cce)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $f97744e9554218f8$export$6f077d94b33a01aa)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $8tsvq.Component));
var $b7d8f67c6c41081e$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $b7d8f67c6c41081e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $b7d8f67c6c41081e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $f97744e9554218f8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b7d8f67c6c41081e$var$Noop = function Noop() {
    return null;
};
var $b7d8f67c6c41081e$export$9b9c0f9d9f3552b8 = (0, $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b)(function(props, context) {
    return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $4e21f7e4fe8f58d3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, context.registered);
            (0, $f97744e9554218f8$export$6f077d94b33a01aa)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $b7d8f67c6c41081e$var$merge(context.registered, css, $b7d8f67c6c41081e$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$Noop, null);
        return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $8tsvq.Fragment), null, possiblyStyleElement, ele);
    });
});




var $7c1d3a8c755aa15d$var$fe = Object.defineProperty, $7c1d3a8c755aa15d$var$ye = Object.defineProperties;
var $7c1d3a8c755aa15d$var$ge = Object.getOwnPropertyDescriptors;
var $7c1d3a8c755aa15d$var$k = Object.getOwnPropertySymbols;
var $7c1d3a8c755aa15d$var$$ = Object.prototype.hasOwnProperty, $7c1d3a8c755aa15d$var$z = Object.prototype.propertyIsEnumerable;
var $7c1d3a8c755aa15d$var$j = (e, o, t)=>o in e ? $7c1d3a8c755aa15d$var$fe(e, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[o] = t, $7c1d3a8c755aa15d$var$i = (e, o)=>{
    for(var t in o || (o = {}))$7c1d3a8c755aa15d$var$$.call(o, t) && $7c1d3a8c755aa15d$var$j(e, t, o[t]);
    if ($7c1d3a8c755aa15d$var$k) for (var t of $7c1d3a8c755aa15d$var$k(o))$7c1d3a8c755aa15d$var$z.call(o, t) && $7c1d3a8c755aa15d$var$j(e, t, o[t]);
    return e;
}, $7c1d3a8c755aa15d$var$s = (e, o)=>$7c1d3a8c755aa15d$var$ye(e, $7c1d3a8c755aa15d$var$ge(o));
var $7c1d3a8c755aa15d$var$d = (e, o)=>{
    var t = {};
    for(var r in e)$7c1d3a8c755aa15d$var$$.call(e, r) && o.indexOf(r) < 0 && (t[r] = e[r]);
    if (e != null && $7c1d3a8c755aa15d$var$k) for (var r of $7c1d3a8c755aa15d$var$k(e))o.indexOf(r) < 0 && $7c1d3a8c755aa15d$var$z.call(e, r) && (t[r] = e[r]);
    return t;
};
var $7c1d3a8c755aa15d$var$xe = (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039)`
  /* Remove default margin */
  /* Button has default margin in some browsers, like safari */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd,
  button {
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }

  /* Set core root defaults */
  html:focus-within {
    scroll-behavior: smooth;
  }

  /* Set core body defaults */
  body {
    text-rendering: optimizeSpeed;
    line-height: 1.5;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`, $7c1d3a8c755aa15d$export$c507fb1c2e1ac13a = ({ withNormalize: e = !0, styles: o })=>$8tsvq.createElement((0, $b7d8f67c6c41081e$export$98f03c5d19621d70), {
        styles: (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039)`
        ${e ? $7c1d3a8c755aa15d$var$xe : void 0};
        @font-face {
          font-family: 'Geist Mono';
          src: url('https://cdn.f36.contentful.com/fonts/geist-mono-1.4.01.woff2');
        }

        @font-face {
          font-family: 'Geist Sans';
          src: url('https://cdn.f36.contentful.com/fonts/geist-sans-1.4.01.woff2');
        }

        html {
          border: 0;
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          color: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray800};
          font-family: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontStackPrimary};
          font-size: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontSizeM};
          line-height: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).lineHeightM};
          font-synthesis-weight: none;
          /* Improves readability of lowercase L (l) and uppercase i (I) */
          font-feature-settings: 'ss05' on;
        }

        code {
          font-family: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontStackMonospace};
        }

        fieldset {
          border: 0;
          margin: 0;
          padding: 0;
        }

        *,
        *::after,
        *::before {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
          box-sizing: inherit;
        }

        ${o};
      `
    });
var $7c1d3a8c755aa15d$var$Pe = {
    none: 0,
    spacing2Xs: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing2Xs,
    spacingXs: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingXs,
    spacingS: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingS,
    spacingM: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingM,
    spacingL: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingL,
    spacingXl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingXl,
    spacing2Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing2Xl,
    spacing3Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing3Xl,
    spacing4Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing4Xl
};
function $7c1d3a8c755aa15d$var$c(e) {
    return $7c1d3a8c755aa15d$var$Pe[e];
}
function $7c1d3a8c755aa15d$var$K(e) {
    return Object.assign({}, e.margin ? {
        margin: $7c1d3a8c755aa15d$var$c(e.margin)
    } : null, e.marginLeft ? {
        marginLeft: $7c1d3a8c755aa15d$var$c(e.marginLeft)
    } : null, e.marginRight ? {
        marginRight: $7c1d3a8c755aa15d$var$c(e.marginRight)
    } : null, e.marginTop ? {
        marginTop: $7c1d3a8c755aa15d$var$c(e.marginTop)
    } : null, e.marginBottom ? {
        marginBottom: $7c1d3a8c755aa15d$var$c(e.marginBottom)
    } : null, e.padding ? {
        padding: $7c1d3a8c755aa15d$var$c(e.padding)
    } : null, e.paddingLeft ? {
        paddingLeft: $7c1d3a8c755aa15d$var$c(e.paddingLeft)
    } : null, e.paddingRight ? {
        paddingRight: $7c1d3a8c755aa15d$var$c(e.paddingRight)
    } : null, e.paddingTop ? {
        paddingTop: $7c1d3a8c755aa15d$var$c(e.paddingTop)
    } : null, e.paddingBottom ? {
        paddingBottom: $7c1d3a8c755aa15d$var$c(e.paddingBottom)
    } : null);
}
var $7c1d3a8c755aa15d$var$he = "div";
function $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(e) {
    let E = e, { display: o, className: t, margin: r, marginBottom: a, marginLeft: p, marginRight: n, marginTop: m, padding: f, paddingBottom: y, paddingLeft: g, paddingRight: x, paddingTop: P, testId: R, as: b = $7c1d3a8c755aa15d$var$he } = E, T = $7c1d3a8c755aa15d$var$d(E, [
        "display",
        "className",
        "margin",
        "marginBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "padding",
        "paddingBottom",
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "testId",
        "as"
    ]);
    return {
        boxProps: $7c1d3a8c755aa15d$var$i({
            className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
                display: o
            }), (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)($7c1d3a8c755aa15d$var$i({}, $7c1d3a8c755aa15d$var$K({
                margin: r,
                marginBottom: a,
                marginLeft: p,
                marginRight: n,
                marginTop: m,
                padding: f,
                paddingBottom: y,
                paddingLeft: g,
                paddingRight: x,
                paddingTop: P
            }))), t),
            "data-test-id": R
        }, T),
        Element: b
    };
}
function $7c1d3a8c755aa15d$var$V(e, o) {
    let { boxProps: t, Element: r } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(e);
    return $8tsvq.createElement(r, $7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, t), {
        ref: o
    }), e.children);
}
$7c1d3a8c755aa15d$var$V.displayName = "Box";
var $7c1d3a8c755aa15d$export$e71c4d32a2263218 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$V);
var $7c1d3a8c755aa15d$var$Te = "div";
function $7c1d3a8c755aa15d$var$Y(We, ce) {
    var U = We, { isInline: e, alignItems: o, alignSelf: t, alignContent: r, flex: a, flexBasis: p, flexShrink: n, flexDirection: m, flexGrow: f, flexWrap: y, fullHeight: g, fullWidth: x, gap: P, justifyContent: R, justifyItems: b, justifySelf: T, order: I, children: E, as: A } = U, G = $7c1d3a8c755aa15d$var$d(U, [
        "isInline",
        "alignItems",
        "alignSelf",
        "alignContent",
        "flex",
        "flexBasis",
        "flexShrink",
        "flexDirection",
        "flexGrow",
        "flexWrap",
        "fullHeight",
        "fullWidth",
        "gap",
        "justifyContent",
        "justifyItems",
        "justifySelf",
        "order",
        "children",
        "as"
    ]);
    var X;
    let { boxProps: N, Element: de } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, G), {
        as: A || $7c1d3a8c755aa15d$var$Te
    }));
    return $8tsvq.createElement(de, $7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, N), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: e ? "inline-flex" : "flex",
            width: x ? "100%" : void 0,
            height: g ? "100%" : void 0,
            flex: a,
            flexBasis: p,
            flexShrink: n,
            flexDirection: m,
            gap: P === "none" ? 0 : (X = (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports)))[P]) != null ? X : P,
            justifyContent: R,
            justifyItems: b,
            justifySelf: T,
            alignItems: o,
            alignSelf: t,
            alignContent: r,
            order: I,
            flexWrap: y,
            flexGrow: f
        }), N.className),
        ref: ce
    }), E);
}
$7c1d3a8c755aa15d$var$Y.displayName = "Flex";
var $7c1d3a8c755aa15d$export$f51f4c4ede09e011 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$Y);
var $7c1d3a8c755aa15d$var$Ie = "div";
function $7c1d3a8c755aa15d$var$Z(P, x) {
    var R = P, { alignContent: e, children: o, columnGap: t = "spacingM", columns: r = "auto", flow: a, isInline: p, justifyContent: n, rowGap: m = "none", rows: f = "auto", as: y } = R, g = $7c1d3a8c755aa15d$var$d(R, [
        "alignContent",
        "children",
        "columnGap",
        "columns",
        "flow",
        "isInline",
        "justifyContent",
        "rowGap",
        "rows",
        "as"
    ]);
    var E, A;
    let b = (G)=>typeof G == "number" ? `repeat(${G}, minmax(0, 1fr))` : G, { boxProps: T, Element: I } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, g), {
        as: y || $7c1d3a8c755aa15d$var$Ie
    }));
    return $8tsvq.createElement(I, $7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, T), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: p ? "inline-grid" : "grid",
            gridTemplateColumns: b(r),
            gridTemplateRows: b(f),
            flow: a,
            justifyContent: n,
            alignContent: e,
            columnGap: (E = $7c1d3a8c755aa15d$var$c(t)) != null ? E : 0,
            rowGap: (A = $7c1d3a8c755aa15d$var$c(m)) != null ? A : 0
        }), T.className),
        ref: x
    }), o);
}
$7c1d3a8c755aa15d$var$Z.displayName = "Grid";
var $7c1d3a8c755aa15d$var$ee = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$Z);
function $7c1d3a8c755aa15d$var$oe(y, f) {
    var g = y, { children: e, columnStart: o, columnEnd: t, rowStart: r, rowEnd: a, area: p, order: n } = g, m = $7c1d3a8c755aa15d$var$d(g, [
        "children",
        "columnStart",
        "columnEnd",
        "rowStart",
        "rowEnd",
        "area",
        "order"
    ]);
    let x = p || [
        r || "auto",
        o || "auto",
        a || "auto",
        t || "auto"
    ].join(" / "), { boxProps: P, Element: R } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(m);
    return $8tsvq.createElement(R, $7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, P), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            gridArea: x,
            order: n
        }), P.className),
        ref: f
    }), e);
}
$7c1d3a8c755aa15d$var$oe.displayName = "GridItem";
var $7c1d3a8c755aa15d$export$9eb849b9b922d396 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$oe);
var $7c1d3a8c755aa15d$export$ef2184bd89960b14 = $7c1d3a8c755aa15d$var$ee;
$7c1d3a8c755aa15d$export$ef2184bd89960b14.Item = $7c1d3a8c755aa15d$export$9eb849b9b922d396;
var $7c1d3a8c755aa15d$var$_e = "div";
function $7c1d3a8c755aa15d$var$te(f, m) {
    var y = f, { flexDirection: e = "row", alignItems: o = "center", isInline: t = !1, spacing: r = "spacingM", children: a, as: p } = y, n = $7c1d3a8c755aa15d$var$d(y, [
        "flexDirection",
        "alignItems",
        "isInline",
        "spacing",
        "children",
        "as"
    ]);
    let { boxProps: g, Element: x } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, n), {
        as: p || $7c1d3a8c755aa15d$var$_e
    }));
    return $8tsvq.createElement($7c1d3a8c755aa15d$export$f51f4c4ede09e011, $7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, g), {
        as: x,
        flexDirection: e,
        alignItems: o,
        isInline: t,
        className: g.className,
        gap: r,
        ref: m
    }), a);
}
$7c1d3a8c755aa15d$var$te.displayName = "Stack";
var $7c1d3a8c755aa15d$export$694e0d28c7ffc90c = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$te);
function $7c1d3a8c755aa15d$var$ne() {
    return {
        screenReaderOnly: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            border: 0
        })
    };
}
var $7c1d3a8c755aa15d$export$518e781dade4a416 = (p)=>{
    var n = p, { children: e, className: o, testId: t = "cf-ui-ScreenReaderOnly", as: r = "div" } = n, a = $7c1d3a8c755aa15d$var$d(n, [
        "children",
        "className",
        "testId",
        "as"
    ]);
    let m = $7c1d3a8c755aa15d$var$ne();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement(r, $7c1d3a8c755aa15d$var$s($7c1d3a8c755aa15d$var$i({}, a), {
        "data-test-id": t,
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)(m.screenReaderOnly, o)
    }), e);
};
function $7c1d3a8c755aa15d$export$f680877a34711e37(e, o) {
    return (0, $8tsvq.useMemo)(()=>e || [
            o || "id",
            Math.round(Math.random() * 1e4)
        ].join("_"), []);
}
function $7c1d3a8c755aa15d$export$6f32135080cb4c3({ isOpen: e, defaultIsOpen: o, onOpen: t, onClose: r }) {
    let [a, p] = (0, $8tsvq.useState)(o || !1), n = e !== void 0, m = n ? e : a, f = (0, $8tsvq.useCallback)(()=>{
        n || p(!1), r == null || r();
    }, [
        n,
        r
    ]), y = (0, $8tsvq.useCallback)(()=>{
        n || p(!0), t == null || t();
    }, [
        n,
        t
    ]);
    return {
        isOpen: m,
        isControlled: n,
        handleClose: f,
        handleOpen: y
    };
}
function $7c1d3a8c755aa15d$export$2312e6e6009df96({ onLoad: e } = {}) {
    let [o, t] = (0, $8tsvq.useState)(!1), r = (0, $8tsvq.useRef)(), a = (0, $8tsvq.useCallback)(()=>{
        e == null || e(), t(!0);
    }, [
        e
    ]);
    return (0, $8tsvq.useEffect)(()=>{
        r.current && r.current.complete && a();
    }, [
        a
    ]), {
        ref: r,
        loaded: o,
        onLoad: a
    };
}
function $7c1d3a8c755aa15d$export$c9058316764c140e(...e) {
    return (o)=>{
        e.forEach((t)=>{
            typeof t == "function" ? t(o) : t != null && (t.current = o);
        });
    };
}
var $7c1d3a8c755aa15d$export$125b56fdc77c3731 = ({ status: e })=>{
    switch(e){
        case "published":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorGreenBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorGreenLightest
            };
        case "changed":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorBlueBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorBlueLightest
            };
        case "deleted":
        case "archived":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorRedBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorRedLightest
            };
        case "draft":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorOrangeDark,
                backgroundColor: "#ffefd5"
            };
        case "new":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorWhite,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).blue500
            };
        default:
            return console.warn(`Unknown EntityStatus: ${e}`), {};
    }
};
var $7c1d3a8c755aa15d$var$$e = {
    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray200,
    "&:hover, &:active": {
        backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray200
    }
}, $7c1d3a8c755aa15d$var$me = {
    opacity: .5,
    cursor: "auto",
    "&:hover": {
        backgroundColor: "unset"
    }
}, $7c1d3a8c755aa15d$export$adaad53e003c74d0 = ({ isActive: e = !1, isDisabled: o = !1 })=>(0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
        alignItems: "center",
        display: "flex",
        background: "none",
        borderWidth: "1px 0",
        borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorWhite,
        borderRadius: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).borderRadiusSmall,
        borderStyle: "solid",
        outline: "none",
        fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontSizeM,
        lineHeight: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).lineHeightM,
        fontWeight: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontWeightNormal,
        position: "relative",
        textAlign: "left",
        padding: `5px ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingXs}`,
        wordBreak: "break-word",
        whiteSpace: "break-spaces",
        cursor: "pointer",
        hyphens: "auto",
        minWidth: "150px",
        textDecoration: "none",
        color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray700,
        "&:focus, &:hover": {
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray100
        },
        "&:focus": {
            boxShadow: `inset ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).glowPrimary}`
        },
        "&:focus:not(:focus-visible)": {
            boxShadow: "unset"
        },
        "&:focus-visible": {
            boxShadow: `inset ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).glowPrimary}`
        },
        "&:active": {
            color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray700,
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray200
        },
        "&:disabled": $7c1d3a8c755aa15d$var$me
    }), e && (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)($7c1d3a8c755aa15d$var$$e), o && (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)($7c1d3a8c755aa15d$var$me));
 //# sourceMappingURL=out.js.map


var $6e6b089c3d63766c$var$N = Object.defineProperty, $6e6b089c3d63766c$var$T = Object.defineProperties;
var $6e6b089c3d63766c$var$v = Object.getOwnPropertyDescriptors;
var $6e6b089c3d63766c$var$m = Object.getOwnPropertySymbols;
var $6e6b089c3d63766c$var$c = Object.prototype.hasOwnProperty, $6e6b089c3d63766c$var$x = Object.prototype.propertyIsEnumerable;
var $6e6b089c3d63766c$var$f = (r, a, t)=>a in r ? $6e6b089c3d63766c$var$N(r, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[a] = t, $6e6b089c3d63766c$var$S = (r, a)=>{
    for(var t in a || (a = {}))$6e6b089c3d63766c$var$c.call(a, t) && $6e6b089c3d63766c$var$f(r, t, a[t]);
    if ($6e6b089c3d63766c$var$m) for (var t of $6e6b089c3d63766c$var$m(a))$6e6b089c3d63766c$var$x.call(a, t) && $6e6b089c3d63766c$var$f(r, t, a[t]);
    return r;
}, $6e6b089c3d63766c$var$d = (r, a)=>$6e6b089c3d63766c$var$T(r, $6e6b089c3d63766c$var$v(a));
var $6e6b089c3d63766c$var$g = (r, a)=>{
    var t = {};
    for(var n in r)$6e6b089c3d63766c$var$c.call(r, n) && a.indexOf(n) < 0 && (t[n] = r[n]);
    if (r != null && $6e6b089c3d63766c$var$m) for (var n of $6e6b089c3d63766c$var$m(r))a.indexOf(n) < 0 && $6e6b089c3d63766c$var$x.call(r, n) && (t[n] = r[n]);
    return t;
};
var $6e6b089c3d63766c$var$h = {
    large: "36px",
    medium: "20px",
    small: "14px"
}, $6e6b089c3d63766c$var$y = ()=>{
    let r = {
        scale1: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    6.666667% {
      transform: scale(1.5, 0.5);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1.5, 0.5);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        scale2: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    20% {
      transform: scale(1.5, 0.5);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    46.666667% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    73.333333% {
      transform: scale(1.5, 0.5);
    }
    80% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        scale3: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1.5, 0.5);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    80% {
      transform: scale(1, 1);
    }
    86.666667% {
      transform: scale(1.5, 0.5);
    }
    93.333333% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        translate1: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(10px, 33.528168px);
    }
    6.666667% {
      transform: translate(10px, 41.764084px);
    }
    13.333333% {
      transform: translate(10px, 33.528168px);
    }
    26.666667% {
      transform: translate(10px, -2.651608px);
    }
    33.333333% {
      transform: translate(10px, -4.471832px);
    }
    40% {
      transform: translate(10px, -2.651608px);
    }
    53.333333% {
      transform: translate(10px, 33.528168px);
    }
    60% {
      transform: translate(10px, 41.764084px);
    }
    66.666667% {
      transform: translate(10px, 33.528168px);
    }
    100% {
      transform: translate(10px, 33.528168px);
    }
  `,
        translate2: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(30px, 33.528168px);
    }
    13.333333% {
      transform: translate(30px, 33.528168px);
    }
    20% {
      transform: translate(30px, 41.764084px);
    }
    26.666667% {
      transform: translate(30px, 33.528168px);
    }
    40% {
      transform: translate(30px, -2.651608px);
    }
    46.666667% {
      transform: translate(30px, -4.471832px);
    }
    53.333333% {
      transform: translate(30px, -2.651608px);
    }
    66.666667% {
      transform: translate(30px, 33.528168px);
    }
    73.333333% {
      transform: translate(30px, 41.764084px);
    }
    80% {
      transform: translate(30px, 33.528168px);
    }
    100% {
      transform: translate(30px, 33.528168px);
    }
  `,
        translate3: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(50px, 33.528168px);
    }
    26.666667% {
      transform: translate(50px, 33.528168px);
    }
    33.333333% {
      transform: translate(50px, 41.764084px);
    }
    40% {
      transform: translate(50px, 33.528168px);
    }
    53.333333% {
      transform: translate(50px, -2.651608px);
    }
    60% {
      transform: translate(50px, -4.471832px);
    }
    66.666667% {
      transform: translate(50px, -2.651608px);
    }
    80% {
      transform: translate(50px, 33.528168px);
    }
    86.666667% {
      transform: translate(50px, 41.764084px);
    }
    93.333333% {
      transform: translate(50px, 33.528168px);
    }
    100% {
      transform: translate(50px, 33.528168px);
    }
  `
    };
    return {
        root: (a)=>(0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
                height: a.customSize ? `${a.customSize}px` : void 0,
                verticalAlign: "middle",
                width: a.customSize ? `${a.customSize}px` : $6e6b089c3d63766c$var$h[a.size]
            }),
        circle1Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale1} 1s linear infinite normal forwards;`
        }),
        circle2Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale2} 1s linear infinite normal forwards;`
        }),
        circle3Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale3} 1s linear infinite normal forwards;`
        }),
        circle1Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate1} 1s linear infinite normal forwards;`
        }),
        circle2Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate2} 1s linear infinite normal forwards;`
        }),
        circle3Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate3} 1s linear infinite normal forwards;`
        })
    };
};
var $6e6b089c3d63766c$var$L = "div", $6e6b089c3d63766c$var$I = {
    default: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray700,
    primary: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).blue500,
    white: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorWhite
}, $6e6b089c3d63766c$export$7f7cbe89f1eacd2 = (0, $8tsvq.forwardRef)((A, P)=>{
    var p = A, { className: r, customSize: a, size: t = "medium", variant: n = "default", testId: z = "cf-ui-spinner" } = p, w = $6e6b089c3d63766c$var$g(p, [
        "className",
        "customSize",
        "size",
        "variant",
        "testId"
    ]);
    let e = $6e6b089c3d63766c$var$y();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement((0, $7c1d3a8c755aa15d$export$e71c4d32a2263218), $6e6b089c3d63766c$var$d($6e6b089c3d63766c$var$S({
        as: $6e6b089c3d63766c$var$L,
        display: "inline-block"
    }, w), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)(e.root({
            size: t,
            customSize: a
        }), r),
        ref: P,
        testId: z
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("svg", {
        className: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: "block",
            fill: $6e6b089c3d63766c$var$I[n]
        }),
        viewBox: "0 0 60 51",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("title", null, "Loading\u2026"), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle1Translate,
        transform: "translate(10,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle1Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle2Translate,
        transform: "translate(30,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle2Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle3Translate,
        transform: "translate(50,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle3Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    })))));
});
$6e6b089c3d63766c$export$7f7cbe89f1eacd2.displayName = "Spinner";
 //# sourceMappingURL=out.js.map




var $e519f03a75c81288$exports = {};

$e519f03a75c81288$exports["notification"] = `gGhtoW_notification`;
for(let key in {})if (key in $e519f03a75c81288$exports) $e519f03a75c81288$exports[key] += ' ' + {}[key];
else $e519f03a75c81288$exports[key] = {}[key];


var $96d12809385be3c5$export$4a295a2b4ab66da6;
'use strict';

var $8tsvq = parcelRequire("8tsvq");
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $dad3209a3a2cdfa7$export$4473561af957c5c7;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd;
/**
 * Map of all Contentful marks.
 */ var $dad3209a3a2cdfa7$export$c85f128c9305332e;
var $dad3209a3a2cdfa7$export$f31e81340f60ac4f;
var $dad3209a3a2cdfa7$export$e5cde5f1d56fabad;
var $dad3209a3a2cdfa7$export$7b02abc60d9af577;
var $dad3209a3a2cdfa7$export$f164f8df1f226ed8;
var $dad3209a3a2cdfa7$export$61dc594370225b3;
var $dad3209a3a2cdfa7$export$33c1f54ccb4cc9b7;
var $dad3209a3a2cdfa7$export$ba32543429ed7e1c;
var $dad3209a3a2cdfa7$export$d8b073923a26e49d;
var $dad3209a3a2cdfa7$export$f8a6793e9df3d55d;
var $dad3209a3a2cdfa7$export$85f9856e66f16aa5;
var $dad3209a3a2cdfa7$export$cbfd4c4104bf5a27;
var $dad3209a3a2cdfa7$export$1ee7d3855fc41eb3;
'use strict';
var $2fc0c0fa00f9c834$exports = {};
'use strict';
$2fc0c0fa00f9c834$exports = (value)=>{
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};


$dad3209a3a2cdfa7$export$4473561af957c5c7 = void 0;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($dad3209a3a2cdfa7$export$4473561af957c5c7 || ($dad3209a3a2cdfa7$export$4473561af957c5c7 = {}));
$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd = void 0;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd || ($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd = {}));
$dad3209a3a2cdfa7$export$c85f128c9305332e = void 0;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($dad3209a3a2cdfa7$export$c85f128c9305332e || ($dad3209a3a2cdfa7$export$c85f128c9305332e = {}));
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $dad3209a3a2cdfa7$var$extendStatics = function(d, b) {
    $dad3209a3a2cdfa7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $dad3209a3a2cdfa7$var$extendStatics(d, b);
};
function $dad3209a3a2cdfa7$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $dad3209a3a2cdfa7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $dad3209a3a2cdfa7$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $dad3209a3a2cdfa7$var$_a$1;
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ var $dad3209a3a2cdfa7$var$TOP_LEVEL_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE
];
/**
 * Array of all allowed block types inside list items
 */ var $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE
];
var $dad3209a3a2cdfa7$var$TABLE_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL
];
/**
 * Array of all void block types
 */ var $dad3209a3a2cdfa7$var$VOID_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ var $dad3209a3a2cdfa7$var$CONTAINERS = ($dad3209a3a2cdfa7$var$_a$1 = {}, $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM] = $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS, $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
], $dad3209a3a2cdfa7$var$_a$1);
/**
 * Array of all heading levels
 */ var $dad3209a3a2cdfa7$var$HEADINGS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6
];
/**
 * Array of all block types that may contain text and inline nodes.
 */ var $dad3209a3a2cdfa7$var$TEXT_CONTAINERS = $dad3209a3a2cdfa7$var$__spreadArray([
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
], $dad3209a3a2cdfa7$var$HEADINGS, true);
/**
 * Node types before `tables` release.
 */ var $dad3209a3a2cdfa7$var$V1_NODE_TYPES = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.HYPERLINK,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY,
    'text'
];
/**
 * Marks before `superscript` & `subscript` release.
 */ var $dad3209a3a2cdfa7$var$V1_MARKS = [
    $dad3209a3a2cdfa7$export$c85f128c9305332e.BOLD,
    $dad3209a3a2cdfa7$export$c85f128c9305332e.CODE,
    $dad3209a3a2cdfa7$export$c85f128c9305332e.ITALIC,
    $dad3209a3a2cdfa7$export$c85f128c9305332e.UNDERLINE
];
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ var $dad3209a3a2cdfa7$var$EMPTY_DOCUMENT = {
    nodeType: $dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $dad3209a3a2cdfa7$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $dad3209a3a2cdfa7$var$isInline(node) {
    return $dad3209a3a2cdfa7$var$hasValue($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $dad3209a3a2cdfa7$var$isBlock(node) {
    return $dad3209a3a2cdfa7$var$hasValue($dad3209a3a2cdfa7$export$4473561af957c5c7, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $dad3209a3a2cdfa7$var$isText(node) {
    return node.nodeType === 'text';
}
var $dad3209a3a2cdfa7$var$helpers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isBlock: $dad3209a3a2cdfa7$var$isBlock,
    isInline: $dad3209a3a2cdfa7$var$isInline,
    isText: $dad3209a3a2cdfa7$var$isText
});
var $dad3209a3a2cdfa7$var$typeMismatchError = function(_a) {
    var path = _a.path, property = _a.property, typeName = _a.typeName, value = _a.value;
    return {
        details: "The type of \"".concat(property, "\" is incorrect, expected type: ").concat(typeName),
        name: 'type',
        path: path.toArray(),
        type: typeName,
        value: value
    };
};
var $dad3209a3a2cdfa7$var$minSizeError = function(_a) {
    var min = _a.min, value = _a.value, path = _a.path;
    return {
        name: 'size',
        min: min,
        path: path.toArray(),
        details: "Size must be at least ".concat(min),
        value: value
    };
};
var $dad3209a3a2cdfa7$var$maxSizeError = function(_a) {
    var max = _a.max, value = _a.value, path = _a.path;
    return {
        name: 'size',
        max: max,
        path: path.toArray(),
        details: "Size must be at most ".concat(max),
        value: value
    };
};
var $dad3209a3a2cdfa7$var$enumError = function(_a) {
    var expected = _a.expected, value = _a.value, path = _a.path;
    return {
        details: "Value must be one of expected values",
        name: 'in',
        expected: $dad3209a3a2cdfa7$var$__spreadArray([], expected, true).sort(),
        path: path.toArray(),
        value: value
    };
};
var $dad3209a3a2cdfa7$var$unknownPropertyError = function(_a) {
    var property = _a.property, path = _a.path;
    return {
        details: "The property \"".concat(property, "\" is not expected"),
        name: 'unexpected',
        path: path.toArray()
    };
};
var $dad3209a3a2cdfa7$var$requiredPropertyError = function(_a) {
    var property = _a.property, path = _a.path;
    return {
        details: "The property \"".concat(property, "\" is required here"),
        name: 'required',
        path: path.toArray()
    };
};
var $dad3209a3a2cdfa7$var$ObjectAssertion = /** @class */ function() {
    function ObjectAssertion(obj, path) {
        var _this = this;
        this.obj = obj;
        this.path = path;
        this._errors = [];
        this.catch = function() {
            var _a;
            var errors = [];
            for(var _i = 0; _i < arguments.length; _i++)errors[_i] = arguments[_i];
            (_a = _this._errors).push.apply(_a, errors);
        };
        /**
         * Asserts the key exists in the object. You probably shouldn't call this
         * function directly. Instead, use `$.object`, `$.number`, `$.string`, etc.
         */ this.exists = function(key) {
            if (key in _this.obj) return true;
            _this.catch($dad3209a3a2cdfa7$var$requiredPropertyError({
                property: key,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is a plain object. if
         * no key is provided, it asserts the object itself.
         */ this.object = function(key) {
            var _a;
            var value = key ? _this.obj[key] : _this.obj;
            if (key) {
                if (!_this.exists(key)) return false;
            }
            if ($2fc0c0fa00f9c834$exports(value)) return true;
            var path = key ? _this.path.of(key) : _this.path;
            var property = (_a = key !== null && key !== void 0 ? key : _this.path.last()) !== null && _a !== void 0 ? _a : 'value';
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'Object',
                property: property,
                path: path,
                value: value
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is a string.
         */ this.string = function(key) {
            var value = _this.obj[key];
            if (key && !_this.exists(key)) return false;
            if (typeof value === 'string') return true;
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'String',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is a number.
         */ this.number = function(key, optional) {
            var value = _this.obj[key];
            if (optional && !(key in _this.obj)) return true;
            if (!_this.exists(key)) return false;
            if (typeof value === 'number' && !Number.isNaN(value)) return true;
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'Number',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is an array. You don't
         * need to manually call this function before `$.each` or `$.maxLength`.
         */ this.array = function(key) {
            var value = _this.obj[key];
            if (key && !_this.exists(key)) return false;
            if (Array.isArray(value)) return true;
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'Array',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        /**
         * Asserts the value of the key is one of the expected values.
         */ this.enum = function(key, expected) {
            var value = _this.obj[key];
            if (typeof value === 'string' && expected.includes(value)) return true;
            _this.catch($dad3209a3a2cdfa7$var$enumError({
                expected: expected,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the array value of the object key is empty. If the value isn't an
         * array, the function captures a type error and returns false.
         */ this.empty = function(key) {
            if (!_this.array(key)) return false;
            var value = _this.obj[key];
            if (value.length === 0) return true;
            _this.catch($dad3209a3a2cdfa7$var$maxSizeError({
                max: 0,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the length of the value of the object key is at least `min`. If the
         * value isn't an array, the function captures a type error and returns false.
         */ this.minLength = function(key, min) {
            if (!_this.array(key)) return false;
            var value = _this.obj[key];
            if (value.length >= min) return true;
            _this.catch($dad3209a3a2cdfa7$var$minSizeError({
                min: min,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the object has no additional properties other than the ones
         * specified
         */ this.noAdditionalProperties = function(properties) {
            var unknowns = Object.keys(_this.obj).sort().filter(function(key) {
                return !properties.includes(key);
            });
            unknowns.forEach(function(property) {
                return _this.catch($dad3209a3a2cdfa7$var$unknownPropertyError({
                    property: property,
                    path: _this.path.of(property)
                }));
            });
            return unknowns.length === 0;
        };
        /**
         * Iterates over the value of the key and assert each item. If the value isn't
         * an array, the function captures a type error and safely exits.
         *
         * To maintain compatibility with previous implementation, we stop early if we
         * find any errors.
         */ this.each = function(key, assert) {
            if (!_this.array(key)) return;
            var value = _this.obj[key];
            var foundErrors = false;
            value.forEach(function(item, index) {
                if (foundErrors) return;
                var errors = assert(item, _this.path.of(key).of(index));
                if (errors.length > 0) foundErrors = true;
                _this.catch.apply(_this, errors);
            });
        };
    }
    Object.defineProperty(ObjectAssertion.prototype, "errors", {
        get: function() {
            var _this = this;
            var serializeError = function(error) {
                return JSON.stringify({
                    details: error.details,
                    path: error.path
                });
            };
            return this._errors.filter(function(error, index) {
                return _this._errors.findIndex(function(step) {
                    return serializeError(error) === serializeError(step);
                }) === index;
            });
        },
        enumerable: false,
        configurable: true
    });
    return ObjectAssertion;
}();
var $dad3209a3a2cdfa7$var$VOID_CONTENT = [];
var $dad3209a3a2cdfa7$var$NodeAssertion = /** @class */ function() {
    function NodeAssertion(contentRule, validateData) {
        this.contentRule = contentRule;
        this.validateData = validateData;
    }
    NodeAssertion.prototype.assert = function(node, path) {
        var _a, _b;
        var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(node, path);
        if (!$.object()) return $.errors;
        $.noAdditionalProperties([
            'nodeType',
            'data',
            'content'
        ]);
        var _c = Array.isArray(this.contentRule) ? {
            nodeTypes: this.contentRule
        } : this.contentRule(node, path), nodeTypes = _c.nodeTypes, _d = _c.min, min = _d === void 0 ? 0 : _d;
        if (nodeTypes.length === 0 && min > 0) throw new Error("Invalid content rule. Cannot have enforce a 'min' of ".concat(min, " with no nodeTypes"));
        $.minLength('content', min);
        // Is void
        if (nodeTypes.length === 0) $.empty('content');
        else $.each('content', function(item, path) {
            var item$ = new $dad3209a3a2cdfa7$var$ObjectAssertion(item, path);
            if (!item$.object()) return item$.errors;
            item$.enum('nodeType', nodeTypes);
            return item$.errors;
        });
        if ($.object('data')) {
            var dataErrors = (_b = (_a = this.validateData) === null || _a === void 0 ? void 0 : _a.call(this, node.data, path.of('data'))) !== null && _b !== void 0 ? _b : [];
            $.catch.apply($, dataErrors);
        }
        return $.errors;
    };
    return NodeAssertion;
}();
var $dad3209a3a2cdfa7$var$EntityLinkAssertion = /** @class */ function(_super) {
    $dad3209a3a2cdfa7$var$__extends(EntityLinkAssertion, _super);
    function EntityLinkAssertion(linkType, contentNodeTypes) {
        var _this = _super.call(this, contentNodeTypes, function(data, path) {
            return _this.assertLink(data, path);
        }) || this;
        _this.linkType = linkType;
        _this.assertLink = function(data, path) {
            var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data, path);
            if ($.object('target')) {
                var sys$ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data.target.sys, path.of('target').of('sys'));
                if (sys$.object()) {
                    sys$.enum('type', [
                        _this.type
                    ]);
                    sys$.enum('linkType', [
                        _this.linkType
                    ]);
                    if (_this.type === 'Link') {
                        sys$.string('id');
                        sys$.noAdditionalProperties([
                            'type',
                            'linkType',
                            'id'
                        ]);
                    } else if (_this.type === 'ResourceLink') {
                        sys$.string('urn');
                        sys$.noAdditionalProperties([
                            'type',
                            'linkType',
                            'urn'
                        ]);
                    }
                }
                $.catch.apply($, sys$.errors);
            }
            $.noAdditionalProperties([
                'target'
            ]);
            return $.errors;
        };
        _this.type = _this.linkType.startsWith('Contentful:') ? 'ResourceLink' : 'Link';
        return _this;
    }
    return EntityLinkAssertion;
}($dad3209a3a2cdfa7$var$NodeAssertion);
var $dad3209a3a2cdfa7$var$HyperLinkAssertion = /** @class */ function(_super) {
    $dad3209a3a2cdfa7$var$__extends(HyperLinkAssertion, _super);
    function HyperLinkAssertion() {
        var _this = _super.call(this, [
            'text'
        ], function(data, path) {
            return _this.assertLink(data, path);
        }) || this;
        _this.assertLink = function(data, path) {
            var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data, path);
            $.string('uri');
            $.noAdditionalProperties([
                'uri'
            ]);
            return $.errors;
        };
        return _this;
    }
    return HyperLinkAssertion;
}($dad3209a3a2cdfa7$var$NodeAssertion);
var $dad3209a3a2cdfa7$var$assert = function(contentRule, validateData) {
    return new $dad3209a3a2cdfa7$var$NodeAssertion(contentRule, validateData);
};
var $dad3209a3a2cdfa7$var$assertLink = function(linkType, contentRule) {
    return new $dad3209a3a2cdfa7$var$EntityLinkAssertion(linkType, contentRule);
};
var $dad3209a3a2cdfa7$var$Path = /** @class */ function() {
    function Path(path) {
        if (path === void 0) path = [];
        var _this = this;
        this.path = path;
        this.of = function(element) {
            return new Path($dad3209a3a2cdfa7$var$__spreadArray($dad3209a3a2cdfa7$var$__spreadArray([], _this.path, true), [
                element
            ], false));
        };
        this.isRoot = function() {
            return _this.path.length === 0;
        };
        this.last = function() {
            return _this.path[_this.path.length - 1];
        };
        this.toArray = function() {
            return _this.path;
        };
    }
    return Path;
}();
function $dad3209a3a2cdfa7$var$assertText(text, path) {
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(text, path);
    if (!$.object()) return $.errors;
    $.noAdditionalProperties([
        'nodeType',
        'data',
        'value',
        'marks'
    ]);
    $.object('data');
    $.each('marks', function(mark, path) {
        var mark$ = new $dad3209a3a2cdfa7$var$ObjectAssertion(mark, path);
        if (!mark$.object()) return mark$.errors;
        // For historical reasons, we don't explicitly check for supported marks
        // e.g. bold, italic ..etc. This makes it possible for a customer to add
        // custom marks
        mark$.string('type');
        return mark$.errors;
    });
    $.string('value');
    return $.errors;
}
var $dad3209a3a2cdfa7$var$_a;
var $dad3209a3a2cdfa7$var$assertInlineOrText = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$__spreadArray($dad3209a3a2cdfa7$var$__spreadArray([], Object.values($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd), true), [
    'text'
], false).sort());
var $dad3209a3a2cdfa7$var$assertList = $dad3209a3a2cdfa7$var$assert([
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM
]);
var $dad3209a3a2cdfa7$var$assertVoidEntryLink = $dad3209a3a2cdfa7$var$assertLink('Entry', $dad3209a3a2cdfa7$var$VOID_CONTENT);
var $dad3209a3a2cdfa7$var$assertTableCell = $dad3209a3a2cdfa7$var$assert(function() {
    return {
        nodeTypes: [
            $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
        ],
        min: 1
    };
}, function(data, path) {
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data, path);
    $.noAdditionalProperties([
        'colspan',
        'rowspan'
    ]);
    $.number('colspan', true);
    $.number('rowspan', true);
    return $.errors;
});
var $dad3209a3a2cdfa7$var$nodeValidator = ($dad3209a3a2cdfa7$var$_a = {}, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$TOP_LEVEL_BLOCKS), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$CONTAINERS[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE]), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY] = $dad3209a3a2cdfa7$var$assertVoidEntryLink, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET] = $dad3209a3a2cdfa7$var$assertLink('Asset', $dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE] = $dad3209a3a2cdfa7$var$assertLink('Contentful:Entry', $dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HR] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST] = $dad3209a3a2cdfa7$var$assertList, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST] = $dad3209a3a2cdfa7$var$assertList, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$__spreadArray([], $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS, true).sort()), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE] = $dad3209a3a2cdfa7$var$assert(function() {
    return {
        nodeTypes: [
            $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW
        ],
        min: 1
    };
}), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW] = $dad3209a3a2cdfa7$var$assert(function() {
    return {
        nodeTypes: [
            $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL,
            $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL
        ],
        min: 1
    };
}), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL] = $dad3209a3a2cdfa7$var$assertTableCell, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL] = $dad3209a3a2cdfa7$var$assertTableCell, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.HYPERLINK] = new $dad3209a3a2cdfa7$var$HyperLinkAssertion(), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY] = $dad3209a3a2cdfa7$var$assertVoidEntryLink, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_RESOURCE] = $dad3209a3a2cdfa7$var$assertLink('Contentful:Entry', $dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK] = $dad3209a3a2cdfa7$var$assertLink('Entry', [
    'text'
]), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK] = $dad3209a3a2cdfa7$var$assertLink('Asset', [
    'text'
]), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.RESOURCE_HYPERLINK] = $dad3209a3a2cdfa7$var$assertLink('Contentful:Entry', [
    'text'
]), $dad3209a3a2cdfa7$var$_a);
function $dad3209a3a2cdfa7$var$validateNode(node, path) {
    if (node.nodeType === 'text') return $dad3209a3a2cdfa7$var$assertText(node, path);
    var errors = $dad3209a3a2cdfa7$var$nodeValidator[node.nodeType].assert(node, path);
    if (errors.length > 0) return errors;
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(node, path);
    $.each('content', function(item, path) {
        // We already know those are valid nodes thanks to the assertion done in
        // the NodeAssertion class
        return $dad3209a3a2cdfa7$var$validateNode(item, path);
    });
    return $.errors;
}
var $dad3209a3a2cdfa7$var$validateRichTextDocument = function(document) {
    var path = new $dad3209a3a2cdfa7$var$Path();
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(document, path);
    if ($.object()) $.enum('nodeType', [
        $dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT
    ]);
    if ($.errors.length > 0) return $.errors;
    return $dad3209a3a2cdfa7$var$validateNode(document, path);
};
$dad3209a3a2cdfa7$export$f31e81340f60ac4f = $dad3209a3a2cdfa7$var$CONTAINERS;
$dad3209a3a2cdfa7$export$e5cde5f1d56fabad = $dad3209a3a2cdfa7$var$EMPTY_DOCUMENT;
$dad3209a3a2cdfa7$export$7b02abc60d9af577 = $dad3209a3a2cdfa7$var$HEADINGS;
$dad3209a3a2cdfa7$export$f164f8df1f226ed8 = $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS;
$dad3209a3a2cdfa7$export$61dc594370225b3 = $dad3209a3a2cdfa7$var$TABLE_BLOCKS;
$dad3209a3a2cdfa7$export$33c1f54ccb4cc9b7 = $dad3209a3a2cdfa7$var$TEXT_CONTAINERS;
$dad3209a3a2cdfa7$export$ba32543429ed7e1c = $dad3209a3a2cdfa7$var$TOP_LEVEL_BLOCKS;
$dad3209a3a2cdfa7$export$d8b073923a26e49d = $dad3209a3a2cdfa7$var$V1_MARKS;
$dad3209a3a2cdfa7$export$f8a6793e9df3d55d = $dad3209a3a2cdfa7$var$V1_NODE_TYPES;
$dad3209a3a2cdfa7$export$85f9856e66f16aa5 = $dad3209a3a2cdfa7$var$VOID_BLOCKS;
$dad3209a3a2cdfa7$export$cbfd4c4104bf5a27 = $dad3209a3a2cdfa7$var$helpers;
$dad3209a3a2cdfa7$export$1ee7d3855fc41eb3 = $dad3209a3a2cdfa7$var$validateRichTextDocument;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $96d12809385be3c5$var$__assign = function() {
    $96d12809385be3c5$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96d12809385be3c5$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
function $96d12809385be3c5$var$appendKeyToValidElement(element, key) {
    if ($8tsvq.isValidElement(element) && element.key === null) return $8tsvq.cloneElement(element, {
        key: key
    });
    return element;
}
function $96d12809385be3c5$var$nodeListToReactComponents(nodes, options) {
    return nodes.map(function(node, index) {
        return $96d12809385be3c5$var$appendKeyToValidElement($96d12809385be3c5$var$nodeToReactComponent(node, options), index);
    });
}
function $96d12809385be3c5$var$nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText, preserveWhitespace = options.preserveWhitespace;
    if ($dad3209a3a2cdfa7$export$cbfd4c4104bf5a27.isText(node)) {
        var nodeValue = renderText ? renderText(node.value) : node.value;
        // Preserving whitespace is only supported with the default transformations.
        if (preserveWhitespace && !renderText) {
            // Preserve multiple spaces.
            nodeValue = nodeValue.replace(/ {2,}/g, function(match) {
                return '\u00A0'.repeat(match.length);
            });
            // Preserve line breaks.
            var lines_1 = nodeValue.split('\n');
            var jsxLines_1 = [];
            lines_1.forEach(function(line, index) {
                jsxLines_1.push(line);
                if (index !== lines_1.length - 1) jsxLines_1.push($8tsvq.createElement("br", null));
            });
            nodeValue = jsxLines_1;
        }
        return node.marks.reduce(function(value, mark) {
            if (!renderMark[mark.type]) return value;
            return renderMark[mark.type](value);
        }, nodeValue);
    } else {
        var children = $96d12809385be3c5$var$nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) return $8tsvq.createElement($8tsvq.Fragment, null, children);
        return renderNode[node.nodeType](node, children);
    }
}
var $96d12809385be3c5$var$_a, $96d12809385be3c5$var$_b;
var $96d12809385be3c5$var$defaultNodeRenderers = ($96d12809385be3c5$var$_a = {}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT] = function(node, children) {
    return children;
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH] = function(node, children) {
    return $8tsvq.createElement("p", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1] = function(node, children) {
    return $8tsvq.createElement("h1", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2] = function(node, children) {
    return $8tsvq.createElement("h2", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3] = function(node, children) {
    return $8tsvq.createElement("h3", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4] = function(node, children) {
    return $8tsvq.createElement("h4", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5] = function(node, children) {
    return $8tsvq.createElement("h5", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6] = function(node, children) {
    return $8tsvq.createElement("h6", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY] = function(node, children) {
    return $8tsvq.createElement("div", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE] = function(node, children) {
    return $8tsvq.createElement("div", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST] = function(node, children) {
    return $8tsvq.createElement("ul", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST] = function(node, children) {
    return $8tsvq.createElement("ol", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM] = function(node, children) {
    return $8tsvq.createElement("li", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE] = function(node, children) {
    return $8tsvq.createElement("blockquote", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HR] = function() {
    return $8tsvq.createElement("hr", null);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE] = function(node, children) {
    return $8tsvq.createElement("table", null, $8tsvq.createElement("tbody", null, children));
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW] = function(node, children) {
    return $8tsvq.createElement("tr", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL] = function(node, children) {
    return $8tsvq.createElement("th", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL] = function(node, children) {
    return $8tsvq.createElement("td", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK] = function(node) {
    return $96d12809385be3c5$var$defaultInline($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK] = function(node) {
    return $96d12809385be3c5$var$defaultInline($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.RESOURCE_HYPERLINK] = function(node) {
    return $96d12809385be3c5$var$defaultInlineResource($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.RESOURCE_HYPERLINK, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY] = function(node) {
    return $96d12809385be3c5$var$defaultInline($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_RESOURCE] = function(node, _children) {
    return $96d12809385be3c5$var$defaultInlineResource($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_RESOURCE, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.HYPERLINK] = function(node, children) {
    return $8tsvq.createElement("a", {
        href: node.data.uri
    }, children);
}, $96d12809385be3c5$var$_a);
var $96d12809385be3c5$var$defaultMarkRenderers = ($96d12809385be3c5$var$_b = {}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.BOLD] = function(text) {
    return $8tsvq.createElement("b", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.ITALIC] = function(text) {
    return $8tsvq.createElement("i", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.UNDERLINE] = function(text) {
    return $8tsvq.createElement("u", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.CODE] = function(text) {
    return $8tsvq.createElement("code", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.SUPERSCRIPT] = function(text) {
    return $8tsvq.createElement("sup", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.SUBSCRIPT] = function(text) {
    return $8tsvq.createElement("sub", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.STRIKETHROUGH] = function(text) {
    return $8tsvq.createElement("s", null, text);
}, $96d12809385be3c5$var$_b);
function $96d12809385be3c5$var$defaultInline(type, node) {
    return $8tsvq.createElement("span", {
        key: node.data.target.sys.id
    }, "type: ", node.nodeType, " id: ", node.data.target.sys.id);
}
function $96d12809385be3c5$var$defaultInlineResource(type, node) {
    return $8tsvq.createElement("span", {
        key: node.data.target.sys.urn
    }, "type: ", node.nodeType, " urn: ", node.data.target.sys.urn);
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */ function $96d12809385be3c5$var$documentToReactComponents(richTextDocument, options) {
    if (options === void 0) options = {};
    if (!richTextDocument) return null;
    return $96d12809385be3c5$var$nodeToReactComponent(richTextDocument, {
        renderNode: $96d12809385be3c5$var$__assign($96d12809385be3c5$var$__assign({}, $96d12809385be3c5$var$defaultNodeRenderers), options.renderNode),
        renderMark: $96d12809385be3c5$var$__assign($96d12809385be3c5$var$__assign({}, $96d12809385be3c5$var$defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
        preserveWhitespace: options.preserveWhitespace
    });
}
$96d12809385be3c5$export$4a295a2b4ab66da6 = $96d12809385be3c5$var$documentToReactComponents;


const $8286b9e55678ebc0$var$Notification = ({ content: content, enable: enable = false })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: content && enable && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
            className: $e519f03a75c81288$exports.notification,
            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "container-text container-sm",
                children: (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(content)
            })
        })
    });
};
var $8286b9e55678ebc0$export$2e2bcd8739ae039 = $8286b9e55678ebc0$var$Notification;



parcelRequire("8tsvq");
var $6882a1981437925b$exports = {};

$6882a1981437925b$exports["bgLight"] = `qklgKW_bgLight`;
$6882a1981437925b$exports["contentContainer"] = `qklgKW_contentContainer`;
$6882a1981437925b$exports["ctaContainer"] = `qklgKW_ctaContainer`;
$6882a1981437925b$exports["left"] = `qklgKW_left`;
$6882a1981437925b$exports["right"] = `qklgKW_right`;
$6882a1981437925b$exports["textImage"] = `qklgKW_textImage`;
for(let key in {})if (key in $6882a1981437925b$exports) $6882a1981437925b$exports[key] += ' ' + {}[key];
else $6882a1981437925b$exports[key] = {}[key];




parcelRequire("8tsvq");
const $8b3cd8192a570e36$var$Button = ({ button: button, className: className = '', onClick: onClick })=>{
    if (!button?.fields) return null;
    const { url: url, target: target, title: title, theme: theme = 'primary' } = button.fields;
    // Build dynamic classes: 'button button--theme'
    const buttonClasses = `button button--${theme}`;
    // Combine with any additional className prop
    const finalClasses = [
        buttonClasses,
        className
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
        href: url,
        target: target,
        title: title,
        className: finalClasses,
        onClick: onClick,
        children: title
    });
};
var $8b3cd8192a570e36$export$2e2bcd8739ae039 = $8b3cd8192a570e36$var$Button;


const $5a1e45fdeecd37a3$var$handleCtaClick = (e)=>{
    console.log('button click');
    const href = e.currentTarget.href;
    const isNewTab = e.currentTarget.target === '_blank';
    if (typeof twq === 'function') {
        if (!isNewTab) {
            e.preventDefault();
            twq('event', 'tw-r3t8x-rcd0t', {});
            setTimeout(()=>{
                window.location.href = href;
            }, 300);
        } else twq('event', 'tw-r3t8x-rcd0t', {});
    }
};
const $5a1e45fdeecd37a3$var$TextImage = ({ text: text, image: image, ctaButton: ctaButton, ctaButtonSecondary: ctaButtonSecondary })=>{
    if (!text || !image) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
        className: `${$6882a1981437925b$exports.bgLight}`,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            className: `container ${$6882a1981437925b$exports.textImage}`,
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: $6882a1981437925b$exports.left,
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            className: $6882a1981437925b$exports.contentContainer,
                            children: (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(text)
                        }),
                        (ctaButton || ctaButtonSecondary) && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: $6882a1981437925b$exports.ctaContainer,
                            children: [
                                ctaButton && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8b3cd8192a570e36$export$2e2bcd8739ae039), {
                                    button: ctaButton,
                                    onClick: $5a1e45fdeecd37a3$var$handleCtaClick
                                }),
                                ctaButtonSecondary && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8b3cd8192a570e36$export$2e2bcd8739ae039), {
                                    button: ctaButtonSecondary,
                                    onClick: $5a1e45fdeecd37a3$var$handleCtaClick
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: $6882a1981437925b$exports.right,
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("link", {
                            rel: "preload",
                            fetchPriority: "high",
                            as: "image",
                            href: `${image.file?.url}?fm=webp&w=620`,
                            type: "image/webp"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                            src: `${image.file?.url}?fm=webp&w=620`,
                            srcSet: `${image.file?.url}?fm=webp&h=300 311w, ${image.file?.url}?fm=webp&w=620 312w`,
                            width: image.file?.details?.image?.width,
                            height: image.file?.details?.image?.height,
                            alt: image.title
                        })
                    ]
                })
            ]
        })
    });
};
var $5a1e45fdeecd37a3$export$2e2bcd8739ae039 = $5a1e45fdeecd37a3$var$TextImage;



var $9d6d586139e57b1d$exports = {};

$9d6d586139e57b1d$exports["left"] = `nnGmKq_left`;
$9d6d586139e57b1d$exports["right"] = `nnGmKq_right`;
$9d6d586139e57b1d$exports["sectionTextImage"] = `nnGmKq_sectionTextImage`;
$9d6d586139e57b1d$exports["textImage"] = `nnGmKq_textImage`;
for(let key in {})if (key in $9d6d586139e57b1d$exports) $9d6d586139e57b1d$exports[key] += ' ' + {}[key];
else $9d6d586139e57b1d$exports[key] = {}[key];



const $641eddb8928dc8ad$var$ImageText = ({ text: text, image: image })=>{
    if (!text || !image) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
        className: `container-sm ${$9d6d586139e57b1d$exports.sectionTextImage}`,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            className: `container-text ${$9d6d586139e57b1d$exports.textImage}`,
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: $9d6d586139e57b1d$exports.left,
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                        src: image.file?.url,
                        alt: image.title,
                        srcSet: `${image.file?.url}?fm=webp&h=300 322w, ${image.file?.url}?fm=webp&w=429 323w`,
                        width: image.file?.details?.image?.width,
                        height: image.file?.details?.image?.height
                    })
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: `ul-checked ${$9d6d586139e57b1d$exports.right}`,
                    children: (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(text)
                })
            ]
        })
    });
};
var $641eddb8928dc8ad$export$2e2bcd8739ae039 = $641eddb8928dc8ad$var$ImageText;



var $316239668b1dd86b$exports = {};

$316239668b1dd86b$exports["sectionSymptoms"] = `_4hQsZG_sectionSymptoms`;
for(let key in {})if (key in $316239668b1dd86b$exports) $316239668b1dd86b$exports[key] += ' ' + {}[key];
else $316239668b1dd86b$exports[key] = {}[key];



const $a7f17a7aab3bdbe5$var$Symptoms = ({ content: content })=>{
    if (!content) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
        className: `container-sm ${$316239668b1dd86b$exports.sectionSymptoms}`,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
            className: 'container-text ul-checked',
            children: (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(content)
        })
    });
};
var $a7f17a7aab3bdbe5$export$2e2bcd8739ae039 = $a7f17a7aab3bdbe5$var$Symptoms;



var $cb368fc32023d66c$exports = {};

$cb368fc32023d66c$exports["content"] = `NB9mxa_content`;
$cb368fc32023d66c$exports["cta"] = `NB9mxa_cta`;
$cb368fc32023d66c$exports["ctaContainer"] = `NB9mxa_ctaContainer`;
$cb368fc32023d66c$exports["testimonials"] = `NB9mxa_testimonials`;
for(let key in {})if (key in $cb368fc32023d66c$exports) $cb368fc32023d66c$exports[key] += ' ' + {}[key];
else $cb368fc32023d66c$exports[key] = {}[key];




const $f0f722615dd8b6e8$var$Testimonials = ({ image: image, ctaButton: ctaButton, ctaButtonSecondary: ctaButtonSecondary, text: text })=>{
    if (!text) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("section", {
        className: `container-text ${$cb368fc32023d66c$exports.testimonials}`,
        style: image ? {
            backgroundImage: `url(${image?.url}?fm=webp)`,
            background: 'cover'
        } : '',
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: `container-xs ${$cb368fc32023d66c$exports.content}`,
                children: (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(text)
            }),
            (ctaButton || ctaButtonSecondary) && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: $cb368fc32023d66c$exports.ctaContainer,
                children: [
                    ctaButton && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8b3cd8192a570e36$export$2e2bcd8739ae039), {
                        button: ctaButton
                    }),
                    ctaButtonSecondary && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8b3cd8192a570e36$export$2e2bcd8739ae039), {
                        button: ctaButtonSecondary
                    })
                ]
            })
        ]
    });
};
var $f0f722615dd8b6e8$export$2e2bcd8739ae039 = $f0f722615dd8b6e8$var$Testimonials;



var $026350e6fbbcb5db$exports = {};

$026350e6fbbcb5db$exports["card"] = `NSu0LG_card`;
$026350e6fbbcb5db$exports["cardImg"] = `NSu0LG_cardImg`;
$026350e6fbbcb5db$exports["cards"] = `NSu0LG_cards`;
$026350e6fbbcb5db$exports["sectionCards"] = `NSu0LG_sectionCards`;
for(let key in {})if (key in $026350e6fbbcb5db$exports) $026350e6fbbcb5db$exports[key] += ' ' + {}[key];
else $026350e6fbbcb5db$exports[key] = {}[key];


const $ff2dc14388db8f6b$var$Cards = ({ title: title, cards: cards })=>{
    if (!cards || !cards.length) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
        className: `container-xs ${$026350e6fbbcb5db$exports.sectionCards}`,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            className: "container-text",
            children: [
                title && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                    children: title
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: $026350e6fbbcb5db$exports.cards,
                    children: cards.map((card)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: $026350e6fbbcb5db$exports.card,
                            children: [
                                card.fields.image && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                    className: $026350e6fbbcb5db$exports.cardImg,
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                        src: card.fields.image.fields?.file?.url,
                                        alt: card.fields.image.fields?.title,
                                        width: card.fields?.image?.fields?.file?.details?.image?.width,
                                        height: card.fields?.image?.fields?.file?.details?.image?.height
                                    })
                                }),
                                card.fields?.title && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                                    children: card.fields.title
                                }),
                                card.fields.description && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                    children: card.fields.description
                                })
                            ]
                        }, card.sys.id))
                })
            ]
        })
    });
};
var $ff2dc14388db8f6b$export$2e2bcd8739ae039 = $ff2dc14388db8f6b$var$Cards;


const $cf05d691bff6a1c9$var$Content = ({ notification: notification, sectionImageText: sectionImageText, sectionReason: sectionReason, sectionTestimonials: sectionTestimonials, sectionTextImage: sectionTextImage, ctaButton: ctaButton, ctaButtonSecondary: ctaButtonSecondary, symptoms: symptoms })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8286b9e55678ebc0$export$2e2bcd8739ae039), {
                content: notification,
                enable: false
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5a1e45fdeecd37a3$export$2e2bcd8739ae039), {
                ...sectionTextImage,
                ctaButton: ctaButton,
                ctaButtonSecondary: ctaButtonSecondary
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $ff2dc14388db8f6b$export$2e2bcd8739ae039), {
                ...sectionReason
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $a7f17a7aab3bdbe5$export$2e2bcd8739ae039), {
                content: symptoms
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f0f722615dd8b6e8$export$2e2bcd8739ae039), {
                ...sectionTestimonials,
                ctaButton: ctaButton,
                ctaButtonSecondary: ctaButtonSecondary
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $641eddb8928dc8ad$export$2e2bcd8739ae039), {
                ...sectionImageText
            })
        ]
    });
};
var $cf05d691bff6a1c9$export$2e2bcd8739ae039 = $cf05d691bff6a1c9$var$Content;



var $6a7d799f25acc0b5$exports = {};

$6a7d799f25acc0b5$exports["header"] = `tKSuUq_header`;
$6a7d799f25acc0b5$exports["logo"] = `tKSuUq_logo`;
$6a7d799f25acc0b5$exports["pointer"] = `tKSuUq_pointer`;
$6a7d799f25acc0b5$exports["right"] = `tKSuUq_right`;
for(let key in {})if (key in $6a7d799f25acc0b5$exports) $6a7d799f25acc0b5$exports[key] += ' ' + {}[key];
else $6a7d799f25acc0b5$exports[key] = {}[key];


var $f9c88b76390f20b3$export$8e1c4644f466949c = /*#__PURE__*/ function(Locales) {
    Locales["EN"] = "en-CA";
    Locales["FR"] = "fr-CA";
    return Locales;
}({});


var $0cfd959286c41076$exports = {};
$0cfd959286c41076$exports = new URL("lang-icon.b99fc6cd.svg", import.meta.url).toString();


const $9fec082c20945cc9$var$langIcon = new URL($0cfd959286c41076$exports);
var $4881b6d8cbab4ad6$exports = {};
$4881b6d8cbab4ad6$exports = new URL("phone-icon.95df6bb3.svg", import.meta.url).toString();


const $9fec082c20945cc9$var$phoneIcon = new URL($4881b6d8cbab4ad6$exports);
var $6d8b922b7035714e$exports = {};
$6d8b922b7035714e$exports = new URL("email-icon.c914d7fc.svg", import.meta.url).toString();


const $9fec082c20945cc9$var$emailIcon = new URL($6d8b922b7035714e$exports);
const $9fec082c20945cc9$var$Header = ({ email: email, languageUrl: languageUrl, logo: logo, phone: phone, locale: locale })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("header", {
        className: "header container-md",
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            className: `container-text ${$6a7d799f25acc0b5$exports.header}`,
            children: [
                logo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: $6a7d799f25acc0b5$exports.logo,
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                        src: logo?.file?.url,
                        alt: logo?.title,
                        width: logo.file?.details?.image?.width,
                        height: logo.file?.details?.image?.height
                    })
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: $6a7d799f25acc0b5$exports.right,
                    children: [
                        languageUrl && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                            href: languageUrl,
                            className: $6a7d799f25acc0b5$exports.pointer,
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                    src: $9fec082c20945cc9$var$langIcon,
                                    alt: "language",
                                    "aria-hidden": "true"
                                }),
                                locale === (0, $f9c88b76390f20b3$export$8e1c4644f466949c).EN ? "Fran\xe7ais" : 'English'
                            ]
                        }),
                        phone && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                            href: `tel:${phone}`,
                            className: $6a7d799f25acc0b5$exports.pointer,
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                    src: $9fec082c20945cc9$var$phoneIcon,
                                    alt: "phone",
                                    "aria-hidden": "true"
                                }),
                                phone
                            ]
                        }),
                        email && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                            href: `mailto:${email}`,
                            className: $6a7d799f25acc0b5$exports.pointer,
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                    src: $9fec082c20945cc9$var$emailIcon,
                                    alt: "email",
                                    "aria-hidden": "true"
                                }),
                                email
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $9fec082c20945cc9$export$2e2bcd8739ae039 = $9fec082c20945cc9$var$Header;


'use strict';
function $5d219f656b13ee51$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $4kiXg = parcelRequire("4kiXg");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $3b0e765f17086bfd$var$toString } = Object.prototype;
const { getPrototypeOf: $3b0e765f17086bfd$var$getPrototypeOf } = Object;
const $3b0e765f17086bfd$var$kindOf = ((cache)=>(thing)=>{
        const str = $3b0e765f17086bfd$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $3b0e765f17086bfd$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$3b0e765f17086bfd$var$kindOf(thing) === type;
};
const $3b0e765f17086bfd$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $3b0e765f17086bfd$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $3b0e765f17086bfd$var$isUndefined = $3b0e765f17086bfd$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $3b0e765f17086bfd$var$isBuffer(val) {
    return val !== null && !$3b0e765f17086bfd$var$isUndefined(val) && val.constructor !== null && !$3b0e765f17086bfd$var$isUndefined(val.constructor) && $3b0e765f17086bfd$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $3b0e765f17086bfd$var$isArrayBuffer = $3b0e765f17086bfd$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $3b0e765f17086bfd$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $3b0e765f17086bfd$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $3b0e765f17086bfd$var$isString = $3b0e765f17086bfd$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $3b0e765f17086bfd$var$isFunction = $3b0e765f17086bfd$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $3b0e765f17086bfd$var$isNumber = $3b0e765f17086bfd$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $3b0e765f17086bfd$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $3b0e765f17086bfd$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $3b0e765f17086bfd$var$isPlainObject = (val)=>{
    if ($3b0e765f17086bfd$var$kindOf(val) !== 'object') return false;
    const prototype = $3b0e765f17086bfd$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $3b0e765f17086bfd$var$isDate = $3b0e765f17086bfd$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $3b0e765f17086bfd$var$isFile = $3b0e765f17086bfd$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $3b0e765f17086bfd$var$isBlob = $3b0e765f17086bfd$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $3b0e765f17086bfd$var$isFileList = $3b0e765f17086bfd$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $3b0e765f17086bfd$var$isStream = (val)=>$3b0e765f17086bfd$var$isObject(val) && $3b0e765f17086bfd$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $3b0e765f17086bfd$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $3b0e765f17086bfd$var$isFunction(thing.append) && ((kind = $3b0e765f17086bfd$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $3b0e765f17086bfd$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $3b0e765f17086bfd$var$isURLSearchParams = $3b0e765f17086bfd$var$kindOfTest('URLSearchParams');
const [$3b0e765f17086bfd$var$isReadableStream, $3b0e765f17086bfd$var$isRequest, $3b0e765f17086bfd$var$isResponse, $3b0e765f17086bfd$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($3b0e765f17086bfd$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $3b0e765f17086bfd$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $3b0e765f17086bfd$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($3b0e765f17086bfd$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $3b0e765f17086bfd$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $3b0e765f17086bfd$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $3b0e765f17086bfd$var$isContextDefined = (context)=>!$3b0e765f17086bfd$var$isUndefined(context) && context !== $3b0e765f17086bfd$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $3b0e765f17086bfd$var$merge() {
    const { caseless: caseless } = $3b0e765f17086bfd$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $3b0e765f17086bfd$var$findKey(result, key) || key;
        if ($3b0e765f17086bfd$var$isPlainObject(result[targetKey]) && $3b0e765f17086bfd$var$isPlainObject(val)) result[targetKey] = $3b0e765f17086bfd$var$merge(result[targetKey], val);
        else if ($3b0e765f17086bfd$var$isPlainObject(val)) result[targetKey] = $3b0e765f17086bfd$var$merge({}, val);
        else if ($3b0e765f17086bfd$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $3b0e765f17086bfd$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $3b0e765f17086bfd$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $3b0e765f17086bfd$var$forEach(b, (val, key)=>{
        if (thisArg && $3b0e765f17086bfd$var$isFunction(val)) a[key] = (0, $5d219f656b13ee51$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $3b0e765f17086bfd$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $3b0e765f17086bfd$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $3b0e765f17086bfd$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $3b0e765f17086bfd$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $3b0e765f17086bfd$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $3b0e765f17086bfd$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($3b0e765f17086bfd$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$3b0e765f17086bfd$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $3b0e765f17086bfd$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $3b0e765f17086bfd$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $3b0e765f17086bfd$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $3b0e765f17086bfd$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $3b0e765f17086bfd$var$isHTMLForm = $3b0e765f17086bfd$var$kindOfTest('HTMLFormElement');
const $3b0e765f17086bfd$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $3b0e765f17086bfd$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $3b0e765f17086bfd$var$isRegExp = $3b0e765f17086bfd$var$kindOfTest('RegExp');
const $3b0e765f17086bfd$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $3b0e765f17086bfd$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $3b0e765f17086bfd$var$freezeMethods = (obj)=>{
    $3b0e765f17086bfd$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($3b0e765f17086bfd$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$3b0e765f17086bfd$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $3b0e765f17086bfd$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $3b0e765f17086bfd$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $3b0e765f17086bfd$var$noop = ()=>{};
const $3b0e765f17086bfd$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $3b0e765f17086bfd$var$isSpecCompliantForm(thing) {
    return !!(thing && $3b0e765f17086bfd$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $3b0e765f17086bfd$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($3b0e765f17086bfd$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $3b0e765f17086bfd$var$isArray(source) ? [] : {};
                $3b0e765f17086bfd$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$3b0e765f17086bfd$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $3b0e765f17086bfd$var$isAsyncFn = $3b0e765f17086bfd$var$kindOfTest('AsyncFunction');
const $3b0e765f17086bfd$var$isThenable = (thing)=>thing && ($3b0e765f17086bfd$var$isObject(thing) || $3b0e765f17086bfd$var$isFunction(thing)) && $3b0e765f17086bfd$var$isFunction(thing.then) && $3b0e765f17086bfd$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $3b0e765f17086bfd$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $3b0e765f17086bfd$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $3b0e765f17086bfd$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $3b0e765f17086bfd$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $3b0e765f17086bfd$var$isFunction($3b0e765f17086bfd$var$_global.postMessage));
const $3b0e765f17086bfd$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($3b0e765f17086bfd$var$_global) : typeof $4kiXg !== 'undefined' && $4kiXg.nextTick || $3b0e765f17086bfd$var$_setImmediate;
var // *********************
$3b0e765f17086bfd$export$2e2bcd8739ae039 = {
    isArray: $3b0e765f17086bfd$var$isArray,
    isArrayBuffer: $3b0e765f17086bfd$var$isArrayBuffer,
    isBuffer: $3b0e765f17086bfd$var$isBuffer,
    isFormData: $3b0e765f17086bfd$var$isFormData,
    isArrayBufferView: $3b0e765f17086bfd$var$isArrayBufferView,
    isString: $3b0e765f17086bfd$var$isString,
    isNumber: $3b0e765f17086bfd$var$isNumber,
    isBoolean: $3b0e765f17086bfd$var$isBoolean,
    isObject: $3b0e765f17086bfd$var$isObject,
    isPlainObject: $3b0e765f17086bfd$var$isPlainObject,
    isReadableStream: $3b0e765f17086bfd$var$isReadableStream,
    isRequest: $3b0e765f17086bfd$var$isRequest,
    isResponse: $3b0e765f17086bfd$var$isResponse,
    isHeaders: $3b0e765f17086bfd$var$isHeaders,
    isUndefined: $3b0e765f17086bfd$var$isUndefined,
    isDate: $3b0e765f17086bfd$var$isDate,
    isFile: $3b0e765f17086bfd$var$isFile,
    isBlob: $3b0e765f17086bfd$var$isBlob,
    isRegExp: $3b0e765f17086bfd$var$isRegExp,
    isFunction: $3b0e765f17086bfd$var$isFunction,
    isStream: $3b0e765f17086bfd$var$isStream,
    isURLSearchParams: $3b0e765f17086bfd$var$isURLSearchParams,
    isTypedArray: $3b0e765f17086bfd$var$isTypedArray,
    isFileList: $3b0e765f17086bfd$var$isFileList,
    forEach: $3b0e765f17086bfd$var$forEach,
    merge: $3b0e765f17086bfd$var$merge,
    extend: $3b0e765f17086bfd$var$extend,
    trim: $3b0e765f17086bfd$var$trim,
    stripBOM: $3b0e765f17086bfd$var$stripBOM,
    inherits: $3b0e765f17086bfd$var$inherits,
    toFlatObject: $3b0e765f17086bfd$var$toFlatObject,
    kindOf: $3b0e765f17086bfd$var$kindOf,
    kindOfTest: $3b0e765f17086bfd$var$kindOfTest,
    endsWith: $3b0e765f17086bfd$var$endsWith,
    toArray: $3b0e765f17086bfd$var$toArray,
    forEachEntry: $3b0e765f17086bfd$var$forEachEntry,
    matchAll: $3b0e765f17086bfd$var$matchAll,
    isHTMLForm: $3b0e765f17086bfd$var$isHTMLForm,
    hasOwnProperty: $3b0e765f17086bfd$var$hasOwnProperty,
    hasOwnProp: $3b0e765f17086bfd$var$hasOwnProperty,
    reduceDescriptors: $3b0e765f17086bfd$var$reduceDescriptors,
    freezeMethods: $3b0e765f17086bfd$var$freezeMethods,
    toObjectSet: $3b0e765f17086bfd$var$toObjectSet,
    toCamelCase: $3b0e765f17086bfd$var$toCamelCase,
    noop: $3b0e765f17086bfd$var$noop,
    toFiniteNumber: $3b0e765f17086bfd$var$toFiniteNumber,
    findKey: $3b0e765f17086bfd$var$findKey,
    global: $3b0e765f17086bfd$var$_global,
    isContextDefined: $3b0e765f17086bfd$var$isContextDefined,
    isSpecCompliantForm: $3b0e765f17086bfd$var$isSpecCompliantForm,
    toJSONObject: $3b0e765f17086bfd$var$toJSONObject,
    isAsyncFn: $3b0e765f17086bfd$var$isAsyncFn,
    isThenable: $3b0e765f17086bfd$var$isThenable,
    setImmediate: $3b0e765f17086bfd$var$_setImmediate,
    asap: $3b0e765f17086bfd$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $1802f87332a7475d$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).inherits($1802f87332a7475d$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $1802f87332a7475d$var$prototype = $1802f87332a7475d$var$AxiosError.prototype;
const $1802f87332a7475d$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $1802f87332a7475d$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($1802f87332a7475d$var$AxiosError, $1802f87332a7475d$var$descriptors);
Object.defineProperty($1802f87332a7475d$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$1802f87332a7475d$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($1802f87332a7475d$var$prototype);
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $1802f87332a7475d$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $1802f87332a7475d$export$2e2bcd8739ae039 = $1802f87332a7475d$var$AxiosError;


// eslint-disable-next-line strict
var $a161484968d4e2d6$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $de29dcc6a077369b$export$a143d493d941bafc;
var $de29dcc6a077369b$export$e4cf37d7f6fb9e0a;
var $de29dcc6a077369b$export$f99ded8fe4b79145;
var $de29dcc6a077369b$export$599f31c3813fae4d;
'use strict';
var $8cf1f36cb432a705$export$a48f0734ac7c2329;
var $8cf1f36cb432a705$export$d622b2ad8d90c771;
var $8cf1f36cb432a705$export$6100ba28696e12de;
'use strict';
$8cf1f36cb432a705$export$a48f0734ac7c2329 = $8cf1f36cb432a705$var$byteLength;
$8cf1f36cb432a705$export$d622b2ad8d90c771 = $8cf1f36cb432a705$var$toByteArray;
$8cf1f36cb432a705$export$6100ba28696e12de = $8cf1f36cb432a705$var$fromByteArray;
var $8cf1f36cb432a705$var$lookup = [];
var $8cf1f36cb432a705$var$revLookup = [];
var $8cf1f36cb432a705$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8cf1f36cb432a705$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8cf1f36cb432a705$var$i = 0, $8cf1f36cb432a705$var$len = $8cf1f36cb432a705$var$code.length; $8cf1f36cb432a705$var$i < $8cf1f36cb432a705$var$len; ++$8cf1f36cb432a705$var$i){
    $8cf1f36cb432a705$var$lookup[$8cf1f36cb432a705$var$i] = $8cf1f36cb432a705$var$code[$8cf1f36cb432a705$var$i];
    $8cf1f36cb432a705$var$revLookup[$8cf1f36cb432a705$var$code.charCodeAt($8cf1f36cb432a705$var$i)] = $8cf1f36cb432a705$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8cf1f36cb432a705$var$revLookup['-'.charCodeAt(0)] = 62;
$8cf1f36cb432a705$var$revLookup['_'.charCodeAt(0)] = 63;
function $8cf1f36cb432a705$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8cf1f36cb432a705$var$byteLength(b64) {
    var lens = $8cf1f36cb432a705$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8cf1f36cb432a705$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8cf1f36cb432a705$var$toByteArray(b64) {
    var tmp;
    var lens = $8cf1f36cb432a705$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8cf1f36cb432a705$var$Arr($8cf1f36cb432a705$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 18 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 2 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 10 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8cf1f36cb432a705$var$tripletToBase64(num) {
    return $8cf1f36cb432a705$var$lookup[num >> 18 & 0x3F] + $8cf1f36cb432a705$var$lookup[num >> 12 & 0x3F] + $8cf1f36cb432a705$var$lookup[num >> 6 & 0x3F] + $8cf1f36cb432a705$var$lookup[num & 0x3F];
}
function $8cf1f36cb432a705$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8cf1f36cb432a705$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8cf1f36cb432a705$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8cf1f36cb432a705$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8cf1f36cb432a705$var$lookup[tmp >> 2] + $8cf1f36cb432a705$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8cf1f36cb432a705$var$lookup[tmp >> 10] + $8cf1f36cb432a705$var$lookup[tmp >> 4 & 0x3F] + $8cf1f36cb432a705$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $44ef5096b7191751$export$aafa59e2e03f2942;
var $44ef5096b7191751$export$68d8715fc104d294;
$44ef5096b7191751$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$44ef5096b7191751$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $de29dcc6a077369b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$de29dcc6a077369b$export$a143d493d941bafc = $de29dcc6a077369b$var$Buffer;
$de29dcc6a077369b$export$e4cf37d7f6fb9e0a = $de29dcc6a077369b$var$SlowBuffer;
$de29dcc6a077369b$export$f99ded8fe4b79145 = 50;
var $de29dcc6a077369b$var$K_MAX_LENGTH = 0x7fffffff;
$de29dcc6a077369b$export$599f31c3813fae4d = $de29dcc6a077369b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $de29dcc6a077369b$var$Buffer.TYPED_ARRAY_SUPPORT = $de29dcc6a077369b$var$typedArraySupport();
if (!$de29dcc6a077369b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $de29dcc6a077369b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($de29dcc6a077369b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$de29dcc6a077369b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($de29dcc6a077369b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$de29dcc6a077369b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $de29dcc6a077369b$var$createBuffer(length) {
    if (length > $de29dcc6a077369b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $de29dcc6a077369b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $de29dcc6a077369b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $de29dcc6a077369b$var$allocUnsafe(arg);
    }
    return $de29dcc6a077369b$var$from(arg, encodingOrOffset, length);
}
$de29dcc6a077369b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $de29dcc6a077369b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $de29dcc6a077369b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $de29dcc6a077369b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($de29dcc6a077369b$var$isInstance(value, ArrayBuffer) || value && $de29dcc6a077369b$var$isInstance(value.buffer, ArrayBuffer)) return $de29dcc6a077369b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($de29dcc6a077369b$var$isInstance(value, SharedArrayBuffer) || value && $de29dcc6a077369b$var$isInstance(value.buffer, SharedArrayBuffer))) return $de29dcc6a077369b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $de29dcc6a077369b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $de29dcc6a077369b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $de29dcc6a077369b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $de29dcc6a077369b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $de29dcc6a077369b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($de29dcc6a077369b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($de29dcc6a077369b$var$Buffer, Uint8Array);
function $de29dcc6a077369b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $de29dcc6a077369b$var$alloc(size, fill, encoding) {
    $de29dcc6a077369b$var$assertSize(size);
    if (size <= 0) return $de29dcc6a077369b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $de29dcc6a077369b$var$createBuffer(size).fill(fill, encoding) : $de29dcc6a077369b$var$createBuffer(size).fill(fill);
    return $de29dcc6a077369b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $de29dcc6a077369b$var$Buffer.alloc = function(size, fill, encoding) {
    return $de29dcc6a077369b$var$alloc(size, fill, encoding);
};
function $de29dcc6a077369b$var$allocUnsafe(size) {
    $de29dcc6a077369b$var$assertSize(size);
    return $de29dcc6a077369b$var$createBuffer(size < 0 ? 0 : $de29dcc6a077369b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $de29dcc6a077369b$var$Buffer.allocUnsafe = function(size) {
    return $de29dcc6a077369b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $de29dcc6a077369b$var$Buffer.allocUnsafeSlow = function(size) {
    return $de29dcc6a077369b$var$allocUnsafe(size);
};
function $de29dcc6a077369b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$de29dcc6a077369b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $de29dcc6a077369b$var$byteLength(string, encoding) | 0;
    var buf = $de29dcc6a077369b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $de29dcc6a077369b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $de29dcc6a077369b$var$checked(array.length) | 0;
    var buf = $de29dcc6a077369b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $de29dcc6a077369b$var$fromArrayView(arrayView) {
    if ($de29dcc6a077369b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $de29dcc6a077369b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $de29dcc6a077369b$var$fromArrayLike(arrayView);
}
function $de29dcc6a077369b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $de29dcc6a077369b$var$Buffer.prototype);
    return buf;
}
function $de29dcc6a077369b$var$fromObject(obj) {
    if ($de29dcc6a077369b$var$Buffer.isBuffer(obj)) {
        var len = $de29dcc6a077369b$var$checked(obj.length) | 0;
        var buf = $de29dcc6a077369b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $de29dcc6a077369b$var$numberIsNaN(obj.length)) return $de29dcc6a077369b$var$createBuffer(0);
        return $de29dcc6a077369b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $de29dcc6a077369b$var$fromArrayLike(obj.data);
}
function $de29dcc6a077369b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $de29dcc6a077369b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $de29dcc6a077369b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $de29dcc6a077369b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $de29dcc6a077369b$var$Buffer.alloc(+length);
}
$de29dcc6a077369b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $de29dcc6a077369b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$de29dcc6a077369b$var$Buffer.compare = function compare(a, b) {
    if ($de29dcc6a077369b$var$isInstance(a, Uint8Array)) a = $de29dcc6a077369b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($de29dcc6a077369b$var$isInstance(b, Uint8Array)) b = $de29dcc6a077369b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(a) || !$de29dcc6a077369b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$de29dcc6a077369b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$de29dcc6a077369b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $de29dcc6a077369b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $de29dcc6a077369b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($de29dcc6a077369b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $de29dcc6a077369b$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$de29dcc6a077369b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $de29dcc6a077369b$var$byteLength(string, encoding) {
    if ($de29dcc6a077369b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $de29dcc6a077369b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $de29dcc6a077369b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $de29dcc6a077369b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $de29dcc6a077369b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$de29dcc6a077369b$var$Buffer.byteLength = $de29dcc6a077369b$var$byteLength;
function $de29dcc6a077369b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $de29dcc6a077369b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $de29dcc6a077369b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $de29dcc6a077369b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $de29dcc6a077369b$var$latin1Slice(this, start, end);
        case 'base64':
            return $de29dcc6a077369b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de29dcc6a077369b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$de29dcc6a077369b$var$Buffer.prototype._isBuffer = true;
function $de29dcc6a077369b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$de29dcc6a077369b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$de29dcc6a077369b$var$swap(this, i, i + 1);
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $de29dcc6a077369b$var$swap(this, i, i + 3);
        $de29dcc6a077369b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $de29dcc6a077369b$var$swap(this, i, i + 7);
        $de29dcc6a077369b$var$swap(this, i + 1, i + 6);
        $de29dcc6a077369b$var$swap(this, i + 2, i + 5);
        $de29dcc6a077369b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $de29dcc6a077369b$var$utf8Slice(this, 0, length);
    return $de29dcc6a077369b$var$slowToString.apply(this, arguments);
};
$de29dcc6a077369b$var$Buffer.prototype.toLocaleString = $de29dcc6a077369b$var$Buffer.prototype.toString;
$de29dcc6a077369b$var$Buffer.prototype.equals = function equals(b) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $de29dcc6a077369b$var$Buffer.compare(this, b) === 0;
};
$de29dcc6a077369b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $de29dcc6a077369b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($de29dcc6a077369b$var$customInspectSymbol) $de29dcc6a077369b$var$Buffer.prototype[$de29dcc6a077369b$var$customInspectSymbol] = $de29dcc6a077369b$var$Buffer.prototype.inspect;
$de29dcc6a077369b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($de29dcc6a077369b$var$isInstance(target, Uint8Array)) target = $de29dcc6a077369b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $de29dcc6a077369b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($de29dcc6a077369b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $de29dcc6a077369b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($de29dcc6a077369b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $de29dcc6a077369b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $de29dcc6a077369b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $de29dcc6a077369b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$de29dcc6a077369b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$de29dcc6a077369b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $de29dcc6a077369b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$de29dcc6a077369b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $de29dcc6a077369b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $de29dcc6a077369b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($de29dcc6a077369b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $de29dcc6a077369b$var$utf8Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $de29dcc6a077369b$var$asciiWrite(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$asciiToBytes(string), buf, offset, length);
}
function $de29dcc6a077369b$var$base64Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$base64ToBytes(string), buf, offset, length);
}
function $de29dcc6a077369b$var$ucs2Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$de29dcc6a077369b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $de29dcc6a077369b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $de29dcc6a077369b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $de29dcc6a077369b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $de29dcc6a077369b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de29dcc6a077369b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$de29dcc6a077369b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $de29dcc6a077369b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8cf1f36cb432a705$export$6100ba28696e12de(buf);
    else return $8cf1f36cb432a705$export$6100ba28696e12de(buf.slice(start, end));
}
function $de29dcc6a077369b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $de29dcc6a077369b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $de29dcc6a077369b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $de29dcc6a077369b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $de29dcc6a077369b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $de29dcc6a077369b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $de29dcc6a077369b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $de29dcc6a077369b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$de29dcc6a077369b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $de29dcc6a077369b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $de29dcc6a077369b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$de29dcc6a077369b$var$Buffer.prototype.readUintLE = $de29dcc6a077369b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readUintBE = $de29dcc6a077369b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint8 = $de29dcc6a077369b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$de29dcc6a077369b$var$Buffer.prototype.readUint16LE = $de29dcc6a077369b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint16BE = $de29dcc6a077369b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$de29dcc6a077369b$var$Buffer.prototype.readUint32LE = $de29dcc6a077369b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint32BE = $de29dcc6a077369b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$de29dcc6a077369b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$de29dcc6a077369b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$de29dcc6a077369b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$de29dcc6a077369b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 8, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$de29dcc6a077369b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 8, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $de29dcc6a077369b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$de29dcc6a077369b$var$Buffer.prototype.writeUintLE = $de29dcc6a077369b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUintBE = $de29dcc6a077369b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint8 = $de29dcc6a077369b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint16LE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint16BE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint32LE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint32BE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $de29dcc6a077369b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $44ef5096b7191751$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$de29dcc6a077369b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeFloat(this, value, offset, true, noAssert);
};
$de29dcc6a077369b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeFloat(this, value, offset, false, noAssert);
};
function $de29dcc6a077369b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $44ef5096b7191751$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$de29dcc6a077369b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeDouble(this, value, offset, true, noAssert);
};
$de29dcc6a077369b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$de29dcc6a077369b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$de29dcc6a077369b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$de29dcc6a077369b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $de29dcc6a077369b$var$Buffer.isBuffer(val) ? val : $de29dcc6a077369b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $de29dcc6a077369b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $de29dcc6a077369b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($de29dcc6a077369b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $de29dcc6a077369b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $de29dcc6a077369b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $de29dcc6a077369b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $de29dcc6a077369b$var$base64ToBytes(str) {
    return $8cf1f36cb432a705$export$d622b2ad8d90c771($de29dcc6a077369b$var$base64clean(str));
}
function $de29dcc6a077369b$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $de29dcc6a077369b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $de29dcc6a077369b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $de29dcc6a077369b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $987194e734735588$require$Buffer = $de29dcc6a077369b$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $987194e734735588$var$isVisitable(thing) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $987194e734735588$var$removeBrackets(key) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $987194e734735588$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $987194e734735588$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $987194e734735588$var$isFlatArray(arr) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(arr) && !arr.some($987194e734735588$var$isVisitable);
}
const $987194e734735588$var$predicates = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject((0, $3b0e765f17086bfd$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $987194e734735588$var$toFormData(obj, formData, options) {
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $a161484968d4e2d6$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $987194e734735588$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) && $987194e734735588$var$isFlatArray(value) || ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFileList(value) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $987194e734735588$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $987194e734735588$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($987194e734735588$var$isVisitable(value)) return true;
        formData.append($987194e734735588$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($987194e734735588$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $987194e734735588$var$isVisitable
    });
    function build(value, path) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $987194e734735588$export$2e2bcd8739ae039 = $987194e734735588$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $2d62ebc7b44b3614$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $2d62ebc7b44b3614$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $987194e734735588$export$2e2bcd8739ae039)(params, this, options);
}
const $2d62ebc7b44b3614$var$prototype = $2d62ebc7b44b3614$var$AxiosURLSearchParams.prototype;
$2d62ebc7b44b3614$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$2d62ebc7b44b3614$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $2d62ebc7b44b3614$var$encode);
    } : $2d62ebc7b44b3614$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $2d62ebc7b44b3614$export$2e2bcd8739ae039 = $2d62ebc7b44b3614$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $cc1325dddfd5d959$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $cc1325dddfd5d959$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $cc1325dddfd5d959$var$encode;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $2d62ebc7b44b3614$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $a420fff59be7902c$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $a420fff59be7902c$export$2e2bcd8739ae039 = $a420fff59be7902c$var$InterceptorManager;





'use strict';
var $9db4fba95d842126$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $34729f01ce81b7d2$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $2d62ebc7b44b3614$export$2e2bcd8739ae039);


'use strict';
var $19ab5cefba3b154c$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $8356c2adc32eacfe$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $f2ec196bcb20148e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $34729f01ce81b7d2$export$2e2bcd8739ae039,
        FormData: $19ab5cefba3b154c$export$2e2bcd8739ae039,
        Blob: $8356c2adc32eacfe$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $8ea2ef8349325b95$exports = {};

$parcel$export($8ea2ef8349325b95$exports, "hasBrowserEnv", () => $8ea2ef8349325b95$export$c4996c4b7b93b0bf);
$parcel$export($8ea2ef8349325b95$exports, "navigator", () => $8ea2ef8349325b95$export$ec7c8efa7f5790ae);
$parcel$export($8ea2ef8349325b95$exports, "hasStandardBrowserEnv", () => $8ea2ef8349325b95$export$c0bcc9250309d66);
$parcel$export($8ea2ef8349325b95$exports, "hasStandardBrowserWebWorkerEnv", () => $8ea2ef8349325b95$export$c81692cf5af97dac);
$parcel$export($8ea2ef8349325b95$exports, "origin", () => $8ea2ef8349325b95$export$f710a83a91838a36);
const $8ea2ef8349325b95$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $8ea2ef8349325b95$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $8ea2ef8349325b95$export$c0bcc9250309d66 = $8ea2ef8349325b95$export$c4996c4b7b93b0bf && (!$8ea2ef8349325b95$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($8ea2ef8349325b95$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $8ea2ef8349325b95$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $8ea2ef8349325b95$export$f710a83a91838a36 = $8ea2ef8349325b95$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $5d16336510b0e3a5$export$2e2bcd8739ae039 = {
    ...$8ea2ef8349325b95$exports,
    ...(0, $f2ec196bcb20148e$export$2e2bcd8739ae039)
};


'use strict';
function $54c9a72f9f4172e8$export$2e2bcd8739ae039(data, options) {
    return (0, $987194e734735588$export$2e2bcd8739ae039)(data, new (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).isNode && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $9d923ad61888379b$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $9d923ad61888379b$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $9d923ad61888379b$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $9d923ad61888379b$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(formData) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($9d923ad61888379b$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $9d923ad61888379b$export$2e2bcd8739ae039 = $9d923ad61888379b$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $5d85921ddf900d80$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $5d85921ddf900d80$var$defaults = {
    transitional: (0, $9db4fba95d842126$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $9d923ad61888379b$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBuffer(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isStream(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFile(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $54c9a72f9f4172e8$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $987194e734735588$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $5d85921ddf900d80$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $5d85921ddf900d80$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isResponse(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $1802f87332a7475d$export$2e2bcd8739ae039).from(e, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $5d85921ddf900d80$var$defaults.headers[method] = {};
});
var $5d85921ddf900d80$export$2e2bcd8739ae039 = $5d85921ddf900d80$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $00ff3ca42995cecb$var$ignoreDuplicateOf = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $00ff3ca42995cecb$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $00ff3ca42995cecb$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $2b4c00835bd82ca3$var$$internals = Symbol('internals');
function $2b4c00835bd82ca3$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2b4c00835bd82ca3$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) ? value.map($2b4c00835bd82ca3$var$normalizeValue) : String(value);
}
function $2b4c00835bd82ca3$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2b4c00835bd82ca3$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2b4c00835bd82ca3$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $2b4c00835bd82ca3$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2b4c00835bd82ca3$var$buildAccessors(obj, header) {
    const accessorName = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2b4c00835bd82ca3$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2b4c00835bd82ca3$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$2b4c00835bd82ca3$var$isValidHeaderName(header)) setHeaders((0, $00ff3ca42995cecb$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2b4c00835bd82ca3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2b4c00835bd82ca3$var$parseTokens(value);
                if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $2b4c00835bd82ca3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $2b4c00835bd82ca3$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2b4c00835bd82ca3$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2b4c00835bd82ca3$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2b4c00835bd82ca3$var$$internals] = this[$2b4c00835bd82ca3$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2b4c00835bd82ca3$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$2b4c00835bd82ca3$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).reduceDescriptors($2b4c00835bd82ca3$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).freezeMethods($2b4c00835bd82ca3$var$AxiosHeaders);
var $2b4c00835bd82ca3$export$2e2bcd8739ae039 = $2b4c00835bd82ca3$var$AxiosHeaders;


'use strict';
function $cf865322512f7c70$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $5d85921ddf900d80$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $96fd7b558634ab1c$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $1802f87332a7475d$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).inherits($96fd7b558634ab1c$var$CanceledError, (0, $1802f87332a7475d$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $96fd7b558634ab1c$export$2e2bcd8739ae039 = $96fd7b558634ab1c$var$CanceledError;







'use strict';
function $b50ed5d1058a3519$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $c0626b65ee4f58ad$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $86b5300eb8c2d89a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $86b5300eb8c2d89a$export$2e2bcd8739ae039 = $86b5300eb8c2d89a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $1e06ddf250092091$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $1e06ddf250092091$export$2e2bcd8739ae039 = $1e06ddf250092091$var$throttle;



const $08491b187ed7125f$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $86b5300eb8c2d89a$export$2e2bcd8739ae039)(50, 250);
    return (0, $1e06ddf250092091$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $08491b187ed7125f$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $08491b187ed7125f$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $654ad96f5dc2640f$export$2e2bcd8739ae039 = (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin), (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $7e458861153e1793$export$2e2bcd8739ae039 = (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $b3c557b1375283cb$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $26a5e67631084dd7$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $209a10c5f4d85343$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $b3c557b1375283cb$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) return (0, $26a5e67631084dd7$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $3714d3e24358701c$var$headersToObject = (thing)=>thing instanceof (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $3714d3e24358701c$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(target) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3714d3e24358701c$var$headersToObject(a), $3714d3e24358701c$var$headersToObject(b), prop, true)
    };
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $e73b2be4d36acc11$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $3714d3e24358701c$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $cc1325dddfd5d959$export$2e2bcd8739ae039)((0, $209a10c5f4d85343$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $654ad96f5dc2640f$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $7e458861153e1793$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $665ff90d985d53de$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $665ff90d985d53de$export$2e2bcd8739ae039 = $665ff90d985d53de$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $e73b2be4d36acc11$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b50ed5d1058a3519$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Request aborted', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Network Error', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $9db4fba95d842126$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $1802f87332a7475d$export$2e2bcd8739ae039).ETIMEDOUT : (0, $1802f87332a7475d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $08491b187ed7125f$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $08491b187ed7125f$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $c0626b65ee4f58ad$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $08a9a6bf5f67a1dd$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $1802f87332a7475d$export$2e2bcd8739ae039) ? err : new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $08a9a6bf5f67a1dd$export$2e2bcd8739ae039 = $08a9a6bf5f67a1dd$var$composeSignals;


const $5bfc0d8311c377d7$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $5bfc0d8311c377d7$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $5bfc0d8311c377d7$var$readStream(iterable))yield* $5bfc0d8311c377d7$export$71b051935044bd5d(chunk, chunkSize);
};
const $5bfc0d8311c377d7$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $5bfc0d8311c377d7$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $5bfc0d8311c377d7$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $db39780280fa948e$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $db39780280fa948e$var$isReadableStreamSupported = $db39780280fa948e$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $db39780280fa948e$var$encodeText = $db39780280fa948e$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $db39780280fa948e$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $db39780280fa948e$var$supportsRequestStream = $db39780280fa948e$var$isReadableStreamSupported && $db39780280fa948e$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $db39780280fa948e$var$DEFAULT_CHUNK_SIZE = 65536;
const $db39780280fa948e$var$supportsResponseStream = $db39780280fa948e$var$isReadableStreamSupported && $db39780280fa948e$var$test(()=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $db39780280fa948e$var$resolvers = {
    stream: $db39780280fa948e$var$supportsResponseStream && ((res)=>res.body)
};
$db39780280fa948e$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$db39780280fa948e$var$resolvers[type] && ($db39780280fa948e$var$resolvers[type] = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $db39780280fa948e$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(body)) return (await $db39780280fa948e$var$encodeText(body)).byteLength;
};
const $db39780280fa948e$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $db39780280fa948e$var$getBodyLength(body) : length;
};
var $db39780280fa948e$export$2e2bcd8739ae039 = $db39780280fa948e$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $e73b2be4d36acc11$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $08a9a6bf5f67a1dd$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $db39780280fa948e$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $db39780280fa948e$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $08491b187ed7125f$export$d9fadd12586c18d6)(requestContentLength, (0, $08491b187ed7125f$export$c1b28109d46c3592)((0, $08491b187ed7125f$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $5bfc0d8311c377d7$export$b0119225647bd83)(_request.body, $db39780280fa948e$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $db39780280fa948e$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($db39780280fa948e$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $08491b187ed7125f$export$d9fadd12586c18d6)(responseContentLength, (0, $08491b187ed7125f$export$c1b28109d46c3592)((0, $08491b187ed7125f$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $5bfc0d8311c377d7$export$b0119225647bd83)(response.body, $db39780280fa948e$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $db39780280fa948e$var$resolvers[(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey($db39780280fa948e$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $b50ed5d1058a3519$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Network Error', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $1802f87332a7475d$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $2945414447657243$var$knownAdapters = {
    http: (0, $a161484968d4e2d6$export$2e2bcd8739ae039),
    xhr: (0, $665ff90d985d53de$export$2e2bcd8739ae039),
    fetch: (0, $db39780280fa948e$export$2e2bcd8739ae039)
};
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach($2945414447657243$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $2945414447657243$var$renderReason = (reason)=>`- ${reason}`;
const $2945414447657243$var$isResolvedHandle = (adapter)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $2945414447657243$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$2945414447657243$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $2945414447657243$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($2945414447657243$var$renderReason).join('\n') : ' ' + $2945414447657243$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $2945414447657243$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f06f8d6e3348094a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(null, config);
}
function $f06f8d6e3348094a$export$2e2bcd8739ae039(config) {
    $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
    config.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $2945414447657243$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $5d85921ddf900d80$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039)(reason)) {
            $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $73d2af2398262305$export$a4ad2735b021c132 = "1.8.1";



'use strict';
const $97dffca93d4e7f32$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $97dffca93d4e7f32$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $97dffca93d4e7f32$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $97dffca93d4e7f32$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $73d2af2398262305$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$97dffca93d4e7f32$var$deprecatedWarnings[opt]) {
            $97dffca93d4e7f32$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$97dffca93d4e7f32$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $97dffca93d4e7f32$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('options must be an object', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $97dffca93d4e7f32$export$2e2bcd8739ae039 = {
    assertOptions: $97dffca93d4e7f32$var$assertOptions,
    validators: $97dffca93d4e7f32$var$validators
};



'use strict';
const $0979936342606ee7$var$validators = (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $0979936342606ee7$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $a420fff59be7902c$export$2e2bcd8739ae039)(),
            response: new (0, $a420fff59be7902c$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3714d3e24358701c$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean),
            forcedJSONParsing: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean),
            clarifyTimeoutError: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $0979936342606ee7$var$validators.function,
                serialize: $0979936342606ee7$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $0979936342606ee7$var$validators.spelling('baseURL'),
            withXsrfToken: $0979936342606ee7$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f06f8d6e3348094a$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f06f8d6e3348094a$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3714d3e24358701c$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $209a10c5f4d85343$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $cc1325dddfd5d959$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0979936342606ee7$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3714d3e24358701c$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3714d3e24358701c$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $0979936342606ee7$var$Axios.prototype[method] = generateHTTPMethod();
    $0979936342606ee7$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $0979936342606ee7$export$2e2bcd8739ae039 = $0979936342606ee7$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $edb97a8a31a981a0$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $edb97a8a31a981a0$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $edb97a8a31a981a0$export$2e2bcd8739ae039 = $edb97a8a31a981a0$var$CancelToken;






'use strict';
function $b9d9bbe99a0c13e8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $c7eac602bd26f638$export$2e2bcd8739ae039(payload) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $7f625779f2088931$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($7f625779f2088931$var$HttpStatusCode).forEach(([key, value])=>{
    $7f625779f2088931$var$HttpStatusCode[value] = key;
});
var $7f625779f2088931$export$2e2bcd8739ae039 = $7f625779f2088931$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $4caf0f2bcd8b9e34$var$createInstance(defaultConfig) {
    const context = new (0, $0979936342606ee7$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $5d219f656b13ee51$export$2e2bcd8739ae039)((0, $0979936342606ee7$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).extend(instance, (0, $0979936342606ee7$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $4caf0f2bcd8b9e34$var$createInstance((0, $3714d3e24358701c$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $4caf0f2bcd8b9e34$var$axios = $4caf0f2bcd8b9e34$var$createInstance((0, $5d85921ddf900d80$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$4caf0f2bcd8b9e34$var$axios.Axios = (0, $0979936342606ee7$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$4caf0f2bcd8b9e34$var$axios.CanceledError = (0, $96fd7b558634ab1c$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.CancelToken = (0, $edb97a8a31a981a0$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.isCancel = (0, $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.VERSION = (0, $73d2af2398262305$export$a4ad2735b021c132);
$4caf0f2bcd8b9e34$var$axios.toFormData = (0, $987194e734735588$export$2e2bcd8739ae039);
// Expose AxiosError class
$4caf0f2bcd8b9e34$var$axios.AxiosError = (0, $1802f87332a7475d$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$4caf0f2bcd8b9e34$var$axios.Cancel = $4caf0f2bcd8b9e34$var$axios.CanceledError;
// Expose all/spread
$4caf0f2bcd8b9e34$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$4caf0f2bcd8b9e34$var$axios.spread = (0, $b9d9bbe99a0c13e8$export$2e2bcd8739ae039);
// Expose isAxiosError
$4caf0f2bcd8b9e34$var$axios.isAxiosError = (0, $c7eac602bd26f638$export$2e2bcd8739ae039);
// Expose mergeConfig
$4caf0f2bcd8b9e34$var$axios.mergeConfig = (0, $3714d3e24358701c$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.AxiosHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.formToJSON = (thing)=>(0, $9d923ad61888379b$export$2e2bcd8739ae039)((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$4caf0f2bcd8b9e34$var$axios.getAdapter = (0, $2945414447657243$export$2e2bcd8739ae039).getAdapter;
$4caf0f2bcd8b9e34$var$axios.HttpStatusCode = (0, $7f625779f2088931$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.default = $4caf0f2bcd8b9e34$var$axios;
var // this module should only have a default export
$4caf0f2bcd8b9e34$export$2e2bcd8739ae039 = $4caf0f2bcd8b9e34$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b0959eebdd834785$export$1c00760e9e5a4e95, AxiosError: $b0959eebdd834785$export$c1fbed17c2f6a328, CanceledError: $b0959eebdd834785$export$1ab0c6b20d94fa14, isCancel: $b0959eebdd834785$export$3b22524397b493c6, CancelToken: $b0959eebdd834785$export$fd08e3cb425f0d61, VERSION: $b0959eebdd834785$export$a4ad2735b021c132, all: $b0959eebdd834785$export$84bf76cd7afc7469, Cancel: $b0959eebdd834785$export$848c9b7ead0df967, isAxiosError: $b0959eebdd834785$export$fbafdbe06a5b5a9a, spread: $b0959eebdd834785$export$3ae0fd4797ed47c8, toFormData: $b0959eebdd834785$export$10ae0d317ea97f8b, AxiosHeaders: $b0959eebdd834785$export$4e7d6ff0f3e6520, HttpStatusCode: $b0959eebdd834785$export$a972f69c851492b3, formToJSON: $b0959eebdd834785$export$86d7c59254d6a2c9, getAdapter: $b0959eebdd834785$export$17ddc20a97d669e2, mergeConfig: $b0959eebdd834785$export$7ec1ebcfa9d8bd6a } = (0, $4caf0f2bcd8b9e34$export$2e2bcd8739ae039);


var $d7654884cc979ea3$exports = {};
(function(global, factory) {
    factory($d7654884cc979ea3$exports);
})($d7654884cc979ea3$exports, function(exports1) {
    'use strict';
    var toStringFunction = Function.prototype.toString;
    var create = Object.create;
    var toStringObject = Object.prototype.toString;
    /**
     * @classdesc Fallback cache for when WeakMap is not natively supported
     */ var LegacyCache = /** @class */ function() {
        function LegacyCache() {
            this._keys = [];
            this._values = [];
        }
        LegacyCache.prototype.has = function(key) {
            return !!~this._keys.indexOf(key);
        };
        LegacyCache.prototype.get = function(key) {
            return this._values[this._keys.indexOf(key)];
        };
        LegacyCache.prototype.set = function(key, value) {
            this._keys.push(key);
            this._values.push(value);
        };
        return LegacyCache;
    }();
    function createCacheLegacy() {
        return new LegacyCache();
    }
    function createCacheModern() {
        return new WeakMap();
    }
    /**
     * Get a new cache object to prevent circular references.
     */ var createCache = typeof WeakMap !== 'undefined' ? createCacheModern : createCacheLegacy;
    /**
     * Get an empty version of the object with the same prototype it has.
     */ function getCleanClone(prototype) {
        if (!prototype) return create(null);
        var Constructor = prototype.constructor;
        if (Constructor === Object) return prototype === Object.prototype ? {} : create(prototype);
        if (Constructor && ~toStringFunction.call(Constructor).indexOf('[native code]')) try {
            return new Constructor();
        } catch (_a) {}
        return create(prototype);
    }
    function getRegExpFlagsLegacy(regExp) {
        var flags = '';
        if (regExp.global) flags += 'g';
        if (regExp.ignoreCase) flags += 'i';
        if (regExp.multiline) flags += 'm';
        if (regExp.unicode) flags += 'u';
        if (regExp.sticky) flags += 'y';
        return flags;
    }
    function getRegExpFlagsModern(regExp) {
        return regExp.flags;
    }
    /**
     * Get the flags to apply to the copied regexp.
     */ var getRegExpFlags = /test/g.flags === 'g' ? getRegExpFlagsModern : getRegExpFlagsLegacy;
    function getTagLegacy(value) {
        var type = toStringObject.call(value);
        return type.substring(8, type.length - 1);
    }
    function getTagModern(value) {
        return value[Symbol.toStringTag] || getTagLegacy(value);
    }
    /**
     * Get the tag of the value passed, so that the correct copier can be used.
     */ var getTag = typeof Symbol !== 'undefined' ? getTagModern : getTagLegacy;
    var defineProperty = Object.defineProperty, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var _a = Object.prototype, hasOwnProperty = _a.hasOwnProperty, propertyIsEnumerable = _a.propertyIsEnumerable;
    var SUPPORTS_SYMBOL = typeof getOwnPropertySymbols === 'function';
    function getStrictPropertiesModern(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Get the properites used when copying objects strictly. This includes both keys and symbols.
     */ var getStrictProperties = SUPPORTS_SYMBOL ? getStrictPropertiesModern : getOwnPropertyNames;
    /**
     * Striclty copy all properties contained on the object.
     */ function copyOwnPropertiesStrict(value, clone, state) {
        var properties = getStrictProperties(value);
        for(var index = 0, length_1 = properties.length, property = void 0, descriptor = void 0; index < length_1; ++index){
            property = properties[index];
            if (property === 'callee' || property === 'caller') continue;
            descriptor = getOwnPropertyDescriptor(value, property);
            if (!descriptor) {
                // In extra edge cases where the property descriptor cannot be retrived, fall back to
                // the loose assignment.
                clone[property] = state.copier(value[property], state);
                continue;
            }
            // Only clone the value if actually a value, not a getter / setter.
            if (!descriptor.get && !descriptor.set) descriptor.value = state.copier(descriptor.value, state);
            try {
                defineProperty(clone, property, descriptor);
            } catch (error) {
                // Tee above can fail on node in edge cases, so fall back to the loose assignment.
                clone[property] = descriptor.value;
            }
        }
        return clone;
    }
    /**
     * Deeply copy the indexed values in the array.
     */ function copyArrayLoose(array, state) {
        var clone = new state.Constructor();
        // set in the cache immediately to be able to reuse the object recursively
        state.cache.set(array, clone);
        for(var index = 0, length_2 = array.length; index < length_2; ++index)clone[index] = state.copier(array[index], state);
        return clone;
    }
    /**
     * Deeply copy the indexed values in the array, as well as any custom properties.
     */ function copyArrayStrict(array, state) {
        var clone = new state.Constructor();
        // set in the cache immediately to be able to reuse the object recursively
        state.cache.set(array, clone);
        return copyOwnPropertiesStrict(array, clone, state);
    }
    /**
     * Copy the contents of the ArrayBuffer.
     */ function copyArrayBuffer(arrayBuffer, _state) {
        return arrayBuffer.slice(0);
    }
    /**
     * Create a new Blob with the contents of the original.
     */ function copyBlob(blob, _state) {
        return blob.slice(0, blob.size, blob.type);
    }
    /**
     * Create a new DataView with the contents of the original.
     */ function copyDataView(dataView, state) {
        return new state.Constructor(copyArrayBuffer(dataView.buffer));
    }
    /**
     * Create a new Date based on the time of the original.
     */ function copyDate(date, state) {
        return new state.Constructor(date.getTime());
    }
    /**
     * Deeply copy the keys and values of the original.
     */ function copyMapLoose(map, state) {
        var clone = new state.Constructor();
        // set in the cache immediately to be able to reuse the object recursively
        state.cache.set(map, clone);
        map.forEach(function(value, key) {
            clone.set(key, state.copier(value, state));
        });
        return clone;
    }
    /**
     * Deeply copy the keys and values of the original, as well as any custom properties.
     */ function copyMapStrict(map, state) {
        return copyOwnPropertiesStrict(map, copyMapLoose(map, state), state);
    }
    function copyObjectLooseLegacy(object, state) {
        var clone = getCleanClone(state.prototype);
        // set in the cache immediately to be able to reuse the object recursively
        state.cache.set(object, clone);
        for(var key in object)if (hasOwnProperty.call(object, key)) clone[key] = state.copier(object[key], state);
        return clone;
    }
    function copyObjectLooseModern(object, state) {
        var clone = getCleanClone(state.prototype);
        // set in the cache immediately to be able to reuse the object recursively
        state.cache.set(object, clone);
        for(var key in object)if (hasOwnProperty.call(object, key)) clone[key] = state.copier(object[key], state);
        var symbols = getOwnPropertySymbols(object);
        for(var index = 0, length_3 = symbols.length, symbol = void 0; index < length_3; ++index){
            symbol = symbols[index];
            if (propertyIsEnumerable.call(object, symbol)) clone[symbol] = state.copier(object[symbol], state);
        }
        return clone;
    }
    /**
     * Deeply copy the properties (keys and symbols) and values of the original.
     */ var copyObjectLoose = SUPPORTS_SYMBOL ? copyObjectLooseModern : copyObjectLooseLegacy;
    /**
     * Deeply copy the properties (keys and symbols) and values of the original, as well
     * as any hidden or non-enumerable properties.
     */ function copyObjectStrict(object, state) {
        var clone = getCleanClone(state.prototype);
        // set in the cache immediately to be able to reuse the object recursively
        state.cache.set(object, clone);
        return copyOwnPropertiesStrict(object, clone, state);
    }
    /**
     * Create a new primitive wrapper from the value of the original.
     */ function copyPrimitiveWrapper(primitiveObject, state) {
        return new state.Constructor(primitiveObject.valueOf());
    }
    /**
     * Create a new RegExp based on the value and flags of the original.
     */ function copyRegExp(regExp, state) {
        var clone = new state.Constructor(regExp.source, getRegExpFlags(regExp));
        clone.lastIndex = regExp.lastIndex;
        return clone;
    }
    /**
     * Return the original value (an identity function).
     *
     * @note
     * THis is used for objects that cannot be copied, such as WeakMap.
     */ function copySelf(value, _state) {
        return value;
    }
    /**
     * Deeply copy the values of the original.
     */ function copySetLoose(set, state) {
        var clone = new state.Constructor();
        // set in the cache immediately to be able to reuse the object recursively
        state.cache.set(set, clone);
        set.forEach(function(value) {
            clone.add(state.copier(value, state));
        });
        return clone;
    }
    /**
     * Deeply copy the values of the original, as well as any custom properties.
     */ function copySetStrict(set, state) {
        return copyOwnPropertiesStrict(set, copySetLoose(set, state), state);
    }
    var isArray = Array.isArray;
    var assign = Object.assign;
    var getPrototypeOf = Object.getPrototypeOf || function(obj) {
        return obj.__proto__;
    };
    var DEFAULT_LOOSE_OPTIONS = {
        array: copyArrayLoose,
        arrayBuffer: copyArrayBuffer,
        blob: copyBlob,
        dataView: copyDataView,
        date: copyDate,
        error: copySelf,
        map: copyMapLoose,
        object: copyObjectLoose,
        regExp: copyRegExp,
        set: copySetLoose
    };
    var DEFAULT_STRICT_OPTIONS = assign({}, DEFAULT_LOOSE_OPTIONS, {
        array: copyArrayStrict,
        map: copyMapStrict,
        object: copyObjectStrict,
        set: copySetStrict
    });
    /**
     * Get the copiers used for each specific object tag.
     */ function getTagSpecificCopiers(options) {
        return {
            Arguments: options.object,
            Array: options.array,
            ArrayBuffer: options.arrayBuffer,
            Blob: options.blob,
            Boolean: copyPrimitiveWrapper,
            DataView: options.dataView,
            Date: options.date,
            Error: options.error,
            Float32Array: options.arrayBuffer,
            Float64Array: options.arrayBuffer,
            Int8Array: options.arrayBuffer,
            Int16Array: options.arrayBuffer,
            Int32Array: options.arrayBuffer,
            Map: options.map,
            Number: copyPrimitiveWrapper,
            Object: options.object,
            Promise: copySelf,
            RegExp: options.regExp,
            Set: options.set,
            String: copyPrimitiveWrapper,
            WeakMap: copySelf,
            WeakSet: copySelf,
            Uint8Array: options.arrayBuffer,
            Uint8ClampedArray: options.arrayBuffer,
            Uint16Array: options.arrayBuffer,
            Uint32Array: options.arrayBuffer,
            Uint64Array: options.arrayBuffer
        };
    }
    /**
     * Create a custom copier based on the object-specific copy methods passed.
     */ function createCopier(options) {
        var normalizedOptions = assign({}, DEFAULT_LOOSE_OPTIONS, options);
        var tagSpecificCopiers = getTagSpecificCopiers(normalizedOptions);
        var array = tagSpecificCopiers.Array, object = tagSpecificCopiers.Object;
        function copier(value, state) {
            state.prototype = state.Constructor = undefined;
            if (!value || typeof value !== 'object') return value;
            if (state.cache.has(value)) return state.cache.get(value);
            state.prototype = getPrototypeOf(value);
            state.Constructor = state.prototype && state.prototype.constructor;
            // plain objects
            if (!state.Constructor || state.Constructor === Object) return object(value, state);
            // arrays
            if (isArray(value)) return array(value, state);
            var tagSpecificCopier = tagSpecificCopiers[getTag(value)];
            if (tagSpecificCopier) return tagSpecificCopier(value, state);
            return typeof value.then === 'function' ? value : object(value, state);
        }
        return function copy(value) {
            return copier(value, {
                Constructor: undefined,
                cache: createCache(),
                copier: copier,
                prototype: undefined
            });
        };
    }
    /**
     * Create a custom copier based on the object-specific copy methods passed, defaulting to the
     * same internals as `copyStrict`.
     */ function createStrictCopier(options) {
        return createCopier(assign({}, DEFAULT_STRICT_OPTIONS, options));
    }
    /**
     * Copy an value deeply as much as possible, where strict recreation of object properties
     * are maintained. All properties (including non-enumerable ones) are copied with their
     * original property descriptors on both objects and arrays.
     */ var copyStrict = createStrictCopier({});
    /**
     * Copy an value deeply as much as possible.
     */ var index = createCopier({});
    exports1.copyStrict = copyStrict;
    exports1.createCopier = createCopier;
    exports1.createStrictCopier = createStrictCopier;
    exports1.default = index;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


function $0afe4f51006255f7$export$2e2bcd8739ae039(instance, getToken) {
    instance.interceptors.request.use(function(config) {
        return getToken().then((accessToken)=>{
            config.headers.set('Authorization', `Bearer ${accessToken}`);
            return config;
        });
    });
}



var $4kiXg = parcelRequire("4kiXg");
function $6c4f1a5adeb9b79e$export$8ee0fc9ee280b4ee() {
    /**
     * Polyfills of 'process' might set process.browser === true
     *
     * See:
     * https://github.com/webpack/node-libs-browser/blob/master/mock/process.js#L8
     * https://github.com/defunctzombie/node-process/blob/master/browser.js#L156
     **/ return typeof (0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))) !== 'undefined' && !(0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))).browser;
}
function $6c4f1a5adeb9b79e$export$f7a1e23e542d38e3() {
    return typeof window !== 'undefined' && 'navigator' in window && 'product' in window.navigator && window.navigator.product === 'ReactNative';
}
function $6c4f1a5adeb9b79e$export$bf2c6630ab904918() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))).versions && (0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))).versions.node ? `v${(0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))).versions.node}` : (0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))).version;
}
function $6c4f1a5adeb9b79e$export$38b2d434cce3ea22() {
    return window;
}
function $6c4f1a5adeb9b79e$export$8793edee2d425525() {
    return undefined;
}


const $21553a6a60179854$var$delay = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $21553a6a60179854$var$defaultWait = (attempts)=>{
    return Math.pow(Math.SQRT2, attempts);
};
function $21553a6a60179854$export$2e2bcd8739ae039(instance, maxRetry = 5) {
    const { responseLogger: responseLogger = (0, $6c4f1a5adeb9b79e$export$8793edee2d425525), requestLogger: requestLogger = (0, $6c4f1a5adeb9b79e$export$8793edee2d425525) } = instance.defaults;
    instance.interceptors.request.use(function(config) {
        requestLogger(config);
        return config;
    }, function(error) {
        requestLogger(error);
        return Promise.reject(error);
    });
    instance.interceptors.response.use(function(response) {
        // we don't need to do anything here
        responseLogger(response);
        return response;
    }, async function(error) {
        const { response: response } = error;
        const { config: config } = error;
        responseLogger(error);
        // Do not retry if it is disabled or no request config exists (not an axios error)
        if (!config || !instance.defaults.retryOnError) return Promise.reject(error);
        // Retried already for max attempts
        const doneAttempts = config.attempts || 1;
        if (doneAttempts > maxRetry) {
            error.attempts = config.attempts;
            return Promise.reject(error);
        }
        let retryErrorType = null;
        let wait = $21553a6a60179854$var$defaultWait(doneAttempts);
        // Errors without response did not receive anything from the server
        if (!response) retryErrorType = 'Connection';
        else if (response.status >= 500 && response.status < 600) // 5** errors are server related
        retryErrorType = `Server ${response.status}`;
        else if (response.status === 429) {
            // 429 errors are exceeded rate limit exceptions
            retryErrorType = 'Rate limit';
            // all headers are lowercased by axios https://github.com/mzabriskie/axios/issues/413
            if (response.headers && error.response.headers['x-contentful-ratelimit-reset']) wait = response.headers['x-contentful-ratelimit-reset'];
        }
        if (retryErrorType) {
            // convert to ms and add jitter
            wait = Math.floor(wait * 1000 + Math.random() * 200 + 500);
            instance.defaults.logHandler('warning', `${retryErrorType} error occurred. Waiting for ${wait} ms before retrying...`);
            // increase attempts counter
            config.attempts = doneAttempts + 1;
            /* Somehow between the interceptor and retrying the request the httpAgent/httpsAgent gets transformed from an Agent-like object
             to a regular object, causing failures on retries after rate limits. Removing these properties here fixes the error, but retry
             requests still use the original http/httpsAgent property */ delete config.httpAgent;
            delete config.httpsAgent;
            return $21553a6a60179854$var$delay(wait).then(()=>instance(config));
        }
        return Promise.reject(error);
    });
}


var $e652297b22fb58f1$exports = {};
var $e12df5b696fff3d1$exports = {};
var $11dbec73be17c100$exports = {};
var $e01c03f9de6cd72b$exports = {};
var $a5ce87e14e8cdbf7$exports = {};
/** Detect free variable `global` from Node.js. */ var $a5ce87e14e8cdbf7$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$a5ce87e14e8cdbf7$exports = $a5ce87e14e8cdbf7$var$freeGlobal;


/** Detect free variable `self`. */ var $e01c03f9de6cd72b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e01c03f9de6cd72b$var$root = $a5ce87e14e8cdbf7$exports || $e01c03f9de6cd72b$var$freeSelf || Function('return this')();
$e01c03f9de6cd72b$exports = $e01c03f9de6cd72b$var$root;


/** Built-in value references. */ var $11dbec73be17c100$var$Symbol = $e01c03f9de6cd72b$exports.Symbol;
$11dbec73be17c100$exports = $11dbec73be17c100$var$Symbol;


var $28d4b2f56120dd6f$exports = {};

/** Used for built-in method references. */ var $28d4b2f56120dd6f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28d4b2f56120dd6f$var$hasOwnProperty = $28d4b2f56120dd6f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $28d4b2f56120dd6f$var$nativeObjectToString = $28d4b2f56120dd6f$var$objectProto.toString;
/** Built-in value references. */ var $28d4b2f56120dd6f$var$symToStringTag = $11dbec73be17c100$exports ? $11dbec73be17c100$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $28d4b2f56120dd6f$var$getRawTag(value) {
    var isOwn = $28d4b2f56120dd6f$var$hasOwnProperty.call(value, $28d4b2f56120dd6f$var$symToStringTag), tag = value[$28d4b2f56120dd6f$var$symToStringTag];
    try {
        value[$28d4b2f56120dd6f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $28d4b2f56120dd6f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$28d4b2f56120dd6f$var$symToStringTag] = tag;
        else delete value[$28d4b2f56120dd6f$var$symToStringTag];
    }
    return result;
}
$28d4b2f56120dd6f$exports = $28d4b2f56120dd6f$var$getRawTag;


var $8c47fff1c350382f$exports = {};
/** Used for built-in method references. */ var $8c47fff1c350382f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8c47fff1c350382f$var$nativeObjectToString = $8c47fff1c350382f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8c47fff1c350382f$var$objectToString(value) {
    return $8c47fff1c350382f$var$nativeObjectToString.call(value);
}
$8c47fff1c350382f$exports = $8c47fff1c350382f$var$objectToString;


/** `Object#toString` result references. */ var $e12df5b696fff3d1$var$nullTag = '[object Null]', $e12df5b696fff3d1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $e12df5b696fff3d1$var$symToStringTag = $11dbec73be17c100$exports ? $11dbec73be17c100$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e12df5b696fff3d1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e12df5b696fff3d1$var$undefinedTag : $e12df5b696fff3d1$var$nullTag;
    return $e12df5b696fff3d1$var$symToStringTag && $e12df5b696fff3d1$var$symToStringTag in Object(value) ? $28d4b2f56120dd6f$exports(value) : $8c47fff1c350382f$exports(value);
}
$e12df5b696fff3d1$exports = $e12df5b696fff3d1$var$baseGetTag;


var $db7955163959f248$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $db7955163959f248$var$isArray = Array.isArray;
$db7955163959f248$exports = $db7955163959f248$var$isArray;


var $33440307203792f1$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $33440307203792f1$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$33440307203792f1$exports = $33440307203792f1$var$isObjectLike;


/** `Object#toString` result references. */ var $e652297b22fb58f1$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $e652297b22fb58f1$var$isString(value) {
    return typeof value == 'string' || !$db7955163959f248$exports(value) && $33440307203792f1$exports(value) && $e12df5b696fff3d1$exports(value) == $e652297b22fb58f1$var$stringTag;
}
$e652297b22fb58f1$exports = $e652297b22fb58f1$var$isString;


class $e7d72dade9aebf3b$export$18b052ffd8c84d7 extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
function $e7d72dade9aebf3b$export$2e2bcd8739ae039({ limit: limit, interval: interval, strict: strict, onDelay: onDelay }) {
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        // Clear the queue if there's a significant delay since the last execution
        if (strictTicks.length > 0 && now - strictTicks.at(-1) > interval) strictTicks.length = 0;
        // If the queue is not full, add the current time and execute immediately
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        // Calculate the next execution time based on the first item in the queue
        const nextExecutionTime = strictTicks[0] + interval;
        // Shift the queue and add the new execution time
        strictTicks.shift();
        strictTicks.push(nextExecutionTime);
        // Calculate the delay for the current execution
        return Math.max(0, nextExecutionTime - now);
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...arguments_) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, arguments_))();
            let timeoutId;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, arguments_));
                    queue.delete(timeoutId);
                };
                const delay = getDelay();
                if (delay > 0) {
                    timeoutId = setTimeout(execute, delay);
                    queue.set(timeoutId, reject);
                    onDelay?.(...arguments_);
                } else execute();
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $e7d72dade9aebf3b$export$18b052ffd8c84d7());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        Object.defineProperty(throttled, 'queueSize', {
            get () {
                return queue.size;
            }
        });
        return throttled;
    };
}



const $a39f05bb5d8af405$var$PERCENTAGE_REGEX = /(?<value>\d+)(%)/;
function $a39f05bb5d8af405$var$calculateLimit(type, max = 7) {
    let limit = max;
    if ($a39f05bb5d8af405$var$PERCENTAGE_REGEX.test(type)) {
        const groups = type.match($a39f05bb5d8af405$var$PERCENTAGE_REGEX)?.groups;
        if (groups && groups.value) {
            const percentage = parseInt(groups.value) / 100;
            limit = Math.round(max * percentage);
        }
    }
    return Math.min(30, Math.max(1, limit));
}
function $a39f05bb5d8af405$var$createThrottle(limit, logger) {
    logger('info', `Throttle request to ${limit}/s`);
    return (0, $e7d72dade9aebf3b$export$2e2bcd8739ae039)({
        limit: limit,
        interval: 1000,
        strict: false
    });
}
var $a39f05bb5d8af405$export$2e2bcd8739ae039 = (axiosInstance, type = 'auto')=>{
    const { logHandler: logHandler = (0, $6c4f1a5adeb9b79e$export$8793edee2d425525) } = axiosInstance.defaults;
    let limit = (0, (/*@__PURE__*/$parcel$interopDefault($e652297b22fb58f1$exports)))(type) ? $a39f05bb5d8af405$var$calculateLimit(type) : $a39f05bb5d8af405$var$calculateLimit('auto', type);
    let throttle = $a39f05bb5d8af405$var$createThrottle(limit, logHandler);
    let isCalculated = false;
    let requestInterceptorId = axiosInstance.interceptors.request.use((config)=>{
        return throttle(()=>config)();
    }, function(error) {
        return Promise.reject(error);
    });
    const responseInterceptorId = axiosInstance.interceptors.response.use((response)=>{
        if (!isCalculated && (0, (/*@__PURE__*/$parcel$interopDefault($e652297b22fb58f1$exports)))(type) && (type === 'auto' || $a39f05bb5d8af405$var$PERCENTAGE_REGEX.test(type)) && response.headers && response.headers['x-contentful-ratelimit-second-limit']) {
            const rawLimit = parseInt(response.headers['x-contentful-ratelimit-second-limit']);
            const nextLimit = $a39f05bb5d8af405$var$calculateLimit(type, rawLimit);
            if (nextLimit !== limit) {
                if (requestInterceptorId) axiosInstance.interceptors.request.eject(requestInterceptorId);
                limit = nextLimit;
                throttle = $a39f05bb5d8af405$var$createThrottle(nextLimit, logHandler);
                requestInterceptorId = axiosInstance.interceptors.request.use((config)=>{
                    return throttle(()=>config)();
                }, function(error) {
                    return Promise.reject(error);
                });
            }
            isCalculated = true;
        }
        return response;
    }, function(error) {
        return Promise.reject(error);
    });
    return ()=>{
        axiosInstance.interceptors.request.eject(requestInterceptorId);
        axiosInstance.interceptors.response.eject(responseInterceptorId);
    };
};


var $6e19be61753cbc35$exports = {};
'use strict';
var $79acdf0dd8ee88cb$exports = {};
'use strict';
var $41979e9c210b0e24$exports = {};
'use strict';
var $6e764c828aee0516$exports = {};
'use strict';
/** @type {import('./type')} */ $6e764c828aee0516$exports = TypeError;


var $5a5c8f99294101b7$exports = {};
var $5a5c8f99294101b7$var$hasMap = typeof Map === 'function' && Map.prototype;
var $5a5c8f99294101b7$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $5a5c8f99294101b7$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $5a5c8f99294101b7$var$mapSize = $5a5c8f99294101b7$var$hasMap && $5a5c8f99294101b7$var$mapSizeDescriptor && typeof $5a5c8f99294101b7$var$mapSizeDescriptor.get === 'function' ? $5a5c8f99294101b7$var$mapSizeDescriptor.get : null;
var $5a5c8f99294101b7$var$mapForEach = $5a5c8f99294101b7$var$hasMap && Map.prototype.forEach;
var $5a5c8f99294101b7$var$hasSet = typeof Set === 'function' && Set.prototype;
var $5a5c8f99294101b7$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $5a5c8f99294101b7$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $5a5c8f99294101b7$var$setSize = $5a5c8f99294101b7$var$hasSet && $5a5c8f99294101b7$var$setSizeDescriptor && typeof $5a5c8f99294101b7$var$setSizeDescriptor.get === 'function' ? $5a5c8f99294101b7$var$setSizeDescriptor.get : null;
var $5a5c8f99294101b7$var$setForEach = $5a5c8f99294101b7$var$hasSet && Set.prototype.forEach;
var $5a5c8f99294101b7$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $5a5c8f99294101b7$var$weakMapHas = $5a5c8f99294101b7$var$hasWeakMap ? WeakMap.prototype.has : null;
var $5a5c8f99294101b7$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $5a5c8f99294101b7$var$weakSetHas = $5a5c8f99294101b7$var$hasWeakSet ? WeakSet.prototype.has : null;
var $5a5c8f99294101b7$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $5a5c8f99294101b7$var$weakRefDeref = $5a5c8f99294101b7$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $5a5c8f99294101b7$var$booleanValueOf = Boolean.prototype.valueOf;
var $5a5c8f99294101b7$var$objectToString = Object.prototype.toString;
var $5a5c8f99294101b7$var$functionToString = Function.prototype.toString;
var $5a5c8f99294101b7$var$$match = String.prototype.match;
var $5a5c8f99294101b7$var$$slice = String.prototype.slice;
var $5a5c8f99294101b7$var$$replace = String.prototype.replace;
var $5a5c8f99294101b7$var$$toUpperCase = String.prototype.toUpperCase;
var $5a5c8f99294101b7$var$$toLowerCase = String.prototype.toLowerCase;
var $5a5c8f99294101b7$var$$test = RegExp.prototype.test;
var $5a5c8f99294101b7$var$$concat = Array.prototype.concat;
var $5a5c8f99294101b7$var$$join = Array.prototype.join;
var $5a5c8f99294101b7$var$$arrSlice = Array.prototype.slice;
var $5a5c8f99294101b7$var$$floor = Math.floor;
var $5a5c8f99294101b7$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $5a5c8f99294101b7$var$gOPS = Object.getOwnPropertySymbols;
var $5a5c8f99294101b7$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $5a5c8f99294101b7$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $5a5c8f99294101b7$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $5a5c8f99294101b7$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $5a5c8f99294101b7$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $5a5c8f99294101b7$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $5a5c8f99294101b7$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $5a5c8f99294101b7$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$5a5c8f99294101b7$var$$floor(-num) : $5a5c8f99294101b7$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $5a5c8f99294101b7$var$$slice.call(str, intStr.length + 1);
            return $5a5c8f99294101b7$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $5a5c8f99294101b7$var$$replace.call($5a5c8f99294101b7$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $5a5c8f99294101b7$var$$replace.call(str, sepRegex, '$&_');
}
var $7b3c9bafdaa6f1e6$exports = {};
"use strict";


var $5a5c8f99294101b7$var$inspectCustom = $7b3c9bafdaa6f1e6$exports.custom;
var $5a5c8f99294101b7$var$inspectSymbol = $5a5c8f99294101b7$var$isSymbol($5a5c8f99294101b7$var$inspectCustom) ? $5a5c8f99294101b7$var$inspectCustom : null;
var $5a5c8f99294101b7$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $5a5c8f99294101b7$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$5a5c8f99294101b7$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($5a5c8f99294101b7$var$has(opts, 'quoteStyle') && !$5a5c8f99294101b7$var$has($5a5c8f99294101b7$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($5a5c8f99294101b7$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $5a5c8f99294101b7$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($5a5c8f99294101b7$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($5a5c8f99294101b7$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $5a5c8f99294101b7$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $5a5c8f99294101b7$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $5a5c8f99294101b7$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $5a5c8f99294101b7$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $5a5c8f99294101b7$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($5a5c8f99294101b7$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $5a5c8f99294101b7$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($5a5c8f99294101b7$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$5a5c8f99294101b7$var$isRegExp(obj)) {
        var name = $5a5c8f99294101b7$var$nameOf(obj);
        var keys = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $5a5c8f99294101b7$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($5a5c8f99294101b7$var$isSymbol(obj)) {
        var symString = $5a5c8f99294101b7$var$hasShammedSymbols ? $5a5c8f99294101b7$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $5a5c8f99294101b7$var$symToString.call(obj);
        return typeof obj === 'object' && !$5a5c8f99294101b7$var$hasShammedSymbols ? $5a5c8f99294101b7$var$markBoxed(symString) : symString;
    }
    if ($5a5c8f99294101b7$var$isElement(obj)) {
        var s = '<' + $5a5c8f99294101b7$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $5a5c8f99294101b7$var$wrapQuotes($5a5c8f99294101b7$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $5a5c8f99294101b7$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($5a5c8f99294101b7$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        if (indent && !$5a5c8f99294101b7$var$singleLineValues(xs)) return '[' + $5a5c8f99294101b7$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $5a5c8f99294101b7$var$$join.call(xs, ', ') + ' ]';
    }
    if ($5a5c8f99294101b7$var$isError(obj)) {
        var parts = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$5a5c8f99294101b7$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $5a5c8f99294101b7$var$$join.call($5a5c8f99294101b7$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $5a5c8f99294101b7$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($5a5c8f99294101b7$var$inspectSymbol && typeof obj[$5a5c8f99294101b7$var$inspectSymbol] === 'function' && $7b3c9bafdaa6f1e6$exports) return $7b3c9bafdaa6f1e6$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($5a5c8f99294101b7$var$isMap(obj)) {
        var mapParts = [];
        if ($5a5c8f99294101b7$var$mapForEach) $5a5c8f99294101b7$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $5a5c8f99294101b7$var$collectionOf('Map', $5a5c8f99294101b7$var$mapSize.call(obj), mapParts, indent);
    }
    if ($5a5c8f99294101b7$var$isSet(obj)) {
        var setParts = [];
        if ($5a5c8f99294101b7$var$setForEach) $5a5c8f99294101b7$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $5a5c8f99294101b7$var$collectionOf('Set', $5a5c8f99294101b7$var$setSize.call(obj), setParts, indent);
    }
    if ($5a5c8f99294101b7$var$isWeakMap(obj)) return $5a5c8f99294101b7$var$weakCollectionOf('WeakMap');
    if ($5a5c8f99294101b7$var$isWeakSet(obj)) return $5a5c8f99294101b7$var$weakCollectionOf('WeakSet');
    if ($5a5c8f99294101b7$var$isWeakRef(obj)) return $5a5c8f99294101b7$var$weakCollectionOf('WeakRef');
    if ($5a5c8f99294101b7$var$isNumber(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect(Number(obj)));
    if ($5a5c8f99294101b7$var$isBigInt(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect($5a5c8f99294101b7$var$bigIntValueOf.call(obj)));
    if ($5a5c8f99294101b7$var$isBoolean(obj)) return $5a5c8f99294101b7$var$markBoxed($5a5c8f99294101b7$var$booleanValueOf.call(obj));
    if ($5a5c8f99294101b7$var$isString(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$5a5c8f99294101b7$var$isDate(obj) && !$5a5c8f99294101b7$var$isRegExp(obj)) {
        var ys = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        var isPlainObject = $5a5c8f99294101b7$var$gPO ? $5a5c8f99294101b7$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $5a5c8f99294101b7$var$toStringTag && Object(obj) === obj && $5a5c8f99294101b7$var$toStringTag in obj ? $5a5c8f99294101b7$var$$slice.call($5a5c8f99294101b7$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $5a5c8f99294101b7$var$$join.call($5a5c8f99294101b7$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $5a5c8f99294101b7$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $5a5c8f99294101b7$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $5a5c8f99294101b7$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $5a5c8f99294101b7$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $5a5c8f99294101b7$var$quote(s) {
    return $5a5c8f99294101b7$var$$replace.call(String(s), /"/g, '&quot;');
}
function $5a5c8f99294101b7$var$canTrustToString(obj) {
    return !$5a5c8f99294101b7$var$toStringTag || !(typeof obj === 'object' && ($5a5c8f99294101b7$var$toStringTag in obj || typeof obj[$5a5c8f99294101b7$var$toStringTag] !== 'undefined'));
}
function $5a5c8f99294101b7$var$isArray(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Array]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isDate(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Date]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isRegExp(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object RegExp]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isError(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Error]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isString(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object String]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isNumber(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Number]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isBoolean(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Boolean]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $5a5c8f99294101b7$var$isSymbol(obj) {
    if ($5a5c8f99294101b7$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$5a5c8f99294101b7$var$symToString) return false;
    try {
        $5a5c8f99294101b7$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$5a5c8f99294101b7$var$bigIntValueOf) return false;
    try {
        $5a5c8f99294101b7$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $5a5c8f99294101b7$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $5a5c8f99294101b7$var$has(obj, key) {
    return $5a5c8f99294101b7$var$hasOwn.call(obj, key);
}
function $5a5c8f99294101b7$var$toStr(obj) {
    return $5a5c8f99294101b7$var$objectToString.call(obj);
}
function $5a5c8f99294101b7$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $5a5c8f99294101b7$var$$match.call($5a5c8f99294101b7$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $5a5c8f99294101b7$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $5a5c8f99294101b7$var$isMap(x) {
    if (!$5a5c8f99294101b7$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$mapSize.call(x);
        try {
            $5a5c8f99294101b7$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakMap(x) {
    if (!$5a5c8f99294101b7$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$weakMapHas.call(x, $5a5c8f99294101b7$var$weakMapHas);
        try {
            $5a5c8f99294101b7$var$weakSetHas.call(x, $5a5c8f99294101b7$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakRef(x) {
    if (!$5a5c8f99294101b7$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isSet(x) {
    if (!$5a5c8f99294101b7$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$setSize.call(x);
        try {
            $5a5c8f99294101b7$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakSet(x) {
    if (!$5a5c8f99294101b7$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$weakSetHas.call(x, $5a5c8f99294101b7$var$weakSetHas);
        try {
            $5a5c8f99294101b7$var$weakMapHas.call(x, $5a5c8f99294101b7$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $5a5c8f99294101b7$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $5a5c8f99294101b7$var$inspectString($5a5c8f99294101b7$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $5a5c8f99294101b7$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $5a5c8f99294101b7$var$$replace.call($5a5c8f99294101b7$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $5a5c8f99294101b7$var$lowbyte);
    return $5a5c8f99294101b7$var$wrapQuotes(s, 'single', opts);
}
function $5a5c8f99294101b7$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $5a5c8f99294101b7$var$$toUpperCase.call(n.toString(16));
}
function $5a5c8f99294101b7$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $5a5c8f99294101b7$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $5a5c8f99294101b7$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $5a5c8f99294101b7$var$indentedJoin(entries, indent) : $5a5c8f99294101b7$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $5a5c8f99294101b7$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($5a5c8f99294101b7$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $5a5c8f99294101b7$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $5a5c8f99294101b7$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $5a5c8f99294101b7$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $5a5c8f99294101b7$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $5a5c8f99294101b7$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $5a5c8f99294101b7$var$arrObjKeys(obj, inspect) {
    var isArr = $5a5c8f99294101b7$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $5a5c8f99294101b7$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $5a5c8f99294101b7$var$gOPS === 'function' ? $5a5c8f99294101b7$var$gOPS(obj) : [];
    var symMap;
    if ($5a5c8f99294101b7$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$5a5c8f99294101b7$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($5a5c8f99294101b7$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($5a5c8f99294101b7$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $5a5c8f99294101b7$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($5a5c8f99294101b7$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $b2e3b2b87fe02ae2$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $b2e3b2b87fe02ae2$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $b2e3b2b87fe02ae2$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $b2e3b2b87fe02ae2$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $b2e3b2b87fe02ae2$var$listSet = function(objects, key, value) {
    var node = $b2e3b2b87fe02ae2$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $b2e3b2b87fe02ae2$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$b2e3b2b87fe02ae2$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $b2e3b2b87fe02ae2$var$listDelete = function(objects, key) {
    if (objects) return $b2e3b2b87fe02ae2$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $b2e3b2b87fe02ae2$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $b2e3b2b87fe02ae2$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $b2e3b2b87fe02ae2$var$listGet($o, key);
        },
        has: function(key) {
            return $b2e3b2b87fe02ae2$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $b2e3b2b87fe02ae2$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $922130af2738a625$exports = {};
'use strict';
var $0b745c80c77d8e6b$exports = {};
'use strict';
var $0b745c80c77d8e6b$var$undefined1;
var $ac5b0a5601f4c0cd$exports = {};
'use strict';
/** @type {import('.')} */ $ac5b0a5601f4c0cd$exports = Object;


var $0debf84a8674c2b5$exports = {};
'use strict';
/** @type {import('.')} */ $0debf84a8674c2b5$exports = Error;


var $d9bcd1a4482ed329$exports = {};
'use strict';
/** @type {import('./eval')} */ $d9bcd1a4482ed329$exports = EvalError;


var $887f1160f223563d$exports = {};
'use strict';
/** @type {import('./range')} */ $887f1160f223563d$exports = RangeError;


var $f64d5910103eef78$exports = {};
'use strict';
/** @type {import('./ref')} */ $f64d5910103eef78$exports = ReferenceError;


var $a54d1f36caabb804$exports = {};
'use strict';
/** @type {import('./syntax')} */ $a54d1f36caabb804$exports = SyntaxError;



var $a45c49983ff6c180$exports = {};
'use strict';
/** @type {import('./uri')} */ $a45c49983ff6c180$exports = URIError;


var $ad19e3ed054e8a02$exports = {};
'use strict';
/** @type {import('./abs')} */ $ad19e3ed054e8a02$exports = Math.abs;


var $f0008ae10e682802$exports = {};
'use strict';
/** @type {import('./floor')} */ $f0008ae10e682802$exports = Math.floor;


var $034dfa09ee158379$exports = {};
'use strict';
/** @type {import('./max')} */ $034dfa09ee158379$exports = Math.max;


var $e153ab56521b305a$exports = {};
'use strict';
/** @type {import('./min')} */ $e153ab56521b305a$exports = Math.min;


var $60f095b063f4bba1$exports = {};
'use strict';
/** @type {import('./pow')} */ $60f095b063f4bba1$exports = Math.pow;


var $eb90eb06fbfc2f13$exports = {};
'use strict';
/** @type {import('./round')} */ $eb90eb06fbfc2f13$exports = Math.round;


var $7a151147b84c6e6f$exports = {};
'use strict';
var $c82891fcd82c7915$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $c82891fcd82c7915$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $7a151147b84c6e6f$exports = function sign(number) {
    if ($c82891fcd82c7915$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $0b745c80c77d8e6b$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $0b745c80c77d8e6b$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $0b745c80c77d8e6b$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $2e199f77a4ceed31$exports = {};
'use strict';
var $c120240b3d2ae687$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $c120240b3d2ae687$exports = Object.getOwnPropertyDescriptor;


var $2e199f77a4ceed31$require$$gOPD = $c120240b3d2ae687$exports;
if ($2e199f77a4ceed31$require$$gOPD) try {
    $2e199f77a4ceed31$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $2e199f77a4ceed31$require$$gOPD = null;
}
$2e199f77a4ceed31$exports = $2e199f77a4ceed31$require$$gOPD;


var $ac5fdaf5b4392c78$exports = {};
'use strict';
/** @type {import('.')} */ var $ac5fdaf5b4392c78$var$$defineProperty = Object.defineProperty || false;
if ($ac5fdaf5b4392c78$var$$defineProperty) try {
    $ac5fdaf5b4392c78$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $ac5fdaf5b4392c78$var$$defineProperty = false;
}
$ac5fdaf5b4392c78$exports = $ac5fdaf5b4392c78$var$$defineProperty;


var $0b745c80c77d8e6b$var$throwTypeError = function() {
    throw new $6e764c828aee0516$exports();
};
var $0b745c80c77d8e6b$var$ThrowTypeError = $2e199f77a4ceed31$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $0b745c80c77d8e6b$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $2e199f77a4ceed31$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $0b745c80c77d8e6b$var$throwTypeError;
        }
    }
}() : $0b745c80c77d8e6b$var$throwTypeError;

var $0b745c80c77d8e6b$var$hasSymbols = (parcelRequire("734S0"))();
var $969672b68895c563$exports = {};
'use strict';
var $e6e904cbcb179c37$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $e6e904cbcb179c37$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $639d49df9cf20e24$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $639d49df9cf20e24$exports = $ac5b0a5601f4c0cd$exports.getPrototypeOf || null;


var $7aaa8f03afc71c5f$exports = {};
'use strict';
var $a96fc22b83cedf2c$exports = {};
'use strict';
var $b12e07b877244af1$exports = {};
'use strict';
var $26b45d95c3de106a$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $26b45d95c3de106a$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $26b45d95c3de106a$var$toStr = Object.prototype.toString;
var $26b45d95c3de106a$var$max = Math.max;
var $26b45d95c3de106a$var$funcType = '[object Function]';
var $26b45d95c3de106a$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $26b45d95c3de106a$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $26b45d95c3de106a$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$26b45d95c3de106a$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $26b45d95c3de106a$var$toStr.apply(target) !== $26b45d95c3de106a$var$funcType) throw new TypeError($26b45d95c3de106a$var$ERROR_MESSAGE + target);
    var args = $26b45d95c3de106a$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $26b45d95c3de106a$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $26b45d95c3de106a$var$concatty(args, arguments));
    };
    var boundLength = $26b45d95c3de106a$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $26b45d95c3de106a$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$b12e07b877244af1$exports = Function.prototype.bind || $26b45d95c3de106a$exports;



var $2d03435b98fc89d8$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $2d03435b98fc89d8$exports = Function.prototype.call;


var $b535588daec7a79a$exports = {};
'use strict';

var $89e36fd9aff82ddc$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $89e36fd9aff82ddc$exports = Function.prototype.apply;



var $5abdc7423a63813e$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $5abdc7423a63813e$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $b535588daec7a79a$exports = $5abdc7423a63813e$exports || $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, $89e36fd9aff82ddc$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $a96fc22b83cedf2c$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $6e764c828aee0516$exports('a function is required');
    return $b535588daec7a79a$exports($b12e07b877244af1$exports, $2d03435b98fc89d8$exports, args);
};



var $7aaa8f03afc71c5f$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $7aaa8f03afc71c5f$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $7aaa8f03afc71c5f$var$desc = !!$7aaa8f03afc71c5f$var$hasProtoAccessor && $2e199f77a4ceed31$exports && $2e199f77a4ceed31$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $7aaa8f03afc71c5f$var$$Object = Object;
var $7aaa8f03afc71c5f$var$$getPrototypeOf = $7aaa8f03afc71c5f$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $7aaa8f03afc71c5f$exports = $7aaa8f03afc71c5f$var$desc && typeof $7aaa8f03afc71c5f$var$desc.get === 'function' ? $a96fc22b83cedf2c$exports([
    $7aaa8f03afc71c5f$var$desc.get
]) : typeof $7aaa8f03afc71c5f$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $7aaa8f03afc71c5f$var$$getPrototypeOf(value == null ? value : $7aaa8f03afc71c5f$var$$Object(value));
} : false;


/** @type {import('.')} */ $969672b68895c563$exports = $e6e904cbcb179c37$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $e6e904cbcb179c37$exports(O);
} : $639d49df9cf20e24$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $639d49df9cf20e24$exports(O);
} : $7aaa8f03afc71c5f$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7aaa8f03afc71c5f$exports(O);
} : null;






var $0b745c80c77d8e6b$var$needsEval = {};
var $0b745c80c77d8e6b$var$TypedArray = typeof Uint8Array === 'undefined' || !$969672b68895c563$exports ? undefined : $969672b68895c563$exports(Uint8Array);
var $0b745c80c77d8e6b$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $0b745c80c77d8e6b$var$hasSymbols && $969672b68895c563$exports ? $969672b68895c563$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $0b745c80c77d8e6b$var$needsEval,
    '%AsyncGenerator%': $0b745c80c77d8e6b$var$needsEval,
    '%AsyncGeneratorFunction%': $0b745c80c77d8e6b$var$needsEval,
    '%AsyncIteratorPrototype%': $0b745c80c77d8e6b$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $0debf84a8674c2b5$exports,
    '%eval%': eval,
    '%EvalError%': $d9bcd1a4482ed329$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $0b745c80c77d8e6b$var$$Function,
    '%GeneratorFunction%': $0b745c80c77d8e6b$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $0b745c80c77d8e6b$var$hasSymbols && $969672b68895c563$exports ? $969672b68895c563$exports($969672b68895c563$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$0b745c80c77d8e6b$var$hasSymbols || !$969672b68895c563$exports ? undefined : $969672b68895c563$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $ac5b0a5601f4c0cd$exports,
    '%Object.getOwnPropertyDescriptor%': $2e199f77a4ceed31$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $887f1160f223563d$exports,
    '%ReferenceError%': $f64d5910103eef78$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$0b745c80c77d8e6b$var$hasSymbols || !$969672b68895c563$exports ? undefined : $969672b68895c563$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $0b745c80c77d8e6b$var$hasSymbols && $969672b68895c563$exports ? $969672b68895c563$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $0b745c80c77d8e6b$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $a54d1f36caabb804$exports,
    '%ThrowTypeError%': $0b745c80c77d8e6b$var$ThrowTypeError,
    '%TypedArray%': $0b745c80c77d8e6b$var$TypedArray,
    '%TypeError%': $6e764c828aee0516$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $a45c49983ff6c180$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $2d03435b98fc89d8$exports,
    '%Function.prototype.apply%': $89e36fd9aff82ddc$exports,
    '%Object.defineProperty%': $ac5fdaf5b4392c78$exports,
    '%Object.getPrototypeOf%': $639d49df9cf20e24$exports,
    '%Math.abs%': $ad19e3ed054e8a02$exports,
    '%Math.floor%': $f0008ae10e682802$exports,
    '%Math.max%': $034dfa09ee158379$exports,
    '%Math.min%': $e153ab56521b305a$exports,
    '%Math.pow%': $60f095b063f4bba1$exports,
    '%Math.round%': $eb90eb06fbfc2f13$exports,
    '%Math.sign%': $7a151147b84c6e6f$exports,
    '%Reflect.getPrototypeOf%': $e6e904cbcb179c37$exports
};
if ($969672b68895c563$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $0b745c80c77d8e6b$var$errorProto = $969672b68895c563$exports($969672b68895c563$exports(e));
    $0b745c80c77d8e6b$var$INTRINSICS['%Error.prototype%'] = $0b745c80c77d8e6b$var$errorProto;
}
var $0b745c80c77d8e6b$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $0b745c80c77d8e6b$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $0b745c80c77d8e6b$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $0b745c80c77d8e6b$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $969672b68895c563$exports) value = $969672b68895c563$exports(gen.prototype);
    }
    $0b745c80c77d8e6b$var$INTRINSICS[name] = value;
    return value;
};
var $0b745c80c77d8e6b$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $97681721aaad2266$exports = {};
'use strict';
var $97681721aaad2266$var$call = Function.prototype.call;
var $97681721aaad2266$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $97681721aaad2266$exports = $b12e07b877244af1$exports.call($97681721aaad2266$var$call, $97681721aaad2266$var$$hasOwn);


var $0b745c80c77d8e6b$var$$concat = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, Array.prototype.concat);
var $0b745c80c77d8e6b$var$$spliceApply = $b12e07b877244af1$exports.call($89e36fd9aff82ddc$exports, Array.prototype.splice);
var $0b745c80c77d8e6b$var$$replace = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, String.prototype.replace);
var $0b745c80c77d8e6b$var$$strSlice = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, String.prototype.slice);
var $0b745c80c77d8e6b$var$$exec = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $0b745c80c77d8e6b$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $0b745c80c77d8e6b$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $0b745c80c77d8e6b$var$stringToPath = function stringToPath(string) {
    var first = $0b745c80c77d8e6b$var$$strSlice(string, 0, 1);
    var last = $0b745c80c77d8e6b$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $a54d1f36caabb804$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $a54d1f36caabb804$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $0b745c80c77d8e6b$var$$replace(string, $0b745c80c77d8e6b$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $0b745c80c77d8e6b$var$$replace(subString, $0b745c80c77d8e6b$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $0b745c80c77d8e6b$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($97681721aaad2266$exports($0b745c80c77d8e6b$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $0b745c80c77d8e6b$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($97681721aaad2266$exports($0b745c80c77d8e6b$var$INTRINSICS, intrinsicName)) {
        var value = $0b745c80c77d8e6b$var$INTRINSICS[intrinsicName];
        if (value === $0b745c80c77d8e6b$var$needsEval) value = $0b745c80c77d8e6b$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $6e764c828aee0516$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $a54d1f36caabb804$exports('intrinsic ' + name + ' does not exist!');
};
$0b745c80c77d8e6b$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $6e764c828aee0516$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $6e764c828aee0516$exports('"allowMissing" argument must be a boolean');
    if ($0b745c80c77d8e6b$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $a54d1f36caabb804$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $0b745c80c77d8e6b$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $0b745c80c77d8e6b$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $0b745c80c77d8e6b$var$$spliceApply(parts, $0b745c80c77d8e6b$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $0b745c80c77d8e6b$var$$strSlice(part, 0, 1);
        var last = $0b745c80c77d8e6b$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $a54d1f36caabb804$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($97681721aaad2266$exports($0b745c80c77d8e6b$var$INTRINSICS, intrinsicRealName)) value = $0b745c80c77d8e6b$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $6e764c828aee0516$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($2e199f77a4ceed31$exports && i + 1 >= parts.length) {
                var desc = $2e199f77a4ceed31$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $97681721aaad2266$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $0b745c80c77d8e6b$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $ef2ba1ff0782643c$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $ef2ba1ff0782643c$var$$indexOf = $a96fc22b83cedf2c$exports([
    $0b745c80c77d8e6b$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $ef2ba1ff0782643c$exports = function callBoundIntrinsic(name, allowMissing) {
    // eslint-disable-next-line no-extra-parens
    var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ $0b745c80c77d8e6b$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $ef2ba1ff0782643c$var$$indexOf(name, '.prototype.') > -1) return $a96fc22b83cedf2c$exports([
        intrinsic
    ]);
    return intrinsic;
};




var $922130af2738a625$var$$Map = $0b745c80c77d8e6b$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $922130af2738a625$var$$mapGet = $ef2ba1ff0782643c$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $922130af2738a625$var$$mapSet = $ef2ba1ff0782643c$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $922130af2738a625$var$$mapHas = $ef2ba1ff0782643c$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $922130af2738a625$var$$mapDelete = $ef2ba1ff0782643c$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $922130af2738a625$var$$mapSize = $ef2ba1ff0782643c$exports('Map.prototype.size', true);
/** @type {import('.')} */ $922130af2738a625$exports = !!$922130af2738a625$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $922130af2738a625$var$$mapDelete($m, key);
                if ($922130af2738a625$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $922130af2738a625$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $922130af2738a625$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $922130af2738a625$var$$Map();
            $922130af2738a625$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $01e06040bfaa583d$exports = {};
'use strict';





var $01e06040bfaa583d$var$$WeakMap = $0b745c80c77d8e6b$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $01e06040bfaa583d$var$$weakMapGet = $ef2ba1ff0782643c$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $01e06040bfaa583d$var$$weakMapSet = $ef2ba1ff0782643c$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $01e06040bfaa583d$var$$weakMapHas = $ef2ba1ff0782643c$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $01e06040bfaa583d$var$$weakMapDelete = $ef2ba1ff0782643c$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $01e06040bfaa583d$exports = $01e06040bfaa583d$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $01e06040bfaa583d$var$$weakMapDelete($wm, key);
            } else if ($922130af2738a625$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $01e06040bfaa583d$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $01e06040bfaa583d$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $01e06040bfaa583d$var$$WeakMap();
                $01e06040bfaa583d$var$$weakMapSet($wm, key, value);
            } else if ($922130af2738a625$exports) {
                if (!$m) $m = $922130af2738a625$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $922130af2738a625$exports;


var $41979e9c210b0e24$var$makeChannel = $01e06040bfaa583d$exports || $922130af2738a625$exports || $b2e3b2b87fe02ae2$exports;
/** @type {import('.')} */ $41979e9c210b0e24$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $41979e9c210b0e24$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $e2d71df10770edb6$exports = {};
'use strict';
var $0895067d86be0ed7$exports = {};
'use strict';
var $0895067d86be0ed7$var$replace = String.prototype.replace;
var $0895067d86be0ed7$var$percentTwenties = /%20/g;
var $0895067d86be0ed7$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$0895067d86be0ed7$exports = {
    'default': $0895067d86be0ed7$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $0895067d86be0ed7$var$replace.call(value, $0895067d86be0ed7$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $0895067d86be0ed7$var$Format.RFC1738,
    RFC3986: $0895067d86be0ed7$var$Format.RFC3986
};


var $e2d71df10770edb6$var$has = Object.prototype.hasOwnProperty;
var $e2d71df10770edb6$var$isArray = Array.isArray;
var $e2d71df10770edb6$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $e2d71df10770edb6$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($e2d71df10770edb6$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $e2d71df10770edb6$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $e2d71df10770edb6$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($e2d71df10770edb6$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$e2d71df10770edb6$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($e2d71df10770edb6$var$isArray(target) && !$e2d71df10770edb6$var$isArray(source)) mergeTarget = $e2d71df10770edb6$var$arrayToObject(target, options);
    if ($e2d71df10770edb6$var$isArray(target) && $e2d71df10770edb6$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($e2d71df10770edb6$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($e2d71df10770edb6$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $e2d71df10770edb6$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $e2d71df10770edb6$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $e2d71df10770edb6$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $e2d71df10770edb6$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $e2d71df10770edb6$var$limit){
        var segment = string.length >= $e2d71df10770edb6$var$limit ? string.slice(j, j + $e2d71df10770edb6$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $0895067d86be0ed7$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xC0 | c >> 6] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xE0 | c >> 12] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 6 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xF0 | c >> 18] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 12 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 6 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $e2d71df10770edb6$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $e2d71df10770edb6$var$compactQueue(queue);
    return value;
};
var $e2d71df10770edb6$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $e2d71df10770edb6$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $e2d71df10770edb6$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $e2d71df10770edb6$var$maybeMap = function maybeMap(val, fn) {
    if ($e2d71df10770edb6$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$e2d71df10770edb6$exports = {
    arrayToObject: $e2d71df10770edb6$var$arrayToObject,
    assign: $e2d71df10770edb6$var$assign,
    combine: $e2d71df10770edb6$var$combine,
    compact: $e2d71df10770edb6$var$compact,
    decode: $e2d71df10770edb6$var$decode,
    encode: $e2d71df10770edb6$var$encode,
    isBuffer: $e2d71df10770edb6$var$isBuffer,
    isRegExp: $e2d71df10770edb6$var$isRegExp,
    maybeMap: $e2d71df10770edb6$var$maybeMap,
    merge: $e2d71df10770edb6$var$merge
};



var $79acdf0dd8ee88cb$var$has = Object.prototype.hasOwnProperty;
var $79acdf0dd8ee88cb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $79acdf0dd8ee88cb$var$isArray = Array.isArray;
var $79acdf0dd8ee88cb$var$push = Array.prototype.push;
var $79acdf0dd8ee88cb$var$pushToArray = function(arr, valueOrArray) {
    $79acdf0dd8ee88cb$var$push.apply(arr, $79acdf0dd8ee88cb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $79acdf0dd8ee88cb$var$toISO = Date.prototype.toISOString;
var $79acdf0dd8ee88cb$var$defaultFormat = $0895067d86be0ed7$exports.default;
var $79acdf0dd8ee88cb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $e2d71df10770edb6$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $79acdf0dd8ee88cb$var$defaultFormat,
    formatter: $0895067d86be0ed7$exports.formatters[$79acdf0dd8ee88cb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $79acdf0dd8ee88cb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $79acdf0dd8ee88cb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $79acdf0dd8ee88cb$var$sentinel = {};
var $79acdf0dd8ee88cb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($79acdf0dd8ee88cb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($79acdf0dd8ee88cb$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $79acdf0dd8ee88cb$var$isArray(obj)) obj = $e2d71df10770edb6$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $79acdf0dd8ee88cb$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($79acdf0dd8ee88cb$var$isNonNullishPrimitive(obj) || $e2d71df10770edb6$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $79acdf0dd8ee88cb$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $79acdf0dd8ee88cb$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $79acdf0dd8ee88cb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $e2d71df10770edb6$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($79acdf0dd8ee88cb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $79acdf0dd8ee88cb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $79acdf0dd8ee88cb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $79acdf0dd8ee88cb$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $41979e9c210b0e24$exports();
        valueSideChannel.set($79acdf0dd8ee88cb$var$sentinel, sideChannel);
        $79acdf0dd8ee88cb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $79acdf0dd8ee88cb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $79acdf0dd8ee88cb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $79acdf0dd8ee88cb$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $79acdf0dd8ee88cb$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $0895067d86be0ed7$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$79acdf0dd8ee88cb$var$has.call($0895067d86be0ed7$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $0895067d86be0ed7$exports.formatters[format];
    var filter = $79acdf0dd8ee88cb$var$defaults.filter;
    if (typeof opts.filter === 'function' || $79acdf0dd8ee88cb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $79acdf0dd8ee88cb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $79acdf0dd8ee88cb$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $79acdf0dd8ee88cb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $79acdf0dd8ee88cb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $79acdf0dd8ee88cb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $79acdf0dd8ee88cb$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $79acdf0dd8ee88cb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $79acdf0dd8ee88cb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $79acdf0dd8ee88cb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $79acdf0dd8ee88cb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $79acdf0dd8ee88cb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $79acdf0dd8ee88cb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $79acdf0dd8ee88cb$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $79acdf0dd8ee88cb$var$defaults.strictNullHandling
    };
};
$79acdf0dd8ee88cb$exports = function(object, opts) {
    var obj = object;
    var options = $79acdf0dd8ee88cb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($79acdf0dd8ee88cb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $79acdf0dd8ee88cb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $41979e9c210b0e24$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $79acdf0dd8ee88cb$var$pushToArray(keys, $79acdf0dd8ee88cb$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $bad802c248311354$exports = {};
'use strict';

var $bad802c248311354$var$has = Object.prototype.hasOwnProperty;
var $bad802c248311354$var$isArray = Array.isArray;
var $bad802c248311354$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $e2d71df10770edb6$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $bad802c248311354$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $bad802c248311354$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $bad802c248311354$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $bad802c248311354$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $bad802c248311354$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $bad802c248311354$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $bad802c248311354$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $bad802c248311354$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $bad802c248311354$var$defaults.decoder, charset, 'key');
            val = $e2d71df10770edb6$exports.maybeMap($bad802c248311354$var$parseArrayValue(part.slice(pos + 1), options, $bad802c248311354$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $bad802c248311354$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $bad802c248311354$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $bad802c248311354$var$isArray(val) ? [
            val
        ] : val;
        var existing = $bad802c248311354$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $e2d71df10770edb6$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $bad802c248311354$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $bad802c248311354$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $e2d71df10770edb6$exports.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $bad802c248311354$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $bad802c248311354$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $bad802c248311354$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $bad802c248311354$var$parseObject(keys, val, options, valuesParsed);
};
var $bad802c248311354$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $bad802c248311354$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $bad802c248311354$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $bad802c248311354$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $bad802c248311354$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $bad802c248311354$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $bad802c248311354$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $bad802c248311354$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $bad802c248311354$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $bad802c248311354$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $bad802c248311354$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $bad802c248311354$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $bad802c248311354$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $e2d71df10770edb6$exports.isRegExp(opts.delimiter) ? opts.delimiter : $bad802c248311354$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $bad802c248311354$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $bad802c248311354$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $bad802c248311354$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $bad802c248311354$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $bad802c248311354$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $bad802c248311354$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$bad802c248311354$exports = function(str, opts) {
    var options = $bad802c248311354$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $bad802c248311354$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $bad802c248311354$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $e2d71df10770edb6$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $e2d71df10770edb6$exports.compact(obj);
};



$6e19be61753cbc35$exports = {
    formats: $0895067d86be0ed7$exports,
    parse: $bad802c248311354$exports,
    stringify: $79acdf0dd8ee88cb$exports
};


// Matches 'sub.host:port' or 'host:port' and extracts hostname and port
// Also enforces toplevel domain specified, no spaces and no protocol
const $704d3018a628a806$var$HOST_REGEX = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
function $704d3018a628a806$export$2e2bcd8739ae039(options) {
    const defaultConfig = {
        insecure: false,
        retryOnError: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logHandler: (level, data)=>{
            if (level === 'error' && data) {
                const title = [
                    data.name,
                    data.message
                ].filter((a)=>a).join(' - ');
                console.error(`[error] ${title}`);
                console.error(data);
                return;
            }
            console.log(`[${level}] ${data}`);
        },
        // Passed to axios
        headers: {},
        httpAgent: false,
        httpsAgent: false,
        timeout: 30000,
        throttle: 0,
        basePath: '',
        adapter: undefined,
        maxContentLength: 1073741824,
        maxBodyLength: 1073741824
    };
    const config = {
        ...defaultConfig,
        ...options
    };
    if (!config.accessToken) {
        const missingAccessTokenError = new TypeError('Expected parameter accessToken');
        config.logHandler('error', missingAccessTokenError);
        throw missingAccessTokenError;
    }
    // Construct axios baseURL option
    const protocol = config.insecure ? 'http' : 'https';
    const space = config.space ? `${config.space}/` : '';
    let hostname = config.defaultHostname;
    let port = config.insecure ? 80 : 443;
    if (config.host && $704d3018a628a806$var$HOST_REGEX.test(config.host)) {
        const parsed = config.host.split(':');
        if (parsed.length === 2) [hostname, port] = parsed;
        else hostname = parsed[0];
    }
    // Ensure that basePath does start but not end with a slash
    if (config.basePath) config.basePath = `/${config.basePath.split('/').filter(Boolean).join('/')}`;
    const baseURL = options.baseURL || `${protocol}://${hostname}:${port}${config.basePath}/spaces/${space}`;
    if (!config.headers.Authorization && typeof config.accessToken !== 'function') config.headers.Authorization = 'Bearer ' + config.accessToken;
    const axiosOptions = {
        baseURL: // Axios
        baseURL,
        headers: config.headers,
        httpAgent: config.httpAgent,
        httpsAgent: config.httpsAgent,
        proxy: config.proxy,
        timeout: config.timeout,
        adapter: config.adapter,
        maxContentLength: config.maxContentLength,
        maxBodyLength: config.maxBodyLength,
        paramsSerializer: {
            serialize: (params)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($6e19be61753cbc35$exports))).stringify(params);
            }
        },
        // Contentful
        logHandler: config.logHandler,
        responseLogger: config.responseLogger,
        requestLogger: config.requestLogger,
        retryOnError: config.retryOnError
    };
    return axiosOptions;
}


function $6cbad996768a444b$var$copyHttpClientParams(options) {
    const copiedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($d7654884cc979ea3$exports)))(options);
    // httpAgent and httpsAgent cannot be copied because they can contain private fields
    copiedOptions.httpAgent = options.httpAgent;
    copiedOptions.httpsAgent = options.httpsAgent;
    return copiedOptions;
}
function $6cbad996768a444b$export$2e2bcd8739ae039(axios, options) {
    const axiosOptions = (0, $704d3018a628a806$export$2e2bcd8739ae039)(options);
    const instance = axios.create(axiosOptions);
    instance.httpClientParams = options;
    /**
     * Creates a new axios instance with the same default base parameters as the
     * current one, and with any overrides passed to the newParams object
     * This is useful as the SDKs use dependency injection to get the axios library
     * and the version of the library comes from different places depending
     * on whether it's a browser build or a node.js build.
     * @private
     * @param {CreateHttpClientParams} newParams - Initialization parameters for the HTTP client
     * @return {AxiosInstance} Initialized axios instance
     */ instance.cloneWithNewParams = function(newParams) {
        return $6cbad996768a444b$export$2e2bcd8739ae039(axios, {
            ...$6cbad996768a444b$var$copyHttpClientParams(options),
            ...newParams
        });
    };
    /**
     * Apply interceptors.
     * Please note that the order of interceptors is important
     */ if (options.onBeforeRequest) instance.interceptors.request.use(options.onBeforeRequest);
    if (typeof options.accessToken === 'function') (0, $0afe4f51006255f7$export$2e2bcd8739ae039)(instance, options.accessToken);
    if (options.throttle) (0, $a39f05bb5d8af405$export$2e2bcd8739ae039)(instance, options.throttle);
    (0, $21553a6a60179854$export$2e2bcd8739ae039)(instance, options.retryLimit);
    if (options.onError) instance.interceptors.response.use((response)=>response, options.onError);
    return instance;
}



function $1b583313d87ac2ed$export$2e2bcd8739ae039({ query: query }) {
    const config = {};
    delete query.resolveLinks;
    config.params = (0, (/*@__PURE__*/$parcel$interopDefault($d7654884cc979ea3$exports)))(query);
    return config;
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $80c4299622e8ede3$export$2e2bcd8739ae039(obj, path) {
    if (!(path in obj)) {
        const err = new Error();
        err.name = 'PropertyMissing';
        err.message = `Required property ${path} missing from:

${JSON.stringify(obj)}

`;
        throw err;
    }
    return true;
}


// copied from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
function $5f2658cac0f27b2d$var$deepFreeze(object) {
    const propNames = Object.getOwnPropertyNames(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === 'object') $5f2658cac0f27b2d$var$deepFreeze(value);
    }
    return Object.freeze(object);
}
function $5f2658cac0f27b2d$export$2e2bcd8739ae039(obj) {
    $5f2658cac0f27b2d$var$deepFreeze(obj.sys || {});
    return obj;
}



var $4kiXg = parcelRequire("4kiXg");

function $999138c164fc2759$var$getBrowserOS() {
    const win = (0, $6c4f1a5adeb9b79e$export$38b2d434cce3ea22)();
    if (!win) return null;
    const userAgent = win.navigator.userAgent;
    // TODO: platform is deprecated.
    const platform = win.navigator.platform;
    const macosPlatforms = [
        'Macintosh',
        'MacIntel',
        'MacPPC',
        'Mac68K'
    ];
    const windowsPlatforms = [
        'Win32',
        'Win64',
        'Windows',
        'WinCE'
    ];
    const iosPlatforms = [
        'iPhone',
        'iPad',
        'iPod'
    ];
    if (macosPlatforms.indexOf(platform) !== -1) return 'macOS';
    else if (iosPlatforms.indexOf(platform) !== -1) return 'iOS';
    else if (windowsPlatforms.indexOf(platform) !== -1) return 'Windows';
    else if (/Android/.test(userAgent)) return 'Android';
    else if (/Linux/.test(platform)) return 'Linux';
    return null;
}
function $999138c164fc2759$var$getNodeOS() {
    const platform = (0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))).platform || 'linux';
    const version = (0, (/*@__PURE__*/$parcel$interopDefault($4kiXg))).version || '0.0.0';
    const platformMap = {
        android: 'Android',
        aix: 'Linux',
        darwin: 'macOS',
        freebsd: 'Linux',
        linux: 'Linux',
        openbsd: 'Linux',
        sunos: 'Linux',
        win32: 'Windows'
    };
    if (platform in platformMap) return `${platformMap[platform] || 'Linux'}/${version}`;
    return null;
}
function $999138c164fc2759$export$2e2bcd8739ae039(sdk, application, integration, feature) {
    const headerParts = [];
    if (application) headerParts.push(`app ${application}`);
    if (integration) headerParts.push(`integration ${integration}`);
    if (feature) headerParts.push('feature ' + feature);
    headerParts.push(`sdk ${sdk}`);
    let platform = null;
    try {
        if ((0, $6c4f1a5adeb9b79e$export$f7a1e23e542d38e3)()) {
            platform = $999138c164fc2759$var$getBrowserOS();
            headerParts.push('platform ReactNative');
        } else if ((0, $6c4f1a5adeb9b79e$export$8ee0fc9ee280b4ee)()) {
            platform = $999138c164fc2759$var$getNodeOS();
            headerParts.push(`platform node.js/${(0, $6c4f1a5adeb9b79e$export$bf2c6630ab904918)()}`);
        } else {
            platform = $999138c164fc2759$var$getBrowserOS();
            headerParts.push('platform browser');
        }
    } catch (e) {
        platform = null;
    }
    if (platform) headerParts.push(`os ${platform}`);
    return `${headerParts.filter((item)=>item !== '').join('; ')};`;
}



function $3fdb165b3001cf99$export$2e2bcd8739ae039(data) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return Object.defineProperty(data, 'toPlainObject', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($d7654884cc979ea3$exports)))(this);
        }
    });
}


var $0bdb4d038b50c719$exports = {};

var $10dedc12a6dba32b$exports = {};
var $69c75421474b4be5$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $69c75421474b4be5$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$69c75421474b4be5$exports = $69c75421474b4be5$var$overArg;


/** Built-in value references. */ var $10dedc12a6dba32b$var$getPrototype = $69c75421474b4be5$exports(Object.getPrototypeOf, Object);
$10dedc12a6dba32b$exports = $10dedc12a6dba32b$var$getPrototype;



/** `Object#toString` result references. */ var $0bdb4d038b50c719$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0bdb4d038b50c719$var$funcProto = Function.prototype, $0bdb4d038b50c719$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0bdb4d038b50c719$var$funcToString = $0bdb4d038b50c719$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0bdb4d038b50c719$var$hasOwnProperty = $0bdb4d038b50c719$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0bdb4d038b50c719$var$objectCtorString = $0bdb4d038b50c719$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0bdb4d038b50c719$var$isPlainObject(value) {
    if (!$33440307203792f1$exports(value) || $e12df5b696fff3d1$exports(value) != $0bdb4d038b50c719$var$objectTag) return false;
    var proto = $10dedc12a6dba32b$exports(value);
    if (proto === null) return true;
    var Ctor = $0bdb4d038b50c719$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0bdb4d038b50c719$var$funcToString.call(Ctor) == $0bdb4d038b50c719$var$objectCtorString;
}
$0bdb4d038b50c719$exports = $0bdb4d038b50c719$var$isPlainObject;


function $5bacf07a5d1999ab$export$2e2bcd8739ae039(errorResponse) {
    const { config: config, response: response } = errorResponse;
    let errorName;
    // Obscure the Management token
    if (config && config.headers && config.headers['Authorization']) {
        const token = `...${config.headers['Authorization'].toString().substr(-5)}`;
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0bdb4d038b50c719$exports)))(response) || !(0, (/*@__PURE__*/$parcel$interopDefault($0bdb4d038b50c719$exports)))(config)) throw errorResponse;
    const data = response?.data;
    const errorData = {
        status: response?.status,
        statusText: response?.statusText,
        message: '',
        details: {}
    };
    if (config && (0, (/*@__PURE__*/$parcel$interopDefault($0bdb4d038b50c719$exports)))(config)) errorData.request = {
        url: config.url,
        headers: config.headers,
        method: config.method,
        payloadData: config.data
    };
    if (data && typeof data === 'object') {
        if ('requestId' in data) errorData.requestId = data.requestId || 'UNKNOWN';
        if ('message' in data) errorData.message = data.message || '';
        if ('details' in data) errorData.details = data.details || {};
        errorName = data.sys?.id;
    }
    const error = new Error();
    error.name = errorName && errorName !== 'Unknown' ? errorName : `${response?.status} ${response?.statusText}`;
    try {
        error.message = JSON.stringify(errorData, null, '  ');
    } catch  {
        error.message = errorData?.message ?? '';
    }
    throw error;
}





/**
 * @param globalSettings - Global library settings
 * @returns getGlobalSettings - Method returning client settings
 * @category Client
 */ function $5f8199cd2f1b34bc$export$6ba8541dd7703421(globalSettings) {
    /**
     * Method merging pre-configured global options and provided local parameters
     * @param query - regular query object used for collection endpoints
     * @param query.environment - optional name of the environment
     * @param query.space - optional space ID
     * @param query.spaceBaseUrl - optional base URL for the space
     * @param query.environmentBaseUrl - optional base URL for the environment
     * @returns global options
     */ return function getGlobalOptions(query) {
        return Object.assign({}, globalSettings, query);
    };
}


var $8ac322cb35ca3943$var$W = {
    0: 8203,
    1: 8204,
    2: 8205,
    3: 8290,
    4: 8291,
    5: 8288,
    6: 65279,
    7: 8289,
    8: 119155,
    9: 119156,
    a: 119157,
    b: 119158,
    c: 119159,
    d: 119160,
    e: 119161,
    f: 119162
}, $8ac322cb35ca3943$var$L = {
    0: 8203,
    1: 8204,
    2: 8205,
    3: 65279
}, $8ac322cb35ca3943$var$j = new Array(4).fill(String.fromCodePoint($8ac322cb35ca3943$var$L[0])).join(""), $8ac322cb35ca3943$var$V = "\0";
function $8ac322cb35ca3943$var$U(t) {
    let n = JSON.stringify(t);
    return `${$8ac322cb35ca3943$var$j}${Array.from(n).map((o)=>{
        let e = o.charCodeAt(0);
        if (e > 255) throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${n} on character ${o} (${e})`);
        return Array.from(e.toString(4).padStart(4, "0")).map((r)=>String.fromCodePoint($8ac322cb35ca3943$var$L[r])).join("");
    }).join("")}`;
}
function $8ac322cb35ca3943$var$Z(t) {
    return !Number.isNaN(Number(t)) || /[a-z]/i.test(t) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(t) ? !1 : !!Date.parse(t);
}
function $8ac322cb35ca3943$var$q(t) {
    try {
        new URL(t, t.startsWith("/") ? "https://acme.com" : void 0);
    } catch (n) {
        return !1;
    }
    return !0;
}
function $8ac322cb35ca3943$var$G(t, n, o = "auto") {
    return o === !0 || o === "auto" && ($8ac322cb35ca3943$var$Z(t) || $8ac322cb35ca3943$var$q(t)) ? t : `${t}${$8ac322cb35ca3943$var$U(n)}`;
}
var $8ac322cb35ca3943$var$H = Object.fromEntries(Object.entries($8ac322cb35ca3943$var$L).map((t)=>t.reverse())), $8ac322cb35ca3943$var$F = Object.fromEntries(Object.entries($8ac322cb35ca3943$var$W).map((t)=>t.reverse())), $8ac322cb35ca3943$var$K = `${Object.values($8ac322cb35ca3943$var$W).map((t)=>`\\u{${t.toString(16)}}`).join("")}`, $8ac322cb35ca3943$var$O = new RegExp(`[${$8ac322cb35ca3943$var$K}]{4,}`, "gu");
function $8ac322cb35ca3943$var$X(t) {
    let n = t.match($8ac322cb35ca3943$var$O);
    if (n) return $8ac322cb35ca3943$var$Y(n[0], !0)[0];
}
function $8ac322cb35ca3943$var$Y(t, n = !1) {
    let o = Array.from(t);
    if (o.length % 2 === 0) {
        if (o.length % 4 || !t.startsWith($8ac322cb35ca3943$var$j)) return $8ac322cb35ca3943$var$ee(o, n);
    } else throw new Error("Encoded data has invalid length");
    let e = [];
    for(let r = o.length * 0.25; r--;){
        let s = o.slice(r * 4, r * 4 + 4).map((c)=>$8ac322cb35ca3943$var$H[c.codePointAt(0)]).join("");
        e.unshift(String.fromCharCode(parseInt(s, 4)));
    }
    if (n) {
        e.shift();
        let r = e.indexOf($8ac322cb35ca3943$var$V);
        return r === -1 && (r = e.length), [
            JSON.parse(e.slice(0, r).join(""))
        ];
    }
    return e.join("").split($8ac322cb35ca3943$var$V).filter(Boolean).map((r)=>JSON.parse(r));
}
function $8ac322cb35ca3943$var$ee(t, n) {
    var o;
    let e = [];
    for(let i = t.length * 0.5; i--;){
        let u = `${$8ac322cb35ca3943$var$F[t[i * 2].codePointAt(0)]}${$8ac322cb35ca3943$var$F[t[i * 2 + 1].codePointAt(0)]}`;
        e.unshift(String.fromCharCode(parseInt(u, 16)));
    }
    let r = [], s = [
        e.join("")
    ], c = 10;
    for(; s.length;){
        let i = s.shift();
        try {
            if (r.push(JSON.parse(i)), n) return r;
        } catch (u) {
            if (!c--) throw u;
            let a = +((o = u.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : o[1]);
            if (!a) throw u;
            s.unshift(i.substring(0, a), i.substring(a));
        }
    }
    return r;
}
function $8ac322cb35ca3943$var$te(t) {
    var n;
    return {
        cleaned: t.replace($8ac322cb35ca3943$var$O, ""),
        encoded: ((n = t.match($8ac322cb35ca3943$var$O)) == null ? void 0 : n[0]) || ""
    };
}
function $8ac322cb35ca3943$export$1be1fc439b849fdf(t, n) {
    return $8ac322cb35ca3943$var$G(t, n);
}
function $8ac322cb35ca3943$export$c564cdbbe6da493(t) {
    return $8ac322cb35ca3943$var$U(t);
}
function $8ac322cb35ca3943$export$2f872c0f2117be69(t) {
    return $8ac322cb35ca3943$var$X(t);
}
function $8ac322cb35ca3943$export$637dffca72c4ae9d(t) {
    return $8ac322cb35ca3943$var$te(t);
}
var $8ac322cb35ca3943$var$x, $8ac322cb35ca3943$var$k;
function $8ac322cb35ca3943$var$ne() {
    if ($8ac322cb35ca3943$var$k) return $8ac322cb35ca3943$var$x;
    $8ac322cb35ca3943$var$k = 1;
    var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
    return $8ac322cb35ca3943$var$x = function(e, r, s) {
        if (n.call(r) !== "[object Function]") throw new TypeError("iterator must be a function");
        var c = e.length;
        if (c === +c) for(var i = 0; i < c; i++)r.call(s, e[i], i, e);
        else for(var u in e)t.call(e, u) && r.call(s, e[u], u, e);
    }, $8ac322cb35ca3943$var$x;
}
var $8ac322cb35ca3943$var$I, $8ac322cb35ca3943$var$_;
function $8ac322cb35ca3943$var$re() {
    if ($8ac322cb35ca3943$var$_) return $8ac322cb35ca3943$var$I;
    $8ac322cb35ca3943$var$_ = 1;
    var t = $8ac322cb35ca3943$var$ne();
    $8ac322cb35ca3943$var$I = n;
    function n(o, e, r) {
        if (arguments.length === 3) return n.set(o, e, r);
        if (arguments.length === 2) return n.get(o, e);
        var s = n.bind(n, o);
        for(var c in n)n.hasOwnProperty(c) && (s[c] = n[c].bind(s, o));
        return s;
    }
    return n.get = function(e, r) {
        for(var s = Array.isArray(r) ? r : n.parse(r), c = 0; c < s.length; ++c){
            var i = s[c];
            if (!(typeof e == "object" && i in e)) throw new Error("Invalid reference token: " + i);
            e = e[i];
        }
        return e;
    }, n.set = function(e, r, s) {
        var c = Array.isArray(r) ? r : n.parse(r), i = c[0];
        if (c.length === 0) throw Error("Can not set the root object");
        for(var u = 0; u < c.length - 1; ++u){
            var a = c[u];
            typeof a != "string" && typeof a != "number" && (a = String(a)), !(a === "__proto__" || a === "constructor" || a === "prototype") && (a === "-" && Array.isArray(e) && (a = e.length), i = c[u + 1], a in e || (i.match(/^(\d+|-)$/) ? e[a] = [] : e[a] = {}), e = e[a]);
        }
        return i === "-" && Array.isArray(e) && (i = e.length), e[i] = s, this;
    }, n.remove = function(o, e) {
        var r = Array.isArray(e) ? e : n.parse(e), s = r[r.length - 1];
        if (s === void 0) throw new Error('Invalid JSON pointer for remove: "' + e + '"');
        var c = n.get(o, r.slice(0, -1));
        if (Array.isArray(c)) {
            var i = +s;
            if (s === "" && isNaN(i)) throw new Error('Invalid array index: "' + s + '"');
            Array.prototype.splice.call(c, i, 1);
        } else delete c[s];
    }, n.dict = function(e, r) {
        var s = {};
        return n.walk(e, function(c, i) {
            s[i] = c;
        }, r), s;
    }, n.walk = function(e, r, s) {
        var c = [];
        s = s || function(i) {
            var u = Object.prototype.toString.call(i);
            return u === "[object Object]" || u === "[object Array]";
        }, function i(u) {
            t(u, function(a, l) {
                c.push(String(l)), s(a) ? i(a) : r(a, n.compile(c)), c.pop();
            });
        }(e);
    }, n.has = function(e, r) {
        try {
            n.get(e, r);
        } catch (s) {
            return !1;
        }
        return !0;
    }, n.escape = function(e) {
        return e.toString().replace(/~/g, "~0").replace(/\//g, "~1");
    }, n.unescape = function(e) {
        return e.replace(/~1/g, "/").replace(/~0/g, "~");
    }, n.parse = function(e) {
        if (e === "") return [];
        if (e.charAt(0) !== "/") throw new Error("Invalid JSON pointer: " + e);
        return e.substring(1).split(/\//).map(n.unescape);
    }, n.compile = function(e) {
        return e.length === 0 ? "" : "/" + e.map(n.escape).join("/");
    }, $8ac322cb35ca3943$var$I;
}
var $8ac322cb35ca3943$var$p = $8ac322cb35ca3943$var$re();
const $8ac322cb35ca3943$export$30d14a216ec47eb6 = ({ pointer: t, mappings: n, data: o, hiddenStrings: e })=>{
    const r = n[t];
    if (r) {
        delete n[t];
        const s = $8ac322cb35ca3943$var$b(o, t);
        for (const c of s){
            n[c] = r;
            const i = $8ac322cb35ca3943$var$p.get(o, c), u = $8ac322cb35ca3943$export$1be1fc439b849fdf(i, e);
            $8ac322cb35ca3943$var$p.set(o, c, u);
        }
    } else {
        const s = $8ac322cb35ca3943$var$b(o, t);
        for (const c of s){
            const i = $8ac322cb35ca3943$var$p.get(o, c), u = $8ac322cb35ca3943$export$1be1fc439b849fdf(i, e);
            $8ac322cb35ca3943$var$p.set(o, c, u);
        }
    }
}, $8ac322cb35ca3943$var$b = (t, n = "")=>{
    const o = [], e = $8ac322cb35ca3943$var$p.get(t, n);
    if (e.content) for(let r = 0; r < e.content.length; r++)e.content[r].nodeType === "text" ? o.push(`${n}/content/${r}/value`) : o.push(...$8ac322cb35ca3943$var$b(t, `${n}/content/${r}`));
    return o;
}, $8ac322cb35ca3943$export$9d7dc8096393ad00 = ({ entityId: t, entityType: n, space: o, environment: e, field: r, locale: s, editorInterface: c, fieldType: i, targetOrigin: u, platform: a })=>{
    const d = {
        origin: "contentful.com",
        href: `${`${u || "https://app.contentful.com"}/spaces/${o}/environments/${e}`}/${n === "Entry" ? "entries" : "assets"}/${t}/?focusedField=${r}&focusedLocale=${s}&source=vercel-content-link`,
        contentful: {
            editorInterface: c,
            fieldType: i
        }
    };
    return a === "vercel" && delete d.contentful, d;
}, $8ac322cb35ca3943$export$564a0675187c3753 = (t)=>[
        "builtin",
        "sidebar-builtin",
        "editor-builtin"
    ].includes(t), $8ac322cb35ca3943$export$632f1cf2e0cd3381 = (t)=>$8ac322cb35ca3943$export$c38c570fc7d9a2ba.includes(t);
function $8ac322cb35ca3943$export$9cd59f9826255e47(t) {
    if (typeof structuredClone == "function") return structuredClone(t);
    try {
        return JSON.parse(JSON.stringify(t));
    } catch (n) {
        return console.warn("Failed to clone data:", t, n), t;
    }
}
const $8ac322cb35ca3943$export$c38c570fc7d9a2ba = [
    "singleLine",
    "tagEditor",
    "listInput",
    "checkbox",
    "richTextEditor",
    "multipleLine"
];
function $8ac322cb35ca3943$export$67ff64d80fa7f197(t, n, o, e, r, s, c) {
    const i = c ? n[c] : n;
    switch(t){
        case "Symbol":
            {
                const u = $8ac322cb35ca3943$export$1be1fc439b849fdf(i, o);
                $8ac322cb35ca3943$var$p.set(e, r, u);
                break;
            }
        case "Text":
            {
                const u = $8ac322cb35ca3943$export$1be1fc439b849fdf(i, o);
                $8ac322cb35ca3943$var$p.set(e, r, u);
                break;
            }
        case "RichText":
            $8ac322cb35ca3943$export$30d14a216ec47eb6({
                pointer: "",
                mappings: s,
                data: i,
                hiddenStrings: o
            });
            break;
        case "Array":
            {
                const u = i.map((a)=>typeof a == "string" ? $8ac322cb35ca3943$export$1be1fc439b849fdf(a, o) : a);
                $8ac322cb35ca3943$var$p.set(e, r, u);
                break;
            }
    }
}
const $8ac322cb35ca3943$export$54910783efa1969a = (t, n, o)=>{
    if (!t || !t.extensions || !t.extensions.contentSourceMaps) return console.error("GraphQL response does not contain Content Source Maps information.", t), t;
    const e = $8ac322cb35ca3943$export$9cd59f9826255e47(t), { spaces: r, environments: s, editorInterfaces: c, fields: i, locales: u, entries: a, assets: l, mappings: m, fieldTypes: v } = e.extensions.contentSourceMaps, y = e;
    for(const d in m){
        const { source: f } = m[d], h = "entry" in f ? a[f.entry] : l[f.asset], M = "entry" in f ? "Entry" : "Asset";
        if (!h) return e;
        const g = r[h.space], A = s[h.environment], E = h.id, S = i[f.field], T = u[f.locale], N = c[f.editorInterface], J = v[f.fieldType];
        if (!($8ac322cb35ca3943$export$564a0675187c3753(N.widgetNamespace) && !$8ac322cb35ca3943$export$632f1cf2e0cd3381(N.widgetId)) && $8ac322cb35ca3943$var$p.has(y, d)) {
            const R = $8ac322cb35ca3943$var$p.get(y, d);
            if (R !== null) {
                const z = $8ac322cb35ca3943$export$9d7dc8096393ad00({
                    entityId: E,
                    entityType: M,
                    space: g,
                    environment: A,
                    field: S,
                    locale: T,
                    editorInterface: N,
                    fieldType: J,
                    targetOrigin: n,
                    platform: o
                });
                $8ac322cb35ca3943$export$67ff64d80fa7f197(J, R, z, y, d, m);
            }
        }
    }
    return e;
}, $8ac322cb35ca3943$var$$ = (t, n, o, e, r)=>{
    if (!t.fields) return;
    const { contentSourceMaps: s } = t.sys;
    if (!s) return;
    const { mappings: c } = s;
    for(const i in c){
        const { source: u } = c[i], a = t.sys.space.sys.id, l = t.sys.environment.sys.id, m = t.sys.id, v = t.sys.type, y = n[u.fieldType], d = o[u.editorInterface];
        if ($8ac322cb35ca3943$export$564a0675187c3753(d.widgetNamespace) && !$8ac322cb35ca3943$export$632f1cf2e0cd3381(d.widgetId)) continue;
        const f = i.startsWith("/") ? i : `/${i}`;
        if ($8ac322cb35ca3943$var$p.has(t, f)) {
            const h = $8ac322cb35ca3943$var$p.get(t, f);
            if (h === null) return;
            const g = f.split("/").pop();
            if (!g) {
                console.error("Field name could not be extracted from the pointer", f);
                return;
            }
            const A = t.sys.locale;
            if (A) {
                const E = $8ac322cb35ca3943$export$9d7dc8096393ad00({
                    entityId: m,
                    entityType: v,
                    space: a,
                    environment: l,
                    field: g,
                    locale: A,
                    editorInterface: d,
                    fieldType: y,
                    targetOrigin: e,
                    platform: r
                });
                $8ac322cb35ca3943$export$67ff64d80fa7f197(y, h, E, t, f, c);
            } else Object.keys(h).forEach((S)=>{
                const T = $8ac322cb35ca3943$export$9d7dc8096393ad00({
                    entityId: m,
                    entityType: v,
                    space: a,
                    environment: l,
                    field: g,
                    locale: S,
                    editorInterface: d,
                    fieldType: y,
                    targetOrigin: e,
                    platform: r
                });
                $8ac322cb35ca3943$export$67ff64d80fa7f197(y, h, T, t, `${f}/${S}`, c, S);
            });
        }
    }
}, $8ac322cb35ca3943$export$15f61f09c5dea429 = (t, n, o)=>{
    var r;
    const e = $8ac322cb35ca3943$export$9cd59f9826255e47(t);
    if (e.sys && "items" in e) {
        const s = e;
        if (!((r = s.sys) != null && r.contentSourceMapsLookup)) return s;
        const { contentSourceMapsLookup: { fieldTypes: c, editorInterfaces: i } } = s.sys, { items: u, includes: a } = s;
        u.forEach((l)=>$8ac322cb35ca3943$var$$(l, c, i, n, o)), a && a.Entry && a.Entry.forEach((l)=>$8ac322cb35ca3943$var$$(l, c, i, n, o)), a && a.Asset && a.Asset.forEach((l)=>$8ac322cb35ca3943$var$$(l, c, i, n, o));
    } else {
        const s = e;
        if (!s.sys.contentSourceMapsLookup) return console.error("Content source maps lookup data is missing"), s;
        $8ac322cb35ca3943$var$$(s, s.sys.contentSourceMapsLookup.fieldTypes, s.sys.contentSourceMapsLookup.editorInterfaces, n, o);
    }
    return e;
};



var $049eb15558c246cf$exports = {};
(function(global1, factory) {
    $049eb15558c246cf$exports = factory();
})($049eb15558c246cf$exports, function() {
    'use strict';
    var toStringFunction = Function.prototype.toString;
    var create = Object.create, defineProperty = Object.defineProperty, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getPrototypeOf$1 = Object.getPrototypeOf;
    var _a = Object.prototype, hasOwnProperty = _a.hasOwnProperty, propertyIsEnumerable = _a.propertyIsEnumerable;
    var SYMBOL_PROPERTIES = typeof getOwnPropertySymbols === 'function';
    var WEAK_MAP = typeof WeakMap === 'function';
    /**
     * @function createCache
     *
     * @description
     * get a new cache object to prevent circular references
     *
     * @returns the new cache object
     */ var createCache = function() {
        if (WEAK_MAP) return function() {
            return new WeakMap();
        };
        var Cache = /** @class */ function() {
            function Cache() {
                this._keys = [];
                this._values = [];
            }
            Cache.prototype.has = function(key) {
                return !!~this._keys.indexOf(key);
            };
            Cache.prototype.get = function(key) {
                return this._values[this._keys.indexOf(key)];
            };
            Cache.prototype.set = function(key, value) {
                this._keys.push(key);
                this._values.push(value);
            };
            return Cache;
        }();
        return function() {
            return new Cache();
        };
    }();
    /**
     * @function getCleanClone
     *
     * @description
     * get an empty version of the object with the same prototype it has
     *
     * @param object the object to build a clean clone from
     * @param realm the realm the object resides in
     * @returns the empty cloned object
     */ var getCleanClone = function(object, realm) {
        var prototype = object.__proto__ || getPrototypeOf$1(object);
        if (!prototype) return create(null);
        var Constructor = prototype.constructor;
        if (Constructor === realm.Object) return prototype === realm.Object.prototype ? {} : create(prototype);
        if (~toStringFunction.call(Constructor).indexOf('[native code]')) try {
            return new Constructor();
        } catch (_a) {}
        return create(prototype);
    };
    /**
     * @function getObjectCloneLoose
     *
     * @description
     * get a copy of the object based on loose rules, meaning all enumerable keys
     * and symbols are copied, but property descriptors are not considered
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneLoose = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        for(var key in object)if (hasOwnProperty.call(object, key)) clone[key] = handleCopy(object[key], cache);
        if (SYMBOL_PROPERTIES) {
            var symbols = getOwnPropertySymbols(object);
            for(var index = 0, length_1 = symbols.length, symbol = void 0; index < length_1; ++index){
                symbol = symbols[index];
                if (propertyIsEnumerable.call(object, symbol)) clone[symbol] = handleCopy(object[symbol], cache);
            }
        }
        return clone;
    };
    /**
     * @function getObjectCloneStrict
     *
     * @description
     * get a copy of the object based on strict rules, meaning all keys and symbols
     * are copied based on the original property descriptors
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneStrict = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        var properties = SYMBOL_PROPERTIES ? getOwnPropertyNames(object).concat(getOwnPropertySymbols(object)) : getOwnPropertyNames(object);
        for(var index = 0, length_2 = properties.length, property = void 0, descriptor = void 0; index < length_2; ++index){
            property = properties[index];
            if (property !== 'callee' && property !== 'caller') {
                descriptor = getOwnPropertyDescriptor(object, property);
                if (descriptor) {
                    // Only clone the value if actually a value, not a getter / setter.
                    if (!descriptor.get && !descriptor.set) descriptor.value = handleCopy(object[property], cache);
                    try {
                        defineProperty(clone, property, descriptor);
                    } catch (error) {
                        // Tee above can fail on node in edge cases, so fall back to the loose assignment.
                        clone[property] = descriptor.value;
                    }
                } else // In extra edge cases where the property descriptor cannot be retrived, fall back to
                // the loose assignment.
                clone[property] = handleCopy(object[property], cache);
            }
        }
        return clone;
    };
    /**
     * @function getRegExpFlags
     *
     * @description
     * get the flags to apply to the copied regexp
     *
     * @param regExp the regexp to get the flags of
     * @returns the flags for the regexp
     */ var getRegExpFlags = function(regExp) {
        var flags = '';
        if (regExp.global) flags += 'g';
        if (regExp.ignoreCase) flags += 'i';
        if (regExp.multiline) flags += 'm';
        if (regExp.unicode) flags += 'u';
        if (regExp.sticky) flags += 'y';
        return flags;
    };
    // utils
    var isArray = Array.isArray;
    var getPrototypeOf = Object.getPrototypeOf;
    var GLOBAL_THIS = function() {
        if (typeof globalThis !== 'undefined') return globalThis;
        if (typeof self !== 'undefined') return self;
        if (typeof window !== 'undefined') return window;
        if (typeof $parcel$global !== 'undefined') return $parcel$global;
        if (console && console.error) console.error('Unable to locate global object, returning "this".');
        return this;
    }();
    /**
     * @function copy
     *
     * @description
     * copy an value deeply as much as possible
     *
     * If `strict` is applied, then all properties (including non-enumerable ones)
     * are copied with their original property descriptors on both objects and arrays.
     *
     * The value is compared to the global constructors in the `realm` provided,
     * and the native constructor is always used to ensure that extensions of native
     * objects (allows in ES2015+) are maintained.
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.isStrict] should the copy be strict
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ function copy(value, options) {
        // manually coalesced instead of default parameters for performance
        var isStrict = !!(options && options.isStrict);
        var realm = options && options.realm || GLOBAL_THIS;
        var getObjectClone = isStrict ? getObjectCloneStrict : getObjectCloneLoose;
        /**
         * @function handleCopy
         *
         * @description
         * copy the value recursively based on its type
         *
         * @param value the value to copy
         * @returns the copied value
         */ var handleCopy = function(value, cache) {
            if (!value || typeof value !== 'object') return value;
            if (cache.has(value)) return cache.get(value);
            var prototype = value.__proto__ || getPrototypeOf(value);
            var Constructor = prototype && prototype.constructor;
            // plain objects
            if (!Constructor || Constructor === realm.Object) return getObjectClone(value, realm, handleCopy, cache);
            var clone;
            // arrays
            if (isArray(value)) {
                // if strict, include non-standard properties
                if (isStrict) return getObjectCloneStrict(value, realm, handleCopy, cache);
                clone = new Constructor();
                cache.set(value, clone);
                for(var index = 0, length_1 = value.length; index < length_1; ++index)clone[index] = handleCopy(value[index], cache);
                return clone;
            }
            // dates
            if (value instanceof realm.Date) return new Constructor(value.getTime());
            // regexps
            if (value instanceof realm.RegExp) {
                clone = new Constructor(value.source, value.flags || getRegExpFlags(value));
                clone.lastIndex = value.lastIndex;
                return clone;
            }
            // maps
            if (realm.Map && value instanceof realm.Map) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value, key) {
                    clone.set(key, handleCopy(value, cache));
                });
                return clone;
            }
            // sets
            if (realm.Set && value instanceof realm.Set) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value) {
                    clone.add(handleCopy(value, cache));
                });
                return clone;
            }
            // blobs
            if (realm.Blob && value instanceof realm.Blob) return value.slice(0, value.size, value.type);
            // buffers (node-only)
            if (realm.Buffer && realm.Buffer.isBuffer(value)) {
                clone = realm.Buffer.allocUnsafe ? realm.Buffer.allocUnsafe(value.length) : new Constructor(value.length);
                cache.set(value, clone);
                value.copy(clone);
                return clone;
            }
            // arraybuffers / dataviews
            if (realm.ArrayBuffer) {
                // dataviews
                if (realm.ArrayBuffer.isView(value)) {
                    clone = new Constructor(value.buffer.slice(0));
                    cache.set(value, clone);
                    return clone;
                }
                // arraybuffers
                if (value instanceof realm.ArrayBuffer) {
                    clone = value.slice(0);
                    cache.set(value, clone);
                    return clone;
                }
            }
            // if the value cannot / should not be cloned, don't
            if (// promise-like
            typeof value.then === 'function' || // errors
            value instanceof Error || // weakmaps
            realm.WeakMap && value instanceof realm.WeakMap || // weaksets
            realm.WeakSet && value instanceof realm.WeakSet) return value;
            // assume anything left is a custom constructor
            return getObjectClone(value, realm, handleCopy, cache);
        };
        return handleCopy(value, createCache());
    }
    // Adding reference to allow usage in CommonJS libraries compiled using TSC, which
    // expects there to be a default property on the exported value. See
    // [#37](https://github.com/planttheidea/fast-copy/issues/37) for details.
    copy.default = copy;
    /**
     * @function strictCopy
     *
     * @description
     * copy the value with `strict` option pre-applied
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ copy.strict = function strictCopy(value, options) {
        return copy(value, {
            isStrict: true,
            realm: options ? options.realm : void 0
        });
    };
    return copy;
});


var $ca1cd7dc0760fd40$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $ca1cd7dc0760fd40$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
function $ca1cd7dc0760fd40$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $ca1cd7dc0760fd40$var$UNRESOLVED_LINK = {}; // unique object to avoid polyfill bloat using Symbol()
/**
 * isLink Function
 * Checks if the object has sys.type "Link"
 * @param object
 */ var $ca1cd7dc0760fd40$var$isLink = function isLink(object) {
    return object && object.sys && object.sys.type === 'Link';
};
/**
 * isResourceLink Function
 * Checks if the object has sys.type "ResourceLink"
 * @param object
 */ var $ca1cd7dc0760fd40$var$isResourceLink = function isResourceLink(object) {
    return object && object.sys && object.sys.type === 'ResourceLink';
};
/**
 * Creates a key with spaceId and a key without for entityMap
 *
 * @param {*} sys
 * @param {String} sys.type
 * @param {String} sys.id
 * @param {*} sys.space
 * @param {*} sys.space.sys
 * @param {String} sys.space.id
 * @return {string[]}
 */ var $ca1cd7dc0760fd40$var$makeEntityMapKeys = function makeEntityMapKeys(sys) {
    if (sys.space && sys.environment) return [
        sys.type + '!' + sys.id,
        sys.space.sys.id + '!' + sys.environment.sys.id + '!' + sys.type + '!' + sys.id
    ];
    return [
        sys.type + '!' + sys.id
    ];
};
/**
 * Looks up in entityMap
 *
 * @param entityMap
 * @param {*} linkData
 * @param {String} linkData.type
 * @param {String} linkData.linkType
 * @param {String} linkData.id
 * @param {String} linkData.urn
 * @return {String}
 */ var $ca1cd7dc0760fd40$var$lookupInEntityMap = function lookupInEntityMap(entityMap, linkData) {
    var entryId = linkData.entryId, linkType = linkData.linkType, spaceId = linkData.spaceId, environmentId = linkData.environmentId;
    if (spaceId && environmentId) return entityMap.get(spaceId + '!' + environmentId + '!' + linkType + '!' + entryId);
    return entityMap.get(linkType + '!' + entryId);
};
var $ca1cd7dc0760fd40$var$getIdsFromUrn = function getIdsFromUrn(urn) {
    var regExp = /.*:spaces\/([^/]+)(?:\/environments\/([^/]+))?\/entries\/([^/]+)$/;
    if (!regExp.test(urn)) return undefined;
    // eslint-disable-next-line no-unused-vars
    var _urn$match = urn.match(regExp), _urn$match2 = $ca1cd7dc0760fd40$var$_slicedToArray(_urn$match, 4), _ = _urn$match2[0], spaceId = _urn$match2[1], _urn$match2$ = _urn$match2[2], environmentId = _urn$match2$ === undefined ? 'master' : _urn$match2$, entryId = _urn$match2[3];
    return {
        spaceId: spaceId,
        environmentId: environmentId,
        entryId: entryId
    };
};
/**
 * getResolvedLink Function
 *
 * @param entityMap
 * @param link
 * @return {undefined}
 */ var $ca1cd7dc0760fd40$var$getResolvedLink = function getResolvedLink(entityMap, link) {
    var _link$sys = link.sys, type = _link$sys.type, linkType = _link$sys.linkType;
    if (type === 'ResourceLink') {
        if (!linkType.startsWith('Contentful:')) return link;
        var urn = link.sys.urn;
        var _getIdsFromUrn = $ca1cd7dc0760fd40$var$getIdsFromUrn(urn), spaceId = _getIdsFromUrn.spaceId, environmentId = _getIdsFromUrn.environmentId, _entryId = _getIdsFromUrn.entryId;
        var extractedLinkType = linkType.split(':')[1];
        return $ca1cd7dc0760fd40$var$lookupInEntityMap(entityMap, {
            linkType: extractedLinkType,
            entryId: _entryId,
            spaceId: spaceId,
            environmentId: environmentId
        }) || $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
    }
    var entryId = link.sys.id;
    return $ca1cd7dc0760fd40$var$lookupInEntityMap(entityMap, {
        linkType: linkType,
        entryId: entryId
    }) || $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
};
/**
 * cleanUpLinks Function
 * - Removes unresolvable links from Arrays and Objects
 *
 * @param {Object[]|Object} input
 */ var $ca1cd7dc0760fd40$var$cleanUpLinks = function cleanUpLinks(input) {
    if (Array.isArray(input)) return input.filter(function(val) {
        return val !== $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
    });
    for(var key in input)if (input[key] === $ca1cd7dc0760fd40$var$UNRESOLVED_LINK) delete input[key];
    return input;
};
/**
 * walkMutate Function
 * @param input
 * @param predicate
 * @param mutator
 * @param removeUnresolved
 * @return {*}
 */ var $ca1cd7dc0760fd40$var$walkMutate = function walkMutate(input, predicate, mutator, removeUnresolved) {
    if (predicate(input)) return mutator(input);
    if (input && (typeof input === 'undefined' ? 'undefined' : $ca1cd7dc0760fd40$var$_typeof(input)) === 'object') {
        for(var key in input)// eslint-disable-next-line no-prototype-builtins
        if (input.hasOwnProperty(key)) input[key] = walkMutate(input[key], predicate, mutator, removeUnresolved);
        if (removeUnresolved) input = $ca1cd7dc0760fd40$var$cleanUpLinks(input);
    }
    return input;
};
var $ca1cd7dc0760fd40$var$normalizeLink = function normalizeLink(entityMap, link, removeUnresolved) {
    var resolvedLink = $ca1cd7dc0760fd40$var$getResolvedLink(entityMap, link);
    if (resolvedLink === $ca1cd7dc0760fd40$var$UNRESOLVED_LINK) return removeUnresolved ? resolvedLink : link;
    return resolvedLink;
};
var $ca1cd7dc0760fd40$var$makeEntryObject = function makeEntryObject(item, itemEntryPoints) {
    if (!Array.isArray(itemEntryPoints)) return item;
    var entryPoints = Object.keys(item).filter(function(ownKey) {
        return itemEntryPoints.indexOf(ownKey) !== -1;
    });
    return entryPoints.reduce(function(entryObj, entryPoint) {
        entryObj[entryPoint] = item[entryPoint];
        return entryObj;
    }, {});
};
/**
 * resolveResponse Function
 * Resolves contentful response to normalized form.
 * @param {Object} response Contentful response
 * @param {{removeUnresolved: Boolean, itemEntryPoints: Array<String>}|{}} options
 * @param {Boolean} options.removeUnresolved - Remove unresolved links default:false
 * @param {Array<String>} options.itemEntryPoints - Resolve links only in those item properties
 * @return {Object}
 */ var $ca1cd7dc0760fd40$var$resolveResponse = function resolveResponse(response, options) {
    options = options || {};
    if (!response.items) return [];
    var responseClone = (0, (/*@__PURE__*/$parcel$interopDefault($049eb15558c246cf$exports)))(response);
    var allIncludes = Object.keys(responseClone.includes || {}).reduce(function(all, type) {
        return [].concat($ca1cd7dc0760fd40$var$_toConsumableArray(all), $ca1cd7dc0760fd40$var$_toConsumableArray(response.includes[type]));
    }, []);
    var allEntries = [].concat($ca1cd7dc0760fd40$var$_toConsumableArray(responseClone.items), $ca1cd7dc0760fd40$var$_toConsumableArray(allIncludes)).filter(function(entity) {
        return Boolean(entity.sys);
    });
    var entityMap = new Map(allEntries.reduce(function(acc, entity) {
        var entries = $ca1cd7dc0760fd40$var$makeEntityMapKeys(entity.sys).map(function(key) {
            return [
                key,
                entity
            ];
        });
        acc.push.apply(acc, $ca1cd7dc0760fd40$var$_toConsumableArray(entries));
        return acc;
    }, []));
    allEntries.forEach(function(item) {
        var entryObject = $ca1cd7dc0760fd40$var$makeEntryObject(item, options.itemEntryPoints);
        Object.assign(item, $ca1cd7dc0760fd40$var$walkMutate(entryObject, function(x) {
            return $ca1cd7dc0760fd40$var$isLink(x) || $ca1cd7dc0760fd40$var$isResourceLink(x);
        }, function(link) {
            return $ca1cd7dc0760fd40$var$normalizeLink(entityMap, link, options.removeUnresolved);
        }, options.removeUnresolved));
    });
    return responseClone.items;
};
var $ca1cd7dc0760fd40$export$2e2bcd8739ae039 = $ca1cd7dc0760fd40$var$resolveResponse;




var $kR54n = parcelRequire("kR54n");
function $0cf955c956cdb33a$export$2e2bcd8739ae039(data) {
    return Object.defineProperty(data, 'stringifySafe', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function(serializer = null, indent = '') {
            return (0, (/*@__PURE__*/$parcel$interopDefault($kR54n)))(this, serializer, indent, (key, value)=>{
                return {
                    sys: {
                        type: 'Link',
                        linkType: 'Entry',
                        id: value.sys.id,
                        circular: true
                    }
                };
            });
        }
    });
}


/**
 * Retrieves all the available pages for a sync operation
 */ async function $1f8dc9f64481944a$export$2e2bcd8739ae039(http, query, options) {
    if (!query || !query.initial && !query.nextSyncToken && !query.nextPageToken) throw new Error('Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing');
    if (query['content_type'] && !query.type) query.type = 'Entry';
    else if (query['content_type'] && query.type && query.type !== 'Entry') throw new Error('When using the `content_type` filter your `type` parameter cannot be different from `Entry`.');
    const defaultOptions = {
        withoutLinkResolution: false,
        withoutUnresolvableLinks: false,
        paginate: true
    };
    const { withoutLinkResolution: withoutLinkResolution, withoutUnresolvableLinks: withoutUnresolvableLinks, paginate: paginate } = Object.assign(Object.assign({}, defaultOptions), options);
    const response = await $1f8dc9f64481944a$var$getSyncPage(http, [], query, {
        paginate: paginate
    });
    // clones response.items used in includes because we don't want these to be mutated
    if (!withoutLinkResolution) response.items = (0, $ca1cd7dc0760fd40$export$2e2bcd8739ae039)(response, {
        removeUnresolved: withoutUnresolvableLinks,
        itemEntryPoints: [
            'fields'
        ]
    });
    // maps response items again after getters are attached
    const mappedResponseItems = $1f8dc9f64481944a$var$mapResponseItems(response.items);
    if (response.nextSyncToken) mappedResponseItems.nextSyncToken = response.nextSyncToken;
    if (response.nextPageToken) mappedResponseItems.nextPageToken = response.nextPageToken;
    return (0, $5f2658cac0f27b2d$export$2e2bcd8739ae039)((0, $0cf955c956cdb33a$export$2e2bcd8739ae039)((0, $3fdb165b3001cf99$export$2e2bcd8739ae039)(mappedResponseItems)));
}
/**
 * @private
 * @param items
 * @returns Entities mapped to an object for each entity type
 */ function $1f8dc9f64481944a$var$mapResponseItems(items) {
    const reducer = (type)=>{
        return (accumulated, item)=>{
            if (item.sys.type === type) accumulated.push((0, $3fdb165b3001cf99$export$2e2bcd8739ae039)(item));
            return accumulated;
        };
    };
    return {
        entries: items.reduce(reducer('Entry'), []),
        assets: items.reduce(reducer('Asset'), []),
        deletedEntries: items.reduce(reducer('DeletedEntry'), []),
        deletedAssets: items.reduce(reducer('DeletedAsset'), [])
    };
}
function $1f8dc9f64481944a$var$createRequestQuery(originalQuery) {
    if (originalQuery.nextPageToken) return {
        sync_token: originalQuery.nextPageToken
    };
    if (originalQuery.nextSyncToken) return {
        sync_token: originalQuery.nextSyncToken
    };
    if (originalQuery.sync_token) return {
        sync_token: originalQuery.sync_token
    };
    return originalQuery;
}
/**
 * If the response contains a nextPageUrl, extracts the sync token to get the
 * next page and calls itself again with that token.
 * Otherwise, if the response contains a nextSyncUrl, extracts the sync token
 * and returns it.
 * On each call of this function, any retrieved items are collected in the
 * supplied items array, which gets returned in the end.
 */ async function $1f8dc9f64481944a$var$getSyncPage(http, items, query, { paginate: paginate }) {
    const requestQuery = $1f8dc9f64481944a$var$createRequestQuery(query);
    const response = await http.get('sync', (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
        query: requestQuery
    }));
    const data = response.data || {};
    items = items.concat(data.items || []);
    if (data.nextPageUrl) {
        if (paginate) {
            delete requestQuery.initial;
            requestQuery.sync_token = $1f8dc9f64481944a$var$getToken(data.nextPageUrl);
            return $1f8dc9f64481944a$var$getSyncPage(http, items, requestQuery, {
                paginate: paginate
            });
        }
        return {
            items: items,
            nextPageToken: $1f8dc9f64481944a$var$getToken(data.nextPageUrl)
        };
    } else if (data.nextSyncUrl) return {
        items: items,
        nextSyncToken: $1f8dc9f64481944a$var$getToken(data.nextSyncUrl)
    };
    else return {
        items: []
    };
}
/**
 * Extracts token out of an url
 * @private
 */ function $1f8dc9f64481944a$var$getToken(url) {
    const urlParts = url.split('?');
    return urlParts.length > 0 ? urlParts[1].replace('sync_token=', '') : '';
}


function $c7003b8f7fd6801b$export$2e2bcd8739ae039(query) {
    const convertedQuery = {};
    let hasConverted = false;
    for(const key in query)// We allow multiple values to be passed as arrays
    // which have to be converted to comma-separated strings before being sent to the API
    if (Array.isArray(query[key])) {
        convertedQuery[key] = query[key].join(',');
        hasConverted = true;
    }
    if (hasConverted) return Object.assign(Object.assign({}, query), convertedQuery);
    return query;
}


function $4545c2b15b84792e$export$2e2bcd8739ae039(query) {
    if (!query.select) return new Set();
    // The selection of fields for the query is limited
    // Get the different parts that are listed for selection
    const allSelects = Array.isArray(query.select) ? query.select : query.select.split(',').map((q)=>q.trim());
    // Move the parts into a set for easy access and deduplication
    return new Set(allSelects);
}


/*
 * sdk relies heavily on sys metadata
 * so we cannot omit the sys property on sdk level entirely
 * and we have to ensure that at least `id` and `type` are present
 * */ function $241641b139603108$export$2e2bcd8739ae039(query) {
    if (!query.select) return query;
    const selectedSet = (0, $4545c2b15b84792e$export$2e2bcd8739ae039)(query);
    // If we already select all of `sys` we can just return
    // since we're anyway fetching everything that is needed
    if (selectedSet.has('sys')) return query;
    // We don't select `sys` so we need to ensure the minimum set
    selectedSet.add('sys.id');
    selectedSet.add('sys.type');
    // Reassign the normalized sys properties
    return Object.assign(Object.assign({}, query), {
        select: [
            ...selectedSet
        ].join(',')
    });
}




function $ec4eb32ce098e928$export$2e2bcd8739ae039(data, { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved }) {
    const wrappedData = (0, $0cf955c956cdb33a$export$2e2bcd8739ae039)(data);
    if (resolveLinks) wrappedData.items = (0, $ca1cd7dc0760fd40$export$2e2bcd8739ae039)(wrappedData, {
        removeUnresolved: removeUnresolved,
        itemEntryPoints: [
            'fields'
        ]
    });
    return wrappedData;
}



class $64b957018310fbaa$export$2191b9da168c6cf0 extends Error {
    constructor(name, message){
        super(`Invalid "${name}" provided, ` + message);
        this.name = 'ValidationError';
    }
}


function $91185bd952b09464$export$2e2bcd8739ae039(name, timestamp, options) {
    options = options || {};
    if (typeof timestamp !== 'number') throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)(name, `only numeric values are allowed for timestamps, provided type was "${typeof timestamp}"`);
    if (options.maximum && timestamp > options.maximum) throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)(name, `value (${timestamp}) cannot be further in the future than expected maximum (${options.maximum})`);
    if (options.now && timestamp < options.now) throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)(name, `value (${timestamp}) cannot be in the past, current time was ${options.now}`);
}



function $a5831382b46e76cb$var$checkLocaleParamIsAll(query) {
    if (query.locale === '*') throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)('locale', `The use of locale='*' is no longer supported.To fetch an entry in all existing locales,
      use client.withAllLocales instead of the locale='*' parameter.`);
}
function $a5831382b46e76cb$var$checkLocaleParamExists(query) {
    if (query.locale) throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)('locale', 'The `locale` parameter is not allowed');
}
function $a5831382b46e76cb$export$17c49c51685bc436(query, isWithAllLocalesClient) {
    if (isWithAllLocalesClient) $a5831382b46e76cb$var$checkLocaleParamExists(query);
    else $a5831382b46e76cb$var$checkLocaleParamIsAll(query);
    return;
}
function $a5831382b46e76cb$export$e7c0742140718fa4(query) {
    if ('resolveLinks' in query) throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)('resolveLinks', `The use of the 'resolveLinks' parameter is no longer supported. By default, links are resolved.
      If you do not want to resolve links, use client.withoutLinkResolution.`);
    return;
}
function $a5831382b46e76cb$export$9f2bae7059814fea(query) {
    if ('removeUnresolved' in query) throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)('removeUnresolved', `The use of the 'removeUnresolved' parameter is no longer supported. By default, unresolved links are kept as link objects.
      If you do not want to include unresolved links, use client.withoutUnresolvableLinks.`);
    return;
}
function $a5831382b46e76cb$export$46cc9f17c7633478(host, includeContentSourceMaps) {
    if (includeContentSourceMaps === undefined) return false;
    if (typeof includeContentSourceMaps !== 'boolean') throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)('includeContentSourceMaps', `The 'includeContentSourceMaps' parameter must be a boolean.`);
    const includeContentSourceMapsIsAllowed = host === 'preview.contentful.com';
    if (includeContentSourceMaps && !includeContentSourceMapsIsAllowed) throw new (0, $64b957018310fbaa$export$2191b9da168c6cf0)('includeContentSourceMaps', `The 'includeContentSourceMaps' parameter can only be used with the CPA. Please set host to 'preview.contentful.com' to include Content Source Maps.
      `);
    return includeContentSourceMaps;
}


function $0b6ced789a0773ac$export$2e2bcd8739ae039(query) {
    for(const key in query){
        const value = query[key];
        // We don’t allow any objects as values for query parameters
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) throw new Error(`Objects are not supported as value for the "${key}" query parameter.`);
    }
}


/**
 * Contentful Delivery API Client. Contains methods which allow access to the
 * different kinds of entities present in Contentful (Entries, Assets, etc).
 */ const $6c3fd661619ddfe6$var$ASSET_KEY_MAX_LIFETIME = 172800;
class $6c3fd661619ddfe6$var$NotFoundError extends Error {
    constructor(id, environment, space){
        super('The resource could not be found.');
        this.sys = {
            type: 'Error',
            id: 'NotFound'
        };
        this.details = {
            type: 'Entry',
            id: id,
            environment: environment,
            space: space
        };
    }
}
function $6c3fd661619ddfe6$export$2e2bcd8739ae039({ http: http, getGlobalOptions: getGlobalOptions }, options) {
    const notFoundError = (id = 'unknown')=>{
        return new $6c3fd661619ddfe6$var$NotFoundError(id, getGlobalOptions().environment, getGlobalOptions().space);
    };
    const getBaseUrl = (context)=>{
        let baseUrl = context === 'space' ? getGlobalOptions().spaceBaseUrl : getGlobalOptions().environmentBaseUrl;
        if (!baseUrl) throw new Error('Please define baseUrl for ' + context);
        if (!baseUrl.endsWith('/')) baseUrl += '/';
        return baseUrl;
    };
    function maybeEnableSourceMaps(query = {}) {
        var _a, _b;
        const params = http.httpClientParams;
        const includeContentSourceMaps = (_a = params === null || params === void 0 ? void 0 : params.includeContentSourceMaps) !== null && _a !== void 0 ? _a : (_b = params === null || params === void 0 ? void 0 : params.alphaFeatures) === null || _b === void 0 ? void 0 : _b.includeContentSourceMaps;
        const host = params === null || params === void 0 ? void 0 : params.host;
        const areAllowed = (0, $a5831382b46e76cb$export$46cc9f17c7633478)(host, includeContentSourceMaps);
        if (areAllowed) {
            query.includeContentSourceMaps = true;
            // Ensure that content source maps and required attributes are selected
            if (query.select) {
                const selection = (0, $4545c2b15b84792e$export$2e2bcd8739ae039)(query);
                selection.add('sys');
                query.select = Array.from(selection).join(',');
            }
        }
        return query;
    }
    function maybeEncodeCPAResponse(data, config) {
        var _a;
        const includeContentSourceMaps = (_a = config === null || config === void 0 ? void 0 : config.params) === null || _a === void 0 ? void 0 : _a.includeContentSourceMaps;
        if (includeContentSourceMaps) return (0, $8ac322cb35ca3943$export$15f61f09c5dea429)(data);
        return data;
    }
    async function get({ context: context, path: path, config: config }) {
        const baseUrl = getBaseUrl(context);
        try {
            const response = await http.get(baseUrl + path, config);
            return maybeEncodeCPAResponse(response.data, config);
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    async function post({ context: context, path: path, data: data, config: config }) {
        const baseUrl = getBaseUrl(context);
        try {
            const response = await http.post(baseUrl + path, data, config);
            return response.data;
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    async function getSpace() {
        return get({
            context: 'space',
            path: ''
        });
    }
    async function getContentType(id) {
        return get({
            context: 'environment',
            path: `content_types/${id}`
        });
    }
    async function getContentTypes(query = {}) {
        return get({
            context: 'environment',
            path: 'content_types',
            config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                query: query
            })
        });
    }
    async function getEntry(id, query = {}) {
        return makeGetEntry(id, query, options);
    }
    async function getEntries(query = {}) {
        return makeGetEntries(query, options);
    }
    async function makeGetEntry(id, query, options = {
        withAllLocales: false,
        withoutLinkResolution: false,
        withoutUnresolvableLinks: false
    }) {
        const { withAllLocales: withAllLocales } = options;
        (0, $a5831382b46e76cb$export$17c49c51685bc436)(query, withAllLocales);
        (0, $a5831382b46e76cb$export$e7c0742140718fa4)(query);
        (0, $a5831382b46e76cb$export$9f2bae7059814fea)(query);
        (0, $0b6ced789a0773ac$export$2e2bcd8739ae039)(query);
        return internalGetEntry(id, withAllLocales ? Object.assign(Object.assign({}, query), {
            locale: '*'
        }) : query, options);
    }
    async function internalGetEntry(id, query, options) {
        if (!id) throw notFoundError(id);
        try {
            const response = await internalGetEntries(Object.assign({
                'sys.id': id
            }, maybeEnableSourceMaps(query)), options);
            if (response.items.length > 0) return response.items[0];
            else throw notFoundError(id);
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    async function makeGetEntries(query, options = {
        withAllLocales: false,
        withoutLinkResolution: false,
        withoutUnresolvableLinks: false
    }) {
        const { withAllLocales: withAllLocales } = options;
        (0, $a5831382b46e76cb$export$17c49c51685bc436)(query, withAllLocales);
        (0, $a5831382b46e76cb$export$e7c0742140718fa4)(query);
        (0, $a5831382b46e76cb$export$9f2bae7059814fea)(query);
        (0, $0b6ced789a0773ac$export$2e2bcd8739ae039)(query);
        return internalGetEntries(withAllLocales ? Object.assign(Object.assign({}, query), {
            locale: '*'
        }) : query, options);
    }
    async function internalGetEntries(query, options) {
        const { withoutLinkResolution: withoutLinkResolution, withoutUnresolvableLinks: withoutUnresolvableLinks } = options;
        try {
            const entries = await get({
                context: 'environment',
                path: 'entries',
                config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                    query: maybeEnableSourceMaps((0, $c7003b8f7fd6801b$export$2e2bcd8739ae039)((0, $241641b139603108$export$2e2bcd8739ae039)(query)))
                })
            });
            return (0, $ec4eb32ce098e928$export$2e2bcd8739ae039)(entries, {
                resolveLinks: !withoutLinkResolution,
                removeUnresolved: withoutUnresolvableLinks !== null && withoutUnresolvableLinks !== void 0 ? withoutUnresolvableLinks : false
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    async function getAsset(id, query = {}) {
        return makeGetAsset(id, query, options);
    }
    async function getAssets(query = {}) {
        return makeGetAssets(query, options);
    }
    async function makeGetAssets(query, options = {
        withAllLocales: false,
        withoutLinkResolution: false,
        withoutUnresolvableLinks: false
    }) {
        const { withAllLocales: withAllLocales } = options;
        (0, $a5831382b46e76cb$export$17c49c51685bc436)(query, withAllLocales);
        (0, $0b6ced789a0773ac$export$2e2bcd8739ae039)(query);
        const localeSpecificQuery = withAllLocales ? Object.assign(Object.assign({}, query), {
            locale: '*'
        }) : query;
        return internalGetAssets(localeSpecificQuery);
    }
    async function internalGetAsset(id, query) {
        try {
            return get({
                context: 'environment',
                path: `assets/${id}`,
                config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                    query: maybeEnableSourceMaps((0, $241641b139603108$export$2e2bcd8739ae039)(query))
                })
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    async function makeGetAsset(id, query, options = {
        withAllLocales: false,
        withoutLinkResolution: false,
        withoutUnresolvableLinks: false
    }) {
        const { withAllLocales: withAllLocales } = options;
        (0, $a5831382b46e76cb$export$17c49c51685bc436)(query, withAllLocales);
        (0, $0b6ced789a0773ac$export$2e2bcd8739ae039)(query);
        const localeSpecificQuery = withAllLocales ? Object.assign(Object.assign({}, query), {
            locale: '*'
        }) : query;
        return internalGetAsset(id, localeSpecificQuery);
    }
    async function internalGetAssets(query) {
        try {
            return get({
                context: 'environment',
                path: 'assets',
                config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                    query: maybeEnableSourceMaps((0, $c7003b8f7fd6801b$export$2e2bcd8739ae039)((0, $241641b139603108$export$2e2bcd8739ae039)(query)))
                })
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    async function getTag(id) {
        return get({
            context: 'environment',
            path: `tags/${id}`
        });
    }
    async function getTags(query = {}) {
        (0, $0b6ced789a0773ac$export$2e2bcd8739ae039)(query);
        return get({
            context: 'environment',
            path: 'tags',
            config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                query: (0, $c7003b8f7fd6801b$export$2e2bcd8739ae039)((0, $241641b139603108$export$2e2bcd8739ae039)(query))
            })
        });
    }
    async function createAssetKey(expiresAt) {
        try {
            const now = Math.floor(Date.now() / 1000);
            const currentMaxLifetime = now + $6c3fd661619ddfe6$var$ASSET_KEY_MAX_LIFETIME;
            (0, $91185bd952b09464$export$2e2bcd8739ae039)('expiresAt', expiresAt, {
                maximum: currentMaxLifetime,
                now: now
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
        return post({
            context: 'environment',
            path: 'asset_keys',
            data: {
                expiresAt: expiresAt
            }
        });
    }
    async function getLocales(query = {}) {
        (0, $0b6ced789a0773ac$export$2e2bcd8739ae039)(query);
        return get({
            context: 'environment',
            path: 'locales',
            config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                query: (0, $241641b139603108$export$2e2bcd8739ae039)(query)
            })
        });
    }
    async function sync(query, syncOptions = {
        paginate: true
    }) {
        return makePagedSync(query, syncOptions, options);
    }
    async function makePagedSync(query, syncOptions, options = {
        withAllLocales: false,
        withoutLinkResolution: false,
        withoutUnresolvableLinks: false
    }) {
        (0, $a5831382b46e76cb$export$e7c0742140718fa4)(query);
        (0, $a5831382b46e76cb$export$9f2bae7059814fea)(query);
        const combinedOptions = Object.assign(Object.assign({}, syncOptions), options);
        switchToEnvironment(http);
        return (0, $1f8dc9f64481944a$export$2e2bcd8739ae039)(http, query, combinedOptions);
    }
    function parseEntries(data) {
        return makeParseEntries(data, options);
    }
    function makeParseEntries(data, options = {
        withAllLocales: false,
        withoutLinkResolution: false,
        withoutUnresolvableLinks: false
    }) {
        return internalParseEntries(data, options);
    }
    function internalParseEntries(data, options) {
        const { withoutLinkResolution: withoutLinkResolution, withoutUnresolvableLinks: withoutUnresolvableLinks } = options;
        return (0, $ec4eb32ce098e928$export$2e2bcd8739ae039)(data, {
            resolveLinks: !withoutLinkResolution,
            removeUnresolved: withoutUnresolvableLinks !== null && withoutUnresolvableLinks !== void 0 ? withoutUnresolvableLinks : false
        });
    }
    function getConceptScheme(id, query = {}) {
        return internalGetConceptScheme(id, query);
    }
    async function internalGetConceptScheme(id, query = {}) {
        try {
            return get({
                context: 'environment',
                path: `taxonomy/concept-schemes/${id}`,
                config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                    query: (0, $c7003b8f7fd6801b$export$2e2bcd8739ae039)((0, $241641b139603108$export$2e2bcd8739ae039)(query))
                })
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    function getConceptSchemes(query = {}) {
        return internalGetConceptSchemes(query);
    }
    async function internalGetConceptSchemes(query = {}) {
        try {
            return get({
                context: 'environment',
                path: 'taxonomy/concept-schemes',
                config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                    query: (0, $c7003b8f7fd6801b$export$2e2bcd8739ae039)((0, $241641b139603108$export$2e2bcd8739ae039)(query))
                })
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    function getConcept(id, query = {}) {
        return internalGetConcept(id, query);
    }
    async function internalGetConcept(id, query = {}) {
        try {
            return get({
                context: 'environment',
                path: `taxonomy/concepts/${id}`,
                config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                    query: (0, $c7003b8f7fd6801b$export$2e2bcd8739ae039)((0, $241641b139603108$export$2e2bcd8739ae039)(query))
                })
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    function getConcepts(query = {}) {
        return internalGetConcepts(query);
    }
    async function internalGetConcepts(query = {}) {
        try {
            return get({
                context: 'environment',
                path: 'taxonomy/concepts',
                config: (0, $1b583313d87ac2ed$export$2e2bcd8739ae039)({
                    query: (0, $c7003b8f7fd6801b$export$2e2bcd8739ae039)((0, $241641b139603108$export$2e2bcd8739ae039)(query))
                })
            });
        } catch (error) {
            (0, $5bacf07a5d1999ab$export$2e2bcd8739ae039)(error);
        }
    }
    /*
     * Switches BaseURL to use /environments path
     * */ function switchToEnvironment(http) {
        http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
    }
    return {
        version: "11.5.0",
        getSpace: getSpace,
        getContentType: getContentType,
        getContentTypes: getContentTypes,
        getAsset: getAsset,
        getAssets: getAssets,
        getTag: getTag,
        getTags: getTags,
        getLocales: getLocales,
        parseEntries: parseEntries,
        sync: sync,
        getEntry: getEntry,
        getEntries: getEntries,
        getConceptScheme: getConceptScheme,
        getConceptSchemes: getConceptSchemes,
        getConcept: getConcept,
        getConcepts: getConcepts,
        createAssetKey: createAssetKey
    };
}


function $c077223504a271d7$var$create({ http: http, getGlobalOptions: getGlobalOptions }, options, makeInnerClient) {
    const client = (0, $6c3fd661619ddfe6$export$2e2bcd8739ae039)({
        http: http,
        getGlobalOptions: getGlobalOptions
    }, options);
    const response = client ? client : {};
    Object.defineProperty(response, 'withAllLocales', {
        get: ()=>makeInnerClient(Object.assign(Object.assign({}, options), {
                withAllLocales: true
            }))
    });
    Object.defineProperty(response, 'withoutLinkResolution', {
        get: ()=>makeInnerClient(Object.assign(Object.assign({}, options), {
                withoutLinkResolution: true
            }))
    });
    Object.defineProperty(response, 'withoutUnresolvableLinks', {
        get: ()=>makeInnerClient(Object.assign(Object.assign({}, options), {
                withoutUnresolvableLinks: true
            }))
    });
    return Object.create(response);
}
const $c077223504a271d7$export$6ae809cb18958494 = ({ http: http, getGlobalOptions: getGlobalOptions })=>{
    function makeInnerClient(options) {
        return $c077223504a271d7$var$create({
            http: http,
            getGlobalOptions: getGlobalOptions
        }, options, makeInnerClient);
    }
    const client = (0, $6c3fd661619ddfe6$export$2e2bcd8739ae039)({
        http: http,
        getGlobalOptions: getGlobalOptions
    }, {
        withoutLinkResolution: false,
        withAllLocales: false,
        withoutUnresolvableLinks: false
    });
    return Object.assign(Object.assign({}, client), {
        get withAllLocales () {
            return makeInnerClient({
                withAllLocales: true,
                withoutLinkResolution: false,
                withoutUnresolvableLinks: false
            });
        },
        get withoutLinkResolution () {
            return makeInnerClient({
                withAllLocales: false,
                withoutLinkResolution: true,
                withoutUnresolvableLinks: false
            });
        },
        get withoutUnresolvableLinks () {
            return makeInnerClient({
                withAllLocales: false,
                withoutLinkResolution: false,
                withoutUnresolvableLinks: true
            });
        }
    });
};



/**
 * Contentful Delivery API SDK. Allows you to create instances of a client
 * with access to the Contentful Content Delivery API.
 */ /**
 * Create a client instance
 * @param params - Client initialization parameters
 * @category Client
 * @example
 * ```typescript
 * const contentful = require('contentful')
 * const client = contentful.createClient({
 *   accessToken: 'myAccessToken',
 *   space: 'mySpaceId'
 * })
 * ```
 */ function $2f96f945c784f4d4$export$5d730b7aed1a3eb0(params) {
    if (!params.accessToken) throw new TypeError('Expected parameter accessToken');
    if (!params.space) throw new TypeError('Expected parameter space');
    (0, $a5831382b46e76cb$export$e7c0742140718fa4)(params);
    (0, $a5831382b46e76cb$export$9f2bae7059814fea)(params);
    const defaultConfig = {
        resolveLinks: true,
        removeUnresolved: false,
        defaultHostname: 'cdn.contentful.com',
        environment: 'master'
    };
    const config = Object.assign(Object.assign({}, defaultConfig), params);
    const userAgentHeader = (0, $999138c164fc2759$export$2e2bcd8739ae039)(`contentful.js/${"11.5.0"}`, config.application, config.integration);
    config.headers = Object.assign(Object.assign({}, config.headers), {
        'Content-Type': 'application/vnd.contentful.delivery.v1+json',
        'X-Contentful-User-Agent': userAgentHeader
    });
    const http = (0, $6cbad996768a444b$export$2e2bcd8739ae039)((0, $4caf0f2bcd8b9e34$export$2e2bcd8739ae039), config);
    if (!http.defaults.baseURL) throw new Error('Please define a baseURL');
    const getGlobalOptions = (0, $5f8199cd2f1b34bc$export$6ba8541dd7703421)({
        space: config.space,
        environment: config.environment,
        spaceBaseUrl: http.defaults.baseURL,
        environmentBaseUrl: `${http.defaults.baseURL}environments/${config.environment}`
    });
    // Append environment to baseURL
    http.defaults.baseURL = getGlobalOptions({}).environmentBaseUrl;
    return (0, $c077223504a271d7$export$6ae809cb18958494)({
        http: http,
        getGlobalOptions: getGlobalOptions
    });
}



parcelRequire("kR54n");



const $bdc57433a683d18b$var$client = (0, $2f96f945c784f4d4$export$5d730b7aed1a3eb0)({
    space: "6jhe0m58t9oh",
    accessToken: "gOW07Mraj0kEQdoRDyEwnJH3Of1a1ZPMGPNSRtX8vTI",
    environment: "master"
});
const $bdc57433a683d18b$export$47fdd40111eda34c = async ()=>{
    const locale = "fr-CA";
    const entryItems = await $bdc57433a683d18b$var$client.getEntries({
        content_type: 'promoCcClinics',
        locale: locale
    });
    const entries = entryItems.items.map((entry)=>{
        const { fields: fields } = entry;
        return fields ? {
            meta: fields.metaData?.fields,
            header: {
                logo: fields.logo?.fields,
                languageUrl: fields.languageUrl,
                phone: fields.phone,
                email: fields.email,
                locale: locale
            },
            content: {
                notification: fields.notification,
                sectionTextImage: {
                    text: fields.sectionTextImageText,
                    image: fields.sectionTextImageImage?.fields
                },
                ctaButton: fields.ctaButton,
                ctaButtonSecondary: fields.ctaButtonSecondary,
                sectionReason: {
                    title: fields.reasonTitle,
                    cards: fields.reasonCards
                },
                symptoms: fields.symptoms,
                sectionTestimonials: {
                    text: fields.testimonials,
                    image: {
                        url: fields.testimonialsBackgroundImage?.fields?.file?.url,
                        alt: fields.testimonialsBackgroundImage?.fields?.title
                    }
                },
                sectionImageText: {
                    text: fields.sectionImageTextText,
                    image: fields.sectionImageTextImage?.fields
                }
            },
            footer: {
                copyright: fields.copyright,
                terms: fields.terms,
                privacy: fields.privacy
            }
        } : {};
    });
    return {
        entry: entries[0]
    };
};



var $e0a27d46c54dab96$exports = {};

$e0a27d46c54dab96$exports["footer"] = `_ggtVG_footer`;
$e0a27d46c54dab96$exports["footerContent"] = `_ggtVG_footerContent`;
$e0a27d46c54dab96$exports["left"] = `_ggtVG_left`;
$e0a27d46c54dab96$exports["right"] = `_ggtVG_right`;
for(let key in {})if (key in $e0a27d46c54dab96$exports) $e0a27d46c54dab96$exports[key] += ' ' + {}[key];
else $e0a27d46c54dab96$exports[key] = {}[key];


const $144e70455fced15e$var$Footer = ({ copyright: copyright, terms: terms, privacy: privacy })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("footer", {
        className: `container ${$e0a27d46c54dab96$exports.footer}`,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
            className: `container-sm`,
            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: `container-text ${$e0a27d46c54dab96$exports.footerContent}`,
                children: [
                    copyright && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: $e0a27d46c54dab96$exports.left,
                        children: copyright
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        className: $e0a27d46c54dab96$exports.right,
                        children: [
                            terms && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: terms.fields?.url,
                                target: terms.fields?.target,
                                children: terms.fields?.title
                            }),
                            privacy && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: privacy.fields?.url,
                                target: privacy.fields?.target,
                                children: privacy.fields?.title
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $144e70455fced15e$export$2e2bcd8739ae039 = $144e70455fced15e$var$Footer;



const $5e10739f1fe4f515$var$Meta = ({ meta: meta })=>{
    if (!meta) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            meta?.metaTitle && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("title", {
                children: meta.metaTitle
            }),
            meta?.description && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                name: "description",
                content: meta.description
            }, "description"),
            meta?.metaTitle && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                property: "og:title",
                content: meta.metaTitle
            }, "og:title"),
            meta?.description && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                property: "og:description",
                content: meta.description
            }, "og:description"),
            meta?.ogImage?.fields?.file?.url && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                property: "og:image",
                content: meta?.ogImage?.fields?.file?.url
            }, "og:image"),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "og:type"),
            meta?.ogSiteName && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                property: "og:site_name",
                content: meta.ogSiteName
            }, "og:site_name"),
            meta?.ogLocale && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                property: "og:locale",
                content: meta.ogLocale
            }, "og:locale"),
            meta?.ogURL && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                property: "og:url",
                content: meta.ogURL
            }, "og:url"),
            meta?.keywords && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("meta", {
                name: "keywords",
                content: meta.keywords
            })
        ]
    });
};
var $5e10739f1fe4f515$export$2e2bcd8739ae039 = $5e10739f1fe4f515$var$Meta;




var $8tsvq = parcelRequire("8tsvq");
const $27b52c99a1fc3f76$export$888dca072be1e18a = {
    BC: 19,
    NB: 19,
    NS: 19,
    NT: 19,
    NU: 19,
    YT: 19,
    AB: 18,
    QC: 21,
    MB: 19,
    NL: 19,
    ON: 19,
    PE: 19,
    SK: 19,
    OC: 18
};


var $497cf91cc3a61b26$exports = {};

$497cf91cc3a61b26$exports["ButtonWrapper"] = `L9k7-G_ButtonWrapper`;
$497cf91cc3a61b26$exports["ageGateLogo"] = `L9k7-G_ageGateLogo`;
$497cf91cc3a61b26$exports["buttonWrapper"] = `L9k7-G_buttonWrapper`;
$497cf91cc3a61b26$exports["checkboxBox"] = `L9k7-G_checkboxBox`;
$497cf91cc3a61b26$exports["checkboxInnerCheck"] = `L9k7-G_checkboxInnerCheck`;
$497cf91cc3a61b26$exports["checkboxLabel"] = `L9k7-G_checkboxLabel`;
$497cf91cc3a61b26$exports["checkboxWrapper"] = `L9k7-G_checkboxWrapper`;
$497cf91cc3a61b26$exports["container"] = `L9k7-G_container`;
$497cf91cc3a61b26$exports["heading"] = `L9k7-G_heading`;
$497cf91cc3a61b26$exports["locationWrapper"] = `L9k7-G_locationWrapper`;
$497cf91cc3a61b26$exports["paragraph"] = `L9k7-G_paragraph`;
$497cf91cc3a61b26$exports["section"] = `L9k7-G_section`;
for(let key in {})if (key in $497cf91cc3a61b26$exports) $497cf91cc3a61b26$exports[key] += ' ' + {}[key];
else $497cf91cc3a61b26$exports[key] = {}[key];


var $66f6ee0945ae4596$export$534219b709288da9;
var $66f6ee0945ae4596$export$4b1c805aad1afa3;
$66f6ee0945ae4596$export$534219b709288da9 = `fpuN7G_btn`;
$66f6ee0945ae4596$export$4b1c805aad1afa3 = `fpuN7G_btnActive`;



const $3e9278537961c18a$var$locales = {
    'en-CA': {
        logo: 'Live Well Naturally',
        select: 'Please select your location',
        international: 'International',
        confirm_age1: 'I confirm that I am',
        confirm_age2: 'years of age or older',
        confirm_int: 'I confirm I am of legal age in my jurisdiction',
        shared: "This is not a shared device \u2013 remember me for 30 days",
        enter: 'ENTER',
        consent: `You consent to our use of location services to display content relevant to you. You may adjust your location manually at any time in the future. 
    By entering our website you confirm you're of the legal age in your current location.`
    },
    'fr-CA': {
        logo: 'Bien naturellement',
        select: "S\xe9lectionnez votre emplacement",
        international: "\xc0 l'ext\xe9rieur du Canada",
        confirm_age1: 'Je confirme que j\'ai',
        confirm_age2: 'ans ou plus.',
        confirm_int: "Je confirme avoir l'\xe2ge l\xe9gal dans ma juridiction.",
        shared: "Ceci n'est pas un appareil partag\xe9 - m\xe9morisez-le pendant 30 jours.",
        enter: 'Entrez le site Web',
        consent: `Vous consentez \xe0 ce que nous utilisions les services de localisation pour afficher du contenu qui vous concerne.
     Vous pouvez ajuster votre emplacement manuellement \xe0 tout moment \xe0 l'avenir.
     En entrant dans Bien Naturellement, vous confirmez que vous avez l'\xe2ge l\xe9gal dans votre emplacement actuel et acceptez notre politique de confidentialit\xe9 et nos conditions d'utilisation.`
    }
};
const $3e9278537961c18a$var$locale = "fr-CA";
const $3e9278537961c18a$export$d73ee8ef04f5226a = (key)=>$3e9278537961c18a$var$locales[$3e9278537961c18a$var$locale]?.[key] || '';



const $a532f1810416b9e4$var$locale = "fr-CA";
var $295ec357d87000f6$exports = {};
$295ec357d87000f6$exports = new URL("lwn-en.02c82178.svg", import.meta.url).toString();


const $a532f1810416b9e4$var$logoEn = new URL($295ec357d87000f6$exports);
var $9a888fa98b2aea00$exports = {};
$9a888fa98b2aea00$exports = new URL("lwn-fr.0fef77da.svg", import.meta.url).toString();


const $a532f1810416b9e4$var$logoFr = new URL($9a888fa98b2aea00$exports);
const $a532f1810416b9e4$export$ebd2b79985152ae7 = ({ user: user })=>{
    const { location: location, remember: save } = user;
    const [isAdult, setIsAdult] = (0, $8tsvq.useState)(false);
    const onClickAge = user.setIsAdult;
    const onClickLocation = user.setLocation;
    const onClickRemember = user.setRemember;
    const ageOfConsent = (0, $27b52c99a1fc3f76$export$888dca072be1e18a)[location || 'ON'] || 18;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        className: $497cf91cc3a61b26$exports.section,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            className: $497cf91cc3a61b26$exports.container,
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                    className: $497cf91cc3a61b26$exports.ageGateLogo,
                    src: $a532f1810416b9e4$var$locale === (0, $f9c88b76390f20b3$export$8e1c4644f466949c).EN ? $a532f1810416b9e4$var$logoEn : $a532f1810416b9e4$var$logoFr,
                    alt: (0, $3e9278537961c18a$export$d73ee8ef04f5226a)('logo')
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                    className: $497cf91cc3a61b26$exports.heading,
                    children: (0, $3e9278537961c18a$export$d73ee8ef04f5226a)('select')
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: $497cf91cc3a61b26$exports.locationWrapper,
                    children: Object.keys((0, $27b52c99a1fc3f76$export$888dca072be1e18a)).map((_location)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                            className: `${$66f6ee0945ae4596$export$534219b709288da9} ${location === _location ? $66f6ee0945ae4596$export$4b1c805aad1afa3 : ''}`,
                            onClick: ()=>onClickLocation(_location),
                            children: _location === 'OC' ? (0, $3e9278537961c18a$export$d73ee8ef04f5226a)('international') : _location
                        }, _location))
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    onClick: ()=>setIsAdult(!isAdult),
                    className: $497cf91cc3a61b26$exports.checkboxWrapper,
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            className: $497cf91cc3a61b26$exports.checkboxBox,
                            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                className: isAdult ? $497cf91cc3a61b26$exports.checkboxInnerCheck : ''
                            })
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            className: $497cf91cc3a61b26$exports.checkboxLabel,
                            children: !location || location === 'OC' ? (0, $3e9278537961c18a$export$d73ee8ef04f5226a)('confirm_int') : `${(0, $3e9278537961c18a$export$d73ee8ef04f5226a)('confirm_age1')} ${ageOfConsent} ${(0, $3e9278537961c18a$export$d73ee8ef04f5226a)('confirm_age2')}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    onClick: ()=>onClickRemember(!save),
                    className: $497cf91cc3a61b26$exports.checkboxWrapper,
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            className: $497cf91cc3a61b26$exports.checkboxBox,
                            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                className: save ? $497cf91cc3a61b26$exports.checkboxInnerCheck : ''
                            })
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            className: $497cf91cc3a61b26$exports.checkboxLabel,
                            children: (0, $3e9278537961c18a$export$d73ee8ef04f5226a)('shared')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: $497cf91cc3a61b26$exports.buttonWrapper,
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                        className: $66f6ee0945ae4596$export$534219b709288da9,
                        disabled: !user.location || !isAdult,
                        onClick: ()=>onClickAge(true),
                        children: (0, $3e9278537961c18a$export$d73ee8ef04f5226a)('enter')
                    })
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: $497cf91cc3a61b26$exports.paragraph,
                    children: (0, $3e9278537961c18a$export$d73ee8ef04f5226a)('consent')
                })
            ]
        })
    });
};



var $8tsvq = parcelRequire("8tsvq");
const $8bd48a047e5abe1d$export$d3720feff416e85b = (key)=>{
    if (typeof window === 'undefined') return null;
    return localStorage.getItem(key);
};
const $8bd48a047e5abe1d$export$1f73f60bdb811cb1 = (key, value)=>{
    if (typeof window === 'undefined') return null;
    return localStorage.setItem(key, value);
};
const $8bd48a047e5abe1d$export$23bbbc4533528f03 = ()=>{
    const [remember, _setRemember] = (0, $8tsvq.useState)(true);
    const [location, _setLocation] = (0, $8tsvq.useState)($8bd48a047e5abe1d$export$d3720feff416e85b('location'));
    const [isAdult, _setIsAdult] = (0, $8tsvq.useState)($8bd48a047e5abe1d$export$d3720feff416e85b('is-adult') == null ? null : $8bd48a047e5abe1d$export$d3720feff416e85b('is-adult') === '1');
    const wasPromptedToday = $8bd48a047e5abe1d$export$d3720feff416e85b('last-prompt') === new Date().toISOString().split('T')[0];
    const complete = !!(location != null && isAdult) || wasPromptedToday;
    const setLocation = (location)=>{
        if (remember) $8bd48a047e5abe1d$export$1f73f60bdb811cb1('location', location);
        _setLocation(location);
    };
    const setIsAdult = (isAdult)=>{
        if (remember) $8bd48a047e5abe1d$export$1f73f60bdb811cb1('is-adult', isAdult ? '1' : '0');
        _setIsAdult(isAdult);
    };
    const setRemember = (remember)=>{
        if (!remember) localStorage.clear();
        _setRemember(remember);
    };
    return {
        remember: remember,
        location: location,
        isAdult: isAdult,
        setLocation: setLocation,
        setIsAdult: setIsAdult,
        setRemember: setRemember,
        complete: complete,
        wasPromptedToday: wasPromptedToday
    };
};


function $77abae077dfc33c4$var$App() {
    const { data: data, error: error } = (0, $97e4acba0fbbeffb$export$2e2bcd8739ae039)('contentful', (0, $bdc57433a683d18b$export$47fdd40111eda34c));
    const user = (0, $8bd48a047e5abe1d$export$23bbbc4533528f03)();
    if (error) {
        console.log(error);
        return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
            children: "failed to load "
        });
    }
    if (!data) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        className: "scr-center",
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $6e6b089c3d63766c$export$7f7cbe89f1eacd2), {
            size: "large"
        })
    });
    const { entry: entry } = data;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("main", {
        children: !user?.isAdult ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $a532f1810416b9e4$export$ebd2b79985152ae7), {
            user: user
        }) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5e10739f1fe4f515$export$2e2bcd8739ae039), {
                    meta: entry?.meta
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9fec082c20945cc9$export$2e2bcd8739ae039), {
                    ...entry?.header
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $cf05d691bff6a1c9$export$2e2bcd8739ae039), {
                    ...entry?.content
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $144e70455fced15e$export$2e2bcd8739ae039), {
                    ...entry?.footer
                })
            ]
        })
    });
}
var $77abae077dfc33c4$export$2e2bcd8739ae039 = $77abae077dfc33c4$var$App;


const $bd3c5464ff7fefe4$var$root = (0, $416246511aeb39de$exports.createRoot)(document.getElementById('root'));
$bd3c5464ff7fefe4$var$root.render(/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).StrictMode, {
    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $77abae077dfc33c4$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.9b49b141.js.map
